import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';

const SvgDeIceOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 40.33 28.084",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.58 22.518c-3.424 0-6.2-3.126-6.2-6.982s2.775-6.982 6.2-6.982M39.58.75v7.804M24.843 9.913l9.682 1.582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.459 16.161-16.76-1.305 1.215 2.5 17.406 3.252M30.987 22.901v-2.963"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.193,
    y: 22.901,
    width: 3.588,
    height: 4.433,
    rx: 1.794,
    transform: "rotate(180 30.987 25.117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.648 13.041h1.932"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.207,
    cy: 25.368,
    r: 1.923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.493,
    cy: 25.368,
    r: 1.924
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.949 25.1 3.185.028v-2.227l-3.09-5.139-14.294-.66V25.1h2.242M7.927 25.1h2.087M2.737 17.117.75 14.999 11.335 4.413l3.51 3.642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.845 3.18h2.027a2.621 2.621 0 0 1 2.621 2.62v3.229h0-4.648 0V3.18h0ZM19.493 9.029l1.983 1.982"
  })));
};
var SvgDeIceOutlined$1 = SvgDeIceOutlined;

const SvgTaxiOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.056 24.46",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8 4.507H9.34a4.512 4.512 0 0 0-3.855 2.167l-2.1 3.444h20.367l-2.1-3.444A4.509 4.509 0 0 0 17.8 4.507ZM24.68 10.118H2.376a1.626 1.626 0 0 0 0 3.252h.432v4.284a2.175 2.175 0 0 0 2.176 2.175h17.089a2.175 2.175 0 0 0 2.175-2.175V13.37h.432a1.626 1.626 0 1 0 0-3.252Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.007 19.829v1.781a2.1 2.1 0 0 1-2.1 2.1h0a2.1 2.1 0 0 1-2.1-2.1v-4.552M24.248 17.058v4.552a2.1 2.1 0 0 1-2.1 2.1h0a2.1 2.1 0 0 1-2.1-2.1v-1.781M6.249 15.36h3.31M17.575 15.36h3.309M17.626 4.507H9.43l.3-2.577A1.437 1.437 0 0 1 11.142.75h4.772a1.437 1.437 0 0 1 1.414 1.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color || `#1d1d1b`
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.809,
    y: 2.629,
    width: 1.026,
    height: 0.938,
    rx: 0.166
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.912,
    y: 1.69,
    width: 1.026,
    height: 0.938,
    rx: 0.166
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.015,
    y: 2.629,
    width: 1.026,
    height: 0.938,
    rx: 0.166
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.118,
    y: 1.69,
    width: 1.026,
    height: 0.938,
    rx: 0.166
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.221,
    y: 2.629,
    width: 1.026,
    height: 0.938,
    rx: 0.166
  })));
};
var SvgTaxiOutlined$1 = SvgTaxiOutlined;

const SvgAircraftParkingOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.374 25.009a.333.333 0 0 1 .155.281V26a.333.333 0 0 1-.43.318l-2.323-.712v1.196l.588.481a.333.333 0 0 1 .122.258v.602a.333.333 0 0 1-.433.318l-1.133-.354-1.132.354a.334.334 0 0 1-.433-.318v-.602c0-.098.043-.19.117-.254l.566-.481v-1.2l-2.322.712a.333.333 0 0 1-.431-.319v-.709c0-.114.058-.22.155-.281l2.598-1.643v-1.701a.87.87 0 0 1 1.738 0v1.7l2.598 1.644Zm-.511.465-2.598-1.643a.333.333 0 0 1-.155-.282v-1.884a.202.202 0 0 0-.406 0v1.884c0 .114-.058.22-.155.282l-2.598 1.643v.074l2.322-.712a.333.333 0 0 1 .431.319v1.805c0 .098-.043.19-.117.254l-.555.472.79-.246a.333.333 0 0 1 .198 0l.78.244-.568-.466a.334.334 0 0 1-.122-.258v-1.805a.333.333 0 0 1 .43-.319l2.323.712v-.074Zm-.616-19.741a.333.333 0 0 1 .135.268v.709c0 .114-.059.22-.155.282l-2.598 1.643v1.7a.87.87 0 0 1-1.739 0v-1.7l-2.598-1.643a.333.333 0 0 1-.155-.282V6a.333.333 0 0 1 .431-.318l2.322.712V5.198l-.587-.481a.333.333 0 0 1-.123-.258v-.602a.333.333 0 0 1 .433-.318l1.133.354 1.133-.354a.334.334 0 0 1 .432.318v.602c0 .098-.043.19-.117.254l-.565.481v1.2l2.322-.712a.333.333 0 0 1 .296.05Zm-.532.719-2.322.712a.333.333 0 0 1-.43-.319V5.04c0-.097.042-.19.116-.254l.556-.472-.79.246a.333.333 0 0 1-.198 0l-.781-.244.569.466a.333.333 0 0 1 .122.258v1.805a.333.333 0 0 1-.431.319l-2.322-.712v.074l2.598 1.643a.333.333 0 0 1 .155.282v1.885a.202.202 0 0 0 .202.202.203.203 0 0 0 .203-.202V8.45c0-.114.059-.22.155-.282l2.598-1.643v-.074Zm-7.007 18.557a.333.333 0 0 1 .155.281V26a.334.334 0 0 1-.431.318l-2.322-.712v1.196l.587.481a.333.333 0 0 1 .122.258v.602a.333.333 0 0 1-.432.318l-1.133-.354-1.133.354a.333.333 0 0 1-.433-.318v-.602c0-.098.043-.19.118-.254l.565-.481v-1.2l-2.322.712a.333.333 0 0 1-.431-.319v-.709c0-.114.059-.22.155-.281l2.598-1.643v-1.701a.87.87 0 1 1 1.739 0v1.7l2.598 1.644Zm-.512.465-2.598-1.643a.333.333 0 0 1-.155-.282v-1.884a.204.204 0 0 0-.125-.188.203.203 0 0 0-.28.188v1.884c0 .114-.059.22-.155.282l-2.598 1.643v.074l2.322-.712a.333.333 0 0 1 .43.319v1.805c0 .098-.042.19-.117.254l-.555.472.79-.246a.333.333 0 0 1 .198 0l.781.244-.569-.466a.334.334 0 0 1-.122-.258v-1.805a.333.333 0 0 1 .431-.319l2.322.712v-.074ZM15.58 5.733a.333.333 0 0 1 .135.268v.709c0 .114-.058.22-.155.282l-2.598 1.643v1.7a.87.87 0 1 1-1.739 0v-1.7L8.625 6.992a.333.333 0 0 1-.155-.282V6a.333.333 0 0 1 .431-.318l2.322.712V5.198l-.587-.481a.333.333 0 0 1-.122-.258v-.602a.333.333 0 0 1 .433-.318l1.132.354 1.133-.354a.333.333 0 0 1 .433.318v.602c0 .098-.043.19-.117.254l-.566.481v1.2l2.322-.712a.333.333 0 0 1 .296.05Zm-.531.719-2.322.712a.333.333 0 0 1-.432-.319V5.04c0-.097.043-.19.118-.254l.555-.472-.79.246a.333.333 0 0 1-.198 0l-.781-.244.569.466a.333.333 0 0 1 .122.258v1.805a.333.333 0 0 1-.431.319l-2.322-.712v.074l2.598 1.643a.333.333 0 0 1 .155.282v1.885a.202.202 0 0 0 .203.202.203.203 0 0 0 .202-.202V8.45c0-.114.059-.22.156-.282l2.598-1.643v-.074Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 13.648V10h-.667v3.648H16V10h-.667v3.648h-5.2c-.176 0-.35-.035-.514-.104l-5.286-2.21v9.015L10 18.087V22h.667V18.13l8-.106V22h.666v-3.985l6.334-.084v-4.283H24ZM18 22c0 .369.298.667.667.667h.666A.667.667 0 0 0 20 22v-3.328l5.675-.074a.667.667 0 0 0 .658-.667v-4.283a.667.667 0 0 0-.666-.667h-1v-2.98A.667.667 0 0 0 24 9.333h-.667a.667.667 0 0 0-.666.666v2.981h-6v-2.98A.667.667 0 0 0 16 9.333h-.667a.667.667 0 0 0-.666.666v2.981h-4.533a.668.668 0 0 1-.257-.051L4.59 10.72a.667.667 0 0 0-.923.615v9.014c0 .472.476.794.913.62l4.753-1.898V22c0 .367.299.666.667.666h.667a.667.667 0 0 0 .666-.667v-3.213L18 18.699V22Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgAircraftParkingOutlined$1 = SvgAircraftParkingOutlined;

const SvgAirfranceIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#airfrance_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.331 41 68.867 57.587c-1.51 2.182-3.959 4.284-6.916 4.51v.509h12.751c3.385 0 5.854-2.204 7.526-4.632L94 41.002H80.331V41Z",
    fill: "#FF2600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.824 62.605V42.823h19.293v4.24H50.593v4.917h13.218v4.243H50.594v6.382h-5.77Z",
    fill: "#004578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m35.396 62.585-2.531-4.343H21.812l-2.305 4.343H14l11.011-19.763h5.018L42.51 62.585h-7.115Zm-11.718-9.324h6.444l-3.345-6.04-3.1 6.04Z",
    fill: "#004578"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "airfrance_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25837",
    result: "shape"
  }))));
};
var SvgAirfranceIcon$1 = SvgAirfranceIcon;

const SvgAirlineIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#airline_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#airline_icon_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#D7DEE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.57 103H-3.991c-.63 0-.833-1.753-.227-1.929 8.145-2.37 20.57-7.466 31.182-18.071 17.511-17.5 23.31-56 33.378-56H82.41c.31 0 .542.279.49.584l-12.837 75a.5.5 0 0 1-.493.416Z",
    fill: "#B1BCC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.392 28.324c1.211-1.138 2.52-1.824 3.95-1.824H82.41a.998.998 0 0 1 .983 1.169l-12.837 75a1 1 0 0 1-.986.831H-3.991c-.418 0-.682-.292-.818-.523a2.137 2.137 0 0 1-.256-.818 2.181 2.181 0 0 1 .06-.855c.075-.255.255-.599.647-.713 8.097-2.356 20.437-7.42 30.969-17.945 8.67-8.665 14.463-22.561 19.371-34.4l.08-.19c2.412-5.82 4.617-11.141 6.846-15.016 1.127-1.96 2.276-3.58 3.484-4.716ZM46.906 48.63c-4.886 11.786-10.748 25.89-19.589 34.725C16.648 94.016 4.165 99.146-4.028 101.536a.412.412 0 0 0-.02.054 1.197 1.197 0 0 0-.024.454 1.15 1.15 0 0 0 .144.456H69.57l12.837-75H60.342c-1.087 0-2.162.517-3.265 1.553-1.104 1.038-2.196 2.562-3.302 4.485-2.196 3.819-4.382 9.09-6.812 14.954l-.057.137Zm-50.813 53.896-.004-.004a.02.02 0 0 1 .004.004Zm-.109-1.011s0 .002-.003.005l.003-.005Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.668 102.581 12.237-75a.5.5 0 0 0-.493-.581h-9.737a.5.5 0 0 0-.483.371l-20.024 75a.5.5 0 0 0 .483.629h17.524a.5.5 0 0 0 .493-.419Z",
    fill: "#8393A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.709 27.242a1 1 0 0 1 .966-.742h9.737a1 1 0 0 1 .987 1.161l-12.237 75a1 1 0 0 1-.987.839H52.651a1 1 0 0 1-.966-1.258l20.024-75Zm10.703.258h-9.737l-20.024 75h17.524l12.237-75Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "airline_icon_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "airline_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25870",
    result: "shape"
  }))));
};
var SvgAirlineIcon$1 = SvgAirlineIcon;

const SvgAnalyzeGlasOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.587 7.308a6.676 6.676 0 1 0 0 13.352 6.676 6.676 0 0 0 0-13.352Zm5.77 11.738a7.676 7.676 0 1 0-.707.707l.546.547a1.067 1.067 0 0 0 .047 1.459l3.559 3.558a1.067 1.067 0 0 0 1.51 0l.61-.61a1.067 1.067 0 0 0 0-1.51l-3.56-3.558c-.4-.4-1.04-.416-1.459-.046l-.546-.547Zm.889 1.615.009-.01.01-.009.295-.296a.067.067 0 0 1 .096 0l3.558 3.559a.067.067 0 0 1 0 .095l-.61.61a.067.067 0 0 1-.095 0l-3.559-3.558a.067.067 0 0 1 0-.096l.296-.295Zm-8.503-10.128a.5.5 0 0 1 .434.398l.908 4.49 1.333-3.274a.5.5 0 0 1 .937.029l.73 2.165.665-.701a.5.5 0 0 1 .363-.156h1.27a.5.5 0 0 1 0 1h-1.055l-1.088 1.148a.5.5 0 0 1-.837-.184l-.566-1.678-1.45 3.561a.5.5 0 0 1-.954-.089l-.93-4.596-.7 1.544a.5.5 0 0 1-.455.294h-1.58a.5.5 0 1 1 0-1h1.258l1.206-2.66a.5.5 0 0 1 .511-.29Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgAnalyzeGlasOutlined$1 = SvgAnalyzeGlasOutlined;

const SvgArrowDoubleLeftOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 18.733 19.773",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.983 19.023 8.829 9.869 17.948.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.904 19.023.75 9.869 9.869.75"
  })));
};
var SvgArrowDoubleLeftOutlined$1 = SvgArrowDoubleLeftOutlined;

const SvgArrowDoubleRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 18.733 19.773",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.75.75 9.154 9.154-9.119 9.119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.829.75 9.154 9.154-9.119 9.119"
  })));
};
var SvgArrowDoubleRightOutlined$1 = SvgArrowDoubleRightOutlined;

const SvgArrowDownBoxOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.151 28.972",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.015 13.753-6.438 6.438h-.003l-6.438-6.438M13.575.75v19.442"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.326 8.176h5.891A2.184 2.184 0 0 1 26.4 10.36v15.677a2.184 2.184 0 0 1-2.184 2.185H2.934A2.184 2.184 0 0 1 .75 26.037V10.36a2.184 2.184 0 0 1 2.184-2.184h5.891"
  })));
};
var SvgArrowDownBoxOutlined$1 = SvgArrowDownBoxOutlined;

const SvgArrowDownOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 19.773 10.654",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.023.75 9.869 9.904.75.785"
  }));
};
var SvgArrowDownOutlined$1 = SvgArrowDownOutlined;

const SvgArrowDownRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.056 22.056",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.492 12.504.75.75l11.754 15.742-4.815 4.814h13.615l.002-.002V7.689l-4.814 4.815z"
  }));
};
var SvgArrowDownRightOutlined$1 = SvgArrowDownRightOutlined;

const SvgArrowLeftOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 10.654 19.773",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.904 19.023.75 9.869 9.869.75"
  }));
};
var SvgArrowLeftOutlined$1 = SvgArrowLeftOutlined;

const SvgArrowRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 10.654 19.773",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m.75.75 9.154 9.154-9.119 9.119"
  }));
};
var SvgArrowRightOutlined$1 = SvgArrowRightOutlined;

const SvgArrowSplitLeftRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.45 32.882",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.7.75-8.259 1.095 2.145 2.145-9.361 9.362L6.863 3.99l2.146-2.145L.75.75l1.095 8.259L3.99 6.863l10.203 10.203v15.066h4.063V17.066l.842-.841 9.361-9.362 2.146 2.146L31.7.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.98 11.342a8.839 8.839 0 0 1-5.724 12.445M10.916 8.042a8.835 8.835 0 0 1 10.468.151M14.268 23.886a8.839 8.839 0 0 1-6.043-12.76"
  })));
};
var SvgArrowSplitLeftRightOutlined$1 = SvgArrowSplitLeftRightOutlined;

const SvgArrowUpBoxOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.151 30.972",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.136 7.189 13.574.751h.003l6.438 6.438M13.575 20.192V.75M18.326 10.176h5.891A2.184 2.184 0 0 1 26.4 12.36v15.677a2.184 2.184 0 0 1-2.184 2.185H2.934A2.184 2.184 0 0 1 .75 28.037V12.36a2.184 2.184 0 0 1 2.184-2.184h5.891"
  })));
};
var SvgArrowUpBoxOutlined$1 = SvgArrowUpBoxOutlined;

const SvgArrowUpOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 19.773 10.654",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M.75 9.904 9.904.75l9.119 9.119"
  }));
};
var SvgArrowUpOutlined$1 = SvgArrowUpOutlined;

const SvgArrowUturnToLeftOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 23.945 22.819",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.236.75.751 7.235v.002l6.485 6.485"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.847 22.069h15.136a2.2 2.2 0 0 0 2.2-2.2v-7.848l.017-2.575a2.2 2.2 0 0 0-2.2-2.21H.75"
  })));
};
var SvgArrowUturnToLeftOutlined$1 = SvgArrowUturnToLeftOutlined;

const SvgArrowDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.22 27.222a.75.75 0 0 1 1.06 0l5.91 5.908 5.909-5.908a.75.75 0 1 1 1.06 1.06l-6.438 6.438a.75.75 0 0 1-.53.22h-.002a.75.75 0 0 1-.53-.22l-6.44-6.438a.75.75 0 0 1 0-1.06Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.19 14a.75.75 0 0 1 .75.75v19.44a.75.75 0 1 1-1.5 0V14.75a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgArrowDown$1 = SvgArrowDown;

const SvgArrowUp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.658 14.22a.75.75 0 0 1 .53-.219h.003a.75.75 0 0 1 .53.22l6.438 6.438a.75.75 0 1 1-1.06 1.06l-5.91-5.909-5.909 5.91a.75.75 0 1 1-1.06-1.061l6.438-6.438Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.19 14a.75.75 0 0 1 .75.75v19.441a.75.75 0 1 1-1.5 0V14.75a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgArrowUp$1 = SvgArrowUp;

const SvgArrowsRotateOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.433 34.433",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 17.216A16.467 16.467 0 0 1 28.86 5.573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.661 1.914v4.509h-4.508M33.683 17.216A16.467 16.467 0 0 1 5.573 28.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.772 32.519V28.01H9.28"
  })));
};
var SvgArrowsRotateOutlined$1 = SvgArrowsRotateOutlined;

const SvgArrowsToCircleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 37.902 37.902",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.235 30.317 4.715-4.715h.002l4.715 4.715M18.951 37.152V25.601M23.667 7.585 18.952 12.3h-.002l-4.715-4.715M18.951.75v11.551M30.317 23.667l-4.715-4.715v-.002l4.715-4.715M37.152 18.951H25.601M7.585 14.235 12.3 18.95v.002l-4.715 4.715M.75 18.951h11.551"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.951,
    cy: 18.951,
    r: 3.294
  })));
};
var SvgArrowsToCircleOutlined$1 = SvgArrowsToCircleOutlined;

const SvgArrowsUpDownLeftRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.444 32.444",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.332 10.86 5.361 5.361v.002l-5.361 5.361M15.504 16.222h16.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.332 10.86 5.361 5.361v.002l-5.361 5.361M15.504 16.222h16.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.332 10.86 5.361 5.361v.002l-5.361 5.361M15.504 16.222h16.19M6.112 21.584.751 16.223v-.002l5.361-5.361M16.939 16.222H.75M10.86 6.112 16.221.751h.002l5.361 5.361M16.222 16.939V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.86 6.112 16.221.751h.002l5.361 5.361M16.222 16.939V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.86 6.112 16.221.751h.002l5.361 5.361M16.222 16.939V.75M21.584 26.332l-5.361 5.361h-.002l-5.361-5.361M16.222 15.504v16.19"
  })));
};
var SvgArrowsUpDownLeftRightOutlined$1 = SvgArrowsUpDownLeftRightOutlined;

const SvgArrowsUpDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.847 14.206a.75.75 0 0 1 .75.75V33.84a.75.75 0 0 1-1.5 0V14.956a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.263 28.512a.75.75 0 0 1 1.06 0l5.43 5.429 5.429-5.429a.75.75 0 0 1 1.06 1.06l-5.959 5.96a.75.75 0 0 1-1.06 0l-5.96-5.96a.75.75 0 0 1 0-1.06ZM30.319 13.188a.75.75 0 0 1 .75.75v18.884a.75.75 0 1 1-1.5 0V13.937a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.883 12.247a.75.75 0 0 1 1.06 0l5.96 5.959a.75.75 0 0 1-1.061 1.06l-5.429-5.428-5.429 5.429a.75.75 0 1 1-1.06-1.061l5.959-5.959Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgArrowsUpDown$1 = SvgArrowsUpDown;

const SvgAtbIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#atb_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.928 76.806c.446.338 1.278.654 2.838.654l17.026-.002c1.4 0 2.595-.187 3.585-.561a6.116 6.116 0 0 0 2.408-1.576 6.299 6.299 0 0 0 1.358-2.426c.298-.998.445-2.036.435-3.078 0-.68-.092-1.355-.272-2.01a5.916 5.916 0 0 0-.85-1.83 5.002 5.002 0 0 0-1.486-1.394 4.858 4.858 0 0 0-2.173-.67v-.072a4.737 4.737 0 0 0 1.848-.761c.5-.354.925-.803 1.25-1.322a5.873 5.873 0 0 0 .724-1.738 8.281 8.281 0 0 0 .236-1.974c0-1.956-.573-3.52-1.72-4.69-1.148-1.17-2.929-1.756-5.342-1.756h-10.15l.01 21.512H58.72c-.531 0-.923-.115-1.177-.344-.253-.229-.38-.621-.38-1.177v-9.344h2.572v-4.382h-2.572v-5.759h-6.52v5.759h-6.54L42.567 51.6H34.09L27.9 77.458h7.061l.688-4.527h5.36l.689 4.527h7.17l-3.715-15.21h5.49v10.43a9.15 9.15 0 0 0 .307 2.625c.158.592.5 1.119.979 1.503ZM36.446 67.86l1.846-10.974h.073l1.847 10.974h-3.767Zm34.433-6.304a1.818 1.818 0 0 1-.898.182h-1.63v-5.287h1.63a1.807 1.807 0 0 1 1.593.797c.37.557.56 1.214.543 1.883a3.112 3.112 0 0 1-.543 1.828c-.177.255-.416.46-.695.597Zm.273 10.839c-.288.134-.6.205-.918.208h-1.883v-6.301h1.883a2.2 2.2 0 0 1 1.666.797c.483.53.724 1.304.724 2.318 0 1.086-.241 1.889-.724 2.407-.206.242-.46.436-.748.57Z",
    fill: "#37424A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.152 17A4.853 4.853 0 0 1 89 21.848v60.285a4.853 4.853 0 0 1-4.848 4.848H23.867a4.852 4.852 0 0 1-4.848-4.847L19 36.294A19.296 19.296 0 0 1 38.273 17.02l45.88-.02Zm0 3.817-45.878.02a15.457 15.457 0 0 0-15.457 15.457l.003 7.089a34.64 34.64 0 0 1 2.433-1.703l.147-.097a25.557 25.557 0 0 1 4.883-2.586c5.375-2.172 11.575-2.832 18.14-3.53h.002c1.351-.144 2.747-.293 4.16-.458 6.252-.73 15.29-2.242 22.848-5.295l.342-.177c4.447-2.093 7.575-4.737 8.985-8.52-.176-.13-.389-.2-.608-.2ZM23.867 83.163h60.285a1.03 1.03 0 0 0 1.031-1.03V31.518a32.547 32.547 0 0 1-7.361 4.107c-8.217 3.32-17.856 4.94-24.497 5.716-1.337.156-2.644.296-3.913.431l-.316.034c-6.109.65-11.877 1.264-16.425 3.102-1.3.515-2.54 1.17-3.7 1.954l-.04.029-.237.155c-2.29 1.454-4.338 3.276-5.87 4.804l.012 30.283a1.032 1.032 0 0 0 1.03 1.03Z",
    fill: "#37424A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "atb_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4455_2528"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4455_2528",
    result: "shape"
  }))));
};
var SvgAtbIcon$1 = SvgAtbIcon;

const SvgAvinorAppOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 20.713 32.744",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 19.213,
    height: 31.244,
    rx: 2.174
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 4.714h19.213M.75 25.793h19.213M7.231 28.786h5.767"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.451,
    cy: 20.592,
    r: 1.63
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.262,
    cy: 9.915,
    r: 1.63
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.995 19.055 2.724-7.602"
  })));
};
var SvgAvinorAppOutlined$1 = SvgAvinorAppOutlined;

const SvgBabyBottleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.141 33.123",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.896,
    y: 8.649,
    width: 17.283,
    height: 4.447,
    rx: 2.224,
    transform: "rotate(45 22.538 10.872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.057 14.037a7.108 7.108 0 0 0 .9-7.051L31.6 5.341a2.689 2.689 0 0 0 0-3.8h0a2.689 2.689 0 0 0-3.8 0l-1.645 1.642a7.109 7.109 0 0 0-7.221 1.035M15.836 7.317l9.97 9.97h0L11.793 31.302a3.658 3.658 0 0 1-5.173 0L1.82 26.504a3.658 3.658 0 0 1 0-5.173L15.836 7.316h0ZM15.136 15.462l-3.723-3.723M7.492 23.107l-3.723-3.723M9.844 17.686l-2.189-2.188"
  })));
};
var SvgBabyBottleOutlined$1 = SvgBabyBottleOutlined;

const SvgBabyFullOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 20.196 31.157",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.971 5.684a4.935 4.935 0 1 1-9.869 0M5.1 5.684a4.935 4.935 0 0 1 9.869 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 3.531a1.656 1.656 0 0 1-2.872-1.125M8.328 2.406A1.656 1.656 0 0 1 9.984.75M7.893 10.367a5.531 5.531 0 0 0-3.626 2.1L1.1 16.586a1.66 1.66 0 0 0 .239 2.277h0a1.659 1.659 0 0 0 2.39-.251l3.307-4.291v6.354l-3.097 3.093a2.173 2.173 0 0 0-.539 2.184l.984 3.159A1.844 1.844 0 0 0 6.769 30.3h0a1.845 1.845 0 0 0 1.143-2.26l-.706-2.381 5.959-4.984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.185 10.352a5.533 5.533 0 0 1 3.745 2.119l3.17 4.115a1.659 1.659 0 0 1-.239 2.277h0a1.659 1.659 0 0 1-2.39-.251l-3.307-4.291v6.354l3.093 3.093a2.175 2.175 0 0 1 .538 2.184l-.984 3.159a1.844 1.844 0 0 1-2.384 1.189h0a1.843 1.843 0 0 1-1.142-2.258l.705-2.381-5.959-4.986M7.031 18.419h6.134"
  })));
};
var SvgBabyFullOutlined$1 = SvgBabyFullOutlined;

const SvgBabyOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 20.948 26.738",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.639 15.541a9.192 9.192 0 0 0-6.353 8.742v1.7h18.376v-1.7a9.192 9.192 0 0 0-6.353-8.742"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.093 8.369a7.619 7.619 0 0 1-15.237 0M2.856 8.369a7.619 7.619 0 1 1 15.237 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.864 3.967a2.558 2.558 0 0 1-5.028-.66M7.836 3.307A2.557 2.557 0 0 1 10.393.75M18.006 7.218a2.39 2.39 0 0 1-.2 4.772h-.629M2.942 7.218a2.39 2.39 0 0 0 .2 4.772h.63"
  })));
};
var SvgBabyOutlined$1 = SvgBabyOutlined;

const SvgBadgePercentOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.604 36.137",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3 35.387c-1.733 0-3.012-2.731-4.576-3.238-1.62-.526-4.257.913-5.6-.069s-.8-3.95-1.8-5.312-3.973-1.726-4.5-3.346C.319 21.859 2.5 19.8 2.5 18.069S.319 14.279.827 12.715c.526-1.62 3.518-2 4.5-3.346s.433-4.321 1.8-5.312 3.985.458 5.605-.068C14.29 3.481 15.569.75 17.3.75s3.012 2.731 4.575 3.239c1.62.526 4.257-.913 5.606.068s.8 3.951 1.794 5.313 3.974 1.726 4.5 3.346c.508 1.563-1.675 3.62-1.675 5.353s2.183 3.79 1.675 5.353c-.526 1.62-3.518 2-4.5 3.346s-.432 4.321-1.794 5.312-3.986-.457-5.606.069c-1.561.507-2.841 3.238-4.575 3.238ZM24.217 11.114 10.2 25.131"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.782,
    cy: 12.539,
    r: 2.805
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.867,
    cy: 23.743,
    r: 2.805
  })));
};
var SvgBadgePercentOutlined$1 = SvgBadgePercentOutlined;

const SvgBagPointerClickOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.672 32.487",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.081 15.617 8.784 13.32M15.607 15.002v-3.249M10.484 20.125H7.235M23.144 21.418l-9.481-3.23a.009.009 0 0 0-.011.011l3.229 9.482a.038.038 0 0 0 .063.014l2.067-2.067h.012l2.565 2.565a.1.1 0 0 0 .146 0l1.923-1.922a.105.105 0 0 0 0-.147l-2.565-2.565v-.012l2.067-2.067a.038.038 0 0 0-.015-.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.087 31.737H3.585A2.835 2.835 0 0 1 .794 28.41l3.224-18.262a2.153 2.153 0 0 1 2.121-1.779h18.394a2.153 2.153 0 0 1 2.121 1.779l3.224 18.262a2.834 2.834 0 0 1-2.791 3.327Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.336.75h0a5.35 5.35 0 0 1 5.35 5.35v2.269h0-10.7 0V6.1a5.35 5.35 0 0 1 5.35-5.35Z"
  })));
};
var SvgBagPointerClickOutlined$1 = SvgBagPointerClickOutlined;

const SvgBagSuitcaseClaimOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 47.404 36.444",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 35.694V32.49h45.904v3.204M5.85 32.49v3.204M10.951 32.49v3.204M16.051 32.49v3.204M21.152 32.49v3.204M31.353 32.49v3.204M36.453 32.49v3.204M41.553 32.49v3.204M26.252 32.49v3.204"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.323,
    y: 12.925,
    width: 23.212,
    height: 15.891,
    rx: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.467 12.925h14.924v15.891H7.467zM11.633 12.925v-2.6a.73.73 0 0 1 .73-.73H17.5a.73.73 0 0 1 .73.73v2.6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.168,
    y: 6.694,
    width: 13.913,
    height: 22.122,
    rx: 1.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.868.75h4.512v5.944h-4.512zM33.887 10.622h6.475M38.432 15.249h-2.615a2.055 2.055 0 0 0-1.93 2.16v11.407h6.475V17.409a2.055 2.055 0 0 0-1.93-2.16Z"
  })));
};
var SvgBagSuitcaseClaimOutlined$1 = SvgBagSuitcaseClaimOutlined;

const SvgBagsShoppingOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 37.742 34.373",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.086 33.623H15.631a1.905 1.905 0 0 1-1.9-2.058l1.018-12.735a2.063 2.063 0 0 1 2.056-1.9h17.108a2.062 2.062 0 0 1 2.055 1.9l1.018 12.735a1.907 1.907 0 0 1-1.9 2.058ZM14.946.75h0a5.207 5.207 0 0 1 5.207 5.207v2.208h0H9.739h0V5.957A5.207 5.207 0 0 1 14.946.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.151 21.636v2.207a5.208 5.208 0 0 0 5.208 5.208h0a5.208 5.208 0 0 0 5.207-5.208v-2.207"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.784 30.908H3.509A2.758 2.758 0 0 1 .793 27.67L3.93 9.9A2.1 2.1 0 0 1 6 8.165h17.9A2.1 2.1 0 0 1 25.962 9.9l1.238 7.032"
  })));
};
var SvgBagsShoppingOutlined$1 = SvgBagsShoppingOutlined;

const SvgBankOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.447 36.406",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 31.65h31.947v4.006H.75zM19.111 31.65h-4.775l.461-13.14h3.853l.461 13.14zM30.788 31.65h-4.775l.462-13.14h3.852l.461 13.14zM7.433 31.65H2.659l.461-13.14h3.852l.461 13.14zM9.977 15.7H23.47"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.723,
    cy: 8.191,
    r: 7.441
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.52 10.133.75 14.218h0v4.006h31.947v-4.006h0l-8.77-4.085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.325 10.662a1.631 1.631 0 1 0 1.4-2.471 1.631 1.631 0 1 1 1.486-2.305M16.723 4.929V3.773M16.723 11.453v1.156"
  })));
};
var SvgBankOutlined$1 = SvgBankOutlined;

const SvgBarsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 21.334 16.252",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75.75h19.834M.75 10.585h19.834M.75 15.502h19.834M.75 5.667h19.834"
  })));
};
var SvgBarsOutlined$1 = SvgBarsOutlined;

const SvgBellOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.872 31.297",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.748 24.258 25.786 22.3a6.181 6.181 0 0 1-1.811-4.37v-4.689a9.543 9.543 0 0 0-5.892-8.816C17.676 2.315 16.2.75 14.436.75S11.2 2.315 10.789 4.425A9.541 9.541 0 0 0 4.9 13.241v4.684A6.181 6.181 0 0 1 3.086 22.3l-1.962 1.958a1.268 1.268 0 0 0 .9 2.164h24.828a1.268 1.268 0 0 0 .896-2.164Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.588 26.422a4.125 4.125 0 0 1-8.25 0"
  })));
};
var SvgBellOutlined$1 = SvgBellOutlined;

const SvgBicycleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.671 21.024",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.813,
    cy: 14.211,
    r: 6.063
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.858,
    cy: 14.211,
    r: 6.063
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.292 14.211H6.813l5.827-9.277h11.037a.333.333 0 0 1 .251.552ZM11.115 1.778l5.177 12.433M27.858 14.211 22.681 1.778 25.439.75M14.023 1.778H9.626"
  })));
};
var SvgBicycleOutlined$1 = SvgBicycleOutlined;

const SvgBinOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.483 32.515",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 4.047,
    width: 22.983,
    height: 4.156,
    rx: 0.934
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.762 4.047V1.829A1.078 1.078 0 0 1 9.84.75h4.8a1.079 1.079 0 0 1 1.079 1.079v2.218M2.508 8.2h19.467v20.39a3.171 3.171 0 0 1-3.175 3.175H5.68a3.171 3.171 0 0 1-3.171-3.171V8.2h-.001ZM7.333 27.407V12.491M12.242 27.407V12.491M17.151 27.407V12.491"
  })));
};
var SvgBinOutlined$1 = SvgBinOutlined;

const SvgBinocularsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.746 23.417",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.208,
    cy: 17.209,
    r: 2.803
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.538,
    cy: 17.209,
    r: 2.803
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.208,
    cy: 17.209,
    r: 5.458
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.669 3.935.437-1.487A2.365 2.365 0 0 1 8.614.762h0a2.365 2.365 0 0 1 2.125 2.353v1.641"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.538,
    cy: 17.209,
    r: 5.458
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.077 3.935-.437-1.487A2.365 2.365 0 0 0 19.133.762h0a2.365 2.365 0 0 0-2.126 2.353v1.641"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.745 15.569-2.966-9.454a3.939 3.939 0 0 0-4.105-2.745h0A3.94 3.94 0 0 0 16.08 7.3h-4.414a3.94 3.94 0 0 0-3.594-3.93h0a3.941 3.941 0 0 0-4.1 2.745L1 15.569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.666 17.209v-5.91h4.414v5.91"
  })));
};
var SvgBinocularsOutlined$1 = SvgBinocularsOutlined;

const SvgBoardingCard = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.938 18.73a.75.75 0 0 1 .75.75v1.252a.75.75 0 0 1-1.5 0V19.48a.75.75 0 0 1 .75-.75ZM13.688 24.225a.75.75 0 0 0-1.5 0v1.253a.75.75 0 0 0 1.5 0v-1.253ZM12.938 28.221a.75.75 0 0 1 .75.75v1.253a.75.75 0 0 1-1.5 0v-1.253a.75.75 0 0 1 .75-.75ZM37.218 29.066l-1 1-2.656-5.038-2.547 2.547.171 1.812-.85.85-1.178-2.266-2.265-1.178.85-.85 1.774.134 2.547-2.548-5.039-2.655 1-1 6.306 1.39 2.66-2.66c.2-.201.471-.314.754-.316a1.054 1.054 0 0 1 .976 1.467c-.054.13-.133.247-.233.347l-2.66 2.66 1.39 6.304Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85 13.25c-.674 0-1.33.251-1.82.712a2.437 2.437 0 0 0-.78 1.775v5.82c0 .414.336.75.75.75h.704a2.6 2.6 0 0 1 1.778.688c.463.434.713 1.013.713 1.606 0 .593-.25 1.171-.713 1.606a2.6 2.6 0 0 1-1.778.688H5a.75.75 0 0 0-.75.75v5.618c0 .675.287 1.313.78 1.775.49.46 1.146.712 1.82.712h33.3c.674 0 1.33-.251 1.82-.712.493-.462.78-1.1.78-1.775V15.737c0-.675-.287-1.313-.78-1.775a2.663 2.663 0 0 0-1.82-.712H6.85Zm-.794 1.806c.203-.191.488-.306.795-.306h5.442a.747.747 0 0 0-.043.25v1.252a.75.75 0 0 0 1.5 0V15a.747.747 0 0 0-.043-.25H40.15c.307 0 .592.115.795.306.202.189.306.436.306.682v17.524a.937.937 0 0 1-.306.682c-.203.191-.488.306-.795.306H13.687v-.533a.75.75 0 0 0-1.5 0v.533H6.851c-.307 0-.592-.115-.795-.306a.937.937 0 0 1-.306-.682v-4.867A4.098 4.098 0 0 0 8.51 27.3a3.703 3.703 0 0 0 1.185-2.7 3.703 3.703 0 0 0-1.186-2.698 4.098 4.098 0 0 0-2.759-1.095v-5.07c0-.246.104-.492.306-.681Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgBoardingCard$1 = SvgBoardingCard;

const SvgBookFrontOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.776 32.709",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.855,
    y: 0.75,
    width: 23.171,
    height: 31.209,
    rx: 0.769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.653 31.959H1.494a.744.744 0 0 1-.744-.745V1.494A.744.744 0 0 1 1.494.75h20.159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.207 9.97h14.467v4.013H8.207zM11.703 16.675h6.983v2.209h-6.983z"
  })));
};
var SvgBookFrontOutlined$1 = SvgBookFrontOutlined;

const SvgBookOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.695 27.695",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.347 26.945h0a13 13 0 0 0-15.6 0h0V4.251h0a10.436 10.436 0 0 1 15.6 0h0ZM16.347 26.945h0a13.005 13.005 0 0 1 15.6 0h0V4.251h0a10.437 10.437 0 0 0-15.6 0h0Z"
  })));
};
var SvgBookOutlined$1 = SvgBookOutlined;

const SvgBookPersonOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.333 34.216",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.005,
    y: 0.75,
    width: 25.579,
    height: 32.716,
    rx: 0.806
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.951 33.466H1.53a.78.78 0 0 1-.78-.78V1.53a.78.78 0 0 1 .78-.78h22.421"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.794,
    cy: 12.74,
    r: 4.403
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.747 16.638a6.638 6.638 0 0 0-4.587 6.313v2.928h13.268v-2.928a6.638 6.638 0 0 0-4.587-6.313"
  })));
};
var SvgBookPersonOutlined$1 = SvgBookPersonOutlined;

const SvgBookTextFlatOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.695 27.695",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.347 26.945h0a13 13 0 0 0-15.6 0h0V4.251h0a10.436 10.436 0 0 1 15.6 0h0ZM16.347 26.945h0a13.005 13.005 0 0 1 15.6 0h0V4.251h0a10.437 10.437 0 0 0-15.6 0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.394 7.8a10.492 10.492 0 0 0-8.442-.024M28.394 11.579a10.488 10.488 0 0 0-8.442-.024M12.77 7.8a10.492 10.492 0 0 0-8.442-.024M12.77 11.579a10.488 10.488 0 0 0-8.442-.024M28.394 15.362a10.484 10.484 0 0 0-8.442-.024M12.77 15.362a10.484 10.484 0 0 0-8.442-.024M28.394 19.145a10.484 10.484 0 0 0-8.442-.024M12.77 19.145a10.484 10.484 0 0 0-8.442-.024"
  })));
};
var SvgBookTextFlatOutlined$1 = SvgBookTextFlatOutlined;

const SvgBookTextOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.204 27.662",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.021 21.932-2.837-.032a12.2 12.2 0 0 0-8.176 3.009L16.1 26.57V5.954l1.923-1.909a11.352 11.352 0 0 1 8.42-3.287l2.578.095Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 26.57a17.27 17.27 0 0 1 7.871-2.117 13.444 13.444 0 0 1 7.481 2.459V5.987a12.194 12.194 0 0 0-2.433-1.381M3.182 21.932 6.02 21.9a12.206 12.206 0 0 1 8.18 3.006l1.9 1.664V5.954l-1.921-1.909A11.356 11.356 0 0 0 5.76.758L3.182.853Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1 26.57a17.272 17.272 0 0 0-7.87-2.117 13.443 13.443 0 0 0-7.48 2.459V5.987a12.2 12.2 0 0 1 2.432-1.381M13.332 7.294A11.207 11.207 0 0 0 5.76 4.952"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.332 11.337A11.207 11.207 0 0 0 5.76 8.995M13.332 15.381a11.207 11.207 0 0 0-7.572-2.342M13.332 19.424a11.2 11.2 0 0 0-7.572-2.341M18.872 7.294a11.2 11.2 0 0 1 7.571-2.342M18.872 11.337a11.2 11.2 0 0 1 7.571-2.342M18.872 15.381a11.2 11.2 0 0 1 7.571-2.342M18.872 19.424a11.2 11.2 0 0 1 7.571-2.341"
  })));
};
var SvgBookTextOutlined$1 = SvgBookTextOutlined;

const SvgBookmarkOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.128 31.206",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.564 21.962 7.8 7.8a2.351 2.351 0 0 0 4.014-1.662V5.714A4.963 4.963 0 0 0 19.414.75h-13.7A4.963 4.963 0 0 0 .75 5.714V28.1a2.351 2.351 0 0 0 4.013 1.663Z",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }));
};
var SvgBookmarkOutlined$1 = SvgBookmarkOutlined;

const SvgBooksOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.941 27.747",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 2.6h7.02v24.397H.75zM7.77 3.862h4.082v23.135H7.77zM11.852.75h6.226v26.247h-6.226z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.077 9.506 3.754-1.82 8.359 17.239-3.754 1.82zM12.272 5.519h5.386M12.272 8.684h5.386M1.567 6.953h5.386M1.567 10.118h5.386M14.266 20.649h1.398M14.266 22.735h1.398M3.561 20.649h1.398M3.561 22.735h1.398M10.455 22.179h1.397M10.455 8.057h1.397"
  })));
};
var SvgBooksOutlined$1 = SvgBooksOutlined;

const SvgBottlePlasticOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.447 32.447",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.472.989 2.987 2.986a.815.815 0 0 1 0 1.153l-1.867 1.866h0l-4.138-4.139h0L27.319.99a.815.815 0 0 1 1.153 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.881 15.329C28.623 12.586 29.122 9.611 28 7.29l.945-.945L26.1 3.5l-.945.945c-2.321-1.123-5.3-.625-8.038 2.117s-2.632 4.208-4.02 5.6-2.35.774-3.816 2.24L1.4 22.288a2.21 2.21 0 0 0 0 3.125l5.634 5.637a2.21 2.21 0 0 0 3.125 0l7.887-7.886c1.465-1.466.851-2.427 2.239-3.816s2.851-1.275 5.596-4.019ZM8.744 14.942l8.762 8.762M2.496 21.189l8.762 8.762"
  })));
};
var SvgBottlePlasticOutlined$1 = SvgBottlePlasticOutlined;

const SvgBoxArrowOutRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.529 32.508",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25 9.474 6.778 6.779v.002L25 23.034M11.31 16.254h20.469M20.758 21.255v8.2a2.3 2.3 0 0 1-2.3 2.3H3.05a2.3 2.3 0 0 1-2.3-2.3V3.05a2.3 2.3 0 0 1 2.3-2.3h15.408a2.3 2.3 0 0 1 2.3 2.3v8.2"
  })));
};
var SvgBoxArrowOutRightOutlined$1 = SvgBoxArrowOutRightOutlined;

const SvgBoxClosedOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.485 27.485",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.433.75h20.619a2.683 2.683 0 0 1 2.683 2.683v22.7a.6.6 0 0 1-.6.6H1.348a.6.6 0 0 1-.6-.6v-22.7A2.683 2.683 0 0 1 3.433.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.162.75h5.161v9.378h-5.161zM16.323 6.445h10.412M.75 6.445h10.412M22.641 21.573h-4.509"
  })));
};
var SvgBoxClosedOutlined$1 = SvgBoxClosedOutlined;

const SvgBritishAirwaysIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#british_airways_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#004578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.716 62.84-.063.496h-.005l-.014-.002-.055-.008a50.836 50.836 0 0 1-1.027-.154 84.734 84.734 0 0 1-3.054-.552 117.764 117.764 0 0 1-10.641-2.656.5.5 0 0 1-.002-.957l.145.478-.145-.478.003-.001.01-.003.034-.01.136-.042.5-.152c.423-.128 1.009-.307 1.66-.507 1.302-.4 2.86-.883 3.898-1.22l.853-.275c1.493-.481 2.956-.952 5.715-1.989 1.2-.45 3.008-1.15 4.794-2.015 1.791-.868 3.51-1.878 4.58-2.935l.169-.19a.5.5 0 0 1 .47-.158l-.097.49.097-.49h.004l.01.002.035.007a16.173 16.173 0 0 1 .566.124c.342.08.782.192 1.129.312h.001c.974.343 1.612.678 2.055.97.334.22.57.43.707.55l.09.079c.545.438.865 1.085.95 1.317l.002.005a3.31 3.31 0 0 1 .122.462l.007.035v.002a1.118 1.118 0 0 1 .018.09c.01.056.019.132.023.221a3.24 3.24 0 0 1 .013.273v.03h-.5.5c0 .231-.039.46-.054.55l-.004.023-.002.01c-.233 1.25-1.148 2.19-1.487 2.496-.903.84-2.144 1.695-4.59 2.938a58.442 58.442 0 0 1-5.388 2.559c-.642.262-1.144.45-1.487.572a19.858 19.858 0 0 1-.495.169l-.027.008-.007.003h-.003l-.148-.477Zm0 0-.063.496c.071.01.143.003.211-.018l-.148-.478Z",
    fill: "#fff",
    stroke: "#004578",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.027 53.597a.5.5 0 0 1-.527-.47v-.006l-.002-.022a1.5 1.5 0 0 0-.051-.306l-.005-.016a1.209 1.209 0 0 0-.178-.38 4.116 4.116 0 0 0-.569-.669 5.185 5.185 0 0 0-.688-.536c-1.094-.715-2.534-1.133-3.834-1.311-1.727-.23-3.649-.23-4.378-.23-.13 0-.223 0-.27-.002-.774-.01-5.718.03-6.994.053l-.01-.5c-5.672.117-12.616.133-14.435.133l31.94 4.262Zm0 0a.5.5 0 0 0 .471-.526l-.499.027.5-.027v-.002l-.001-.004v-.011l-.013-.212v-.004a4.467 4.467 0 0 0-.177-.96c-.046-.143-.115-.361-.252-.683l-.001-.002c-.15-.347-.311-.716-.495-1.075-.17-.341-.646-1.294-1.64-2.8a27.017 27.017 0 0 0-.79-1.158l-.005-.007a7.762 7.762 0 0 0-.49-.593c-.762-.988-2.218-1.888-3.864-2.497a21.13 21.13 0 0 0-3.629-.98 36.843 36.843 0 0 0-4.35-.476c-2.727-.158-6.123-.128-10.88.006-4.507.12-21.535.8-35.45 1.356-8.53.341-15.89.636-18.48.725a.5.5 0 0 0-.143.973l.161-.473-.16.473.003.002.01.003.04.013.152.05c.135.044.336.108.6.19a77.64 77.64 0 0 0 2.338.674 131.51 131.51 0 0 0 8.953 2.083c9.15 1.835 17.37 2.238 36.15 2.153l31.94 3.762Zm-3.773-7.712s.2.204.47.567l-.47-.567Zm0 0c-.674-.888-2.038-1.754-3.656-2.353a20.617 20.617 0 0 0-3.54-.955l7.196 3.308Z",
    fill: "#D12600",
    stroke: "#004578",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "british_airways_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25841"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25841",
    result: "shape"
  }))));
};
var SvgBritishAirwaysIcon$1 = SvgBritishAirwaysIcon;

const SvgBuildingColumnsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.772 34.217",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.182 14.157a8.329 8.329 0 0 1 16.472-.013M17.386.75v6.312M17.386 4.487h1.05c.636 0 1-.62 2.021-.62a1.743 1.743 0 0 1 1.12.248.035.035 0 0 0 .057-.027V1.06s-.159-.31-1.177-.31-1.385.621-2.021.621h-1.05M.75 14.157h33.272v4.212H.75zM.75 29.256h33.272v4.212H.75zM3.131 18.369v10.887M7.883 18.369v10.887M12.634 18.369v10.887M17.386 18.369v10.887M22.137 18.369v10.887M31.64 18.369v10.887M26.889 18.369v10.887"
  })));
};
var SvgBuildingColumnsOutlined$1 = SvgBuildingColumnsOutlined;

const SvgBurgerDrinkOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.141 39.382",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.367,
    y: 15.585,
    width: 17.023,
    height: 3.9,
    rx: 1.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.918 8.983.51-3.378a1.731 1.731 0 0 1 .6-1.067L27.52.75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 34.835,
    width: 17.847,
    height: 3.797,
    rx: 1.899
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 31.753,
    width: 17.847,
    height: 3.082,
    rx: 1.541
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.063 31.753a1.546 1.546 0 0 0 1.537-1.706C18.167 25.966 14.744 23 9.681 23c-5.013 0-8.474 2.961-8.919 7.04A1.545 1.545 0 0 0 2.3 31.753Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.431 24.061-.2-4.576H27.52L26.856 34.9a3.2 3.2 0 0 1-3.192 3.058h-5.385M13.955 15.619a6.925 6.925 0 0 1 13.844 0"
  })));
};
var SvgBurgerDrinkOutlined$1 = SvgBurgerDrinkOutlined;

const SvgBusRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.205 20.336",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.602,
    cy: 17.033,
    r: 2.552
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.737,
    cy: 17.033,
    r: 2.552
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.307,
    cy: 17.033,
    r: 2.552
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.281 3.586h5.48v13.106h-5.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.348 3.586h14.934v5.379H4.348zM26.368 3.586h-1.607v6.961h6.474V8.924a2.752 2.752 0 0 0-.621-1.74L28.5 4.594a2.749 2.749 0 0 0-2.132-1.008ZM11.815 3.586v5.342M15.266 16.691h11.512M8.131 16.691h2.077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.836 16.691h.8a1.823 1.823 0 0 0 1.823-1.824v-6.9a2.669 2.669 0 0 0-.622-1.713l-3.81-4.547A2.667 2.667 0 0 0 27.978.75H2.574A1.824 1.824 0 0 0 .75 2.574v12.293a1.824 1.824 0 0 0 1.824 1.824h.5"
  })));
};
var SvgBusRightOutlined$1 = SvgBusRightOutlined;

const SvgBusTaxiOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 39.82 31.851",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M39.07 18.026h-9.967M19.5 9.982h-9.3a4.961 4.961 0 0 0-4.239 2.383l-2.308 3.788h22.4l-2.3-3.788A4.962 4.962 0 0 0 19.5 9.982ZM27.069 16.153H2.538a1.789 1.789 0 0 0 0 3.577h.475v4.711a2.394 2.394 0 0 0 2.393 2.393H24.2a2.394 2.394 0 0 0 2.393-2.393V19.73h.475a1.789 1.789 0 0 0 0-3.577Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.632 26.834v1.958A2.309 2.309 0 0 1 5.323 31.1h0a2.31 2.31 0 0 1-2.31-2.309v-5.006M26.594 23.785v5.007a2.31 2.31 0 0 1-2.31 2.309h0a2.309 2.309 0 0 1-2.309-2.309v-1.958M39.07 21.013v7.779a2.309 2.309 0 0 1-2.309 2.308h0a2.31 2.31 0 0 1-2.31-2.309v-1.957M6.798 21.918h3.64M19.254 21.918h3.639M31.709 21.918h3.639",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.428 5.578A4.828 4.828 0 0 1 20.256.75h13.986a4.828 4.828 0 0 1 4.828 4.828v16.428a4.829 4.829 0 0 1-4.828 4.828h-7.648",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.172 9.835h-9.054l.329-2.847a1.588 1.588 0 0 1 1.562-1.3h5.272a1.586 1.586 0 0 1 1.562 1.3Z",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: props.color || `#1d1d1b`
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.641,
    y: 7.76,
    width: 1.134,
    height: 1.037,
    rx: 0.183
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.86,
    y: 6.723,
    width: 1.134,
    height: 1.037,
    rx: 0.183
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.078,
    y: 7.76,
    width: 1.134,
    height: 1.037,
    rx: 0.183
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.297,
    y: 6.723,
    width: 1.134,
    height: 1.037,
    rx: 0.183
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.516,
    y: 7.76,
    width: 1.134,
    height: 1.037,
    rx: 0.183
  })));
};
var SvgBusTaxiOutlined$1 = SvgBusTaxiOutlined;

const SvgBusTrainOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 39.918 34.442",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 24.94v6.53a2.222 2.222 0 0 0 2.222 2.222h0A2.222 2.222 0 0 0 5.2 31.47v-1.885M23.5 24.94l-.2 6.53a2.222 2.222 0 0 1-2.222 2.222h0a2.222 2.222 0 0 1-2.223-2.222v-1.885M23.501 21.109H.75M16.417 24.855h3.502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 29.585h7.36a4.646 4.646 0 0 0 4.64-4.645V9.13a4.646 4.646 0 0 0-4.646-4.646H5.4A4.646 4.646 0 0 0 .75 9.13v15.809a4.646 4.646 0 0 0 4.65 4.646ZM7.834 24.855H4.332M39.168 17.375H23.501M32.084 21.121h3.503M34.117 25.987l3.954 5.842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.473 25.852h11.049a4.647 4.647 0 0 0 4.646-4.646V5.4A4.646 4.646 0 0 0 34.522.75H21.063a4.649 4.649 0 0 0-4.552 3.71"
  })));
};
var SvgBusTrainOutlined$1 = SvgBusTrainOutlined;

const SvgByBanenIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#by_banen_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#D15700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.555 54.761c-.83.068-1.447.097-2.004.097-2.084 0-2.62-.339-2.62-1.317 0-.887.444-1.161 2.203-1.161h2.421v2.381Zm-2.576-7.792a22.6 22.6 0 0 0-3.762.31l.329 1.746c1.234-.17 2.287-.242 3.126-.242 2.411 0 2.883.361 2.883 1.41v.503h-2.874c-2.964 0-4.238.796-4.238 2.831 0 2.188 1.692 3.133 4.998 3.133.934 0 2.592-.062 4.538-.234v-6.232c0-2.314-1.54-3.225-5-3.225ZM30.624 60.23c-1.225 0-2.471-.117-3.985-.378l.294-1.748c1.12.172 2.453.315 3.58.315 1.247 0 2.043-.063 2.415-.433.4-.401.404-1.033.415-1.584-.546.138-1.503.245-2.136.245-3.31 0-5.304-.798-5.304-4.155v-5.414h2.444v5.386c0 1.552.294 2.404 3.135 2.404.504 0 1.235-.066 1.872-.152v-7.638H35.8v9.1c0 2.834-.954 4.052-5.176 4.052ZM18.448 54.771c-.61 0-1.315-.028-2.048-.076v-5.818c.716-.072 1.45-.112 2.134-.112 2.655 0 3.324.59 3.324 3.002 0 2.415-.692 3.004-3.41 3.004Zm.329-7.824c-.565 0-1.228.03-2.377.097V43H14v13.394c2.23.218 3.668.266 4.49.266 4.15 0 5.836-1.397 5.836-4.928 0-3.477-1.543-4.785-5.549-4.785ZM42.326 54.771c-.608 0-1.312-.028-2.046-.076v-5.818a21.67 21.67 0 0 1 2.135-.112c2.652 0 3.324.59 3.324 3.002 0 2.415-.694 3.004-3.413 3.004Zm.33-7.824c-.565 0-1.226.03-2.376.097V43h-2.402v13.394c2.231.218 3.668.266 4.493.266 4.148 0 5.834-1.397 5.834-4.928 0-3.477-1.542-4.785-5.548-4.785ZM77.837 51.26h-2.45v-2.402a25.846 25.846 0 0 1 2.034-.102c2.073 0 2.606.343 2.606 1.33 0 .897-.44 1.174-2.19 1.174Zm.425 1.673c2.949 0 4.213-.796 4.213-2.83 0-2.19-1.684-3.134-4.975-3.134-.933 0-2.588.089-4.536.274v6.192c0 2.315 1.54 3.225 5 3.225 1.141 0 2.46-.086 3.762-.31l-.33-1.746c-1.234.17-2.286.243-3.125.243-2.412 0-2.883-.363-2.883-1.41v-.504h2.874ZM68.674 56.51h2.4V51c0-2.823-1.532-4.026-5.3-4.026-1.168 0-2.814.097-4.758.306v9.228h2.398v-7.592s1.16-.111 1.964-.111c1.133 0 1.884.072 2.408.376.683.398.888.953.888 2.651v4.676ZM91.602 56.51H94V51c0-2.823-1.53-4.026-5.3-4.026-1.167 0-2.813.097-4.757.306v9.228h2.399v-7.592s1.158-.111 1.964-.111c1.132 0 1.883.072 2.407.376.684.398.889.953.889 2.651v4.676Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "by_banen_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4455_2688"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4455_2688",
    result: "shape"
  }))));
};
var SvgByBanenIcon$1 = SvgByBanenIcon;

const SvgCalendarOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.128 29.406",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 3.52,
    width: 32.628,
    height: 25.135,
    rx: 3.248
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.674.75v5.049M24.453.75v5.049M33.378 8.936H.75M15.307 14.577h3.514M22.283 14.577h3.514M8.33 14.577h3.514M15.307 18.612h3.514M22.283 18.612h3.514M8.33 18.612h3.514M15.307 22.647h3.514M22.283 22.647h3.514M8.33 22.647h3.514"
  })));
};
var SvgCalendarOutlined$1 = SvgCalendarOutlined;

const SvgCameraOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.095 25.406",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: props.color || `#1d1d1b`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.873 25.406H2.223A2.225 2.225 0 0 1 0 23.184V6.232a2.225 2.225 0 0 1 2.223-2.223h27.65A2.225 2.225 0 0 1 32.1 6.232v16.952a2.225 2.225 0 0 1-2.227 2.222ZM2.223 5.509a.723.723 0 0 0-.723.723v16.952a.723.723 0 0 0 .723.722h27.65a.723.723 0 0 0 .722-.722V6.232a.723.723 0 0 0-.722-.723Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.189 25.406a9.323 9.323 0 1 1 9.322-9.322 9.333 9.333 0 0 1-9.322 9.322Zm0-17.145a7.823 7.823 0 1 0 7.822 7.823 7.832 7.832 0 0 0-7.822-7.823Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.189 22.169a6.086 6.086 0 1 1 6.085-6.085 6.092 6.092 0 0 1-6.085 6.085Zm0-10.671a4.586 4.586 0 1 0 4.585 4.586 4.591 4.591 0 0 0-4.585-4.584ZM10.853 10.112H.75a.75.75 0 0 1 0-1.5h10.1a.75.75 0 0 1 0 1.5ZM31.345 10.112h-9.821a.75.75 0 0 1 0-1.5h9.821a.75.75 0 0 1 0 1.5ZM21.508 5.509H10.917a.75.75 0 0 1-.712-.984l1.053-3.211A1.905 1.905 0 0 1 13.072 0h6.281a1.905 1.905 0 0 1 1.814 1.314l1.054 3.211a.751.751 0 0 1-.713.984Zm-9.555-1.5h8.52l-.731-2.227a.408.408 0 0 0-.389-.282h-6.281a.409.409 0 0 0-.389.282ZM8.33 5.509H5.508a.75.75 0 0 1-.75-.75V1.938a.75.75 0 0 1 .75-.75H8.33a.75.75 0 0 1 .75.75v2.821a.75.75 0 0 1-.75.75Zm-2.072-1.5H7.58V2.688H6.258Z"
  })));
};
var SvgCameraOutlined$1 = SvgCameraOutlined;

const SvgCameraSurveillanceOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.162 26.837",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 18.231h3.324v7.856H.75zM12.478 20.537 10.143 18.8l-1.694 2.271H4.074v2.768h4.76a2.359 2.359 0 0 0 1.891-.949Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.454 14.006 5.24 3.905h0l-1.697 2.277a1.785 1.785 0 0 1-2.498.365l-2.377-1.772a1.785 1.785 0 0 1-.365-2.498l1.697-2.277h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.631 10.211h0L14.743 1.352a3.041 3.041 0 0 0-3.906.23L6.376 5.8a3.041 3.041 0 0 0 .273 4.646l16.22 12.087 4.137-5.551 5.406-2.465Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.886 15.664c.013.151.02.3.02.458a5.081 5.081 0 0 1-5.979 5M27.006 16.985 8.854 3.459"
  })));
};
var SvgCameraSurveillanceOutlined$1 = SvgCameraSurveillanceOutlined;

const SvgCarBusOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 38.377 30.709",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.627 17.375h-9.592M18.8 9.634H9.841a4.775 4.775 0 0 0-4.079 2.293l-2.219 3.646H25.1l-2.219-3.646A4.775 4.775 0 0 0 18.8 9.634ZM26.078 15.573H2.471a1.721 1.721 0 1 0 0 3.442h.457v4.534a2.3 2.3 0 0 0 2.3 2.3h18.09a2.3 2.3 0 0 0 2.3-2.3v-4.534h.457a1.721 1.721 0 0 0 0-3.442Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.373 25.852v1.884a2.223 2.223 0 0 1-2.223 2.223h0a2.222 2.222 0 0 1-2.222-2.223v-4.818M25.621 22.918v4.818a2.223 2.223 0 0 1-2.221 2.223h0a2.222 2.222 0 0 1-2.222-2.223v-1.884M37.627 21.206v6.53a2.222 2.222 0 0 1-2.222 2.223h0a2.222 2.222 0 0 1-2.222-2.223v-1.884M6.571 21.121h3.502M18.557 21.121h3.503M30.543 21.121h3.502"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.876 9.634V5.4A4.646 4.646 0 0 1 19.522.75h13.459a4.646 4.646 0 0 1 4.646 4.65v15.81a4.647 4.647 0 0 1-4.646 4.646h-7.36"
  })));
};
var SvgCarBusOutlined$1 = SvgCarBusOutlined;

const SvgCarKeyOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.117 35.729",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.125 8.442h11.68l1.861-1.7L23.5 4.069h-3.374l-1.26-.926-1.544.926L16.161 2.9l-1.23 1.173h-2.845a5.551 5.551 0 1 0 .039 4.373ZM3.937 6.3a1.906 1.906 0 1 1 1.906 1.907A1.906 1.906 0 0 1 3.937 6.3ZM22.127 6.301h-9.523M17.843 15.73H9.36A4.521 4.521 0 0 0 5.5 17.9l-2.1 3.454h20.407l-2.1-3.452a4.521 4.521 0 0 0-3.864-2.172ZM24.737 21.354H2.38a1.63 1.63 0 1 0 0 3.26h.433v4.294a2.181 2.181 0 0 0 2.181 2.181h17.13a2.181 2.181 0 0 0 2.18-2.181v-4.294h.433a1.63 1.63 0 1 0 0-3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.022 31.089v1.785a2.105 2.105 0 0 1-2.105 2.1h0a2.1 2.1 0 0 1-2.1-2.1V28.31M24.3 28.31v4.564a2.1 2.1 0 0 1-2.1 2.1h0a2.105 2.105 0 0 1-2.105-2.1v-1.785M6.263 26.609H9.58M17.615 26.609h3.317"
  })));
};
var SvgCarKeyOutlined$1 = SvgCarKeyOutlined;

const SvgCarOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.031 25.944",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.684.75a5.741 5.741 0 0 0-4.906 2.758L4.109 7.892H30.03l-2.668-4.384A5.743 5.743 0 0 0 22.456.75ZM31.211 7.892H2.82a2.07 2.07 0 0 0 0 4.14h.55v5.453a2.769 2.769 0 0 0 2.769 2.769h21.753a2.77 2.77 0 0 0 2.77-2.769v-5.453h.549a2.07 2.07 0 1 0 0-4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.715 20.254v2.267a2.673 2.673 0 0 1-2.673 2.673h0a2.672 2.672 0 0 1-2.672-2.673v-5.8M30.662 16.726v5.8a2.673 2.673 0 0 1-2.673 2.673h0a2.673 2.673 0 0 1-2.673-2.673v-2.272M7.75 14.565h4.213M22.167 14.565h4.212"
  })));
};
var SvgCarOutlined$1 = SvgCarOutlined;

const SvgCarRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 42.504 18.111",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.754,
    cy: 13.319,
    r: 4.042
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.754,
    cy: 13.319,
    r: 1.684
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.147,
    cy: 13.319,
    r: 4.042
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.147,
    cy: 13.319,
    r: 1.684
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.796 13.319h18.309M39.189 13.319h1.375a1.19 1.19 0 0 0 1.19-1.191v-3.09c0-1.693-2.916-3.112-6.178-3.714s-21.137-.355-21.137-.355M12.796 1.565l4.343 8.864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.712 13.319H3.164a1.27 1.27 0 0 1-.9-.372L1.122 11.8a1.27 1.27 0 0 1-.372-.9V6.27a1.436 1.436 0 0 1 1.174-1.413l3.107-.579A34.26 34.26 0 0 1 19.586.75c7.977 0 11.666 4.275 11.666 4.275M2.248 7.034H.75M18.194 7.034h1.197M37.435 5.769l1.754 3.269h2.565"
  })));
};
var SvgCarRightOutlined$1 = SvgCarRightOutlined;

const SvgCarTrainOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 38.377 32.579",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.627 17.375h-9.592M18.8 9.634H9.841a4.775 4.775 0 0 0-4.079 2.293l-2.219 3.646H25.1l-2.219-3.646A4.775 4.775 0 0 0 18.8 9.634ZM26.078 15.573H2.471a1.721 1.721 0 1 0 0 3.442h.457v4.534a2.3 2.3 0 0 0 2.3 2.3h18.09a2.3 2.3 0 0 0 2.3-2.3v-4.534h.457a1.721 1.721 0 0 0 0-3.442Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.373 25.852v1.884a2.223 2.223 0 0 1-2.223 2.223h0a2.222 2.222 0 0 1-2.222-2.223v-4.818M25.621 22.918v4.818a2.223 2.223 0 0 1-2.221 2.223h0a2.222 2.222 0 0 1-2.222-2.223v-1.884M6.571 21.121h3.502M18.557 21.121h3.503M30.543 21.121h3.502M32.576 25.987l3.954 5.842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.876 9.634V5.4A4.646 4.646 0 0 1 19.522.75h13.459a4.646 4.646 0 0 1 4.646 4.65v15.81a4.647 4.647 0 0 1-4.646 4.646h-7.36"
  })));
};
var SvgCarTrainOutlined$1 = SvgCarTrainOutlined;

const SvgCardOverview = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 10.5c0-.966.784-1.75 1.75-1.75h10c.966 0 1.75.784 1.75 1.75v10a1.75 1.75 0 0 1-1.75 1.75h-10a1.75 1.75 0 0 1-1.75-1.75v-10Zm1.75-.25a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-10a.25.25 0 0 0-.25-.25h-10ZM25.75 10.5c0-.966.784-1.75 1.75-1.75h10c.967 0 1.75.784 1.75 1.75v10a1.75 1.75 0 0 1-1.75 1.75h-10a1.75 1.75 0 0 1-1.75-1.75v-10Zm1.75-.25a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-10a.25.25 0 0 0-.25-.25h-10ZM8.75 27.5c0-.966.784-1.75 1.75-1.75h10c.966 0 1.75.784 1.75 1.75v10a1.75 1.75 0 0 1-1.75 1.75h-10a1.75 1.75 0 0 1-1.75-1.75v-10Zm1.75-.25a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-10a.25.25 0 0 0-.25-.25h-10ZM25.75 27.5c0-.966.784-1.75 1.75-1.75h10c.967 0 1.75.784 1.75 1.75v10a1.75 1.75 0 0 1-1.75 1.75h-10a1.75 1.75 0 0 1-1.75-1.75v-10Zm1.75-.25a.25.25 0 0 0-.25.25v10c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-10a.25.25 0 0 0-.25-.25h-10Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgCardOverview$1 = SvgCardOverview;

const SvgCaretDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 31a.75.75 0 0 1-.55-.241l-8.661-9.375a.75.75 0 0 1 .55-1.259H32.66a.75.75 0 0 1 .551 1.259l-8.66 9.375A.75.75 0 0 1 24 31Zm6.946-9.375H17.054L24 29.145l6.946-7.52Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgCaretDown$1 = SvgCaretDown;

const SvgCaretUp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 17a.75.75 0 0 1 .55.241l8.661 9.375a.75.75 0 0 1-.55 1.259H15.34a.75.75 0 0 1-.551-1.259l8.66-9.375A.75.75 0 0 1 24 17Zm-6.946 9.375h13.892L24 18.855l-6.946 7.52Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgCaretUp$1 = SvgCaretUp;

const SvgCaretUpDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 10.75a.75.75 0 0 1 .55.241l8.661 9.375a.75.75 0 0 1-.55 1.259H15.34a.75.75 0 0 1-.551-1.259l8.66-9.375A.75.75 0 0 1 24 10.75Zm0 1.855-6.946 7.52h13.892L24 12.605ZM24 37.25a.75.75 0 0 1-.55-.241l-8.661-9.375a.75.75 0 0 1 .55-1.259H32.66a.75.75 0 0 1 .551 1.259l-8.66 9.375a.75.75 0 0 1-.551.241Zm0-1.855 6.946-7.52H17.054L24 35.395Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgCaretUpDown$1 = SvgCaretUpDown;

const SvgCartBagOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 36.45 36.967",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.808,
    y: 8.263,
    width: 28.163,
    height: 19.281,
    rx: 1.201
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.836 8.263h18.107v19.281H10.836zM15.891 8.263V5.1a.886.886 0 0 1 .885-.886H23a.886.886 0 0 1 .885.886v3.163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75.75h.971a1.32 1.32 0 0 1 1.32 1.32v25.515a2.5 2.5 0 0 0 2.5 2.5H35.7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.075,
    cy: 33.151,
    r: 3.066
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.548,
    cy: 33.151,
    r: 3.066
  })));
};
var SvgCartBagOutlined$1 = SvgCartBagOutlined;

const SvgCartOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.035 28.117",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.987 17.6H8.345L6.461 5.575h22.2a.625.625 0 0 1 .6.807L26.064 16.8a1.126 1.126 0 0 1-1.077.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.539 12.453 5.705.75H.75M8.345 17.598l-1.491 4.463"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.854,
    cy: 24.835,
    r: 2.532
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.493,
    cy: 24.835,
    r: 2.532
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.386 24.835h13.575"
  })));
};
var SvgCartOutlined$1 = SvgCartOutlined;

const SvgCashBagHandOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.882 32.536",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 21.553v10.233L8.4 27.9a.976.976 0 0 0 .441-1.287L5.859 20.3a.978.978 0 0 0-1.286-.473ZM14.668 22.512l4.151 1.641a1.649 1.649 0 0 0 2.151-.953h0a1.65 1.65 0 0 0-.938-2.114l-5.195-2.053a7.275 7.275 0 0 0-5.084-.1L5.859 20.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.645 26.144.6-.211a5.932 5.932 0 0 1 4.568.27l2.6 1.272a6.283 6.283 0 0 0 4.84.286l7.669-2.689a1.809 1.809 0 0 0 1.038-2.481h0a1.81 1.81 0 0 0-2.236-.935l-3.994 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.233 21.556v-6.807a7.788 7.788 0 0 0-7.788-7.788h0a7.788 7.788 0 0 0-7.788 7.788v3.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.578 7.187V4.258h3.733v2.929M18.578 4.258l-1.673-2.607L18.578.75l1.867.676L22.311.75l1.674.901-1.674 2.607M22.344 12.146a2.1 2.1 0 0 0-1.706-.853 1.437 1.437 0 0 0-1.48 1.529c0 .933.848 1.153 1.593 1.287.89.161 1.593.628 1.593 1.481a1.437 1.437 0 0 1-1.593 1.432 1.607 1.607 0 0 1-1.593-1M20.638 11.293v-.974M20.638 18.04v-.974"
  })));
};
var SvgCashBagHandOutlined$1 = SvgCashBagHandOutlined;

const SvgChargingStationOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.133 33.123",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.437.75H18.7a1.489 1.489 0 0 1 1.489 1.489v27.242h0H1.948h0V2.239A1.489 1.489 0 0 1 3.437.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.359 4.01h11.422v4.547H5.359zM9.436 12.231 7.758 19.6h2.1l-1.689 5.68a.491.491 0 0 0 .861.433l6.621-8.528-3.551-.034 2.414-4.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 29.481,
    width: 20.594,
    height: 2.892,
    rx: 0.438
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.192 26.082h1.187a2.5 2.5 0 0 0 2.5-2.5v-7a2.5 2.5 0 0 1 2.5-2.5h0a2.5 2.5 0 0 1 2.5 2.5V19.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.741 20.054h2.25a1.391 1.391 0 0 1 1.391 1.391v2.312h0-5.033 0v-2.312a1.391 1.391 0 0 1 1.392-1.391ZM30.053 23.758v2.255M27.679 23.758v2.255"
  })));
};
var SvgChargingStationOutlined$1 = SvgChargingStationOutlined;

const SvgChartNetworkOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.151 29.337",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.575,
    cy: 16.395,
    r: 4.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.575,
    cy: 3.953,
    r: 3.203
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.198,
    cy: 11.94,
    r: 3.203
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.193,
    cy: 25.384,
    r: 3.203
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.953,
    cy: 11.94,
    r: 3.203
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.958,
    cy: 25.384,
    r: 3.203
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.575 7.156v4.709M19.808 14.779l4.411-1.659M18.69 19.683l3.23 3.299M11.37 14.779 6.958 13.12M12.487 19.683l-3.23 3.299"
  })));
};
var SvgChartNetworkOutlined$1 = SvgChartNetworkOutlined;

const SvgChartNetworkPersonOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.062 32.313",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 16.407,
    r: 6.354
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 15.653,
    r: 2.439
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.926 21.492v-.182a3.677 3.677 0 0 0-2.542-3.5M15.117 17.813a3.677 3.677 0 0 0-2.542 3.5v.182"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 3.507,
    r: 2.757
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.38,
    cy: 23.017,
    r: 2.932
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.291,
    cy: 27.749,
    r: 3.814
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.333,
    cy: 14.15,
    r: 2.583
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 6.265v3.788M5.889 14.773l4.007.746M9.618 24.728l2.388-3.322M23.876 21.406l-2.265-1.585"
  })));
};
var SvgChartNetworkPersonOutlined$1 = SvgChartNetworkPersonOutlined;

const SvgChartUpOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.912 25.912",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75.75v24.412h24.412V10.883M4.819 19.502v5.66M8.887 17.146v8.016M12.956 14.688v10.474M17.025 13.254v11.908M21.093 15.815v9.347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.75 14.558 12.745-9.296 4.532 2.025L25.162.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.162 5.291V.75h-4.541"
  })));
};
var SvgChartUpOutlined$1 = SvgChartUpOutlined;

const SvgChatHappySadOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 43.925 30.379",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.586 20.656H9.377A4.952 4.952 0 0 1 4.425 15.7V9.346L.843 6.355a.258.258 0 0 1 .15-.455l3.432-.2h0A4.952 4.952 0 0 1 9.377.75h10.209a4.952 4.952 0 0 1 4.952 4.95v10a4.952 4.952 0 0 1-4.952 4.956Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.538 9.723h10.01a4.952 4.952 0 0 1 4.952 4.952v6.357l3.582 2.992a.258.258 0 0 1-.151.455l-3.431.2h0a4.952 4.952 0 0 1-4.952 4.952h-10.21a4.952 4.952 0 0 1-4.952-4.952v-4.023M27.411 15.488v1.748M31.475 15.488v1.748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.582 23.922a3.861 3.861 0 1 1 7.722 0M12.452 6.515v1.748M16.54 6.515v1.748M18.357 11.088a3.861 3.861 0 0 1-7.722 0"
  })));
};
var SvgChatHappySadOutlined$1 = SvgChatHappySadOutlined;

const SvgChatHeartOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.971 31.358",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.919 10.937a3.29 3.29 0 0 0-4.549.137l-.44.44-.5-.495a3.239 3.239 0 0 0-4.579 0h0a3.238 3.238 0 0 0 0 4.58l4.964 4.964a.155.155 0 0 0 .22 0L26 15.6a3.238 3.238 0 0 0-.081-4.663Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9 6.146H10.957A2.317 2.317 0 0 0 8.64 8.463v13.952a2.317 2.317 0 0 0 2.317 2.317h10.006l8.317 5.8a.4.4 0 0 0 .62-.432l-1.447-5.369H30.9a2.317 2.317 0 0 0 2.318-2.317V8.463A2.318 2.318 0 0 0 30.9 6.146Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.64 15.825-4.7 3.158a.425.425 0 0 1-.652-.445l.812-3.669H3a2.251 2.251 0 0 1-2.25-2.251V3A2.251 2.251 0 0 1 3 .75h14.172A2.251 2.251 0 0 1 19.423 3v3.146"
  })));
};
var SvgChatHeartOutlined$1 = SvgChatHeartOutlined;

const SvgChatLinesOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.134 27.01",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.968.75H3.166A2.416 2.416 0 0 0 .75 3.166v14.55a2.417 2.417 0 0 0 2.416 2.417H13.6l8.674 6.051a.419.419 0 0 0 .644-.453l-1.508-5.6h2.557a2.417 2.417 0 0 0 2.416-2.417V3.166A2.416 2.416 0 0 0 23.968.75ZM5.027 6.115h8.646M5.027 10.484H22.32M5.027 14.852H22.32"
  })));
};
var SvgChatLinesOutlined$1 = SvgChatLinesOutlined;

const SvgChatOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.063 32.374",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.42.75H9.643A8.892 8.892 0 0 0 .75 9.643v6.613a8.893 8.893 0 0 0 8.893 8.893h5.217l5.606 6.337a.4.4 0 0 0 .708-.252l.246-6.085h0a8.893 8.893 0 0 0 8.893-8.893V9.643A8.892 8.892 0 0 0 21.42.75Z",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }));
};
var SvgChatOutlined$1 = SvgChatOutlined;

const SvgChecklistOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.66 31.385",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.111 11.516h9.175M5.374 10.387l1.425 2.137 3.436-3.311M13.111 17.471h9.175M5.374 16.341l1.425 2.138 3.436-3.311M13.111 23.426h9.175M5.374 22.296l1.425 2.137 3.436-3.31M9.667.75h8.25a1.256 1.256 0 0 1 1.256 1.256v.5a2.427 2.427 0 0 1-2.427 2.424h-5.907A2.427 2.427 0 0 1 8.412 2.5V2A1.256 1.256 0 0 1 9.667.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.162 2.73h3.9a3.85 3.85 0 0 1 3.848 3.85v20.2a3.85 3.85 0 0 1-3.849 3.85H4.6a3.85 3.85 0 0 1-3.85-3.85V6.58A3.85 3.85 0 0 1 4.6 2.73h3.822"
  })));
};
var SvgChecklistOutlined$1 = SvgChecklistOutlined;

const SvgChipOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.427 31.427",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.881 3.881h23.665v23.665H3.881z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.202 21.443V7.225H7.225v16.977h14.218l2.759-2.759zM7.606.75v3.131M13.127.75v3.131M18.648.75v3.131M24.168.75v3.131M.75 23.821h3.131M.75 18.3h3.131M.75 12.779h3.131M.75 7.259h3.131M23.821 30.677v-3.131M18.3 30.677v-3.131M12.779 30.677v-3.131M7.259 30.677v-3.131M30.677 7.606h-3.131M30.677 13.127h-3.131M30.677 18.648h-3.131M30.677 24.168h-3.131"
  })));
};
var SvgChipOutlined$1 = SvgChipOutlined;

const SvgCigaretteOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.269 25.877",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.756 20.96 28.947.037-.005 4.128L.75 25.089z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.756 20.96 10.087.013-.005 4.128L.75 25.09zM31.463 25.127h-1.766L29.7 21h1.766a1.053 1.053 0 0 1 1.051 1.053v2.025a1.051 1.051 0 0 1-1.054 1.049ZM22.05.75l.072.851a5.735 5.735 0 0 0 3.418 4.772h0a5.735 5.735 0 0 1 3.266 3.857l.154.614M21.706 8.06l.072.851a5.736 5.736 0 0 0 3.422 4.772h0a5.734 5.734 0 0 1 3.265 3.857l.155.614"
  })));
};
var SvgCigaretteOutlined$1 = SvgCigaretteOutlined;

const SvgCircleLinesChartOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.644 32.644",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.322,
    cy: 16.322,
    r: 15.572
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.339 1.565 4.983 14.757 9.839-12.07M25.035 29.23l-8.713-12.908L.75 18.109"
  })));
};
var SvgCircleLinesChartOutlined$1 = SvgCircleLinesChartOutlined;

const SvgCircleMinus = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6.75C14.473 6.75 6.75 14.473 6.75 24c0 9.527 7.723 17.25 17.25 17.25 9.527 0 17.25-7.723 17.25-17.25 0-9.527-7.723-17.25-17.25-17.25ZM5.25 24C5.25 13.645 13.645 5.25 24 5.25S42.75 13.645 42.75 24 34.355 42.75 24 42.75 5.25 34.355 5.25 24Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 24a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgCircleMinus$1 = SvgCircleMinus;

const SvgCirclePlusOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.165 31.165",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.583,
    cy: 15.583,
    r: 14.833
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.525 15.583H21.64M15.583 9.525V21.64"
  })));
};
var SvgCirclePlusOutlined$1 = SvgCirclePlusOutlined;

const SvgCirclePlus = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6.75C14.473 6.75 6.75 14.473 6.75 24c0 9.527 7.723 17.25 17.25 17.25 9.527 0 17.25-7.723 17.25-17.25 0-9.527-7.723-17.25-17.25-17.25ZM5.25 24C5.25 13.645 13.645 5.25 24 5.25S42.75 13.645 42.75 24 34.355 42.75 24 42.75 5.25 34.355 5.25 24Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.75 16.25a.75.75 0 0 1 .75.75v6h6a.75.75 0 0 1 0 1.5h-6v6a.75.75 0 0 1-1.5 0v-6h-6a.75.75 0 0 1 0-1.5h6v-6a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgCirclePlus$1 = SvgCirclePlus;

const SvgCircleSlashOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.406 33.406",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.703,
    cy: 16.703,
    r: 15.953
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.422 5.422 22.561 22.561"
  })));
};
var SvgCircleSlashOutlined$1 = SvgCircleSlashOutlined;

const SvgCirclesArrowOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.575 32.575",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.102,
    cy: 18.473,
    r: 2.435
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.102,
    cy: 18.473,
    r: 7.847
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.102,
    cy: 18.473,
    r: 13.352
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.102 18.473 25.034 7.541M28.049 8.302l-3.015-.761-.761-3.015L28.049.75l.761 3.015 3.015.761-3.776 3.776z"
  })));
};
var SvgCirclesArrowOutlined$1 = SvgCirclesArrowOutlined;

const SvgClearskyDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m47.99 29.043-.171-14.68c-.012-.914.742-1.668 1.673-1.679.932-.011 1.703.727 1.714 1.64l.172 14.681c.011.912-.744 1.667-1.675 1.677-.932.01-1.703-.727-1.713-1.639Zm14.55 3.973 10.02-10.922a1.727 1.727 0 0 1 2.394-.125c.692.61.75 1.664.128 2.343L65.06 35.234c-.623.677-1.7.734-2.393.125a1.641 1.641 0 0 1-.128-2.343Zm-29.302 3.65L22.32 26.602a1.639 1.639 0 0 1-.073-2.345 1.724 1.724 0 0 1 2.395-.071L35.56 34.25c.68.625.712 1.68.073 2.345a1.726 1.726 0 0 1-2.395.07ZM74.95 74.861 64.033 64.798a1.64 1.64 0 0 1-.073-2.345 1.728 1.728 0 0 1 2.396-.07l10.918 10.062c.678.626.71 1.68.071 2.345a1.724 1.724 0 0 1-2.394.072ZM34.53 63.815l-10.02 10.921a1.64 1.64 0 0 0 .13 2.344c.691.61 1.768.552 2.39-.125l10.022-10.922a1.64 1.64 0 0 0-.128-2.344 1.727 1.727 0 0 0-2.393.126Zm14.125 6.461.172 14.68c.011.914.782 1.652 1.714 1.641.931-.011 1.685-.765 1.675-1.678l-.172-14.68c-.01-.913-.782-1.65-1.714-1.64-.93.01-1.684.765-1.675 1.677Zm-19.692-22.27L13.97 47.96c-.932-.003-1.697.741-1.7 1.655-.003.912.757 1.66 1.69 1.664l14.993.046c.933.003 1.698-.741 1.7-1.653.003-.912-.757-1.661-1.689-1.664Zm42.117-.048 14.995.045c.931.004 1.691.752 1.688 1.664-.003.914-.768 1.658-1.7 1.655l-14.994-.047c-.932-.004-1.692-.752-1.688-1.664.003-.912.768-1.657 1.7-1.653ZM33.89 49.639c0-8.48 7.047-15.38 15.707-15.38 8.663 0 15.71 6.9 15.71 15.38 0 8.482-7.047 15.382-15.71 15.382-8.66 0-15.707-6.9-15.707-15.382Zm15.707 12.24c6.892 0 12.5-5.492 12.5-12.24s-5.608-12.24-12.5-12.24c-6.891 0-12.498 5.492-12.498 12.24s5.607 12.24 12.498 12.24Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgClearskyDay$1 = SvgClearskyDay;

const SvgClearskyNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.032 80.026c-9.779 1.005-18.052-2.08-24.91-8.938-1.636-1.636-3.068-3.473-4.562-5.244-.66-.784-.705-1.365-.3-1.976.4-.604 1.07-.747 2.026-.511 6.756 1.66 13.45 1.548 19.808-1.408 10.275-4.777 16.1-12.924 17.538-24.012.841-6.488-.823-12.525-4.204-18.117-.107-.174-.212-.349-.322-.521-.381-.604-.392-1.209.069-1.764.464-.556 1.087-.655 1.744-.407 9.8 3.698 17.457 9.816 21.078 19.766 4.542 12.479 2.024 23.725-7.337 33.295-4.596 4.7-10.274 7.649-16.71 9.143-1.29.3-2.611.467-3.918.695Zm-24.915-13.1c.595.647 1.115 1.24 1.663 1.803 3.723 3.84 8.029 6.783 13.365 7.878 9.124 1.872 17.54.028 25.072-5.324 10.785-7.662 14.367-20.377 10.524-32.334-2.612-8.124-8.235-13.679-15.826-17.438-.065-.031-.148-.03-.216-.042 4.79 11.624 3.96 22.735-3.616 32.825-7.625 10.155-18.24 13.956-30.966 12.632Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgClearskyNight$1 = SvgClearskyNight;

const SvgClockTimeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.651 33.651",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.826 7.544v9.858l-6.364 6.363"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.826,
    cy: 16.826,
    r: 16.076
  })));
};
var SvgClockTimeOutlined$1 = SvgClockTimeOutlined;

const SvgClockWifiOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.404 26.794",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.516,
    cy: 24.494,
    r: 1.544
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 20.916a5.743 5.743 0 0 1 8.282 0M19.054 18.115a9.139 9.139 0 0 1 12.846-.077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.377 15.146a11.807 11.807 0 0 1 16.277 0M13.397 6.095v7.755l-5.006 5.007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.291 24a12.646 12.646 0 1 1 4.924-15.1"
  })));
};
var SvgClockWifiOutlined$1 = SvgClockWifiOutlined;

const SvgCloseOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.49.367a.75.75 0 0 1 0 1.06L15.963 14.955 29.439 28.43a.75.75 0 1 1-1.06 1.061L14.901 16.015 1.458 29.459a.75.75 0 1 1-1.06-1.06l13.444-13.445L.347 1.46A.75.75 0 1 1 1.407.4l13.495 13.495L28.43.367a.75.75 0 0 1 1.06 0Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgCloseOutlined$1 = SvgCloseOutlined;

const SvgClothingHangerOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.721 25.321",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.849 20.257 15.012-9.405 15.011 9.405a2.335 2.335 0 0 1-1.24 4.314H3.089a2.335 2.335 0 0 1-1.24-4.314ZM13.691 4.164a3.414 3.414 0 1 1 6.828 0c0 1.886-3.658 4.068-3.658 4.068v2.62"
  })));
};
var SvgClothingHangerOutlined$1 = SvgClothingHangerOutlined;

const SvgCloudArrowUpOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.884 26.593",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.606 17.715 4.957-4.957h.002l4.956 4.957M15.564 25.843V12.757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 21.739h6.155a6.783 6.783 0 0 0 0-13.566h-2.818a8.519 8.519 0 0 0-16.968 1.1v1.678a5.41 5.41 0 0 0 .592 10.787h5.77"
  })));
};
var SvgCloudArrowUpOutlined$1 = SvgCloudArrowUpOutlined;

const SvgCloudCoverPartSunOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 40.701 34.958",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.278 17.417H33.34a5.868 5.868 0 0 0-11.687.758v1.156a3.727 3.727 0 0 0 .407 7.431h13.218a4.673 4.673 0 1 0 0-9.345ZM5.621 5.621l3.125 3.125M.75 17.382h4.418M29.142 5.621l-3.124 3.125M17.382.75v4.418M5.621 29.142l3.125-3.124M17.576 34.208V29.79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.334 23.035a3.726 3.726 0 0 1 3.319-3.7v-1.159a5.87 5.87 0 0 1 3.089-5.171 8.553 8.553 0 1 0-5.209 12.754 3.707 3.707 0 0 1-1.199-2.724Z"
  })));
};
var SvgCloudCoverPartSunOutlined$1 = SvgCloudCoverPartSunOutlined;

const SvgCloudCoverSunOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 41.401 34.763",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.283 21.278h-2.641a8 8 0 0 0-15.928 1.034v1.575a5.078 5.078 0 0 0 .555 10.126h18.014a6.368 6.368 0 1 0 0-12.735ZM5.621 5.621l3.125 3.125M.75 17.382h4.418M29.142 5.621l-3.124 3.125M17.382.75v4.418M5.621 29.142l3.125-3.124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 24.791a5.05 5.05 0 0 1 2.38-.9v-1.579a8 8 0 0 1 9.594-7.841 8.443 8.443 0 1 0-11.974 10.32Z"
  })));
};
var SvgCloudCoverSunOutlined$1 = SvgCloudCoverSunOutlined;

const SvgCloudLightningOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.07 37.943",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.064 8.69h-3.009a9.113 9.113 0 0 0-18.15 1.177v1.8A5.787 5.787 0 0 0 6.537 23.2h20.527a7.256 7.256 0 1 0 0-14.511ZM14.623 37.093l6.452-6.749a.361.361 0 0 0-.246-.625h-2.781a.13.13 0 0 1-.121-.178l1.157-2.868a.211.211 0 0 0-.2-.289h-3.428a.26.26 0 0 0-.244.169l-2.185 5.406a.244.244 0 0 0 .226.335h2.119a.13.13 0 0 1 .123.172l-1.461 4.246a.362.362 0 0 0 .589.381Z"
  })));
};
var SvgCloudLightningOutlined$1 = SvgCloudLightningOutlined;

const SvgCloudOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.244 22.73",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.633 8.258h-2.846A8.617 8.617 0 0 0 5.624 9.371v1.7a5.472 5.472 0 0 0 .6 10.911h19.41a6.861 6.861 0 0 0 0-13.722Z",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }));
};
var SvgCloudOutlined$1 = SvgCloudOutlined;

const SvgCloudRainLightningOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.07 37.291",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.628 35.019 3.482-8.635M21.185 35.019l3.482-8.635M26.117 32.254l2.366-5.87M9.391 30.194l1.536-3.81M27.064 8.69h-3.009a9.113 9.113 0 0 0-18.15 1.177v1.8A5.787 5.787 0 0 0 6.537 23.2h20.527a7.256 7.256 0 1 0 0-14.511ZM13.949 36.448l6.018-6.342a.34.34 0 0 0-.232-.588h-2.567a.121.121 0 0 1-.113-.167l1.086-2.695a.2.2 0 0 0-.183-.272h-3.226a.244.244 0 0 0-.229.159l-2.054 5.08a.229.229 0 0 0 .212.315h1.993a.123.123 0 0 1 .115.162L13.4 36.09a.339.339 0 0 0 .549.358Z"
  })));
};
var SvgCloudRainLightningOutlined$1 = SvgCloudRainLightningOutlined;

const SvgCloudRainOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.07 38.242",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.064 8.69h-3.009a9.113 9.113 0 0 0-18.15 1.177v1.8A5.787 5.787 0 0 0 6.537 23.2h20.527a7.256 7.256 0 1 0 0-14.511ZM4.452 35.019l3.482-8.635M18.192 35.019l3.482-8.635M23.887 32.254l2.367-5.87M10.978 30.194l1.536-3.81M12.615 37.492l4.479-11.108"
  })));
};
var SvgCloudRainOutlined$1 = SvgCloudRainOutlined;

const SvgCloudRainSunOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 43.57 45.735",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.621 5.621 3.125 3.125M.75 17.382h4.418M29.142 5.621l-3.124 3.125M17.382.75v4.418M5.621 29.142l3.125-3.124M24.957 13.653a8.443 8.443 0 1 0-11.623 11.138M22.448 40.11a1.5 1.5 0 0 1-3.01 0c0-1.236 1.505-2.647 1.505-2.647s1.505 1.411 1.505 2.647ZM34.457 40.11a1.5 1.5 0 1 1-3.009 0c0-1.236 1.505-2.647 1.505-2.647s1.504 1.411 1.504 2.647ZM28.453 43.48a1.505 1.505 0 0 1-3.01 0c0-1.236 1.5-2.647 1.5-2.647s1.51 1.411 1.51 2.647Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.958 21.255h-2.845a8.617 8.617 0 0 0-17.163 1.114v1.7a5.472 5.472 0 0 0 .6 10.911h19.41a6.861 6.861 0 1 0 0-13.722Z"
  })));
};
var SvgCloudRainSunOutlined$1 = SvgCloudRainSunOutlined;

const SvgCloudRaindropsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.244 32.738",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.122 27.113a1.5 1.5 0 0 1-3.01 0c0-1.237 1.505-2.647 1.505-2.647s1.505 1.41 1.505 2.647ZM24.132 27.113a1.505 1.505 0 0 1-3.01 0c0-1.237 1.5-2.647 1.5-2.647s1.51 1.41 1.51 2.647ZM18.127 30.483a1.5 1.5 0 1 1-3.01 0c0-1.236 1.5-2.647 1.5-2.647s1.51 1.411 1.51 2.647ZM25.633 8.258h-2.846A8.617 8.617 0 0 0 5.624 9.371v1.7a5.472 5.472 0 0 0 .6 10.911h19.41a6.861 6.861 0 0 0 0-13.722Z"
  })));
};
var SvgCloudRaindropsOutlined$1 = SvgCloudRaindropsOutlined;

const SvgCloudSnowflakeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.244 35.298",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.837 34.548V18.063M17.9 19.538l-2.063 1.61-2.062-1.61M13.775 33.073l2.062-1.609 2.063 1.609M22.975 30.427 8.699 22.185M11.008 21.136l.363 2.591-2.426.981M20.667 31.476l-.363-2.591 2.425-.982M22.975 22.185 8.699 30.427M8.945 27.903l2.426.982-.363 2.591M22.729 24.708l-2.425-.981.363-2.591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.633 21.98a6.861 6.861 0 0 0 0-13.722h-2.846A8.617 8.617 0 0 0 5.624 9.371v1.7a5.472 5.472 0 0 0 .6 10.911"
  })));
};
var SvgCloudSnowflakeOutlined$1 = SvgCloudSnowflakeOutlined;

const SvgCloudWindOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.244 29.282",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9 21.152a6.862 6.862 0 0 0-3.27-12.894h-2.843A8.617 8.617 0 0 0 5.624 9.371v1.7a5.472 5.472 0 0 0 .6 10.911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.163 19.218H19.8a2.443 2.443 0 0 0 2.443-2.443h0a2.443 2.443 0 0 0-2.443-2.443h-.054M2.732 24.854h6.881a3.02 3.02 0 0 0 3.02-3.019h0a3.02 3.02 0 0 0-3.02-3.02h-.955M6.3 28.532h9.254a2.9 2.9 0 0 0 2.9-2.905h0a2.9 2.9 0 0 0-2.9-2.9M21.348 25.129h3.141a2.368 2.368 0 0 0 2.368-2.368h0a2.368 2.368 0 0 0-2.368-2.368h-.053"
  })));
};
var SvgCloudWindOutlined$1 = SvgCloudWindOutlined;

const SvgCloudsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 38.785 27.94",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.174 13.468h-2.846a8.617 8.617 0 0 0-17.162 1.114v1.7a5.472 5.472 0 0 0 .6 10.911h19.41a6.861 6.861 0 0 0 0-13.722Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.354 13.736a6.862 6.862 0 0 0-6.721-5.478M22.309 6.336A8.618 8.618 0 0 0 5.624 9.371v1.7a5.472 5.472 0 0 0 .6 10.911"
  })));
};
var SvgCloudsOutlined$1 = SvgCloudsOutlined;

const SvgCloudy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.55 41.984c-1.114 0-2.225.12-3.31.356-3.472-8.073-11.575-13.457-20.342-13.457-10.94 0-20.037 7.736-21.848 18.48h-.077C18.82 47.363 13 53.205 13 60.386c0 7.18 5.82 13.022 12.973 13.022H71.55c8.628 0 15.648-7.048 15.648-15.711 0-8.664-7.02-15.713-15.648-15.713Zm12.5 15.713c0 6.928-5.608 12.564-12.5 12.564H25.973c-5.418 0-9.827-4.429-9.827-9.875s4.409-9.876 9.827-9.876c.36 0 .757.028 1.244.088l1.598.199.16-1.603c.989-9.785 9.124-17.163 18.923-17.163 8.017 0 15.212 5.11 17.906 12.716l.508 1.436 1.45-.462a12.505 12.505 0 0 1 3.788-.588c6.892 0 12.5 5.636 12.5 12.564Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgCloudy$1 = SvgCloudy;

const SvgCoffeeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.918 29.129",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.007 13.2h2.415a1.746 1.746 0 0 1 1.713 2.084l-.487 2.471a3.058 3.058 0 0 1-2.283 2.38l-1.6.386M11.505 9.157h0a5.134 5.134 0 0 1 1.5-3.633l1.007-1.008a5.134 5.134 0 0 0 1.51-3.633V.75M16.181 9.157h0a3.667 3.667 0 0 1 1.074-2.593l.719-.719a3.667 3.667 0 0 0 1.074-2.593v-.095M21.448 28.379H6.237A6.439 6.439 0 0 1 .75 25.308h26.186a6.439 6.439 0 0 1-5.488 3.071Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 25.309c-3.561-1.458-6.1-4.877-6.4-10.891A1.159 1.159 0 0 1 3.961 13.2h19.764a1.158 1.158 0 0 1 1.156 1.214c-.3 6.014-2.834 9.433-6.393 10.891"
  })));
};
var SvgCoffeeOutlined$1 = SvgCoffeeOutlined;

const SvgComputerCodeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.677 28.739",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.556 27.989h22.388M22.528 27.989H10.972l1.016-6.199h9.525l1.015 6.199zM29.712.75h1.315a1.9 1.9 0 0 1 1.9 1.9v17.24a1.9 1.9 0 0 1-1.9 1.9H2.65a1.9 1.9 0 0 1-1.9-1.9V2.65a1.9 1.9 0 0 1 1.9-1.9h27.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.752 15.793-3.931-3.932 3.931-3.932M20.924 7.929l3.932 3.932-3.932 3.932M18.42 7.477l-3.124 8.316"
  })));
};
var SvgComputerCodeOutlined$1 = SvgComputerCodeOutlined;

const SvgContractOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.671 32.709",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 23.171,
    height: 31.209,
    rx: 0.769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.727 6.161h13.216M5.727 9.65h13.216M5.727 13.139h13.216M5.727 16.628h6.895M13.573 24.355h5.37M9.875 22.4l-3.91 3.911M9.875 26.311 5.965 22.4"
  })));
};
var SvgContractOutlined$1 = SvgContractOutlined;

const SvgCovidTestOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.673 31.859",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.852 15.352 6.874-6.874h0l14.33 14.33a4.861 4.861 0 0 1 0 6.874h0a4.861 4.861 0 0 1-6.875 0l-14.33-14.33h0ZM1.556 9.975l4.793-4.793a2.748 2.748 0 0 1 3.886 0l1.697 1.697a.982.982 0 0 1 0 1.389l-7.291 7.291a.982.982 0 0 1-1.39 0l-1.696-1.697a2.748 2.748 0 0 1 0-3.887ZM3.952 7.578l2.414 2.415M6.015 5.515 8.43 7.929M1.889 9.642l2.414 2.414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.855 13.458 2.427-2.427h0l11.564 11.564h0l-2.426 2.426a2.969 2.969 0 0 1-4.198.001l-7.37-7.369a2.969 2.969 0 0 1 .003-4.195ZM18.627 6.096l13.296 13.296"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.184,
    cy: 3.653,
    rx: 2.215,
    ry: 3.455,
    transform: "rotate(-45 16.184 3.653)"
  })));
};
var SvgCovidTestOutlined$1 = SvgCovidTestOutlined;

const SvgCrownOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 36.209 22.541",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.1 21.791h13.927a.75.75 0 0 0 .738-.616l2.681-14.742a.75.75 0 0 0-1.046-.817l-8.7 3.947a.75.75 0 0 1-.915-.239l-6.07-8.268a.751.751 0 0 0-1.21 0L11.43 9.324a.75.75 0 0 1-.915.239l-8.7-3.947a.75.75 0 0 0-1.048.817l2.68 14.742a.751.751 0 0 0 .739.616Z",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }));
};
var SvgCrownOutlined$1 = SvgCrownOutlined;

const SvgCustomsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.602 34.911",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.152 2.059 10.921.75 3.69 2.059a1.183 1.183 0 0 0-.973 1.165v1.335A7.894 7.894 0 0 0 4.043 8.95a7.938 7.938 0 0 0 13.756 0 7.887 7.887 0 0 0 1.327-4.391V3.224a1.184 1.184 0 0 0-.974-1.165Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.883,
    cy: 5.014,
    r: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.765,
    y: 21.779,
    width: 18.087,
    height: 12.382,
    rx: 0.771
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.994 21.779h11.629v12.382H15.994zM19.24 21.779V19.75a.569.569 0 0 1 .569-.569h4a.569.569 0 0 1 .569.569v2.029M4.171 12.684a6.75 6.75 0 0 0 13.5 0V9.361h-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.694 21.779a10.186 10.186 0 0 0-4.635-3.118M7.783 18.661A10.176 10.176 0 0 0 .75 28.339v4.49h12.015"
  })));
};
var SvgCustomsOutlined$1 = SvgCustomsOutlined;

const SvgDatIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#dat_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.594 51.008a89.837 89.837 0 0 1 10.856 9.859c2.523-1.056 7.57-2.993 11.912-3.697a33.114 33.114 0 0 0-2.523-18.72L63.594 51.008ZM75.33 76.887a32.314 32.314 0 0 0 5.516-6.103 33.462 33.462 0 0 0 3.873-7.277l-6.567 5.399-2.817 7.981m-5.985-8.685a92.1 92.1 0 0 1-12.97-6.866l-4.87 23.297a32.57 32.57 0 0 0 18.426-3.99c-.821-4.343-.703-9.742-.586-12.441ZM44.64 82.696c-.88-1.115 0-23.414.235-29.224-11.15-8.45-18.368-17.546-17.898-19.952-10.22 14.901-6.423 35.264 8.478 45.483a32.714 32.714 0 0 0 10.3 4.69c-.47-.41-.88-.762-1.115-.997Zm7.629-39.786c5.346-2.23 25.996-10.739 27.346-10.211.467.201.918.436 1.35.704-10.263-14.874-30.641-18.613-45.515-8.35a32.727 32.727 0 0 0-8.062 7.939c2.112-1.29 13.144 2.348 24.88 9.918Z",
    fill: "#FC725A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "dat_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25833"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25833",
    result: "shape"
  }))));
};
var SvgDatIcon$1 = SvgDatIcon;

const SvgDiagramBars = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.355 11.997a.75.75 0 0 1 .75.75v12.334l11.553-8.428a.75.75 0 0 1 .748-.078l4.083 1.824 5.35-4.902h-2.612a.75.75 0 0 1 0-1.5h4.54a.75.75 0 0 1 .75.75v4.541a.75.75 0 0 1-1.5 0v-2.836l-5.878 5.385a.75.75 0 0 1-.813.132l-4.135-1.848-12.085 8.817v9.471h2.569V31.5a.75.75 0 0 1 1.5 0v4.91h2.567v-7.266a.75.75 0 0 1 1.5 0v7.265h2.57v-9.724a.75.75 0 0 1 1.5 0v9.724h2.568V25.251a.75.75 0 0 1 1.5 0V36.41h2.569v-8.597a.75.75 0 1 1 1.5 0v8.597h2.568V22.88a.75.75 0 0 1 1.5 0v14.28a.75.75 0 0 1-.75.75H12.355a.75.75 0 0 1-.75-.75V12.747a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgDiagramBars$1 = SvgDiagramBars;

const SvgDocumentCheckOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.09 32.709",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.012 10.71h13.817M6.012 15.767h13.817M6.012 21.705h9.418"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.873,
    cy: 25.491,
    r: 6.468
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.928 25.263 2.167 2.574 3.66-4.138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 19.122V2.355A1.6 1.6 0 0 0 23.4.75H10.007a1.872 1.872 0 0 0-1.324.55L1.3 8.683a1.872 1.872 0 0 0-.55 1.324v18.824a1.6 1.6 0 0 0 1.605 1.605h17.474"
  })));
};
var SvgDocumentCheckOutlined$1 = SvgDocumentCheckOutlined;

const SvgDocumentListCheckboxOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.99 32.709",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.24 7.649h-5.113a1.786 1.786 0 0 1-1.786-1.786V.75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.594,
    y: 15.867,
    width: 4.03,
    height: 4.03,
    rx: 0.676
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.594,
    y: 8.066,
    width: 4.03,
    height: 4.03,
    rx: 0.676
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.577 11.712h-6.435M12.142 8.451h2.556M18.577 19.512h-6.435M12.142 16.251h2.556"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.594,
    y: 23.746,
    width: 4.03,
    height: 4.03,
    rx: 0.676
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.577 27.392h-6.435M12.142 24.131h2.556M24.24 7.649l-6.9-6.9H2.537A1.787 1.787 0 0 0 .75 2.537v27.635a1.787 1.787 0 0 0 1.787 1.787h19.917a1.787 1.787 0 0 0 1.786-1.787Z"
  })));
};
var SvgDocumentListCheckboxOutlined$1 = SvgDocumentListCheckboxOutlined;

const SvgDocumentListPenOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.213 32.709",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.24 7.649h-5.113a1.786 1.786 0 0 1-1.786-1.786V.75"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.594,
    y: 17.474,
    width: 4.03,
    height: 4.03,
    rx: 0.676
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.594,
    y: 8.066,
    width: 4.03,
    height: 4.03,
    rx: 0.676
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.577 11.712h-6.435M12.142 8.451h2.556M16.716 21.12h-4.574M12.142 17.859h2.308M30.835 13.65h0a2.146 2.146 0 0 1-.001 3.035L20.25 27.267h0l-3.035-3.035h0l10.582-10.583a2.146 2.146 0 0 1 3.035 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.216 24.232-1.291 4.326 4.326-1.29M30.184 17.335 27.148 14.3M28.242 19.276l-3.035-3.035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.24 17.022V7.649l-6.9-6.9H2.537A1.787 1.787 0 0 0 .75 2.537v27.635a1.787 1.787 0 0 0 1.787 1.787h19.917a1.787 1.787 0 0 0 1.786-1.787v-6.707"
  })));
};
var SvgDocumentListPenOutlined$1 = SvgDocumentListPenOutlined;

const SvgDocumentOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.99 32.709",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.24 10.394h-7.146a2.5 2.5 0 0 1-2.5-2.5V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.24 23.465V10.394L14.6.75H2.537A1.787 1.787 0 0 0 .75 2.537v27.635a1.787 1.787 0 0 0 1.787 1.787h19.917a1.787 1.787 0 0 0 1.786-1.787v-6.707M5.156 14.921h15.038M5.156 20.592h15.038M5.156 9.25h5.556M5.156 26.263h15.038"
  })));
};
var SvgDocumentOutlined$1 = SvgDocumentOutlined;

const SvgDogRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.891 30.287",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.57 20.037s3.908-1.938 5.719 0 1.081 4.861-1.493 6.1h1.751a2.315 2.315 0 0 1 2.316 2.316v1.083M5.23 29.537H2.194A1.444 1.444 0 0 1 .75 28.093h0a1.444 1.444 0 0 1 1.444-1.444H5.23M20.874.75v7.043a3.421 3.421 0 0 1-3.421 3.421h0a3.421 3.421 0 0 1-3.421-3.421V5.87a1.385 1.385 0 0 1 .49-1.058L18.905 1.1a1.461 1.461 0 0 1 .945-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.874.753h2.763a1.878 1.878 0 0 1 1.721 1.127l.573 1.312a1.76 1.76 0 0 0 1.613 1.056h1.931a.667.667 0 0 1 .666.667V7.6a1.791 1.791 0 0 1-1.791 1.793h-1.768c-1.525 0-3.562.815-3.59 2.023-.032 1.387 1.652 2.393 1.652 5.888S22.8 22.388 22.8 24.453s3.209 2.828 3.209 2.828v2.256H5.23v-4.353c0-1.652 1.4-3.686 3.273-5.56 1.541-1.541 5.616-5.874 7.017-9.008"
  })));
};
var SvgDogRightOutlined$1 = SvgDogRightOutlined;

const SvgDoorArrowLeftOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.863 35.248",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.75 28.308 12.634 6.19V6.94L.75.75v27.558zM10.482 21.967V18.5M33.113 13.356H22.419l3.146-5.766h-4.418l-4.04 7.404v.003l4.04 7.404h4.418l-3.146-5.766h10.694v-3.279z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.525 7.59V.75H.75v27.558M13.384 28.308h8.141v-5.907"
  })));
};
var SvgDoorArrowLeftOutlined$1 = SvgDoorArrowLeftOutlined;

const SvgDotDiagramOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.507 16.613",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.823,
    cy: 3.684,
    r: 2.934
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.068,
    cy: 12.929,
    r: 2.934
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.668,
    cy: 3.684,
    r: 2.934
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.684,
    cy: 12.929,
    r: 2.934
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.569 10.681 4.793-5.184M14.752 5.749l4.442 4.932M23.186 10.9l4.557-5.147"
  })));
};
var SvgDotDiagramOutlined$1 = SvgDotDiagramOutlined;

const SvgDownload = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m30.085 22.952-6.438 6.438h-.002l-6.439-6.438M23.646 9.95v19.441",
    stroke: props.color || `#1d1d1b`,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.396 17.375h5.891a2.184 2.184 0 0 1 2.184 2.184v15.677a2.184 2.184 0 0 1-2.184 2.184H13.004a2.183 2.183 0 0 1-2.184-2.184V19.56a2.184 2.184 0 0 1 2.184-2.184h5.891",
    stroke: props.color || `#1d1d1b`,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var SvgDownload$1 = SvgDownload;

const SvgDressBlingOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.331 34.781",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.525 34.031H20.9s3.372-6.064 3.372-11.536a10.948 10.948 0 0 0-3.244-8.183h-7a10.948 10.948 0 0 0-3.247 8.188c0 5.472 3.372 11.536 3.372 11.536ZM14.025 14.312l-2.052-3.369a8.171 8.171 0 0 1-1.192-4.25V2.662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.025 14.312 2.052-3.369a8.171 8.171 0 0 0 1.192-4.25V2.8M18.577 14.312s-.587-8.588-4.164-13.274A.731.731 0 0 0 13.5.831l-2.333 1.2a.731.731 0 0 0-.228 1.119c1.602 1.917 6.026 7.386 7.638 11.162Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.18 11.214a73.66 73.66 0 0 1 5.935-8.067.731.731 0 0 0-.224-1.126L21.616.861a.73.73 0 0 0-.951.262c-.9 1.43-3.168 5.2-3.14 6.8M34.581 7h-1.359M29.645 7h-1.359M31.433 10.147V8.789M31.433 5.211V3.852M7.045 26.299H5.686M2.109 26.299H.75M3.897 29.446v-1.359M3.897 24.51v-1.359"
  })));
};
var SvgDressBlingOutlined$1 = SvgDressBlingOutlined;

const SvgDrinkMartiniOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.337 32.129",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.27 22.593.75 7.477h23.041L12.27 22.593zM12.27 22.593v8.786M19.078 31.379H5.463M24.587.75l-11.52 15.115M4.09 11.86h16.36"
  })));
};
var SvgDrinkMartiniOutlined$1 = SvgDrinkMartiniOutlined;

const SvgDrinkWaterFountainOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.13 22.637",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 7.733,
    width: 30.63,
    height: 7.412,
    rx: 1.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.376 15.145a14.612 14.612 0 0 1-24.623 0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M2.374 1.302h5.752v6.435H2.374zM8.126 4.175l3.563-.996.996 1.916-1.686 2.643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.456 2.6A9 9 0 0 1 19.825.814a9.376 9.376 0 0 1 7.911 4.542",
    strokeWidth: 1.628,
    strokeDasharray: "0.952 3.095"
  })));
};
var SvgDrinkWaterFountainOutlined$1 = SvgDrinkWaterFountainOutlined;

const SvgDrinksOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.612 35.607",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.911 10.452 6.201-2.015a3.042 3.042 0 0 1 3.833 1.953l2.62 8.065a6.3 6.3 0 0 1-4.044 7.938h0a6.3 6.3 0 0 1-7.939-4.044l-2.62-8.065a3.042 3.042 0 0 1 1.95-3.832ZM34.862 32.233l-8.042 2.613M30.841 33.539l-2.322-7.144M31.849 16.248H18.596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.911 10.452 6.201-2.015a3.042 3.042 0 0 1 3.833 1.953l2.62 8.065a6.3 6.3 0 0 1-4.044 7.938h0a6.3 6.3 0 0 1-7.939-4.044l-2.62-8.065a3.042 3.042 0 0 1 1.95-3.832ZM34.862 32.233l-8.042 2.613M30.841 33.539l-2.322-7.144M31.849 16.248H18.596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.092 26.406h0a6.3 6.3 0 0 0 7.941-4.046l2.621-8.06a3.041 3.041 0 0 0-1.954-3.838L9.5 8.447A3.042 3.042 0 0 0 5.667 10.4l-2.621 8.065a6.3 6.3 0 0 0 4.046 7.941ZM.75 32.244l8.042 2.613M4.771 33.55l2.321-7.144M3.763 16.259h13.253M17.7 4.544V.75M12.022 4.544 10.177.75M23.379 4.544 25.224.75"
  })));
};
var SvgDrinksOutlined$1 = SvgDrinksOutlined;

const SvgDropOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.339 32.716",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.665 20.723a7.284 7.284 0 0 1-7.284 7.283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.589 20.047a11.92 11.92 0 0 1-23.839 0C.75 11.374 10.613 2.4 12.4.853a.417.417 0 0 1 .548 0C14.725 2.4 24.589 11.374 24.589 20.047Z"
  })));
};
var SvgDropOutlined$1 = SvgDropOutlined;

const SvgElChargeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.287 30.122",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.162.75H7.124a15.894 15.894 0 1 0 19.038 0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.96,
    cy: 21.022,
    r: 2.795
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.96,
    cy: 6.922,
    r: 2.219
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.327,
    cy: 6.922,
    r: 2.219
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.327,
    cy: 21.022,
    r: 2.795
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.01,
    cy: 13.539,
    r: 2.795
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.643,
    cy: 13.539,
    r: 2.795
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.277,
    cy: 13.539,
    r: 2.795
  })));
};
var SvgElChargeOutlined$1 = SvgElChargeOutlined;

const SvgElectricCarOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.141 31.35",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.681.75-2.957 5.764h2.58l-1.483 4.128 5.709-5.931h-3.008L20.712.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.95 6.074h-3.229A5.764 5.764 0 0 0 6.8 8.841l-2.677 4.4h26.006l-2.677-4.4a5.764 5.764 0 0 0-4.923-2.767h-2.311"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.314 13.24H2.827a2.077 2.077 0 0 0 0 4.154h.551v5.471a2.779 2.779 0 0 0 2.779 2.779h21.827a2.779 2.779 0 0 0 2.778-2.779v-5.471h.552a2.077 2.077 0 0 0 0-4.154Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.742 25.644v2.275A2.681 2.681 0 0 1 6.06 30.6h0a2.681 2.681 0 0 1-2.682-2.681V22.1M30.762 22.1v5.815a2.681 2.681 0 0 1-2.681 2.685h0a2.681 2.681 0 0 1-2.681-2.681v-2.275M7.774 19.936H12M22.239 19.936h4.226"
  })));
};
var SvgElectricCarOutlined$1 = SvgElectricCarOutlined;

const SvgElevatorOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 26.922 37.854",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.293,
    cy: 13.793,
    r: 2.468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.146 15.978a3.72 3.72 0 0 0-2.571 3.538v5.51a1.244 1.244 0 0 0 1.245 1.245h.615v6.675h3.716v-6.675h.616a1.245 1.245 0 0 0 1.245-1.245v-5.51a3.719 3.719 0 0 0-2.572-3.538"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.629,
    cy: 13.793,
    r: 2.468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.482 15.978a3.719 3.719 0 0 0-2.572 3.538v5.51a1.245 1.245 0 0 0 1.245 1.245h.616v6.675h3.716v-6.675h.613a1.244 1.244 0 0 0 1.245-1.245v-5.51a3.72 3.72 0 0 0-2.571-3.538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 7.167h25.422v29.937H.75zM12.252.75 10.08 3.773 7.908.75M14.67 3.773 16.842.75l2.172 3.023"
  })));
};
var SvgElevatorOutlined$1 = SvgElevatorOutlined;

const SvgEmiratesIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#emirates_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#D12600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4 26.062a5.21 5.21 0 0 0-1.091 3.172v9.96a3.738 3.738 0 0 1-.806 2.055c-.26.26-1.795 1.639-1.925 1.795l.858.026c.286-.26 3.251-2.887 3.537-3.25a5.092 5.092 0 0 0 1.352-3.434v-9.57a3.672 3.672 0 0 1 1.015-2.626c.363-.39 1.508-1.353 1.716-1.587l-.91-.026c-.182.234-3.433 3.173-3.745 3.485Zm-7.307 36.226 3.615 3.147h2.419a8.76 8.76 0 0 0 6.189-2.549c1.482-1.482 2.028-3.485 2.028-5.357v-5.175a4.204 4.204 0 0 0-1.404-3.069c-.156-.156-1.222-1.17-1.222-1.17v3.978s1.17 1.197 1.378 1.43c1.066 1.145 1.066 3.226-2.34 6.528-.599.572-2.289 2.185-4.629 2.185l-6.034.052Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.158 41.042c-.39.416-.78 1.456-.78 2.392v1.95h1.976c.78 0 1.794-.701 2.003-1.066v-1.95a4.83 4.83 0 0 0 1.066 1.118c.208-.26 2.028-2.445 3.536-2.47 2.523-.027 1.951 3.172.937 4.186-.338.338-1.82 1.69-2.289 2.132-1.196 1.145-3.25.599-3.25-2.34 0 0-2.185 2.08-2.523 2.366-.338.287-1.457 1.483-1.457 1.483v5.175c0 2.47-.806 3.303-1.482 4.057-.26.286-3.042 2.835-3.432 3.12l-.911.027s1.638-1.483 1.95-1.82c.365-.39.807-1.171.807-2.471 0-.338-.052-8.114-.052-8.114H45.566c-4.421 0-5.357-4.889-5.383-6.216v-4.914c0-.806-.52-2.158-1.327-2.574h1.249c.156.051.936.364.936 3.38 0 0-.052 3.485-.052 3.693 0 1.534 1.222 3.277 2.965 3.277l14.355-.026c0-.39.39-1.847 1.092-2.627.39-.442 3.485-3.25 3.823-3.536h.91c-.13.13-1.638 1.456-1.95 1.82l-.026-.052Zm4.707 2.938c.372.507.78.985 1.222 1.43 1.56 1.249 2.289-.104 1.249-1.508-.417-.572-2.003-.416-2.471.078Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.47 53.238c0 .702-2.211 2.548-2.341 2.653-.156-.755-.728-1.56-2.366-3.225l2.418-2.419c1.639 1.639 2.289 2.003 2.289 2.991Zm4.213-27.8c.494.494 1.534 1.794.91 2.444-.471.474-.94.951-1.405 1.43-.052-.312-.858-1.091-.858-1.091v2.626c-.026 1.066-.416 1.352-.416 1.352s1.95 1.924 1.95 4.421v2.549a1.741 1.741 0 0 1-.494 1.3c-.182.208-1.976 2.029-2.262 2.262-.416.365-.936.573-1.483.547h-6.734c-1.067 0-2.159-.832-2.159-1.665 0-.208.026-2.496.026-2.496.338.39.702.858 1.534.858.676 0 1.352-.52 1.535-.728.182-.208 5.097-5.305 5.097-5.305s-2.289-2.133-3.797-3.147c-.728-.494-1.716.13-1.872.78-.468 2.029 0 5.097 0 5.097l-1.847-1.846c-.754-.754-.728-2.444.182-3.329.13-.156 1.508-1.664 3.225-1.664h2.679c1.794 0 3.77 1.794 3.77 1.794.156-.182.26-.39.287-.624 0-.936-.026-3.407-.026-3.407-1.353-1.352-1.535-2.756-.885-3.406 1.222-1.223 1.665-1.639 1.665-1.639s-.052 1.483 1.378 2.887ZM47.23 38.96c-.676.702-.78.858-1.404 1.248h7.594c2.054 0 1.639-1.274 1.274-1.924-.754-1.326-3.146-3.771-3.146-3.771S47.36 38.83 47.23 38.96Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.57 45.878h-1.248s1.327.728 1.327 2.627v6.059c0 3.927 3.25 7.568 7.203 7.568h3.303c1.976 0 2.678-.469 3.875-1.535.441-.39 1.014-1.04 1.222-1.274.676-.78 1.43-1.404 1.43-3.433v-1.976c0-1.717-.988-2.42-1.482-2.913-.38-.375-.76-.747-1.144-1.118v4.057s.832.884 1.196 1.17c1.716 1.352.364 3.693-1.248 3.693h-7.256c-2.652.052-6.267-2.315-6.267-6.32v-3.276c.026-3.329-.91-3.329-.91-3.329Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.528 53.264c0 .702-2.21 2.548-2.34 2.652-.156-.754-.728-1.56-2.367-3.225l2.419-2.418c1.612 1.613 2.288 1.976 2.288 2.99ZM21.172 80.18h-3.9c-1.223 0-1.119-1.014-1.249-1.873v-5.565s.859-.026 1.82-.026c1.067 0 2.42-.156 3.72.572a3.957 3.957 0 0 0-3.72-2.262H16.05V69.23s0-1.56-.39-2.002h2.574c2.212 0 3.928-.026 5.722 1.144 0 0-.338-2.938-4.629-2.938h-8.374s1.456 1.248 1.404 3.77l.052 10.142c0 2.55 1.015 2.627 1.015 2.627h8.244c1.872 0 2.522-1.326 2.522-2.054l.026-.962s-.598 1.222-3.043 1.222Zm21.95-.859v-7.099c0-2.757-2.237-3.485-3.928-3.485-2.21 0-2.886 1.847-3.172 2.497-.494-1.716-2.237-2.497-3.641-2.497-2.679 0-3.355 2.549-3.355 2.549s-.052-2.47-2.21-2.47h-2.107s1.222.493 1.222 2.626v7.88c0 2.6 1.04 2.652 1.04 2.652h3.486a3.338 3.338 0 0 1-1.327-2.679V72.3c.052-.312.572-1.352 2.054-1.352.859 0 1.795.884 1.769 1.872v6.501c0 2.627 1.04 2.653 1.04 2.653h3.485c-.832-.65-1.326-1.613-1.326-2.679V72.3a1.962 1.962 0 0 1 3.823.546v6.475c.026 2.653 1.04 2.627 1.04 2.627H44.5a3.328 3.328 0 0 1-1.379-2.627Zm6.085 0a3.326 3.326 0 0 0 1.326 2.653h-3.485s-1.066.026-1.066-2.627v-7.931c0-2.08-1.196-2.627-1.196-2.627h2.106c.754 0 2.289 0 2.289 2.939v7.542l.026.051Zm10.714-9.518s-.338-.936-1.768-.936c-2.184 0-2.705 2.6-2.705 2.6-.182-2.054-.728-2.652-2.263-2.652H51.08s1.222.494 1.222 2.627v7.88c0 2.6 1.041 2.652 1.041 2.652h3.485a3.325 3.325 0 0 1-1.327-2.653v-6.475c.078-.546.39-1.04.858-1.326 1.17-.78 2.705-.546 3.615.52l-.052-2.237Zm16.202.469a4.3 4.3 0 0 1 2.054.52v-1.977h-2.912v-3.017a11.224 11.224 0 0 1-2.341 2.627c-.988.806-3.069 1.82-3.069 1.82l2.211.027v9.153c0 2.549 1.066 2.549 1.066 2.549h3.459a3.278 3.278 0 0 1-1.352-2.575v-9.127h.884Zm10.558 3.978c-1.95 2.029-3.485 1.717-4.707 3.225 0 0 .208 2.029 1.742 2.73.52.235 2.679 1.015 4.057-1.378v2.133S86.89 82 84.055 82c-3.407 0-5.748-2.679-5.748-6.32 0-3.588 1.899-6.89 5.513-6.917 3.511-.052 5.436 2.809 2.861 5.487Zm-2.132-.832c.572-1.066 1.04-3.77-.936-3.615-2.289.183-1.847 6.242-1.847 6.242.754-.832 1.898-1.014 2.783-2.627ZM47.595 67.75a1.61 1.61 0 0 0 1.56-1.612 1.61 1.61 0 0 0-1.613-1.56c-.858.025-1.56.728-1.56 1.586 0 .884.728 1.586 1.613 1.586Zm15.94 12.717c-.78 0-1.351-.832-1.351-1.665 0-3.276 2.678-3.744 3.406-4.603v5.54c-.338.26-.65.728-2.054.728Zm2.055-7.542c-.806 1.405-7.099 1.716-6.137 6.58.39 1.924 1.665 2.496 3.277 2.496 1.56 0 2.523-.806 2.912-1.586.235 1.456.989 1.56.989 1.56h3.484c-.832-.624-1.352-1.586-1.352-2.627v-7.41c0-1.769-1.95-3.147-4.03-3.147a5.549 5.549 0 0 0-3.252.962v2.288s.729-1.82 2.523-1.82c1.768 0 1.899.884 1.899 1.326.026.468-.052.962-.313 1.379v-.001Zm28.789 5.461c.026.936-.806 2.16-2.575 2.16-1.82 0-2.548-1.848-2.548-1.848v2.341a6.166 6.166 0 0 0 3.302.936c2.367 0 4.785-1.794 4.733-4.317a4.004 4.004 0 0 0-.805-2.288c-.807-1.066-2.264-1.82-3.407-2.523-.65-.39-.989-1.118-.989-1.352-.026-.442.209-1.326 1.95-1.326 1.717 0 2.471 1.82 2.471 1.82v-2.21a5.804 5.804 0 0 0-3.329-1.04c-2.08 0-3.978 1.378-3.926 3.146.026 1.56.676 2.549 1.95 3.51.573.413 1.172.786 1.795 1.119.988.546 1.352 1.222 1.378 1.872Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "emirates_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25834"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25834",
    result: "shape"
  }))));
};
var SvgEmiratesIcon$1 = SvgEmiratesIcon;

const SvgExclamationCircleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.079 33.079",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.539,
    cy: 16.539,
    r: 15.789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.539 25.962v-1.068M16.539 20.64V7.117"
  })));
};
var SvgExclamationCircleOutlined$1 = SvgExclamationCircleOutlined;

const SvgExclamationSquareOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.23 33.23",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 31.73,
    height: 31.73,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.058 18.529 19.07 6.316h-4.911l1.013 12.213h2.886z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.615,
    cy: 24.649,
    r: 2.265
  })));
};
var SvgExclamationSquareOutlined$1 = SvgExclamationSquareOutlined;

const SvgEyeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.641 18.329",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.891 9.164a19.9 19.9 0 0 1-16.077 8.415A19.866 19.866 0 0 1 .75 9.164 19.9 19.9 0 0 1 16.827.75a19.866 19.866 0 0 1 16.064 8.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.283 5.3a5.279 5.279 0 1 1 7.517 7.415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 12.715A5.279 5.279 0 0 1 13.283 5.3"
  })));
};
var SvgEyeOutlined$1 = SvgEyeOutlined;

const SvgEyeSlashOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.942 28.881",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.192 14.181a20.087 20.087 0 0 1-16.227 8.493A20.053 20.053 0 0 1 .75 14.181a20.09 20.09 0 0 1 16.227-8.493 20.053 20.053 0 0 1 16.215 8.493ZM3.367.75l27.381 27.381M5.94 9.101l13.431 13.43M3.114 11.41l11.073 11.072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.687 12.536a2.115 2.115 0 0 1 3.013 2.972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4 10.279a5.328 5.328 0 0 1 7.583 7.486"
  })));
};
var SvgEyeSlashOutlined$1 = SvgEyeSlashOutlined;

const SvgFairDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.215 53.447c-1.054 0-2.107.114-3.136.34-3.292-7.728-10.972-12.884-19.281-12.884-10.37 0-18.993 7.407-20.71 17.693h-.072c-6.78 0-12.297 5.594-12.297 12.471 0 6.874 5.516 12.466 12.297 12.466h43.2c8.177 0 14.83-6.748 14.83-15.043 0-8.295-6.653-15.043-14.83-15.043ZM96.064 68.49c0 6.633-5.315 12.03-11.849 12.03h-43.2c-5.135 0-9.313-4.24-9.313-9.453 0-5.215 4.178-9.457 9.314-9.457.343 0 .718.027 1.18.084l1.515.19.152-1.534c.935-9.368 8.646-16.432 17.934-16.432 7.599 0 14.42 4.891 16.973 12.174l.482 1.375 1.374-.443a11.763 11.763 0 0 1 3.59-.562c6.533 0 11.848 5.395 11.848 12.028ZM41.257 28.293a1.62 1.62 0 0 1-1.732 1.488 1.621 1.621 0 0 1-1.482-1.741l1.112-14.291a1.62 1.62 0 0 1 1.734-1.49c.884.07 1.551.855 1.482 1.742l-1.114 14.292ZM25.672 34.33c-.662.59-1.687.53-2.276-.136l-9.476-10.72a1.631 1.631 0 0 1 .135-2.286 1.612 1.612 0 0 1 2.276.134l9.476 10.72c.59.666.53 1.695-.135 2.288ZM11.816 70.47l10.447-9.765a1.614 1.614 0 0 1 2.28.083 1.63 1.63 0 0 1-.083 2.289l-10.447 9.765a1.613 1.613 0 0 1-2.28-.082 1.632 1.632 0 0 1 .083-2.29Zm52.402-47.005a1.614 1.614 0 0 0-2.28-.083L51.49 33.148a1.63 1.63 0 0 0-.081 2.29 1.61 1.61 0 0 0 2.278.082l10.448-9.766a1.63 1.63 0 0 0 .082-2.288ZM19.816 46.62a1.625 1.625 0 0 0-1.457-1.762L4.15 43.529a1.62 1.62 0 0 0-.3 3.226l14.211 1.327a1.62 1.62 0 0 0 1.756-1.463ZM38.84 36.306c-6.533-.59-12.325 4.27-12.911 10.834-.379 4.24 1.516 8.163 4.66 10.572-.798.825-1.4 1.667-1.846 2.437-3.953-3.026-6.333-7.953-5.856-13.284.737-8.247 8.016-14.355 16.226-13.615 4.13.372 7.72 2.409 10.175 5.39a20.614 20.614 0 0 0-2.329 1.986 11.84 11.84 0 0 0-8.119-4.32Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgFairDay$1 = SvgFairDay;

const SvgFairNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.155 55.887c-.915 0-1.828.1-2.72.295C75.579 49.475 68.918 45 61.71 45c-8.995 0-16.474 6.429-17.963 15.356h-.063c-5.88 0-10.666 4.855-10.666 10.824 0 5.966 4.785 10.82 10.666 10.82h37.47c7.094 0 12.864-5.857 12.864-13.056 0-7.2-5.77-13.057-12.864-13.057Zm10.277 13.057c0 5.757-4.61 10.44-10.277 10.44h-37.47c-4.455 0-8.078-3.68-8.078-8.204 0-4.526 3.623-8.208 8.078-8.208.298 0 .623.023 1.023.073l1.315.166.132-1.332c.81-8.131 7.5-14.262 15.556-14.262 6.59 0 12.506 4.245 14.721 10.566l.418 1.194 1.192-.385a10.197 10.197 0 0 1 3.113-.488c5.667 0 10.277 4.683 10.277 10.44Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.748 77.375a26.454 26.454 0 0 1-6.788-.57c-4.487-.97-8.108-3.576-11.238-6.977-.46-.5-.9-1.024-1.4-1.598 10.702 1.174 19.63-2.195 26.04-11.19 6.372-8.939 7.069-18.783 3.04-29.08.058.01.128.01.182.037 6.214 3.241 10.84 8.007 13.108 14.895.73-.222 1.524-.416 2.328-.533-.08-.245-.146-.489-.23-.734-3.046-8.816-9.483-14.235-17.724-17.512-.552-.218-1.078-.132-1.467.362-.389.49-.378 1.027-.058 1.562.092.153.181.308.27.462 2.843 4.952 4.243 10.302 3.536 16.049-1.21 9.824-6.108 17.041-14.748 21.272-5.348 2.619-10.976 2.719-16.657 1.249-.805-.21-1.368-.082-1.705.452-.34.54-.302 1.057.254 1.75 1.256 1.57 2.46 3.198 3.836 4.647 5.767 6.075 12.725 8.808 20.946 7.917.137-.025.274-.046.412-.07a11.87 11.87 0 0 1-1.937-2.39Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgFairNight$1 = SvgFairNight;

const SvgFileAppOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.29 25.798",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.54 9.106h-6a2.131 2.131 0 0 1-2.1-2.164V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.54 13.633V9.106L13.444.75H2.331A1.581 1.581 0 0 0 .75 2.331v11.3M9.583 25.048V17.83h2.175a2.458 2.458 0 0 1 2.458 2.458h0a2.458 2.458 0 0 1-2.458 2.457H9.583M16.907 25.048V17.83h2.175a2.458 2.458 0 0 1 2.458 2.458h0a2.458 2.458 0 0 1-2.458 2.457h-2.175M.75 25.048l2.543-7.089h.754l2.731 7.089M1.618 22.628h3.915"
  })));
};
var SvgFileAppOutlined$1 = SvgFileAppOutlined;

const SvgFileCsvOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.519 26.155",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.993 19.257a2.747 2.747 0 0 0-2.212-1.2c-1.93 0-2.2 1.355-2.2 1.93 0 .937.841 1.484 2.206 1.761 1.38.28 2.629.61 2.629 1.911 0 1.317-1.1 1.814-2.414 1.735a3.708 3.708 0 0 1-2.422-1.306M6.861 24.432a3.651 3.651 0 1 1-.3-5.643M21.769 18.149l-2.571 7.167h0l-2.572-7.167M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.769 13.776V9.2L13.584.75H2.349a1.6 1.6 0 0 0-1.6 1.6v11.426"
  })));
};
var SvgFileCsvOutlined$1 = SvgFileCsvOutlined;

const SvgFileDocOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.52 26.134",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.769 13.776V9.2L13.584.75H2.349a1.6 1.6 0 0 0-1.6 1.6v11.426"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.97,
    cy: 21.722,
    rx: 2.9,
    ry: 3.662
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.035 25.384a3.652 3.652 0 1 0 0-7.3H.75v7.3ZM21.454 18.568a3.637 3.637 0 0 0-1.824-.487 3.419 3.419 0 0 0-3.367 3.652 3.419 3.419 0 0 0 3.367 3.651 3.634 3.634 0 0 0 2.14-.692"
  })));
};
var SvgFileDocOutlined$1 = SvgFileDocOutlined;

const SvgFileEpsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 26.687 26.155",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.193.795v7.298h4.763M5.956.795H1.193M4.935 4.596H1.193"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.974,
    cy: 14.347,
    r: 2.257
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.717 25.405 5.798-6.975 5.797 6.975H5.717zM22.441 25.405h-5.067l-3.833-4.612 6.405-7.397 5.859 7.618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 12.09v10.82a2.5 2.5 0 0 0 2.5 2.5h20.2a2.5 2.5 0 0 0 2.5-2.5V3.266a2.5 2.5 0 0 0-2.5-2.495h-.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.653 8.071V.774h1.628a2.485 2.485 0 0 1 2.485 2.484h0a2.486 2.486 0 0 1-2.485 2.485H8.653M19.355 1.946A2.507 2.507 0 0 0 17.322.75 1.836 1.836 0 0 0 15.3 2.68c0 .937.774 1.484 2.029 1.761s2.416.609 2.416 1.911-1.01 1.814-2.219 1.735a3.342 3.342 0 0 1-2.226-1.31"
  })));
};
var SvgFileEpsOutlined$1 = SvgFileEpsOutlined;

const SvgFileExeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.29 25.863",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.54 9.106h-6a2.131 2.131 0 0 1-2.1-2.164V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.54 13.633V9.106L13.444.75H2.331A1.581 1.581 0 0 0 .75 2.331v11.3M13.902 25.048l-5.515-7.089M8.387 25.048l5.515-7.089M.75 17.895v7.218h4.711M5.461 17.895H.75M4.451 21.654H.75M16.829 17.895v7.218h4.711M21.54 17.895h-4.711M20.529 21.654h-3.7"
  })));
};
var SvgFileExeOutlined$1 = SvgFileExeOutlined;

const SvgFileFsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.519 26.155",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 13.776V2.349a1.6 1.6 0 0 1 1.6-1.6h11.234L21.769 9.2v16.116h-5.093M.75 25.316v-7.297M5.513 18.019H.75M4.492 21.82H.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.66 19.257a2.748 2.748 0 0 0-2.213-1.2c-1.93 0-2.2 1.355-2.2 1.93 0 .937.842 1.484 2.207 1.761 1.38.28 2.628.61 2.628 1.911 0 1.317-1.1 1.814-2.413 1.735a3.71 3.71 0 0 1-2.422-1.309"
  })));
};
var SvgFileFsOutlined$1 = SvgFileFsOutlined;

const SvgFileGifOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 26.687 26.134",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.204 8.051V.753M6.183 1.459A3.631 3.631 0 0 0 4.021.75 3.346 3.346 0 0 0 .75 4.4a3.346 3.346 0 0 0 3.271 3.654A3.637 3.637 0 0 0 6.48 7.1V4.4H4.16M13.863 8.072V.775M18.626.775h-4.763M17.605 4.576h-3.742"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.974,
    cy: 14.327,
    r: 2.257
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.717 25.384 5.798-6.974 5.797 6.974H5.717zM22.441 25.384h-5.067l-3.833-4.612 6.405-7.397 5.859 7.619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 12.07v10.819a2.5 2.5 0 0 0 2.5 2.5h20.2a2.5 2.5 0 0 0 2.5-2.5V3.245A2.5 2.5 0 0 0 23.442.75h-.722"
  })));
};
var SvgFileGifOutlined$1 = SvgFileGifOutlined;

const SvgFileJpegOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 26.687 26.134",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.974,
    cy: 14.327,
    r: 2.257
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.717 25.384 5.798-6.974 5.797 6.974H5.717zM22.441 25.384h-5.067l-3.833-4.612 6.405-7.397 5.859 7.619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 12.07v10.819a2.5 2.5 0 0 0 2.5 2.5h20.2a2.5 2.5 0 0 0 2.5-2.5V3.245A2.5 2.5 0 0 0 23.442.75h-.722M3.322.753v4.726A2.573 2.573 0 0 1 .75 8.051h0M6.546 8.051V.753h2.2a2.484 2.484 0 0 1 2.484 2.485h0a2.484 2.484 0 0 1-2.485 2.484h-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.37 1.459A3.633 3.633 0 0 0 17.208.75a3.346 3.346 0 0 0-3.271 3.65 3.346 3.346 0 0 0 3.271 3.652 3.637 3.637 0 0 0 2.459-.952V4.4h-2.321"
  })));
};
var SvgFileJpegOutlined$1 = SvgFileJpegOutlined;

const SvgFileKsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.519 26.155",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 13.776V2.349a1.6 1.6 0 0 1 1.6-1.6h11.234L21.769 9.2v16.116h-4.9M.75 25.316v-7.297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.85 19.257a2.747 2.747 0 0 0-2.212-1.2c-1.93 0-2.2 1.355-2.2 1.93 0 .937.841 1.484 2.207 1.761s2.628.61 2.628 1.911c0 1.317-1.1 1.814-2.414 1.735a3.708 3.708 0 0 1-2.421-1.309M.75 22.75l4.69-4.731M2.637 20.863l3.176 4.453"
  })));
};
var SvgFileKsOutlined$1 = SvgFileKsOutlined;

const SvgFilePdfOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.519 26.066",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.769 13.776V9.2L13.584.75H2.349a1.6 1.6 0 0 0-1.6 1.6v11.426M8.919 25.275v-7.258s4.859-.7 4.859 3.629-4.859 3.629-4.859 3.629ZM17.006 25.316v-7.297M21.769 18.019h-4.763M20.748 21.82h-3.742M.75 25.316v-7.3h2.485A2.484 2.484 0 0 1 5.719 20.5h0a2.485 2.485 0 0 1-2.484 2.485H.75"
  })));
};
var SvgFilePdfOutlined$1 = SvgFilePdfOutlined;

const SvgFilePngOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 26.687 26.134",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.193 8.051V.753h1.628a2.485 2.485 0 0 1 2.485 2.485h0a2.485 2.485 0 0 1-2.485 2.484H1.193M7.782 8.051V.753l3.987 7.298V.753M19.813 1.459A3.631 3.631 0 0 0 17.651.75 3.346 3.346 0 0 0 14.38 4.4a3.346 3.346 0 0 0 3.271 3.652 3.638 3.638 0 0 0 2.46-.953V4.4H17.79"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.974,
    cy: 14.327,
    r: 2.257
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.717 25.384 5.798-6.974 5.797 6.974H5.717zM22.441 25.384h-5.067l-3.833-4.612 6.405-7.397 5.859 7.619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 12.07v10.819a2.5 2.5 0 0 0 2.5 2.5h20.2a2.5 2.5 0 0 0 2.5-2.5V3.245A2.5 2.5 0 0 0 23.442.75h-.722"
  })));
};
var SvgFilePngOutlined$1 = SvgFilePngOutlined;

const SvgFilePptOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.519 26.066",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.769 13.776V9.2L13.584.75H2.349a1.6 1.6 0 0 0-1.6 1.6v11.426M18.911 25.316v-7.297M21.769 18.019h-5.715M.75 25.316v-7.3h2.485A2.484 2.484 0 0 1 5.719 20.5h0a2.485 2.485 0 0 1-2.484 2.485H.75M8.821 25.316v-7.3h2.485a2.485 2.485 0 0 1 2.485 2.484h0a2.486 2.486 0 0 1-2.485 2.485H8.821"
  })));
};
var SvgFilePptOutlined$1 = SvgFilePptOutlined;

const SvgFileRtfOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.519 26.066",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.769 13.776V9.2L13.584.75H2.349a1.6 1.6 0 0 0-1.6 1.6v11.426M17.006 25.316v-7.297M21.769 18.019h-4.763M20.748 21.82h-3.742M.75 25.314v-7.3h3.471a1.9 1.9 0 0 1 1.9 1.9h0a1.9 1.9 0 0 1-1.9 1.9H.75M3.483 21.824l2.46 3.492M11.384 25.315v-7.297M14.241 18.018H8.526"
  })));
};
var SvgFileRtfOutlined$1 = SvgFileRtfOutlined;

const SvgFileSvgOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 26.687 26.155",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.813 1.479a3.637 3.637 0 0 0-2.162-.708 3.345 3.345 0 0 0-3.271 3.651 3.346 3.346 0 0 0 3.271 3.652 3.641 3.641 0 0 0 2.46-.952v-2.7H17.79M5.251 1.946A2.51 2.51 0 0 0 3.217.75a1.837 1.837 0 0 0-2.024 1.93c0 .937.774 1.484 2.029 1.761s2.416.609 2.416 1.911-1.01 1.814-2.219 1.735a3.347 3.347 0 0 1-2.226-1.31M12.296.839 10.01 8.006h0L7.725.839"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.974,
    cy: 14.347,
    r: 2.257
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.717 25.405 5.798-6.975 5.797 6.975H5.717zM22.441 25.405h-5.067l-3.833-4.612 6.405-7.397 5.859 7.618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 12.09v10.82a2.5 2.5 0 0 0 2.5 2.5h20.2a2.5 2.5 0 0 0 2.5-2.5V3.266a2.5 2.5 0 0 0-2.5-2.495h-.73"
  })));
};
var SvgFileSvgOutlined$1 = SvgFileSvgOutlined;

const SvgFileTxtOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.519 26.131",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.769 13.776V9.2L13.584.75H2.349a1.6 1.6 0 0 0-1.6 1.6v11.426M13.952 25.316l-5.385-7.167M8.567 25.316l5.385-7.167M3.322 25.381v-7.297M5.894 18.084H.75M19.197 25.381v-7.297M21.769 18.084h-5.144"
  })));
};
var SvgFileTxtOutlined$1 = SvgFileTxtOutlined;

const SvgFileXlsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.536 26.155",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.769 13.776V9.2L13.584.75H2.349a1.6 1.6 0 0 0-1.6 1.6v11.426M6.516 25.316.75 18.149M.75 25.316l5.766-7.167M9.835 18.149v7.167h4.234M21.365 19.257a2.748 2.748 0 0 0-2.213-1.2c-1.93 0-2.2 1.355-2.2 1.93 0 .937.842 1.484 2.207 1.761s2.628.61 2.628 1.911c0 1.317-1.1 1.814-2.414 1.735a3.71 3.71 0 0 1-2.421-1.309"
  })));
};
var SvgFileXlsOutlined$1 = SvgFileXlsOutlined;

const SvgFileXmlOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.519 26.066",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.769 9.2H15.7a2.154 2.154 0 0 1-2.12-2.187V.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.769 13.776V9.2L13.584.75H2.349a1.6 1.6 0 0 0-1.6 1.6v11.426M6.326 25.316.75 18.149M.75 25.316l5.576-7.167M9.264 25.316v-7.167l2.762 5.262 2.761-5.262v7.167M17.916 18.149v7.167h3.853"
  })));
};
var SvgFileXmlOutlined$1 = SvgFileXmlOutlined;

const SvgFileZipOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.29 25.865",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.54 9.106h-6a2.131 2.131 0 0 1-2.1-2.164V.75M7.301.75v8.655M5.799 6.596h3.004M8.031 12.579H6.572a.773.773 0 0 1-.773-.772V9.4h3v2.4a.772.772 0 0 1-.768.779ZM5.799 3.596h3.004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.445 25.048h4.095V9.106L13.444.75H2.331A1.581 1.581 0 0 0 .75 2.331v11.3M7.738 25.115v-7.258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.935 25.115v-7.258h1.713a2.471 2.471 0 0 1 2.471 2.471h0a2.471 2.471 0 0 1-2.471 2.472h-1.713M.75 17.857h3.978L.75 25.115h3.978"
  })));
};
var SvgFileZipOutlined$1 = SvgFileZipOutlined;

const SvgFilterOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 29.129 28.453",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.75 5.365 10.022 10.159a1.329 1.329 0 0 1 .383.934v9.913a1.33 1.33 0 0 0 1.934 1.185l4.158-2.12a1.329 1.329 0 0 0 .726-1.185v-7.793a1.33 1.33 0 0 1 .384-.934L28.379 5.365M2.08.75h24.969a1.33 1.33 0 0 1 1.33 1.33v3.285h0H.75h0V2.08A1.33 1.33 0 0 1 2.08.75Z"
  })));
};
var SvgFilterOutlined$1 = SvgFilterOutlined;

const SvgFinnairIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#finnair_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.964 32.326c-4.825 0-7.841 1.206-10.454 4.423L37.632 54.24c-2.413 2.614-2.815 2.815-7.238 2.815H4v12.063h28.003c6.031 0 8.846-1.206 12.264-4.825l5.227-6.635h11.259c4.624 0 7.64-1.608 10.253-4.423l3.82-4.825H55.123s3.016-3.619 3.418-4.021c.402-.402.804-.603 1.809-.603h15.079c4.624 0 8.444-1.206 11.661-4.825l5.026-6.635H62.964Z",
    fill: "#004578"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "finnair_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25832"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25832",
    result: "shape"
  }))));
};
var SvgFinnairIcon$1 = SvgFinnairIcon;

const SvgFireExtinguisherOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 18.958 32.653",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.435 5.921V.75h4.188v5.171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.529 5.612h0a5.812 5.812 0 0 1 5.812 5.812v19.411a1.067 1.067 0 0 1-1.068 1.065H6.784a1.067 1.067 0 0 1-1.067-1.067V11.424a5.812 5.812 0 0 1 5.812-5.812ZM11.529.75h6.679M13.623.75l4.4 4.401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.435 2.95H7.7A6.949 6.949 0 0 0 .75 9.9v20.855M12.77 11.952h4.571v8.346H12.77zM5.717 26.753h11.624"
  })));
};
var SvgFireExtinguisherOutlined$1 = SvgFireExtinguisherOutlined;

const SvgFirstAidOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 38.901 32.476",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 6.122,
    width: 37.401,
    height: 25.604,
    rx: 1.595
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.14 6.122v-4.2A1.176 1.176 0 0 1 15.316.75h8.269a1.175 1.175 0 0 1 1.175 1.176v4.2M27.254 16.719h-5.599V11.12h-4.409v5.599h-5.599v4.409h5.599v5.6h4.409v-5.6h5.599v-4.409z"
  })));
};
var SvgFirstAidOutlined$1 = SvgFirstAidOutlined;

const SvgFlagOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 19.359 28.623",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75.75v27.123M18.609 15.286H.75V2.14h17.859L14.89 8.713l3.719 6.573z"
  })));
};
var SvgFlagOutlined$1 = SvgFlagOutlined;

const SvgFlightTowerOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.561 34.675",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.863 19.581h11.835v14.344H6.863zM22.675 19.581H2.886l-1.023-3.222h21.835l-1.023 3.222zM1.738 5.804h22.085l.988 3.112H.75l.988-3.112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.861 16.359H3.7L2.104 8.916h21.353l-1.596 7.443z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.659 16.359H9.902L8.898 8.916h7.765l-1.004 7.443zM11.436 5.804V.75M14.124 5.804v-3.32"
  })));
};
var SvgFlightTowerOutlined$1 = SvgFlightTowerOutlined;

const SvgFloppyDiskOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.145 28.145",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75.75v26.645h26.645V6.812L21.333.75H.75z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.119,
    cy: 15.856,
    r: 4.057
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96.75h14.317v5.741H6.96z"
  })));
};
var SvgFloppyDiskOutlined$1 = SvgFloppyDiskOutlined;

const SvgFlybussIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#flybuss_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.05 31.195c4.117-2.383 7.908-2.762 12.24-1.462 5.959 1.787 12.08 2.816 18.145 4.279 1.409.325 2.654 0 3.954-.488 3.63-1.354 7.258-2.654 10.887-4.116 4.279-1.68 8.612-1.68 13.053-.921 1.408.217 3.142.488 3.575 2.004.487 1.733-.975 2.762-2.22 3.683-4.117 3.196-8.83 5.254-13.541 7.204C62.11 47.93 45.645 53.13 28.8 57.193c-2.545.596-4.387.271-6.12-1.95-2.491-3.195-5.308-6.12-8.07-9.099-.758-.867-.975-1.354.325-1.896 2.058-.92 4.116-1.516 6.174-.216 6.23 3.845 12.133 3.791 18.578.054 4.82-2.817 5.146-2.275.813-5.796-2.817-2.328-5.525-4.657-8.45-7.095ZM53.065 75.013c-11.374 0-22.694 0-34.068-.055-.758 0-2.708.921-2.22-1.083.379-1.408-.813-3.954 2.6-3.954 22.91.109 45.767.055 68.677.163.867 0 2.546-1.246 2.654.867.163 2.87-.812 4.062-3.033 4.062h-34.61Z",
    fill: "#1D3644"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "flybuss_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4393_37142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4393_37142",
    result: "shape"
  }))));
};
var SvgFlybussIcon$1 = SvgFlybussIcon;

const SvgFlytogetIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#flytoget_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#FD4F00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.426 38.389H19s6.298 7.054 8.864 9.806c2.528 2.71 4.606 2.75 7.32 2.803l.122.003c2.773.054 41.055 0 41.055 0s-1.909-2.274-3.654-3.185c-1.746-.912-2.72-.95-4.706-.95H41.894c-4.592 0-7.073-2.059-7.073-2.059l-6.395-6.418ZM79.513 65.61H89s-6.464-7.084-9.026-9.835c-2.492-2.678-4.818-2.722-7.492-2.773A86.445 86.445 0 0 1 72.26 53c-2.768-.054-40.622 0-40.622 0s2.327 2.506 3.518 3.157c1.192.65 2.191.978 4.663.978h25.87c4.76 0 5.827.78 7 1.742s6.823 6.735 6.823 6.735Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "flytoget_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4393_36997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4393_36997",
    result: "shape"
  }))));
};
var SvgFlytogetIcon$1 = SvgFlytogetIcon;

const SvgFog = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.731 65H77.6c.861 0 1.566-.675 1.566-1.5S78.46 62 77.599 62H17.731c-.861 0-1.566.675-1.566 1.5s.705 1.5 1.566 1.5Zm20 10H83.6c.86 0 1.564-.675 1.564-1.5s-.704-1.5-1.564-1.5H37.73c-.86 0-1.566.675-1.566 1.5s.705 1.5 1.566 1.5Zm38.987 10H28.614c-1.348 0-2.449-.675-2.449-1.5s1.101-1.5 2.45-1.5h48.103c1.346 0 2.447.675 2.447 1.5S78.064 85 76.718 85ZM69.608 26.998c-1.058 0-2.113.11-3.144.325C63.166 19.93 55.471 15 47.144 15c-10.39 0-19.03 7.085-20.75 16.923h-.073C19.528 31.923 14 37.273 14 43.851c0 6.577 5.528 11.926 12.321 11.926h43.287c8.194 0 14.86-6.456 14.86-14.39s-6.666-14.389-14.86-14.389Zm11.871 14.39c0 6.345-5.324 11.506-11.87 11.506H26.32c-5.146 0-9.332-4.056-9.332-9.043 0-4.987 4.186-9.045 9.332-9.045.343 0 .72.026 1.182.081l1.518.182.153-1.469c.937-8.96 8.664-15.717 17.97-15.717 7.615 0 14.449 4.68 17.007 11.646l.484 1.315 1.376-.424c1.17-.357 2.38-.54 3.597-.54 6.547 0 11.871 5.162 11.871 11.507Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgFog$1 = SvgFog;

const SvgFolderOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.529 26.395",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.779 20.441V6.335a2.491 2.491 0 0 0-2.491-2.491H15.354L13.01.75H3.241A2.491 2.491 0 0 0 .75 3.241v17.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 9.048,
    width: 30.029,
    height: 16.597,
    rx: 2.491
  })));
};
var SvgFolderOutlined$1 = SvgFolderOutlined;

const SvgGearOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.489 33.923",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.58 18.015a11.9 11.9 0 0 0 0-2.1 1.15 1.15 0 0 1 .3-.894l2.285-2.455a2.162 2.162 0 0 0 .29-2.556l-1.33-2.3a2.164 2.164 0 0 0-2.365-1.033l-3.268.752a1.148 1.148 0 0 1-.922-.191 11.585 11.585 0 0 0-1.817-1.048 1.156 1.156 0 0 1-.627-.7l-.983-3.21A2.164 2.164 0 0 0 17.074.75h-2.659a2.165 2.165 0 0 0-2.069 1.53l-.983 3.206a1.149 1.149 0 0 1-.627.7 11.966 11.966 0 0 0-1.821 1.052 1.155 1.155 0 0 1-.921.191l-3.265-.752A2.164 2.164 0 0 0 2.37 7.7L1.04 10a2.165 2.165 0 0 0 .29 2.557l2.284 2.452a1.157 1.157 0 0 1 .295.893 11.9 11.9 0 0 0 0 2.1 1.152 1.152 0 0 1-.295.894L1.33 21.359a2.165 2.165 0 0 0-.29 2.557l1.33 2.3a2.163 2.163 0 0 0 2.359 1.027L8 26.494a1.153 1.153 0 0 1 .922.191q.425.3.884.566c.306.177.618.337.933.483a1.153 1.153 0 0 1 .626.7l.983 3.207a2.164 2.164 0 0 0 2.069 1.529h2.659a2.163 2.163 0 0 0 2.069-1.529l.983-3.207a1.154 1.154 0 0 1 .627-.7 11.835 11.835 0 0 0 1.821-1.049 1.154 1.154 0 0 1 .921-.19l3.265.751a2.163 2.163 0 0 0 2.359-1.027l1.33-2.3a2.164 2.164 0 0 0-.29-2.557l-2.283-2.452a1.151 1.151 0 0 1-.298-.895Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.745,
    cy: 16.962,
    r: 5.256
  })));
};
var SvgGearOutlined$1 = SvgGearOutlined;

const SvgGearsGraphOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.03 31.101",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.535 25.523a5.1 5.1 0 0 0 .293-.866.5.5 0 0 1 .247-.327l1.284-.693a.94.94 0 0 0 .476-1.012l-.226-1.135a.941.941 0 0 0-.828-.752l-1.452-.147a.5.5 0 0 1-.353-.207q-.133-.183-.285-.357a4.702 4.702 0 0 0-.317-.329.5.5 0 0 1-.16-.377l.043-1.458a.941.941 0 0 0-.639-.919l-1.1-.372a.942.942 0 0 0-1.066.342L11.6 18.1a.5.5 0 0 1-.357.2 5.05 5.05 0 0 0-.9.178.5.5 0 0 1-.4-.051L8.7 17.662a.941.941 0 0 0-1.115.094l-.87.763a.942.942 0 0 0-.237 1.094l.6 1.329a.5.5 0 0 1 0 .409 5.133 5.133 0 0 0-.293.866.5.5 0 0 1-.247.327l-1.284.692a.941.941 0 0 0-.476 1.013L5 25.383a.942.942 0 0 0 .829.753l1.451.146a.5.5 0 0 1 .353.208q.134.183.286.356c.1.116.207.226.316.329a.5.5 0 0 1 .16.378l-.042 1.458a.941.941 0 0 0 .638.919l1.1.371a.94.94 0 0 0 1.066-.341l.853-1.184a.5.5 0 0 1 .356-.2 5.235 5.235 0 0 0 .9-.178.5.5 0 0 1 .406.05l1.24.766a.941.941 0 0 0 1.115-.094l.87-.763a.942.942 0 0 0 .237-1.094l-.6-1.329a.5.5 0 0 1 .001-.411Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.807,
    cy: 23.437,
    r: 2.286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.962 17.255a5.174 5.174 0 0 0 .293-.867.5.5 0 0 1 .246-.327l1.285-.692a.941.941 0 0 0 .476-1.013l-.226-1.134a.942.942 0 0 0-.829-.753l-1.451-.146a.5.5 0 0 1-.354-.207 4.547 4.547 0 0 0-.285-.357 4.484 4.484 0 0 0-.317-.329.5.5 0 0 1-.16-.377l.043-1.459a.942.942 0 0 0-.639-.919L26.949 8.3a.942.942 0 0 0-1.066.341l-.853 1.188a.5.5 0 0 1-.356.2 5.235 5.235 0 0 0-.9.178.5.5 0 0 1-.406-.05l-1.24-.765a.939.939 0 0 0-1.115.093l-.87.763a.941.941 0 0 0-.237 1.094l.6 1.329a.5.5 0 0 1 0 .409 5.19 5.19 0 0 0-.292.866.5.5 0 0 1-.247.328l-1.284.692a.941.941 0 0 0-.483 1.014l.227 1.135a.94.94 0 0 0 .828.752l1.452.147a.5.5 0 0 1 .353.207q.133.183.285.357c.1.116.208.225.317.329a.5.5 0 0 1 .16.377l-.043 1.459a.942.942 0 0 0 .639.919l1.1.371a.942.942 0 0 0 1.066-.341l.852-1.184a.5.5 0 0 1 .357-.2 5.205 5.205 0 0 0 .9-.178.5.5 0 0 1 .406.05l1.241.765a.942.942 0 0 0 1.115-.093l.869-.764a.941.941 0 0 0 .238-1.093l-.6-1.329a.506.506 0 0 1 0-.411Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.233,
    cy: 15.168,
    r: 2.286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.465 6.175v6.193M11.036.75V13.2M7.607 6.339v7.877M4.179 11.318v5.65M.75 14.686v4.172"
  })));
};
var SvgGearsGraphOutlined$1 = SvgGearsGraphOutlined;

const SvgGlobeDetailsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.318 33.318",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.659,
    cy: 16.659,
    r: 15.909
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.905 14.429 6.71 6.742a2.94 2.94 0 0 0 2.085.867h3.95a3.009 3.009 0 0 1 3.009 3.01v7.52M26.533 4.184l-1.411 1.41a3.2 3.2 0 0 1-2.265.939h-1.623a1.62 1.62 0 0 0-1.62 1.62v2.6a1.744 1.744 0 0 1-1.743 1.743h-.71a1.637 1.637 0 0 0-1.638 1.637v2.179a1.638 1.638 0 0 0 1.638 1.638h5.57a2.489 2.489 0 0 1 2.489 2.489v1.811a3.021 3.021 0 0 0 .885 2.137l2.627 2.627"
  })));
};
var SvgGlobeDetailsOutlined$1 = SvgGlobeDetailsOutlined;

const SvgGlobeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.744 32.744",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.372,
    cy: 16.372,
    r: 15.622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.819 26.887a22.2 22.2 0 0 1 11.553-3.13 22.2 22.2 0 0 1 11.553 3.13M27.925 6a22.2 22.2 0 0 1-11.553 3.127A22.2 22.2 0 0 1 4.819 6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.372,
    cy: 16.372,
    rx: 6.833,
    ry: 15.622
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.994 16.372H.75"
  })));
};
var SvgGlobeOutlined$1 = SvgGlobeOutlined;

const SvgGrid2Outlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 21.334 21.169",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75.75h7.893v7.893H.75zM12.69.75h7.893v7.893H12.69zM.75 12.526h7.893v7.893H.75zM12.69 12.526h7.893v7.893H12.69z"
  })));
};
var SvgGrid2Outlined$1 = SvgGrid2Outlined;

const SvgGridOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.063 9.286a.5.5 0 0 1 .5-.5h5.261a.5.5 0 0 1 .5.5v5.262a.5.5 0 0 1-.5.5H9.564a.5.5 0 0 1-.5-.5V9.286Zm1 .5v4.262h4.261V9.786h-4.261ZM17.023 9.286a.5.5 0 0 1 .5-.5h5.262a.5.5 0 0 1 .5.5v5.262a.5.5 0 0 1-.5.5h-5.262a.5.5 0 0 1-.5-.5V9.286Zm1 .5v4.262h4.262V9.786h-4.262ZM9.063 17.137a.5.5 0 0 1 .5-.5h5.261a.5.5 0 0 1 .5.5v5.262a.5.5 0 0 1-.5.5H9.564a.5.5 0 0 1-.5-.5v-5.262Zm1 .5v4.262h4.261v-4.262h-4.261ZM17.023 17.137a.5.5 0 0 1 .5-.5h5.262a.5.5 0 0 1 .5.5v5.262a.5.5 0 0 1-.5.5h-5.262a.5.5 0 0 1-.5-.5v-5.262Zm1 .5v4.262h4.262v-4.262h-4.262Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgGridOutlined$1 = SvgGridOutlined;

const SvgHandClickOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 22.318 35.316",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.733 15.958h0a1.836 1.836 0 0 0-1.833 1.836v-1.171a1.836 1.836 0 0 0-1.836-1.835h0a1.836 1.836 0 0 0-1.836 1.835V15.3a1.836 1.836 0 0 0-1.836-1.836h0a1.836 1.836 0 0 0-1.839 1.836V8.749a1.836 1.836 0 0 0-1.836-1.836h0a1.836 1.836 0 0 0-1.836 1.836v13.669h0v2.1L4.373 20.2a1.835 1.835 0 0 0-2.507-.672h0a1.835 1.835 0 0 0-.672 2.507l5.417 9.384a7.341 7.341 0 0 0 6.289 3.147h0a8.668 8.668 0 0 0 8.668-8.666v-8.1a1.836 1.836 0 0 0-1.835-1.842ZM10.553 15.303v4.485M14.22 16.623v3.165M17.897 17.64v2.148M8.717 4.26V.75M11.869 5.565l2.482-2.481M13.175 8.717h3.51M5.565 5.565 3.084 3.084M4.26 8.717H.75"
  })));
};
var SvgHandClickOutlined$1 = SvgHandClickOutlined;

const SvgHandHeartOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.089 27.844",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.36 1.557a3.066 3.066 0 0 0-4.24.128l-.41.41-.461-.461a3.017 3.017 0 0 0-4.268 0h0a3.019 3.019 0 0 0 0 4.268l4.627 4.626a.143.143 0 0 0 .2 0L23.439 5.9a3.019 3.019 0 0 0-.079-4.343ZM.75 16.224v10.87l7.267-4.68a.985.985 0 0 0 .309-1.336l-3.64-6.025a.984.984 0 0 0-1.337-.342ZM13.743 16.365l4.33 1.217A1.662 1.662 0 0 0 20.13 16.4h0a1.662 1.662 0 0 0-1.158-2.021l-5.418-1.523a7.33 7.33 0 0 0-5.105.424l-3.763 1.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.081 20.625.58-.272a5.97 5.97 0 0 1 4.605-.2L16 21.159a6.327 6.327 0 0 0 4.881-.212l7.409-3.485a1.824 1.824 0 0 0 .785-2.593h0a1.825 1.825 0 0 0-2.338-.708M26.738 14.161l-7.711 3.404"
  })));
};
var SvgHandHeartOutlined$1 = SvgHandHeartOutlined;

const SvgHandshakeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 43.156 29.502",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.513,
    y: 0.619,
    width: 5.895,
    height: 16.623,
    rx: 1.55,
    transform: "rotate(-27.866 36.46 8.932)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.925,
    y: -0.002,
    width: 5.895,
    height: 16.623,
    rx: 1.55,
    transform: "rotate(42.134 7.872 8.31)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.878 24.156 1.516 1.371a1.852 1.852 0 0 1 .131 2.615h0a1.852 1.852 0 0 1-2.616.131l-2.335-2.112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.543 20.668 3.31 3a1.851 1.851 0 0 1 .131 2.615h0a1.851 1.851 0 0 1-2.615.131l-2.491-2.253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.027 17.922 3.844 3.478A1.852 1.852 0 0 1 31 24.014h0a1.852 1.852 0 0 1-2.616.131l-3.843-3.477M29.512 15.176l4.743 4.291a1.851 1.851 0 0 1 .131 2.615h0a1.851 1.851 0 0 1-2.615.131l-4.744-4.291M30.928 4.491l-2.42 1.438a8.147 8.147 0 0 1-4.467 1.14l-.889-.032a2.188 2.188 0 0 0-1.876.935l-2.426 3.484a1.773 1.773 0 0 0 .534 2.528h0a1.773 1.773 0 0 0 2.354-.47l1.777-2.437M36.718 15.723l-2.917 2.441M8.537 15.62l-1.733-1.568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.388 7.827-.153-.139a3.8 3.8 0 0 0-3.023-.952h0a3.8 3.8 0 0 1-2.949-.888l-.669-.575M31.392 16.877l-7.294-6.599M22.964 11.833l1.754-2.405"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.356,
    y: 13.845,
    width: 3.702,
    height: 5.333,
    rx: 1.851,
    transform: "rotate(42.134 10.208 16.512)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.763,
    y: 14.41,
    width: 3.702,
    height: 7.689,
    rx: 1.851,
    transform: "rotate(42.134 13.614 18.254)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.356,
    y: 17.441,
    width: 3.702,
    height: 6.893,
    rx: 1.851,
    transform: "rotate(42.134 16.207 20.888)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.671,
    y: 21.001,
    width: 3.702,
    height: 5.645,
    rx: 1.851,
    transform: "rotate(42.134 18.522 23.824)"
  })));
};
var SvgHandshakeOutlined$1 = SvgHandshakeOutlined;

const SvgHatGraduationOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 36.4 22.089",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.422 12.371 13.5-4.535a1.068 1.068 0 0 0 0-2.025l-13.5-4.534a10.108 10.108 0 0 0-6.444 0l-13.5 4.534a1.068 1.068 0 0 0 0 2.025l13.5 4.535a10.122 10.122 0 0 0 6.444 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.155 9.773v8.606s-1.628 2.96-10.885 2.96-10.885-2.96-10.885-2.96V9.773M32.698 19.168h2.952v-2.516l-1.476-2.622-1.476 2.622v2.516zM34.174 8.087v5.943"
  })));
};
var SvgHatGraduationOutlined$1 = SvgHatGraduationOutlined;

const SvgHeartOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.016 30.821",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M31.39 3.161a9.15 9.15 0 0 0-12.658.381l-1.224 1.224-1.377-1.377a9.009 9.009 0 0 0-12.742 0h0a9.009 9.009 0 0 0 0 12.742L17.2 29.944a.432.432 0 0 0 .611 0l13.816-13.813a9.009 9.009 0 0 0-.237-12.97Z",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }));
};
var SvgHeartOutlined$1 = SvgHeartOutlined;

const SvgHeavyrain = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.345 27.697c-1.185 0-2.367.126-3.523.377-3.694-8.592-12.314-14.322-21.642-14.322-11.639 0-21.318 8.233-23.245 19.67-.027-.002-.055-.002-.081-.002-7.61 0-13.803 6.22-13.803 13.864 0 7.643 6.192 13.86 13.803 13.86h48.49c9.18 0 16.648-7.503 16.648-16.724s-7.469-16.723-16.647-16.723ZM85.643 44.42c0 7.375-5.965 13.373-13.298 13.373H23.854c-5.765 0-10.455-4.714-10.455-10.509 0-5.798 4.69-10.514 10.455-10.514.384 0 .805.031 1.323.094l1.7.213.172-1.707c1.05-10.414 9.705-18.268 20.131-18.268 8.53 0 16.186 5.44 19.05 13.535l.542 1.528 1.543-.491a13.278 13.278 0 0 1 4.03-.627c7.334 0 13.298 5.999 13.298 13.373ZM24.087 70.367l4.23 7.682c.981 1.782 3.723.192 2.74-1.593l-4.231-7.682c-.982-1.782-3.721-.19-2.739 1.593ZM39.803 70.367l4.23 7.682c.982 1.782 3.724.192 2.74-1.593l-4.23-7.682c-.982-1.782-3.722-.19-2.74 1.593ZM56.323 70.367l4.23 7.682c.982 1.782 3.722.192 2.74-1.593-1.41-2.56-2.821-5.121-4.23-7.682-.982-1.782-3.723-.19-2.74 1.593ZM72.288 70.367l4.23 7.682c.982 1.782 3.722.192 2.74-1.593-1.41-2.56-2.821-5.121-4.23-7.682-.982-1.782-3.723-.19-2.74 1.593ZM37.002 79.44l4.23 7.683c.981 1.782 3.723.191 2.74-1.593l-4.231-7.682c-.98-1.782-3.722-.192-2.739 1.593ZM52.716 79.436l4.231 7.682c.982 1.784 3.722.192 2.74-1.593-1.41-2.56-2.821-5.121-4.23-7.682-.982-1.782-3.724-.19-2.74 1.593ZM68.748 78.803l4.229 7.682c.981 1.781 3.723.191 2.74-1.594l-4.23-7.682c-.982-1.781-3.722-.191-2.74 1.594Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavyrain$1 = SvgHeavyrain;

const SvgHeavyrainandthunder = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.788 46.044h-6.452c-4.206 0-7.629-3.504-7.629-7.81 0-4.309 3.423-7.812 7.63-7.812.28 0 .586.022.965.07l1.24.157.125-1.268c.767-7.74 7.081-13.575 14.69-13.575 3.303 0 6.421 1.148 8.938 3.117a21.676 21.676 0 0 1 1.715-1.77c-2.99-2.418-6.733-3.837-10.653-3.837-8.494 0-15.556 6.118-16.962 14.616h-.059c-5.553 0-10.071 4.622-10.071 10.301 0 5.68 4.518 10.3 10.071 10.3h6.509a14.07 14.07 0 0 1-.097-1.57c0-.31.02-.615.04-.92Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.993 27.958c-1.083 0-2.164.118-3.22.352-3.38-8.002-11.262-13.34-19.791-13.34-10.644 0-19.495 7.669-21.258 18.319h-.074c-6.96 0-12.623 5.792-12.623 12.911S29.69 59.108 36.65 59.108h44.343c8.394 0 15.224-6.986 15.224-15.575 0-8.588-6.83-15.575-15.224-15.575Zm12.162 15.575c0 6.869-5.455 12.456-12.162 12.456H36.65c-5.272 0-9.56-4.391-9.56-9.789 0-5.4 4.288-9.791 9.56-9.791.352 0 .736.028 1.209.087l1.556.198.156-1.589c.961-9.7 8.876-17.015 18.41-17.015 7.801 0 14.801 5.066 17.421 12.607l.496 1.423 1.411-.459a11.984 11.984 0 0 1 3.684-.582c6.707 0 12.162 5.587 12.162 12.454ZM36.864 67.7l3.87 7.154c.896 1.66 3.402.178 2.503-1.484l-3.868-7.155c-.897-1.658-3.403-.177-2.505 1.485ZM80.942 67.7l3.87 7.154c.896 1.66 3.403.178 2.505-1.484l-3.869-7.155c-.898-1.658-3.404-.177-2.506 1.485ZM77.705 75.555c1.29 2.385 2.578 4.77 3.869 7.155.897 1.66 3.403.177 2.504-1.484l-3.868-7.154c-.897-1.66-3.403-.178-2.505 1.483ZM14.935 58.182c1.291 2.385 2.58 4.77 3.87 7.156.896 1.658 3.403.177 2.505-1.485L17.441 56.7c-.897-1.66-3.404-.178-2.505 1.483ZM26.747 66.633c1.29 2.385 2.578 4.769 3.869 7.154.897 1.66 3.403.178 2.504-1.483l-3.868-7.156c-.897-1.66-3.403-.176-2.505 1.485ZM23.368 76.15l3.869 7.155c.897 1.659 3.404.177 2.504-1.484l-3.867-7.155c-.898-1.66-3.404-.178-2.506 1.483ZM36.864 77.79l3.87 7.155c.896 1.66 3.402.178 2.503-1.485l-3.868-7.154c-.897-1.66-3.403-.177-2.505 1.484ZM70.973 77.695H66.3c-.62 0-1.194.312-1.538.836a1.894 1.894 0 0 0-.168 1.76l4.387 10.632L51.117 71.73h4.472c.674 0 1.296-.373 1.62-.972.324-.6.302-1.33-.06-1.908l-4.418-7.036H49.98l4.747 7.563h-4.704c-.739 0-1.406.445-1.698 1.13a1.891 1.891 0 0 0 .352 2.028L69.073 94.45a1.82 1.82 0 0 0 1.339.596c.346 0 .696-.1 1.012-.31.761-.5 1.05-1.443.7-2.293L67.01 80.048h4.707c.636 0 1.22-.327 1.561-.871.34-.545.383-1.218.112-1.799l-7.213-15.565h-2.563l7.359 15.882Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavyrainandthunder$1 = SvgHeavyrainandthunder;

const SvgHeavyrainshowersDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.763 36.573c-.87 0-1.739.092-2.589.277-2.713-6.312-9.046-10.522-15.898-10.522-8.55 0-15.661 6.049-17.076 14.45h-.06C35.55 40.777 31 45.346 31 50.961c0 5.614 4.549 10.182 10.14 10.182h35.623c6.742 0 12.23-5.512 12.23-12.286s-5.488-12.285-12.23-12.285Zm9.769 12.285c0 5.418-4.382 9.825-9.77 9.825H41.14c-4.235 0-7.68-3.464-7.68-7.72 0-4.26 3.445-7.724 7.68-7.724.283 0 .591.022.972.068l1.249.157.127-1.254c.77-7.65 7.129-13.42 14.788-13.42 6.267 0 11.89 3.996 13.995 9.943l.398 1.122 1.133-.36a9.756 9.756 0 0 1 2.96-.46c5.388 0 9.77 4.406 9.77 9.823ZM24.087 70.367l4.23 7.682c.981 1.782 3.723.192 2.74-1.593l-4.231-7.682c-.982-1.782-3.721-.19-2.739 1.593ZM40.803 70.367l4.23 7.682c.982 1.782 3.724.192 2.74-1.593l-4.23-7.682c-.982-1.782-3.722-.19-2.74 1.593ZM57.323 70.367l4.23 7.682c.982 1.782 3.722.192 2.74-1.593-1.41-2.56-2.821-5.121-4.23-7.682-.982-1.782-3.723-.19-2.74 1.593ZM73.288 70.367l4.23 7.682c.982 1.782 3.722.192 2.74-1.593-1.41-2.56-2.821-5.121-4.23-7.682-.982-1.782-3.723-.19-2.74 1.593ZM37.002 81.44l4.23 7.683c.981 1.782 3.723.191 2.74-1.593l-4.231-7.682c-.98-1.782-3.722-.192-2.739 1.593ZM52.716 81.436l4.231 7.682c.982 1.784 3.722.192 2.74-1.593-1.41-2.56-2.821-5.121-4.23-7.682-.982-1.782-3.724-.19-2.74 1.593ZM68.748 80.803l4.229 7.682c.981 1.781 3.723.191 2.74-1.594l-4.23-7.682c-.982-1.781-3.722-.191-2.74 1.594ZM39.257 16.293a1.62 1.62 0 0 1-1.732 1.488 1.621 1.621 0 0 1-1.482-1.741l1.112-14.291a1.62 1.62 0 0 1 1.734-1.49c.884.07 1.551.855 1.482 1.743l-1.114 14.29ZM23.672 22.33c-.662.59-1.687.53-2.276-.136l-9.476-10.72a1.631 1.631 0 0 1 .135-2.286 1.612 1.612 0 0 1 2.276.134l9.476 10.72c.59.666.53 1.695-.135 2.287ZM9.816 58.47l10.447-9.765a1.614 1.614 0 0 1 2.28.083 1.63 1.63 0 0 1-.083 2.289l-10.447 9.765a1.613 1.613 0 0 1-2.28-.082 1.632 1.632 0 0 1 .083-2.29Zm52.401-47.005a1.614 1.614 0 0 0-2.28-.083L49.49 21.148a1.63 1.63 0 0 0-.081 2.29 1.61 1.61 0 0 0 2.278.082l10.448-9.765a1.63 1.63 0 0 0 .083-2.289Zm-44.4 23.153a1.625 1.625 0 0 0-1.458-1.762L2.15 31.529a1.62 1.62 0 0 0-.3 3.226l14.211 1.327a1.62 1.62 0 0 0 1.756-1.463ZM36.84 24.306c-6.533-.59-12.325 4.27-12.911 10.834-.379 4.24 1.516 8.163 4.66 10.572-.798.825-1.4 1.667-1.846 2.437-3.953-3.026-6.333-7.953-5.856-13.284.737-8.247 8.016-14.355 16.226-13.615 4.13.372 7.72 2.409 10.175 5.39a20.614 20.614 0 0 0-2.329 1.986 11.84 11.84 0 0 0-8.119-4.32Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavyrainshowersDay$1 = SvgHeavyrainshowersDay;

const SvgHeavyrainshowersNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.763 36.573c-.87 0-1.739.092-2.589.277-2.713-6.312-9.046-10.522-15.898-10.522-8.55 0-15.661 6.049-17.076 14.45h-.06C35.55 40.777 31 45.346 31 50.961c0 5.614 4.549 10.182 10.14 10.182h35.623c6.742 0 12.23-5.512 12.23-12.286s-5.488-12.285-12.23-12.285Zm9.769 12.285c0 5.418-4.382 9.825-9.77 9.825H41.14c-4.235 0-7.68-3.464-7.68-7.72 0-4.26 3.445-7.724 7.68-7.724.283 0 .591.022.972.068l1.249.157.127-1.254c.77-7.65 7.129-13.42 14.788-13.42 6.267 0 11.89 3.996 13.995 9.943l.398 1.122 1.133-.36a9.756 9.756 0 0 1 2.96-.46c5.388 0 9.77 4.406 9.77 9.823ZM24.087 70.367l4.23 7.682c.981 1.782 3.723.192 2.74-1.593l-4.231-7.682c-.982-1.782-3.721-.19-2.739 1.593ZM40.803 70.367l4.23 7.682c.982 1.782 3.724.192 2.74-1.593l-4.23-7.682c-.982-1.782-3.722-.19-2.74 1.593ZM57.323 70.367l4.23 7.682c.982 1.782 3.722.192 2.74-1.593-1.41-2.56-2.821-5.121-4.23-7.682-.982-1.782-3.723-.19-2.74 1.593ZM73.288 70.367l4.23 7.682c.982 1.782 3.722.192 2.74-1.593-1.41-2.56-2.821-5.121-4.23-7.682-.982-1.782-3.723-.19-2.74 1.593ZM37.002 81.44l4.23 7.683c.981 1.782 3.723.191 2.74-1.593l-4.231-7.682c-.98-1.782-3.722-.192-2.739 1.593ZM52.716 81.436l4.231 7.682c.982 1.784 3.722.192 2.74-1.593-1.41-2.56-2.821-5.121-4.23-7.682-.982-1.782-3.724-.19-2.74 1.593ZM68.748 80.803l4.229 7.682c.981 1.781 3.723.191 2.74-1.594l-4.23-7.682c-.982-1.781-3.722-.191-2.74 1.594ZM21.823 55.75a23.747 23.747 0 0 1-5.957-.488c-3.937-.831-7.115-3.065-9.861-5.98-.405-.43-.79-.879-1.229-1.37 9.391 1.006 17.225-1.882 22.85-9.592 5.593-7.662 6.204-16.1 2.67-24.926.05.01.11.008.159.032 5.453 2.778 9.512 6.863 11.503 12.767.64-.19 1.337-.357 2.042-.457-.07-.21-.128-.419-.202-.629-2.672-7.557-8.32-12.201-15.553-15.01-.485-.187-.946-.113-1.287.31-.341.42-.332.88-.052 1.34.081.13.16.263.237.395 2.495 4.245 3.724 8.83 3.103 13.756-1.061 8.421-5.36 14.607-12.942 18.233-4.692 2.245-9.631 2.33-14.617 1.07-.706-.178-1.2-.07-1.496.389-.298.462-.265.905.223 1.5 1.102 1.345 2.159 2.74 3.366 3.983 5.06 5.207 11.167 7.55 18.382 6.786.12-.022.24-.04.36-.06a10.228 10.228 0 0 1-1.699-2.049Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavyrainshowersNight$1 = SvgHeavyrainshowersNight;

const SvgHeavyrainshowersandthunderDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m72.674 73.52 4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM74.674 91.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948ZM42.864 83.7l3.87 7.154c.896 1.66 3.402.178 2.503-1.485l-3.868-7.154c-.897-1.659-3.403-.177-2.505 1.485ZM20.936 74.182c1.29 2.385 2.58 4.77 3.868 7.156.897 1.658 3.404.176 2.506-1.485l-3.869-7.154c-.897-1.66-3.404-.179-2.505 1.483ZM32.747 82.633c1.29 2.385 2.578 4.769 3.869 7.154.897 1.66 3.403.178 2.504-1.483l-3.868-7.156c-.898-1.66-3.403-.177-2.505 1.485ZM29.368 92.15l3.869 7.155c.897 1.659 3.404.177 2.504-1.484l-3.867-7.155c-.898-1.66-3.404-.178-2.506 1.483ZM42.864 93.79l3.87 7.155c.896 1.66 3.402.178 2.503-1.485l-3.868-7.154c-.897-1.66-3.403-.177-2.505 1.484ZM71.125 43.027c-.839 0-1.676.092-2.495.272C66.013 37.12 59.908 33 53.3 33c-8.245 0-15.1 5.92-16.465 14.144h-.058c-5.39 0-9.777 4.472-9.777 9.968 0 5.495 4.387 9.967 9.777 9.967h34.348c6.502 0 11.792-5.395 11.792-12.026s-5.29-12.026-11.792-12.026Zm9.42 12.026c0 5.303-4.227 9.616-9.42 9.616H36.777c-4.083 0-7.405-3.39-7.405-7.557 0-4.168 3.322-7.56 7.405-7.56.273 0 .57.022.938.068l1.204.153.122-1.228c.744-7.489 6.875-13.137 14.26-13.137 6.04 0 11.464 3.912 13.493 9.734l.384 1.098 1.092-.353a9.312 9.312 0 0 1 2.855-.45c5.194 0 9.42 4.313 9.42 9.616ZM37.26 18.643a1.453 1.453 0 0 1-1.554 1.336 1.454 1.454 0 0 1-1.33-1.563l.998-12.82a1.454 1.454 0 0 1 1.555-1.337 1.457 1.457 0 0 1 1.33 1.563l-1 12.821ZM23.278 24.06a1.448 1.448 0 0 1-2.043-.122l-8.501-9.616a1.463 1.463 0 0 1 .121-2.052 1.446 1.446 0 0 1 2.043.12l8.5 9.619a1.46 1.46 0 0 1-.12 2.051ZM10.845 56.484l9.373-8.76a1.448 1.448 0 0 1 2.046.074c.541.585.508 1.51-.075 2.053l-9.373 8.76a1.447 1.447 0 0 1-2.045-.072 1.464 1.464 0 0 1 .074-2.055Zm47.013-42.17a1.448 1.448 0 0 0-2.046-.075l-9.373 8.76a1.463 1.463 0 0 0-.072 2.055 1.445 1.445 0 0 0 2.043.073l9.373-8.76a1.462 1.462 0 0 0 .075-2.054Zm-39.835 20.77a1.457 1.457 0 0 0-1.307-1.58L3.969 32.313a1.454 1.454 0 0 0-.268 2.894l12.748 1.19a1.453 1.453 0 0 0 1.575-1.312Zm17.068-9.252c-5.862-.528-11.058 3.832-11.584 9.72-.34 3.805 1.36 7.324 4.182 9.485a11.245 11.245 0 0 0-1.658 2.187c-3.546-2.716-5.68-7.136-5.253-11.918.66-7.4 7.191-12.88 14.557-12.215 3.705.333 6.926 2.16 9.129 4.835a18.497 18.497 0 0 0-2.09 1.783 10.623 10.623 0 0 0-7.283-3.877Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavyrainshowersandthunderDay$1 = SvgHeavyrainshowersandthunderDay;

const SvgHeavyrainshowersandthunderNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.125 43.027c-.839 0-1.676.092-2.495.272C66.013 37.12 59.908 33 53.3 33c-8.245 0-15.1 5.92-16.465 14.144h-.058c-5.39 0-9.777 4.472-9.777 9.968 0 5.495 4.387 9.967 9.777 9.967h34.348c6.502 0 11.792-5.395 11.792-12.026s-5.29-12.026-11.792-12.026Zm9.42 12.026c0 5.303-4.227 9.616-9.42 9.616H36.777c-4.083 0-7.405-3.39-7.405-7.557 0-4.168 3.322-7.56 7.405-7.56.273 0 .57.022.938.068l1.204.153.122-1.228c.744-7.489 6.875-13.137 14.26-13.137 6.04 0 11.464 3.912 13.493 9.734l.384 1.098 1.092-.353a9.312 9.312 0 0 1 2.855-.45c5.194 0 9.42 4.313 9.42 9.616ZM72.674 73.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM74.674 91.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948ZM42.864 83.7l3.87 7.154c.896 1.66 3.402.178 2.503-1.485l-3.868-7.154c-.897-1.659-3.403-.177-2.505 1.485ZM20.936 74.182c1.29 2.385 2.58 4.77 3.868 7.156.897 1.658 3.404.176 2.506-1.485l-3.869-7.154c-.897-1.66-3.404-.179-2.505 1.483ZM32.747 82.633c1.29 2.385 2.578 4.769 3.869 7.154.897 1.66 3.403.178 2.504-1.483l-3.868-7.156c-.898-1.66-3.403-.177-2.505 1.485ZM29.368 92.15l3.869 7.155c.897 1.659 3.404.177 2.504-1.484l-3.867-7.155c-.898-1.66-3.404-.178-2.506 1.483ZM42.864 93.79l3.87 7.155c.896 1.66 3.402.178 2.503-1.485l-3.868-7.154c-.897-1.66-3.403-.177-2.505 1.484ZM21.823 55.75a23.747 23.747 0 0 1-5.957-.488c-3.937-.831-7.115-3.065-9.861-5.98-.405-.43-.79-.879-1.229-1.37 9.391 1.006 17.225-1.882 22.85-9.592 5.593-7.662 6.204-16.1 2.67-24.926.05.01.11.008.159.032 5.453 2.778 9.512 6.863 11.503 12.767.64-.19 1.337-.357 2.042-.457-.07-.21-.128-.419-.202-.629-2.672-7.557-8.32-12.201-15.553-15.01-.485-.187-.946-.113-1.287.31-.341.42-.332.88-.052 1.34.081.13.16.263.237.395 2.495 4.245 3.724 8.83 3.103 13.756-1.061 8.421-5.36 14.607-12.942 18.233-4.692 2.245-9.631 2.33-14.617 1.07-.706-.178-1.2-.07-1.496.389-.298.462-.265.905.223 1.5 1.102 1.345 2.159 2.74 3.366 3.983 5.06 5.207 11.167 7.55 18.382 6.786.12-.022.24-.04.36-.06a10.228 10.228 0 0 1-1.699-2.049Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavyrainshowersandthunderNight$1 = SvgHeavyrainshowersandthunderNight;

const SvgHeavysleet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.345 23.979c-1.158 0-2.314.124-3.444.367-3.614-8.363-12.046-13.942-21.17-13.942-11.384 0-20.851 8.016-22.737 19.147h-.08c-7.444 0-13.5 6.055-13.5 13.496 0 7.44 6.056 13.494 13.5 13.494h47.431c8.979 0 16.284-7.305 16.284-16.282s-7.305-16.28-16.284-16.28Zm13.01 16.28c0 7.18-5.835 13.02-13.01 13.02h-47.43c-5.64 0-10.227-4.59-10.227-10.232 0-5.644 4.588-10.234 10.227-10.234.376 0 .787.03 1.293.09l1.664.208.167-1.661a19.732 19.732 0 0 1 19.692-17.785c8.344 0 15.832 5.295 18.634 13.177l.53 1.488 1.51-.48a13.092 13.092 0 0 1 3.94-.608c7.175 0 13.01 5.84 13.01 13.017ZM41.517 66.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM39.517 83.31l4.136 7.479c.961 1.735 3.642.186 2.68-1.55-1.378-2.494-2.757-4.987-4.137-7.48-.96-1.735-3.642-.186-2.68 1.552ZM62.674 66.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM76.674 83.31l4.139 7.479c.96 1.735 3.64.186 2.68-1.55-1.38-2.494-2.76-4.987-4.138-7.48-.96-1.735-3.642-.186-2.68 1.552Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.718 85.233h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.691-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.281 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.256 1.283 2.35c.183.376.64.658 1.099.658.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM87.718 66.23h-2.565l1.282-2.35c.367-.565.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM32.718 70.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavysleet$1 = SvgHeavysleet;

const SvgHeavysleetshowersandthunderDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.26 18.643a1.453 1.453 0 0 1-1.554 1.336 1.454 1.454 0 0 1-1.33-1.563l.998-12.82a1.454 1.454 0 0 1 1.555-1.337 1.457 1.457 0 0 1 1.33 1.563l-1 12.821ZM23.278 24.06a1.448 1.448 0 0 1-2.043-.122l-8.501-9.616a1.463 1.463 0 0 1 .121-2.052 1.446 1.446 0 0 1 2.043.12l8.5 9.619a1.46 1.46 0 0 1-.12 2.051ZM10.845 56.484l9.373-8.76a1.448 1.448 0 0 1 2.046.074c.541.585.508 1.51-.075 2.053l-9.373 8.76a1.447 1.447 0 0 1-2.045-.072 1.464 1.464 0 0 1 .074-2.055Zm47.013-42.17a1.448 1.448 0 0 0-2.046-.075l-9.373 8.76a1.463 1.463 0 0 0-.072 2.055 1.445 1.445 0 0 0 2.043.073l9.373-8.76a1.462 1.462 0 0 0 .075-2.054Zm-39.835 20.77a1.457 1.457 0 0 0-1.307-1.58L3.969 32.313a1.454 1.454 0 0 0-.268 2.894l12.748 1.19a1.453 1.453 0 0 0 1.575-1.312Zm17.068-9.252c-5.862-.528-11.058 3.832-11.584 9.72-.34 3.805 1.36 7.324 4.182 9.485a11.245 11.245 0 0 0-1.658 2.187c-3.546-2.716-5.68-7.136-5.253-11.918.66-7.4 7.191-12.88 14.557-12.215 3.705.333 6.926 2.16 9.129 4.835a18.497 18.497 0 0 0-2.09 1.783 10.623 10.623 0 0 0-7.283-3.877ZM72.846 42.288c-.864 0-1.728.094-2.571.28-2.698-6.368-8.99-10.615-15.8-10.615-8.5 0-15.566 6.102-16.972 14.578h-.06c-5.556 0-10.078 4.61-10.078 10.274 0 5.665 4.522 10.274 10.078 10.274h35.403C79.548 67.079 85 61.518 85 54.683c0-6.835-5.452-12.395-12.154-12.395Zm9.71 12.395c0 5.466-4.357 9.912-9.71 9.912H37.443c-4.209 0-7.633-3.494-7.633-7.79 0-4.295 3.424-7.792 7.633-7.792.281 0 .587.023.966.07l1.242.158.125-1.265c.767-7.72 7.086-13.54 14.698-13.54 6.227 0 11.817 4.03 13.908 10.032l.396 1.132 1.126-.364a9.6 9.6 0 0 1 2.942-.464c5.353 0 9.71 4.445 9.71 9.911ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948ZM42.864 83.7l3.87 7.154c.896 1.66 3.402.178 2.503-1.485l-3.868-7.154c-.897-1.659-3.403-.177-2.505 1.485ZM20.936 74.182c1.29 2.385 2.58 4.77 3.868 7.156.897 1.658 3.404.177 2.506-1.485L23.441 72.7c-.897-1.66-3.404-.178-2.505 1.483ZM29.368 92.15l3.869 7.155c.897 1.659 3.404.177 2.504-1.484l-3.867-7.155c-.898-1.66-3.404-.178-2.506 1.483ZM42.864 93.79l3.87 7.155c.896 1.66 3.402.178 2.503-1.485l-3.868-7.154c-.897-1.66-3.403-.177-2.505 1.484Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.718 74.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM88.718 93.233h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.691-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.281 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.256 1.283 2.35c.183.376.64.658 1.099.658.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM81.718 77.233h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.691-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.281 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.256 1.283 2.35c.183.376.64.658 1.099.658.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavysleetshowersandthunderDay$1 = SvgHeavysleetshowersandthunderDay;

const SvgHeavysleetshowersandthunderNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948ZM72.846 42.288c-.864 0-1.728.094-2.571.28-2.698-6.368-8.99-10.615-15.8-10.615-8.5 0-15.566 6.102-16.972 14.578h-.06c-5.556 0-10.078 4.61-10.078 10.274 0 5.665 4.522 10.274 10.078 10.274h35.403C79.548 67.079 85 61.518 85 54.683c0-6.835-5.452-12.395-12.154-12.395Zm9.71 12.395c0 5.466-4.357 9.912-9.71 9.912H37.443c-4.209 0-7.633-3.494-7.633-7.79 0-4.295 3.424-7.792 7.633-7.792.281 0 .587.023.966.07l1.242.158.125-1.265c.767-7.72 7.086-13.54 14.698-13.54 6.227 0 11.817 4.03 13.908 10.032l.396 1.132 1.126-.364a9.6 9.6 0 0 1 2.942-.464c5.353 0 9.71 4.445 9.71 9.911ZM42.864 83.7l3.87 7.154c.896 1.66 3.402.178 2.503-1.485l-3.868-7.154c-.897-1.659-3.403-.177-2.505 1.485ZM20.936 74.182c1.29 2.385 2.58 4.77 3.868 7.156.897 1.658 3.404.177 2.506-1.485L23.441 72.7c-.897-1.66-3.404-.178-2.505 1.483ZM29.37 92.15c1.288 2.385 2.578 4.77 3.868 7.155.897 1.659 3.404.177 2.504-1.484l-3.867-7.155c-.898-1.66-3.404-.178-2.506 1.483ZM42.864 93.79l3.87 7.155c.896 1.66 3.402.178 2.503-1.485l-3.868-7.154c-.897-1.66-3.403-.177-2.505 1.484Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.718 74.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM88.718 93.233h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.691-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.281 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.256 1.283 2.35c.183.376.64.658 1.099.658.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM81.718 77.233h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.691-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.281 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.256 1.283 2.35c.183.376.64.658 1.099.658.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.823 55.75a23.747 23.747 0 0 1-5.957-.488c-3.937-.831-7.115-3.065-9.861-5.98-.405-.43-.79-.879-1.229-1.37 9.391 1.006 17.225-1.882 22.85-9.592 5.593-7.662 6.204-16.1 2.67-24.926.05.01.11.008.159.032 5.453 2.778 9.512 6.863 11.503 12.767.64-.19 1.337-.357 2.042-.457-.07-.21-.128-.419-.202-.629-2.672-7.557-8.32-12.201-15.553-15.01-.485-.187-.946-.113-1.287.31-.341.42-.332.88-.052 1.34.081.13.16.263.237.395 2.495 4.245 3.724 8.83 3.103 13.756-1.061 8.421-5.36 14.607-12.942 18.233-4.692 2.245-9.631 2.33-14.617 1.07-.706-.178-1.2-.07-1.496.389-.298.462-.265.905.223 1.5 1.102 1.345 2.159 2.74 3.366 3.983 5.06 5.207 11.167 7.55 18.382 6.786.12-.022.24-.04.36-.06a10.228 10.228 0 0 1-1.699-2.049Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavysleetshowersandthunderNight$1 = SvgHeavysleetshowersandthunderNight;

const SvgHeavysnow = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.987 25.996c-1.144 0-2.286.123-3.402.367-3.567-8.343-11.893-13.908-20.9-13.908-11.242 0-20.589 7.996-22.45 19.1l-.079-.001c-7.35 0-13.33 6.04-13.33 13.463 0 7.42 5.98 13.458 13.33 13.458h46.831c8.865 0 16.078-7.286 16.078-16.239 0-8.954-7.213-16.24-16.078-16.24Zm12.845 16.24c0 7.16-5.762 12.985-12.845 12.985h-46.83c-5.569 0-10.098-4.578-10.098-10.204 0-5.63 4.53-10.209 10.097-10.209.372 0 .777.029 1.278.091l1.642.206.166-1.657c1.014-10.113 9.373-17.738 19.443-17.738 8.237 0 15.63 5.281 18.398 13.142l.522 1.483 1.49-.478a12.81 12.81 0 0 1 3.892-.607c7.083 0 12.845 5.825 12.845 12.986Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.718 70.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.824-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM49.718 86.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM57.718 70.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM81.718 70.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM73.718 86.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavysnow$1 = SvgHeavysnow;

const SvgHeavysnowandthunder = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.788 46.044h-6.452c-4.206 0-7.629-3.504-7.629-7.81 0-4.309 3.423-7.812 7.63-7.812.28 0 .586.022.965.07l1.24.157.125-1.268c.767-7.74 7.081-13.575 14.69-13.575 3.303 0 6.421 1.148 8.938 3.117a21.676 21.676 0 0 1 1.715-1.77c-2.99-2.418-6.733-3.837-10.653-3.837-8.494 0-15.556 6.118-16.962 14.616h-.059c-5.553 0-10.071 4.622-10.071 10.301 0 5.68 4.518 10.3 10.071 10.3h6.509a14.07 14.07 0 0 1-.097-1.57c0-.31.02-.615.04-.92Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.993 27.958c-1.083 0-2.164.118-3.22.352-3.38-8.002-11.262-13.34-19.791-13.34-10.644 0-19.495 7.669-21.258 18.319h-.074c-6.96 0-12.623 5.792-12.623 12.911S29.69 59.108 36.65 59.108h44.343c8.394 0 15.224-6.986 15.224-15.575 0-8.588-6.83-15.575-15.224-15.575Zm12.162 15.575c0 6.869-5.455 12.456-12.162 12.456H36.65c-5.272 0-9.56-4.391-9.56-9.789 0-5.4 4.288-9.791 9.56-9.791.352 0 .736.028 1.209.087l1.556.198.156-1.589c.961-9.7 8.876-17.015 18.41-17.015 7.801 0 14.801 5.066 17.421 12.607l.496 1.423 1.411-.459a11.984 11.984 0 0 1 3.684-.582c6.707 0 12.162 5.587 12.162 12.454ZM70.973 77.695H66.3c-.62 0-1.194.312-1.538.836a1.894 1.894 0 0 0-.168 1.76l4.387 10.632L51.117 71.73h4.472c.674 0 1.296-.373 1.62-.972.324-.6.302-1.33-.06-1.908l-4.418-7.036H49.98l4.747 7.563h-4.704c-.739 0-1.406.445-1.698 1.13a1.891 1.891 0 0 0 .352 2.028L69.073 94.45a1.82 1.82 0 0 0 1.339.596c.346 0 .696-.1 1.012-.31.761-.5 1.05-1.443.7-2.293L67.01 80.048h4.707c.636 0 1.22-.327 1.561-.871.34-.545.383-1.218.112-1.799l-7.213-15.565h-2.563l7.359 15.882Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.718 65.23h-2.565l1.282-2.35c.367-.565.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255H7.282C6.55 65.23 6 65.793 6 66.451s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM40.718 70.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM29.718 84.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM88.718 67.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM98.718 84.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavysnowandthunder$1 = SvgHeavysnowandthunder;

const SvgHeavysnowshowersDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.763 36.573c-.87 0-1.739.092-2.589.277-2.713-6.312-9.046-10.522-15.898-10.522-8.55 0-15.661 6.049-17.076 14.45h-.06C35.55 40.777 31 45.346 31 50.961c0 5.614 4.549 10.182 10.14 10.182h35.623c6.742 0 12.23-5.512 12.23-12.286s-5.488-12.285-12.23-12.285Zm9.769 12.285c0 5.418-4.382 9.825-9.77 9.825H41.14c-4.235 0-7.68-3.464-7.68-7.72 0-4.26 3.445-7.724 7.68-7.724.283 0 .591.022.972.068l1.249.157.127-1.254c.77-7.65 7.129-13.42 14.788-13.42 6.267 0 11.89 3.996 13.995 9.943l.398 1.122 1.133-.36a9.756 9.756 0 0 1 2.96-.46c5.388 0 9.77 4.406 9.77 9.823ZM39.257 16.293a1.62 1.62 0 0 1-1.732 1.488 1.621 1.621 0 0 1-1.482-1.741l1.112-14.291a1.62 1.62 0 0 1 1.734-1.49c.884.07 1.551.855 1.482 1.743l-1.114 14.29ZM23.672 22.33c-.662.59-1.687.53-2.276-.136l-9.476-10.72a1.631 1.631 0 0 1 .135-2.286 1.612 1.612 0 0 1 2.276.134l9.476 10.72c.59.666.53 1.695-.135 2.287ZM9.816 58.47l10.447-9.765a1.614 1.614 0 0 1 2.28.083 1.63 1.63 0 0 1-.083 2.289l-10.447 9.765a1.613 1.613 0 0 1-2.28-.082 1.632 1.632 0 0 1 .083-2.29Zm52.401-47.005a1.614 1.614 0 0 0-2.28-.083L49.49 21.148a1.63 1.63 0 0 0-.081 2.29 1.61 1.61 0 0 0 2.278.082l10.448-9.765a1.63 1.63 0 0 0 .083-2.289Zm-44.4 23.153a1.625 1.625 0 0 0-1.458-1.762L2.15 31.529a1.62 1.62 0 0 0-.3 3.226l14.211 1.327a1.62 1.62 0 0 0 1.756-1.463ZM36.84 24.306c-6.533-.59-12.325 4.27-12.911 10.834-.379 4.24 1.516 8.163 4.66 10.572-.798.825-1.4 1.667-1.846 2.437-3.953-3.026-6.333-7.953-5.856-13.284.737-8.247 8.016-14.355 16.226-13.615 4.13.372 7.72 2.409 10.175 5.39a20.614 20.614 0 0 0-2.329 1.986 11.84 11.84 0 0 0-8.119-4.32Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.718 73.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM46.718 89.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM54.718 73.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM78.718 73.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM70.718 89.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavysnowshowersDay$1 = SvgHeavysnowshowersDay;

const SvgHeavysnowshowersNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.763 36.573c-.87 0-1.739.092-2.589.277-2.713-6.312-9.046-10.522-15.898-10.522-8.55 0-15.661 6.049-17.076 14.45h-.06C35.55 40.777 31 45.346 31 50.961c0 5.614 4.549 10.182 10.14 10.182h35.623c6.742 0 12.23-5.512 12.23-12.286s-5.488-12.285-12.23-12.285Zm9.769 12.285c0 5.418-4.382 9.825-9.77 9.825H41.14c-4.235 0-7.68-3.464-7.68-7.72 0-4.26 3.445-7.724 7.68-7.724.283 0 .591.022.972.068l1.249.157.127-1.254c.77-7.65 7.129-13.42 14.788-13.42 6.267 0 11.89 3.996 13.995 9.943l.398 1.122 1.133-.36a9.756 9.756 0 0 1 2.96-.46c5.388 0 9.77 4.406 9.77 9.823Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.718 73.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM46.718 89.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM54.718 73.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM78.718 73.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM70.718 89.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.823 55.75a23.747 23.747 0 0 1-5.957-.488c-3.937-.831-7.115-3.065-9.861-5.98-.405-.43-.79-.879-1.229-1.37 9.391 1.006 17.225-1.882 22.85-9.592 5.593-7.662 6.204-16.1 2.67-24.926.05.01.11.008.159.032 5.453 2.778 9.512 6.863 11.503 12.767.64-.19 1.337-.357 2.042-.457-.07-.21-.128-.419-.202-.629-2.672-7.557-8.32-12.201-15.553-15.01-.485-.187-.946-.113-1.287.31-.341.42-.332.88-.052 1.34.081.13.16.263.237.395 2.495 4.245 3.724 8.83 3.103 13.756-1.061 8.421-5.36 14.607-12.942 18.233-4.692 2.245-9.631 2.33-14.617 1.07-.706-.178-1.2-.07-1.496.389-.298.462-.265.905.223 1.5 1.102 1.345 2.159 2.74 3.366 3.983 5.06 5.207 11.167 7.55 18.382 6.786.12-.022.24-.04.36-.06a10.228 10.228 0 0 1-1.699-2.049Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHeavysnowshowersNight$1 = SvgHeavysnowshowersNight;

const SvgHelicopterOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 42.528 23.729",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.109 14.543c-.808-1.866-3.516-4.855-4.788-6.2a2.489 2.489 0 0 0-1.629-.772 168.69 168.69 0 0 0-11.625-.4c-4.5 0-8.138.23-11.709.323L3.2 3.521H.75L1.957 7.7l.511 2.2a.638.638 0 0 0 .563.426c2.231.139 10.409.046 13.325.7a1.136 1.136 0 0 1 .814.7 56.562 56.562 0 0 0 2.785 5.574c.791 1.345 1.147 2.136 3.561 2.413s8.784.752 10.327-.2 2.334-2.502 1.266-4.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.485 7.331s2.641 5.535 3.621 6.663 2.852.692 7.109.806"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.741 7.265V3.63h2.692v3.746M21.621.75h4.931v2.88h-4.931zM26.552 2.19h15.226M6.395 2.19h15.226M21.974 19.378v3.431M32.911 19.838v2.971M13.703 21.461l1.518 1.518h21.946l1.694-1.695"
  })));
};
var SvgHelicopterOutlined$1 = SvgHelicopterOutlined;

const SvgHome = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.556 5.4a.75.75 0 0 1 .9 0L43.45 19.628c.189.141.3.364.3.6v2.648a.75.75 0 0 1-.75.75h-2.227V41.01a.75.75 0 0 1-.75.75H29.16a.75.75 0 0 1-.75-.75V31.42a4.405 4.405 0 0 0-4.404-4.405 4.416 4.416 0 0 0-4.416 4.406v9.59a.75.75 0 0 1-.75.75H7.977a.75.75 0 0 1-.75-.75V23.626H5a.75.75 0 0 1-.75-.75v-2.648a.75.75 0 0 1 .3-.6L23.557 5.4ZM5.75 20.603v1.523h2.227a.75.75 0 0 1 .75.75V40.26h9.363v-8.843a5.916 5.916 0 0 1 10.091-4.173 5.903 5.903 0 0 1 1.73 4.175v8.841h9.362V22.876a.75.75 0 0 1 .75-.75h2.227v-1.523L24.006 6.937 5.75 20.603Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgHome$1 = SvgHome;

const SvgHouseOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.791 31.255",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.9.75.75 12.841v2.249h2.53v15.415h9.23v-8.149a4.386 4.386 0 0 1 4.39-4.385h0a4.385 4.385 0 0 1 4.385 4.385v8.149h9.23V15.09h2.53v-2.249Z",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }));
};
var SvgHouseOutlined$1 = SvgHouseOutlined;

const SvgHouseShopOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.667 29.495",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.841 15.1v12.1a1.544 1.544 0 0 1-1.541 1.545H4.21A1.544 1.544 0 0 1 2.666 27.2V15.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.226 18.2h0a4.146 4.146 0 0 1 4.146 4.146v6.4h0H7.08h0v-6.4a4.146 4.146 0 0 1 4.146-4.146ZM18.897 18.901h7.801v5.197h-7.801zM4.919 15.1h-.374a3.794 3.794 0 0 1-3.687-4.687L3.2.75h6.568L8.7 11.677A3.794 3.794 0 0 1 4.919 15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.543 15.1h0a3.794 3.794 0 0 1-3.775-4.165l1-10.185h6.569v10.556a3.794 3.794 0 0 1-3.794 3.794ZM27.748 15.1h.374a3.794 3.794 0 0 0 3.687-4.687L29.468.75H22.9l1.073 10.927a3.794 3.794 0 0 0 3.775 3.423Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.124 15.1h0a3.794 3.794 0 0 0 3.776-4.165L22.9.75h-6.57v10.556a3.794 3.794 0 0 0 3.794 3.794Z"
  })));
};
var SvgHouseShopOutlined$1 = SvgHouseShopOutlined;

const SvgIcelandairIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#icelandair_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icelandair_icon_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.103 17.025c-2.537.254-23.34 1.522-23.34 1.522s-.761-.254-2.03 1.015C62.72 20.83-.197 91.864-.197 91.864S-8.823 101.251-21 102.266h86.002l25.877-83.719s.76-1.776-1.776-1.522Z",
    fill: "#004578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.091 87.72.073-.22.002-.003.004-.012.016-.049a24.477 24.477 0 0 1 .29-.806c.188-.503.434-1.118.676-1.601.258-.516.578-1.22.892-1.912l.004-.007c.318-.701.631-1.39.88-1.886l.384-.768-.858.045c-4.856.255-8.745 1.277-11.377 2.851a3.56 3.56 0 0 0-1.475 1.483l-.015.032-.012.034c-.198.596.022 1.147.324 1.562.303.416.737.772 1.142 1.042l.026.017.028.014c1.116.558 2.475.814 4.79.814 1.302 0 2.286-.13 2.952-.264a8.34 8.34 0 0 0 .759-.186 4.646 4.646 0 0 0 .255-.084l.016-.006.005-.002h.002l.001-.001-.185-.465.186.465.215-.087Z",
    fill: "#fff",
    stroke: "#004578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.488 52.225-.008.01-.056.057a3 3 0 0 1-.286.243c-.275.207-.729.495-1.42.78-1.38.571-3.718 1.135-7.466 1.01h-.017c-2.482 0-4.342-.372-6.37-.784l-.076-.015c-2.01-.409-4.184-.85-7.232-.977H50.536c-3.477 0-6.464.579-8.788 1.561-2.32.98-4.02 2.378-4.851 4.042-.387.774-1.535 3.325-2.578 5.665a1370.453 1370.453 0 0 0-1.834 4.13l-.122.277-.032.073-.008.018-.002.005v.001l.457.203-.458-.202.83.533h.001l.003-.002.014-.015a7.463 7.463 0 0 1 .324-.322 11.4 11.4 0 0 1 1.04-.858 12.612 12.612 0 0 1 3.964-1.952l.013-.004c4.713-1.488 9.19-1.246 13.72-.49h.007c.813.126 1.55.267 2.25.405l.362.072c.567.113 1.117.222 1.66.315 1.32.225 2.628.358 4.196.229 2.89-.004 4.487-.8 5.53-1.321 1.637-.819 2.962-2.17 4.747-4.97.807-.955 1.584-2.524 2.182-3.94.608-1.44 1.062-2.798 1.198-3.34l-.873-.432-.002-.002v-.002l.002-.001Zm0 0ZM25.682 83.49h.5-.5l.947.224c.114-.228.287-.517.486-.773.208-.267.406-.45.559-.526l.027-.014.026-.017c3.66-2.44 10.366-3.72 20.221-2.71v.001l.014.001c3.422.254 6.092.325 8.363-.202 2.3-.533 4.164-1.672 5.999-3.768 1.566-1.698 2.857-3.899 3.752-5.656a39.12 39.12 0 0 0 1.32-2.88l.072-.18.018-.048.005-.012.001-.004v-.001l-.466-.178.467.178.615-1.615-1.377 1.033-.002.001-.022.015c-.024.015-.066.04-.13.075-.125.068-.335.17-.649.29-.628.239-1.671.548-3.291.797l-.011.002-.011.002c-.572.114-1.22.117-1.909.086-.224-.01-.458-.025-.694-.04a23.546 23.546 0 0 0-1.337-.056c-1.42-.119-2.619-.294-4.037-.501l-.225-.033c-1.524-.222-3.309-.477-5.857-.732h-.007l-.007-.001c-3.601-.257-6.889.064-9.607.743-2.69.673-4.858 1.706-6.211 2.911-.775.523-1.61 1.333-1.926 2.218-1.638 2.874-2.95 5.913-3.92 8.163-.234.54-.448 1.035-.641 1.472a6.148 6.148 0 0 0-.477 1.233 2.928 2.928 0 0 0-.076.447l-.002.034V83.49Z",
    fill: "#fff",
    stroke: "#004578"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icelandair_icon_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icelandair_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25835",
    result: "shape"
  }))));
};
var SvgIcelandairIcon$1 = SvgIcelandairIcon;

const SvgImageMultiOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.789 24.62",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.196,
    cy: 12.324,
    r: 2.073
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.585 23.87 5.326-6.408 5.326 6.408H11.585zM26.949 23.87h-4.655l-3.522-4.237 5.884-6.796 5.383 6.999"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.808,
    y: 7.808,
    width: 22.232,
    height: 16.062,
    rx: 2.468
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.808 20.341H6.747a2.468 2.468 0 0 1-2.468-2.468V6.747a2.468 2.468 0 0 1 2.468-2.468h17.3a2.467 2.467 0 0 1 2.463 2.468v1.061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.279 16.812H3.218A2.468 2.468 0 0 1 .75 14.344V3.218A2.468 2.468 0 0 1 3.218.75h17.3a2.468 2.468 0 0 1 2.468 2.468v1.061"
  })));
};
var SvgImageMultiOutlined$1 = SvgImageMultiOutlined;

const SvgInboxFilesOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 29.437 26.976",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.541 12.449-2.037 3.5a1.288 1.288 0 0 1-1.114.64h-5.342a1.289 1.289 0 0 1-1.115-.64l-2.033-3.5a1.458 1.458 0 0 0-1.261-.725H1.528a.777.777 0 0 0-.778.776v11.516a2.21 2.21 0 0 0 2.21 2.21h23.518a2.21 2.21 0 0 0 2.209-2.21V12.5a.777.777 0 0 0-.777-.777H21.8a1.459 1.459 0 0 0-1.259.726Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.687 17.055v-4.23a4.526 4.526 0 0 0-.505-2.079L23.4 1.48a1.352 1.352 0 0 0-1.2-.73H7.237a1.349 1.349 0 0 0-1.2.73l-4.782 9.266a4.526 4.526 0 0 0-.5 2.079v4.23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.514 11.724V8.188h18.41v3.536M7.578 8.188v-3.79h14.281v3.79"
  })));
};
var SvgInboxFilesOutlined$1 = SvgInboxFilesOutlined;

const SvgInboxOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.112 22.965",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.019 8.105-2.086 3.581a1.323 1.323 0 0 1-1.142.656H12.32a1.321 1.321 0 0 1-1.141-.656L9.093 8.105A1.5 1.5 0 0 0 7.8 7.363H1.546a.8.8 0 0 0-.8.8v11.789a2.263 2.263 0 0 0 2.263 2.263H27.1a2.263 2.263 0 0 0 2.263-2.263V8.159a.8.8 0 0 0-.8-.8H22.31a1.494 1.494 0 0 0-1.291.746Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.362 12.823V8.18a2.171 2.171 0 0 0-.539-1.431l-4.655-5.306A2.032 2.032 0 0 0 22.639.75H7.473a2.031 2.031 0 0 0-1.529.693L1.289 6.749A2.166 2.166 0 0 0 .75 8.18v4.643"
  })));
};
var SvgInboxOutlined$1 = SvgInboxOutlined;

const SvgInfoICircleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.247 32.247",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.123,
    cy: 16.123,
    r: 15.373
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.949 5.853a2.032 2.032 0 1 0 2.031 2.031 2.033 2.033 0 0 0-2.031-2.031ZM17.949 21.079v-8.584h-6.107v3.883h2.674v4.701h-2.46v3.266h8.349v-3.266h-2.456z"
  })));
};
var SvgInfoICircleOutlined$1 = SvgInfoICircleOutlined;

const SvgInfoILocationOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.941 33.123",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.142 5.905a1.737 1.737 0 1 0 1.736 1.737 1.739 1.739 0 0 0-1.736-1.737ZM14.851 18.373v-6.732H9.805v3.232h2.113v3.5h-1.671v2.79h6.272v-2.79h-1.668z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 12.971a12.221 12.221 0 1 1 24.441 0c0 8.255-12.22 19.4-12.22 19.4S.75 21.226.75 12.971Z"
  })));
};
var SvgInfoILocationOutlined$1 = SvgInfoILocationOutlined;

const SvgInfoIOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 16.555 32.866",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.97.75a3.572 3.572 0 1 0 3.573 3.572A3.576 3.576 0 0 0 7.97.75ZM11.487 26.375V11.283H.75v6.827h4.702v8.265H1.127v5.741h14.678v-5.741h-4.318z"
  })));
};
var SvgInfoIOutlined$1 = SvgInfoIOutlined;

const SvgKlmIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#klm_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#73BEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.94 37.845h2.225v-2.224h2.225v-2.222h-2.225v-2.224H52.94v2.224h-2.225v2.222h2.225v2.224Zm14.395-.556a3.886 3.886 0 0 0-3.895 3.876v.014a3.885 3.885 0 0 0 3.88 3.891h.014a3.885 3.885 0 0 0 3.893-3.877v-.013a3.885 3.885 0 0 0-3.88-3.891h-.012ZM40.736 50.628h26.599v-4.446H40.736v4.446Zm3.893-9.448c0-2.154-1.738-3.891-3.859-3.891a3.886 3.886 0 0 0-3.895 3.876v.014a3.885 3.885 0 0 0 3.88 3.891h.014c2.123.001 3.86-1.737 3.86-3.89Zm9.979 0a3.885 3.885 0 0 0 3.88 3.891h.014c2.155 0 3.859-1.738 3.859-3.891 0-2.154-1.738-3.891-3.859-3.891a3.886 3.886 0 0 0-3.895 3.876l.001.015Zm-5.006 3.891a3.907 3.907 0 0 0 3.893-3.891 3.885 3.885 0 0 0-3.88-3.891h-.013a3.886 3.886 0 0 0-3.895 3.876v.014c.035 2.155 1.74 3.892 3.895 3.892Zm28.824 10.003-3.338 10.005-3.338-10.005H60.658v17.751h6.641V59.486l4.45 13.305h6.641l4.416-13.305v13.305h6.641V55.039H78.426v.035Zm-31.049 0h-6.641v17.751h17.732v-4.48H47.376v-13.27l.001-.001Zm-8.866 0H31.87l-6.677 6.67v-6.67h-6.641v17.751h6.641v-6.669l6.677 6.669h8.866l-9.979-10.004 7.754-7.747Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "klm_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25829",
    result: "shape"
  }))));
};
var SvgKlmIcon$1 = SvgKlmIcon;

const SvgKolumbusIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#kolumbus_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 34.215V12l45.266 25.081-20.178 11.295L28 34.216ZM28 92V69.622L79.06 41v22.709L28 92Z",
    fill: "#3CB454"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "kolumbus_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4455_2687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4455_2687",
    result: "shape"
  }))));
};
var SvgKolumbusIcon$1 = SvgKolumbusIcon;

const SvgLandscapeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.385 31.385",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.255,
    cy: 8.203,
    r: 3.374
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.598 26.865 5.898-9.181 5.897 9.181H4.598z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.466 22.289 5.191-8.08 8.13 12.656H16.393l-2.927-4.576z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.635 22.4v7.154a1.079 1.079 0 0 1-1.079 1.079h-6.885M22.671.75h6.885a1.079 1.079 0 0 1 1.079 1.079v7.154M.75 8.983V1.829A1.079 1.079 0 0 1 1.829.75h6.885M8.714 30.635H1.829A1.079 1.079 0 0 1 .75 29.556V22.4"
  })));
};
var SvgLandscapeOutlined$1 = SvgLandscapeOutlined;

const SvgLaptopOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 38.264 26.753",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.261 22.4V2.984A2.234 2.234 0 0 1 5.5.75h27.269A2.234 2.234 0 0 1 35 2.984V22.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.415 3.708h25.433v15.75H6.415zM22.186 22.4v.828h-6.109V22.4H.75v1.157A2.451 2.451 0 0 0 3.2 26h31.863a2.451 2.451 0 0 0 2.451-2.451V22.4Z"
  })));
};
var SvgLaptopOutlined$1 = SvgLaptopOutlined;

const SvgLetterOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.638 23.247",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 33.138,
    height: 21.747,
    rx: 2.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.41 1.765 13.6 12.823a3.367 3.367 0 0 0 4.62 0L33.192 1.8M33.228 21.495l-11.211-9.158M1.41 21.495l11.212-9.158"
  })));
};
var SvgLetterOutlined$1 = SvgLetterOutlined;

const SvgLightbulbBrightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 29.138 30.768",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.798 4.798 2.595 2.595M.75 14.569h3.671M24.341 4.798l-2.596 2.595M14.569.75v3.671M4.798 24.341l2.595-2.596M28.388 14.569h-3.671M24.341 24.341l-2.596-2.596M12.541 26.886s-3.127-6.9-3.652-8.138-1.408-2.769-1.408-4.105a7.088 7.088 0 0 1 7.088-7.088h0a7.087 7.087 0 0 1 7.088 7.088c0 1.336-.883 2.864-1.408 4.105S16.6 26.886 16.6 26.886Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.631 15.244-3.062 6.825h0l-3.062-6.825M12.541 26.886h4.057v3.132h-4.057z"
  })));
};
var SvgLightbulbBrightOutlined$1 = SvgLightbulbBrightOutlined;

const SvgLightrain = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.346 31.979c-1.158 0-2.314.124-3.445.367-3.614-8.363-12.045-13.942-21.169-13.942-11.385 0-20.852 8.016-22.738 19.147h-.079c-7.444 0-13.501 6.055-13.501 13.496 0 7.44 6.057 13.494 13.501 13.494h47.43c8.98 0 16.285-7.305 16.285-16.282s-7.306-16.28-16.284-16.28Zm13.009 16.28c0 7.18-5.835 13.02-13.01 13.02h-47.43c-5.639 0-10.226-4.59-10.226-10.232 0-5.644 4.587-10.234 10.226-10.234.377 0 .788.03 1.293.09l1.665.208.166-1.661a19.731 19.731 0 0 1 19.693-17.785c8.344 0 15.832 5.295 18.634 13.177l.53 1.488 1.51-.48a13.091 13.091 0 0 1 3.94-.608c7.174 0 13.009 5.84 13.009 13.017ZM38.517 73.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM54.674 73.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.641-.186-2.68 1.552Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightrain$1 = SvgLightrain;

const SvgLightrainandthunder = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.036 22.266c-1.135 0-2.268.12-3.375.361C65.12 14.394 56.858 8.902 47.918 8.902c-11.155 0-20.432 7.891-22.279 18.85h-.079c-7.293 0-13.228 5.959-13.228 13.284 0 7.323 5.935 13.282 13.228 13.282h46.476c8.797 0 15.955-7.19 15.955-16.026 0-8.837-7.158-16.026-15.955-16.026Zm12.746 16.026c0 7.067-5.718 12.815-12.746 12.815H25.56c-5.524 0-10.02-4.517-10.02-10.071 0-5.555 4.496-10.075 10.02-10.075.369 0 .773.028 1.268.09l1.631.203.164-1.635c1.008-9.98 9.303-17.506 19.295-17.506 8.175 0 15.513 5.212 18.259 12.971l.519 1.465 1.48-.472c1.255-.4 2.552-.6 3.86-.6 7.028 0 12.746 5.748 12.746 12.815ZM20.786 63.156l4.053 7.363c.942 1.707 3.568.183 2.626-1.528L23.41 61.63c-.94-1.708-3.567-.184-2.624 1.526ZM71.982 63.156l4.055 7.363c.94 1.707 3.566.183 2.625-1.528-1.351-2.454-2.702-4.907-4.055-7.361-.94-1.708-3.566-.184-2.625 1.526ZM61.532 73.442h-4.896c-.649 0-1.251.32-1.611.858a1.917 1.917 0 0 0-.176 1.813l4.596 10.938-18.721-19.748h4.687a1.94 1.94 0 0 0 1.697-1c.34-.617.317-1.37-.063-1.963l-4.63-7.24h-2.883l4.975 7.782h-4.93c-.776 0-1.474.456-1.78 1.163a1.922 1.922 0 0 0 .37 2.086L59.542 90.68c.383.404.889.613 1.402.613.365 0 .732-.105 1.061-.318a1.897 1.897 0 0 0 .735-2.36L57.38 75.86h4.934c.667 0 1.279-.335 1.636-.895.356-.561.4-1.254.117-1.85L56.508 57.1H53.82l7.712 16.34Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightrainandthunder$1 = SvgLightrainandthunder;

const SvgLightrainshowersDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.92 50.12c-.859 0-1.716.093-2.555.277-2.681-6.295-8.936-10.494-15.704-10.494-8.446 0-15.469 6.033-16.867 14.41h-.06c-5.522 0-10.015 4.557-10.015 10.158 0 5.599 4.493 10.154 10.015 10.154H81.92c6.66 0 12.08-5.497 12.08-12.253S88.58 50.12 81.92 50.12Zm9.65 12.252c0 5.403-4.329 9.798-9.65 9.798H46.734c-4.183 0-7.585-3.454-7.585-7.699 0-4.247 3.402-7.703 7.585-7.703.28 0 .585.022.961.07l1.235.154.124-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.189 0 11.744 3.983 13.824 9.915l.392 1.12 1.12-.36a9.582 9.582 0 0 1 2.923-.458c5.321 0 9.65 4.394 9.65 9.796ZM46.257 26.293a1.62 1.62 0 0 1-1.732 1.488 1.621 1.621 0 0 1-1.482-1.741l1.112-14.291a1.62 1.62 0 0 1 1.734-1.49c.884.07 1.551.855 1.482 1.742l-1.114 14.292ZM30.672 32.33c-.662.59-1.687.53-2.276-.136l-9.476-10.72a1.631 1.631 0 0 1 .135-2.286 1.612 1.612 0 0 1 2.276.134l9.476 10.72c.59.666.53 1.695-.135 2.288ZM16.816 68.47l10.447-9.765a1.614 1.614 0 0 1 2.28.083 1.63 1.63 0 0 1-.083 2.289l-10.447 9.765a1.613 1.613 0 0 1-2.28-.082 1.632 1.632 0 0 1 .083-2.29Zm52.402-47.005a1.614 1.614 0 0 0-2.28-.083L56.49 31.148a1.63 1.63 0 0 0-.081 2.29 1.61 1.61 0 0 0 2.278.082l10.448-9.766a1.63 1.63 0 0 0 .082-2.288ZM24.816 44.62a1.625 1.625 0 0 0-1.457-1.762L9.15 41.529a1.62 1.62 0 0 0-.3 3.226l14.211 1.327a1.62 1.62 0 0 0 1.756-1.463ZM43.84 34.306c-6.533-.59-12.325 4.27-12.911 10.834-.379 4.24 1.516 8.163 4.66 10.572-.798.825-1.4 1.667-1.846 2.437-3.953-3.026-6.333-7.953-5.856-13.284.737-8.247 8.016-14.355 16.226-13.615 4.13.372 7.72 2.409 10.175 5.39a20.607 20.607 0 0 0-2.329 1.986 11.84 11.84 0 0 0-8.119-4.32ZM54.517 82.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM70.674 82.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightrainshowersDay$1 = SvgLightrainshowersDay;

const SvgLightrainshowersNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.92 50.12c-.859 0-1.716.093-2.554.277-2.682-6.295-8.936-10.494-15.705-10.494-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S88.58 50.12 81.92 50.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H46.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.247 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM54.517 82.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM70.674 82.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM28.244 67.469a26.305 26.305 0 0 1-6.65-.55c-4.394-.935-7.942-3.448-11.008-6.727-.451-.484-.88-.988-1.37-1.541 10.482 1.131 19.227-2.117 25.507-10.79 6.242-8.62 6.925-18.113 2.979-28.043.056.011.124.01.178.037 6.087 3.125 10.618 7.72 12.84 14.362a15.98 15.98 0 0 1 2.28-.514c-.077-.236-.143-.471-.225-.708-2.983-8.501-9.289-13.726-17.362-16.886-.541-.21-1.056-.127-1.437.35-.38.472-.37.99-.057 1.505.09.148.178.297.264.446 2.785 4.775 4.157 9.934 3.464 15.476-1.185 9.473-5.983 16.432-14.447 20.512-5.238 2.525-10.751 2.622-16.317 1.204-.788-.201-1.34-.08-1.67.436-.332.521-.296 1.02.25 1.688 1.229 1.514 2.409 3.083 3.756 4.48 5.65 5.859 12.466 8.494 20.52 7.635.133-.024.268-.044.403-.067a11.48 11.48 0 0 1-1.898-2.305Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightrainshowersNight$1 = SvgLightrainshowersNight;

const SvgLightrainshowersandthunderDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.92 41.12c-.859 0-1.716.093-2.555.276-2.681-6.294-8.936-10.493-15.704-10.493-8.446 0-15.469 6.033-16.867 14.41h-.06c-5.522 0-10.015 4.557-10.015 10.158 0 5.599 4.493 10.154 10.015 10.154H73.92c6.66 0 12.08-5.497 12.08-12.253S80.58 41.12 73.92 41.12Zm9.65 12.252c0 5.403-4.329 9.798-9.65 9.798H38.734c-4.183 0-7.585-3.454-7.585-7.699 0-4.248 3.402-7.703 7.585-7.703.28 0 .585.022.961.07l1.235.154.124-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.189 0 11.744 3.983 13.824 9.915l.392 1.12 1.12-.36a9.582 9.582 0 0 1 2.923-.458c5.321 0 9.65 4.394 9.65 9.796ZM38.517 73.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM72.674 73.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948ZM37.26 18.643a1.453 1.453 0 0 1-1.554 1.336 1.454 1.454 0 0 1-1.33-1.563l.998-12.82a1.454 1.454 0 0 1 1.555-1.337 1.457 1.457 0 0 1 1.33 1.563l-1 12.821ZM23.278 24.06a1.448 1.448 0 0 1-2.043-.122l-8.501-9.616a1.463 1.463 0 0 1 .121-2.052 1.446 1.446 0 0 1 2.043.12l8.5 9.619a1.46 1.46 0 0 1-.12 2.051ZM10.845 56.484l9.373-8.76a1.448 1.448 0 0 1 2.046.074c.541.585.508 1.51-.075 2.053l-9.373 8.76a1.447 1.447 0 0 1-2.045-.072 1.464 1.464 0 0 1 .074-2.055Zm47.013-42.17a1.448 1.448 0 0 0-2.046-.075l-9.373 8.76a1.463 1.463 0 0 0-.072 2.055 1.445 1.445 0 0 0 2.043.073l9.373-8.76a1.462 1.462 0 0 0 .075-2.054Zm-39.835 20.77a1.457 1.457 0 0 0-1.307-1.58L3.969 32.313a1.454 1.454 0 0 0-.268 2.894l12.748 1.19a1.453 1.453 0 0 0 1.575-1.312Zm17.068-9.252c-5.862-.528-11.058 3.832-11.584 9.72-.34 3.805 1.36 7.324 4.182 9.485a11.245 11.245 0 0 0-1.658 2.187c-3.546-2.716-5.68-7.136-5.253-11.918.66-7.4 7.191-12.88 14.557-12.215 3.705.333 6.926 2.16 9.129 4.835a18.497 18.497 0 0 0-2.09 1.783 10.623 10.623 0 0 0-7.283-3.877Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightrainshowersandthunderDay$1 = SvgLightrainshowersandthunderDay;

const SvgLightrainshowersandthunderNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.92 41.12c-.859 0-1.716.093-2.554.276-2.682-6.294-8.936-10.493-15.705-10.493-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S80.58 41.12 73.92 41.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H38.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.248 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM38.517 73.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM72.674 73.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948ZM21.823 55.75a23.747 23.747 0 0 1-5.957-.488c-3.937-.831-7.115-3.065-9.861-5.98-.405-.43-.79-.879-1.229-1.37 9.391 1.006 17.225-1.882 22.85-9.592 5.593-7.662 6.204-16.1 2.67-24.926.05.01.11.008.159.032 5.453 2.778 9.512 6.863 11.503 12.767.64-.19 1.337-.357 2.042-.457-.07-.21-.128-.419-.202-.629-2.672-7.557-8.32-12.201-15.553-15.01-.485-.187-.946-.113-1.287.31-.341.42-.332.88-.052 1.34.081.13.16.263.237.395 2.495 4.245 3.724 8.83 3.103 13.756-1.061 8.421-5.36 14.607-12.942 18.233-4.692 2.245-9.631 2.33-14.617 1.07-.706-.178-1.2-.07-1.496.389-.298.462-.265.905.223 1.5 1.102 1.345 2.159 2.74 3.366 3.983 5.06 5.207 11.167 7.55 18.382 6.786.12-.022.24-.04.36-.06a10.228 10.228 0 0 1-1.699-2.049Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightrainshowersandthunderNight$1 = SvgLightrainshowersandthunderNight;

const SvgLightsleet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.345 23.979c-1.158 0-2.314.124-3.444.367-3.614-8.363-12.046-13.942-21.17-13.942-11.384 0-20.851 8.016-22.737 19.147h-.08c-7.444 0-13.5 6.055-13.5 13.496 0 7.44 6.056 13.494 13.5 13.494h47.431c8.979 0 16.284-7.305 16.284-16.282s-7.305-16.28-16.284-16.28Zm13.01 16.28c0 7.18-5.835 13.02-13.01 13.02h-47.43c-5.64 0-10.227-4.59-10.227-10.232 0-5.644 4.588-10.234 10.227-10.234.376 0 .787.03 1.293.09l1.664.208.167-1.661a19.732 19.732 0 0 1 19.692-17.785c8.344 0 15.832 5.295 18.634 13.177l.53 1.488 1.51-.48a13.092 13.092 0 0 1 3.94-.608c7.175 0 13.01 5.84 13.01 13.017ZM35.517 65.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM64.674 65.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.718 73.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightsleet$1 = SvgLightsleet;

const SvgLightsnow = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.987 33.996c-1.144 0-2.286.123-3.402.367-3.567-8.343-11.893-13.908-20.9-13.908-11.242 0-20.589 7.996-22.45 19.1l-.079-.001c-7.35 0-13.33 6.04-13.33 13.463 0 7.42 5.98 13.458 13.33 13.458h46.831c8.865 0 16.078-7.286 16.078-16.239 0-8.954-7.213-16.24-16.078-16.24Zm12.845 16.24c0 7.16-5.762 12.985-12.845 12.985h-46.83c-5.569 0-10.098-4.578-10.098-10.204 0-5.63 4.53-10.209 10.097-10.209.372 0 .777.029 1.278.091l1.642.206.166-1.657c1.014-10.113 9.373-17.738 19.443-17.738 8.237 0 15.63 5.281 18.398 13.142l.522 1.483 1.49-.478a12.81 12.81 0 0 1 3.892-.607c7.083 0 12.845 5.825 12.845 12.986Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.718 78.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM67.718 78.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightsnow$1 = SvgLightsnow;

const SvgLightsnowandthunder = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.036 22.266c-1.135 0-2.268.12-3.375.361C65.12 14.394 56.858 8.902 47.918 8.902c-11.155 0-20.432 7.891-22.279 18.85h-.079c-7.293 0-13.228 5.959-13.228 13.284 0 7.323 5.935 13.282 13.228 13.282h46.476c8.797 0 15.955-7.19 15.955-16.026 0-8.837-7.158-16.026-15.955-16.026Zm12.746 16.026c0 7.067-5.718 12.815-12.746 12.815H25.56c-5.524 0-10.02-4.517-10.02-10.071 0-5.555 4.496-10.075 10.02-10.075.369 0 .773.028 1.268.09l1.631.203.164-1.635c1.008-9.98 9.303-17.506 19.295-17.506 8.175 0 15.513 5.212 18.259 12.971l.519 1.465 1.48-.472c1.255-.4 2.552-.6 3.86-.6 7.028 0 12.746 5.748 12.746 12.815ZM61.532 73.442h-4.896c-.649 0-1.251.32-1.611.858a1.917 1.917 0 0 0-.176 1.813l4.596 10.938-18.721-19.748h4.687a1.94 1.94 0 0 0 1.697-1c.34-.617.317-1.37-.063-1.963l-4.63-7.24h-2.883l4.975 7.782h-4.93c-.776 0-1.474.456-1.78 1.163a1.922 1.922 0 0 0 .37 2.086L59.542 90.68c.383.404.889.613 1.402.613.365 0 .732-.105 1.061-.318a1.897 1.897 0 0 0 .735-2.36L57.38 75.86h4.934c.667 0 1.279-.335 1.636-.895.356-.561.4-1.254.117-1.85L56.508 57.1H53.82l7.712 16.34Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.718 65.23h-2.565l1.282-2.35c.367-.565.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM79.718 65.23h-2.565l1.282-2.35c.367-.565.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightsnowandthunder$1 = SvgLightsnowandthunder;

const SvgLightsnowshowersDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.92 50.12c-.859 0-1.716.093-2.554.277-2.682-6.295-8.936-10.494-15.705-10.494-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S88.58 50.12 81.92 50.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H46.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.247 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM46.257 26.293a1.62 1.62 0 0 1-1.732 1.488 1.621 1.621 0 0 1-1.482-1.741l1.112-14.291a1.62 1.62 0 0 1 1.734-1.49c.884.07 1.551.855 1.482 1.742l-1.114 14.292ZM30.672 32.33c-.662.59-1.687.53-2.276-.136l-9.476-10.72a1.631 1.631 0 0 1 .135-2.286 1.612 1.612 0 0 1 2.276.134l9.476 10.72c.59.666.53 1.695-.135 2.288ZM16.816 68.47l10.447-9.765a1.614 1.614 0 0 1 2.28.083 1.63 1.63 0 0 1-.083 2.289l-10.447 9.765a1.613 1.613 0 0 1-2.28-.082 1.632 1.632 0 0 1 .083-2.29Zm52.402-47.005a1.614 1.614 0 0 0-2.28-.083L56.49 31.148a1.63 1.63 0 0 0-.081 2.29 1.61 1.61 0 0 0 2.278.082l10.448-9.766a1.63 1.63 0 0 0 .082-2.288ZM24.816 44.62a1.625 1.625 0 0 0-1.457-1.762L9.15 41.529a1.62 1.62 0 0 0-.3 3.226l14.211 1.327a1.62 1.62 0 0 0 1.756-1.463ZM43.84 34.306c-6.533-.59-12.325 4.27-12.911 10.834-.379 4.24 1.516 8.163 4.66 10.572-.798.825-1.4 1.667-1.846 2.437-3.953-3.026-6.333-7.953-5.856-13.284.737-8.247 8.016-14.355 16.226-13.615 4.13.372 7.72 2.409 10.175 5.39a20.607 20.607 0 0 0-2.329 1.986 11.84 11.84 0 0 0-8.119-4.32Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.718 86.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM82.718 86.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightsnowshowersDay$1 = SvgLightsnowshowersDay;

const SvgLightsnowshowersNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.92 50.12c-.859 0-1.716.093-2.554.277-2.682-6.295-8.936-10.494-15.705-10.494-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S88.58 50.12 81.92 50.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H46.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.247 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.718 86.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM82.718 86.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.244 67.469a26.305 26.305 0 0 1-6.65-.55c-4.394-.935-7.942-3.448-11.008-6.727-.451-.484-.88-.988-1.37-1.541 10.482 1.131 19.227-2.117 25.507-10.79 6.242-8.62 6.925-18.113 2.979-28.043.056.011.124.01.178.037 6.087 3.125 10.618 7.72 12.84 14.362a15.98 15.98 0 0 1 2.28-.514c-.077-.236-.143-.471-.225-.708-2.983-8.501-9.289-13.726-17.362-16.886-.541-.21-1.056-.127-1.437.35-.38.472-.37.99-.057 1.505.09.148.178.297.264.446 2.785 4.775 4.157 9.934 3.464 15.476-1.185 9.473-5.983 16.432-14.447 20.512-5.238 2.525-10.751 2.622-16.317 1.204-.788-.201-1.34-.08-1.67.436-.332.521-.296 1.02.25 1.688 1.229 1.514 2.409 3.083 3.756 4.48 5.65 5.859 12.466 8.494 20.52 7.635.133-.024.268-.044.403-.067a11.48 11.48 0 0 1-1.898-2.305Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightsnowshowersNight$1 = SvgLightsnowshowersNight;

const SvgLightssleetshowersandthunderDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.92 41.12c-.859 0-1.716.093-2.554.276-2.682-6.294-8.936-10.493-15.705-10.493-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S80.58 41.12 73.92 41.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H38.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.248 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM38.517 73.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.718 75.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.26 18.643a1.453 1.453 0 0 1-1.554 1.336 1.454 1.454 0 0 1-1.33-1.563l.998-12.82a1.454 1.454 0 0 1 1.555-1.337 1.457 1.457 0 0 1 1.33 1.563l-1 12.821ZM23.278 24.06a1.448 1.448 0 0 1-2.043-.122l-8.501-9.616a1.463 1.463 0 0 1 .121-2.052 1.446 1.446 0 0 1 2.043.12l8.5 9.619a1.46 1.46 0 0 1-.12 2.051ZM10.845 56.484l9.373-8.76a1.448 1.448 0 0 1 2.046.074c.541.585.508 1.51-.075 2.053l-9.373 8.76a1.447 1.447 0 0 1-2.045-.072 1.464 1.464 0 0 1 .074-2.055Zm47.013-42.17a1.448 1.448 0 0 0-2.046-.075l-9.373 8.76a1.463 1.463 0 0 0-.072 2.055 1.445 1.445 0 0 0 2.043.073l9.373-8.76a1.462 1.462 0 0 0 .075-2.054Zm-39.835 20.77a1.457 1.457 0 0 0-1.307-1.58L3.969 32.313a1.454 1.454 0 0 0-.268 2.894l12.748 1.19a1.453 1.453 0 0 0 1.575-1.312Zm17.068-9.252c-5.862-.528-11.058 3.832-11.584 9.72-.34 3.805 1.36 7.324 4.182 9.485a11.245 11.245 0 0 0-1.658 2.187c-3.546-2.716-5.68-7.136-5.253-11.918.66-7.4 7.191-12.88 14.557-12.215 3.705.333 6.926 2.16 9.129 4.835a18.497 18.497 0 0 0-2.09 1.783 10.623 10.623 0 0 0-7.283-3.877Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightssleetshowersandthunderDay$1 = SvgLightssleetshowersandthunderDay;

const SvgLightssleetshowersandthunderNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.92 41.12c-.859 0-1.716.093-2.554.276-2.682-6.294-8.936-10.493-15.705-10.493-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S80.58 41.12 73.92 41.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H38.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.248 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM38.517 73.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.718 75.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.823 55.75a23.747 23.747 0 0 1-5.957-.488c-3.937-.831-7.115-3.065-9.861-5.98-.405-.43-.79-.879-1.229-1.37 9.391 1.006 17.225-1.882 22.85-9.592 5.593-7.662 6.204-16.1 2.67-24.926.05.01.11.008.159.032 5.453 2.778 9.512 6.863 11.503 12.767.64-.19 1.337-.357 2.042-.457-.07-.21-.128-.419-.202-.629-2.672-7.557-8.32-12.201-15.553-15.01-.485-.187-.946-.113-1.287.31-.341.42-.332.88-.052 1.34.081.13.16.263.237.395 2.495 4.245 3.724 8.83 3.103 13.756-1.061 8.421-5.36 14.607-12.942 18.233-4.692 2.245-9.631 2.33-14.617 1.07-.706-.178-1.2-.07-1.496.389-.298.462-.265.905.223 1.5 1.102 1.345 2.159 2.74 3.366 3.983 5.06 5.207 11.167 7.55 18.382 6.786.12-.022.24-.04.36-.06a10.228 10.228 0 0 1-1.699-2.049Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgLightssleetshowersandthunderNight$1 = SvgLightssleetshowersandthunderNight;

const SvgLinkOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.651 28.651",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.975 19.676 19.786 8.865M14.6 18.165a5.248 5.248 0 0 1-1.435 4.746l-3.453 3.453a5.25 5.25 0 0 1-7.424 0h0a5.248 5.248 0 0 1 0-7.424l3.452-3.453a5.247 5.247 0 0 1 4.747-1.436M14.051 10.487a5.247 5.247 0 0 1 1.436-4.747l3.453-3.452a5.248 5.248 0 0 1 7.424 0h0a5.25 5.25 0 0 1 0 7.424l-3.453 3.453a5.248 5.248 0 0 1-4.746 1.435"
  })));
};
var SvgLinkOutlined$1 = SvgLinkOutlined;

const SvgListArrowUpDownOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.079 23.724",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.803 2.929v18.884M12.669 17.015l-5.96 5.959L.75 17.015M26.276 20.795V1.911M20.41 6.709 26.37.75l5.959 5.959M10.086 6.653h7.129M15.939 17.071h7.129M10.086 11.862h12.982"
  })));
};
var SvgListArrowUpDownOutlined$1 = SvgListArrowUpDownOutlined;

const SvgListClockOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.782 31.201",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.351 8.275h6.903M5.351 24.38h8.506M5.351 13.643h4.974M5.351 19.012h3.452"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.873,
    cy: 15.847,
    r: 8.159
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.873 24.006v.973a5.471 5.471 0 0 1-5.473 5.472H6.221A5.471 5.471 0 0 1 .75 24.979V6.221A5.47 5.47 0 0 1 6.221.75H19.4a5.47 5.47 0 0 1 5.471 5.471v1.467"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.873 12.087v4.241H22.36M11.072.75v1.035a1.776 1.776 0 1 0 3.552 0V.75"
  })));
};
var SvgListClockOutlined$1 = SvgListClockOutlined;

const SvgLocationDotOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.869 33.029",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 12.934a12.185 12.185 0 0 1 24.369 0c0 8.232-12.185 19.345-12.185 19.345S.75 21.166.75 12.934Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.935,
    cy: 12.944,
    r: 5.116
  })));
};
var SvgLocationDotOutlined$1 = SvgLocationDotOutlined;

const SvgLockClosedOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.327 32.885",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 11.678,
    width: 23.827,
    height: 20.457,
    rx: 1.517
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.929 11.678H5.419V8.005A7.255 7.255 0 0 1 12.674.75h0a7.255 7.255 0 0 1 7.255 7.255ZM14.881 20.016a2.218 2.218 0 1 0-3.327 1.92l-.767 3.7h3.754l-.767-3.7a2.216 2.216 0 0 0 1.107-1.92Z"
  })));
};
var SvgLockClosedOutlined$1 = SvgLockClosedOutlined;

const SvgLockOpenOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.99 35.288",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 14.37,
    width: 23.49,
    height: 20.168,
    rx: 1.496
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.9 7.9 1.641-3.234a7.153 7.153 0 0 1 9.616-3.14h0a7.153 7.153 0 0 1 3.143 9.616l-1.643 3.228M14.681 22.59a2.186 2.186 0 1 0-3.28 1.893l-.756 3.65h3.7l-.756-3.65a2.184 2.184 0 0 0 1.092-1.893Z"
  })));
};
var SvgLockOpenOutlined$1 = SvgLockOpenOutlined;

const SvgLockerLockOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.397 30.144",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.426 22.059v3.66M18.874 22.059v3.66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.96,
    y: 11.849,
    width: 8.388,
    height: 7.414,
    rx: 1.571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.649 11.849c0-1.867 1.145-3.381 2.557-3.381s2.558 1.514 2.558 3.381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 8.468V3.009A2.259 2.259 0 0 1 17.457.75h9.931a2.259 2.259 0 0 1 2.259 2.259v24.126a2.259 2.259 0 0 1-2.259 2.259h-9.931a2.259 2.259 0 0 1-2.257-2.259v-7.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 19.375v7.76a2.259 2.259 0 0 1-2.259 2.259H3.009A2.259 2.259 0 0 1 .75 27.135V3.009A2.259 2.259 0 0 1 3.009.75h9.93A2.259 2.259 0 0 1 15.2 3.009v5.459"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.154,
    cy: 15.027,
    r: 1.168
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.154 16.291v.942"
  })));
};
var SvgLockerLockOutlined$1 = SvgLockerLockOutlined;

const SvgLostAndFoundOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.058 36.65",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.078 25.523a2.493 2.493 0 0 1 4.256-1.763 2.525 2.525 0 0 1 0 3.526c-.851.914-1.969 1.719-1.969 3.179M15.365 32.837v-.263"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.325,
    y: 17.55,
    width: 28.478,
    height: 2.708,
    rx: 1.094
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.537 20.258h26.055v12.35A3.292 3.292 0 0 1 25.3 35.9H5.83a3.292 3.292 0 0 1-3.292-3.292v-12.35h0ZM26.624 17.55l4.684-6.163L19.24 6.21l-1.837 11.34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.44 2.354A2.648 2.648 0 0 1 25.916.965h0A2.645 2.645 0 0 1 27.3 4.44l-1.89 4.417M4.105 17.55l-3.19-4.99a1.046 1.046 0 0 1 .318-1.445L8.7 6.339a1.046 1.046 0 0 1 1.444.318l6.967 10.893M6.059 11.69l1.139-.728"
  })));
};
var SvgLostAndFoundOutlined$1 = SvgLostAndFoundOutlined;

const SvgLufthansaIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#lufthansa_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#FFE45C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.867 52c0-18.762-15.105-33.867-33.867-33.867-18.694 0-33.867 15.105-33.867 33.867 0 18.694 15.172 33.867 33.867 33.867 18.762 0 33.867-15.173 33.867-33.867Zm-2.439 0c0 17.272-14.089 31.428-31.428 31.428-17.272 0-31.428-14.155-31.428-31.428 0-17.34 14.156-31.428 31.428-31.428 17.34 0 31.428 14.088 31.428 31.428ZM65.99 49.968c-.745 0-1.693 0-2.913.068l.881-1.49h1.422c5.08 0 8.873.271 12.328.881l1.558-1.49c-3.86-.677-8.534-1.084-13.276-1.084h-1.15l.744-1.422h1.287c4.945 0 9.415.406 13.75 1.219l1.626-1.558c-4.877-.948-10.092-1.421-15.714-1.421a81.958 81.958 0 0 0-7.18.339c-2.709 5.823-7.044 9.212-11.92 9.144-1.898-.07-4.27-.881-7.316-2.508L37.27 49.02l.881-.813 6.57 2.845 1.422-1.084-13.276-6.028-2.032 1.558-4.74-1.964.067 1.964c6.367 2.913 9.01 4.538 15.714 9.347 8.738 6.231 16.527 9.618 27.364 11.786l2.845-2.709h-.677c-7.18 0-13.614-2.371-17.34-6.367 3.116-1.897 6.975-2.775 12.328-2.775 1.422 0 3.454.134 5.351.337l1.626-1.558a64.414 64.414 0 0 0-7.654-.474 62.737 62.737 0 0 0-5.148.203l1.22-1.49a76.43 76.43 0 0 1 4.334-.135c3.59 0 5.961.135 8.67.542l1.558-1.49c-2.846-.474-6.774-.747-10.364-.747Z",
    fill: "#004578"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lufthansa_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25828",
    result: "shape"
  }))));
};
var SvgLufthansaIcon$1 = SvgLufthansaIcon;

const SvgMagnifyingGlassGraphOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.984 28.984",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.285 11.514h2.369l2.009-4.43 1.855 9.169 2.936-7.212 1.493 4.43 1.855-1.957h1.905"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.514,
    cy: 11.514,
    r: 10.764
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.125 19.125 1.86 1.86"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.758,
    y: 19.63,
    width: 2.996,
    height: 9.251,
    rx: 0.851,
    transform: "rotate(-45 24.256 24.256)"
  })));
};
var SvgMagnifyingGlassGraphOutlined$1 = SvgMagnifyingGlassGraphOutlined;

const SvgMagnifyingGlassOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.216 31.216",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.695,
    cy: 12.695,
    r: 11.945
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.315 8.557a8.677 8.677 0 0 1-3.67 11.857M21.142 21.142l9.324 9.324"
  })));
};
var SvgMagnifyingGlassOutlined$1 = SvgMagnifyingGlassOutlined;

const SvgManOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.46 33.469",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.648 9.533a14.869 14.869 0 0 0 9.785-2.174s2.8 2.293 5.416 2.169V6.979a4.393 4.393 0 0 0-4.393-4.393h0A5.135 5.135 0 0 0 11.282.75c-2.894 0-7.4 2.226-7.4 2.226s-.803 4.098.766 6.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.849 9.528a7.619 7.619 0 0 1-15.237 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.688 16.214v2.7a1.062 1.062 0 0 1-.668.989A11.484 11.484 0 0 0 .75 30.589v2.13h22.96v-2.13a11.484 11.484 0 0 0-7.27-10.684 1.063 1.063 0 0 1-.668-.989v-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.532 19.472 3.698 3.791 3.699-3.791"
  })));
};
var SvgManOutlined$1 = SvgManOutlined;

const SvgManWcOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 11.731 31.789",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.866,
    cy: 4.145,
    r: 3.395
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.287 7.151A5.117 5.117 0 0 0 .75 12.019v7.372A1.713 1.713 0 0 0 2.463 21.1h.847v9.935h5.111V21.1h.848a1.712 1.712 0 0 0 1.712-1.713v-7.368a5.117 5.117 0 0 0-3.537-4.868"
  })));
};
var SvgManWcOutlined$1 = SvgManWcOutlined;

const SvgMapOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.938 30.766",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.949 29.877V5.315M18.254 29.974l9.323-3.574a.951.951 0 0 0 .611-.889V2.228a.577.577 0 0 0-.783-.539l-9.456 3.626L11.262.856a.634.634 0 0 0-.578-.064L1.361 4.367a.951.951 0 0 0-.611.889v23.282a.577.577 0 0 0 .783.539l9.456-3.626 6.687 4.459a.634.634 0 0 0 .578.064ZM10.989.903v24.548"
  })));
};
var SvgMapOutlined$1 = SvgMapOutlined;

const SvgMaskOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 39.825 22.025",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.815 18.464-9.456 2.513a10.451 10.451 0 0 1-4.969 0l-9.38-2.513V3.855l8.977-2.712a10.871 10.871 0 0 1 5.774-.005l9.054 2.717Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.332 7.24-7.458-1.468-7.459 1.468M12.415 14.784l7.459 1.469 7.458-1.469M12.415 11.012h14.917M6.476 5.286H8.01v11.452h0-1.534A5.726 5.726 0 0 1 .75 11.012v0a5.726 5.726 0 0 1 5.726-5.726ZM33.349 16.739h-1.534 0V5.287h1.534a5.726 5.726 0 0 1 5.726 5.726h0a5.726 5.726 0 0 1-5.726 5.726Z"
  })));
};
var SvgMaskOutlined$1 = SvgMaskOutlined;

const SvgMazeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.385 31.385",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.727.75v5.888h11.865M24.792 6.638h5.843M12.838 6.638v5.977M6.905 12.838v11.82h5.933v-5.91h17.797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.77 12.615h6.022v6.133M18.77 24.502h6.022v6.133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 .75h13.348a2.287 2.287 0 0 1 2.287 2.287v19.034M30.635 27.3v1.044a2.287 2.287 0 0 1-2.287 2.287H3.037A2.287 2.287 0 0 1 .75 28.348V3.037A2.287 2.287 0 0 1 3.037.75h6.731"
  })));
};
var SvgMazeOutlined$1 = SvgMazeOutlined;

const SvgMobileBatteryOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 20.713 32.744",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 19.213,
    height: 31.244,
    rx: 2.174
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 4.714h19.213M.75 25.793h19.213M7.231 28.786h5.767M6.36 9.499h7.821v13.208H6.36zM8.689 7.159h3.335v2.34H8.689z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.316 12.175 8.99 16.234l2.591-.799-1.968 4.61"
  })));
};
var SvgMobileBatteryOutlined$1 = SvgMobileBatteryOutlined;

const SvgMobileDownloadOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 20.713 32.744",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 19.213,
    height: 31.244,
    rx: 2.174
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 4.714h19.213M.75 25.793h19.213M7.231 28.786h5.767M10.401 9.535v8.256M14.092 14.61l-3.736 3.735L6.62 14.61M5.338 20.972h9.554"
  })));
};
var SvgMobileDownloadOutlined$1 = SvgMobileDownloadOutlined;

const SvgMobileNetworkWiredOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 37.348 33.615",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 20.68,
    width: 15.32,
    height: 9.412,
    rx: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.363 32.865h10.015M10.955 32.865H5.786l.454-2.773h4.261l.454 2.773z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.278,
    y: 20.68,
    width: 15.32,
    height: 9.412,
    rx: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.891 32.865h10.015M31.483 32.865h-5.169l.454-2.773h4.261l.454 2.773zM18.674 13.806v3.129M8.41 20.68v-1.91a1.836 1.836 0 0 1 1.835-1.835H27.1a1.836 1.836 0 0 1 1.836 1.835v1.91"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.953,
    y: 0.75,
    width: 9.441,
    height: 13.056,
    rx: 1.404
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.953 10.418h9.442M17.543 4.049h2.262"
  })));
};
var SvgMobileNetworkWiredOutlined$1 = SvgMobileNetworkWiredOutlined;

const SvgMobileOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 20.713 32.744",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 19.213,
    height: 31.244,
    rx: 2.174
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 4.714h19.213M.75 25.793h19.213M7.231 28.786h5.767"
  })));
};
var SvgMobileOutlined$1 = SvgMobileOutlined;

const SvgMoneyCircleArrowOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.431 35.431",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.546 10.621h20.232v12.083H6.546z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.778 12.728h2.107v12.083H8.654v-2.108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.21 18.586v-3.848a1.606 1.606 0 0 1-1.605-1.605H10.719a1.606 1.606 0 0 1-1.6 1.605v3.848a1.606 1.606 0 0 1 1.6 1.605h11.886a1.606 1.606 0 0 1 1.605-1.605Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.662,
    cy: 16.662,
    r: 1.513
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.681 17.716a16.966 16.966 0 1 1-4.969-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.538 1.95v4.645h-4.645"
  })));
};
var SvgMoneyCircleArrowOutlined$1 = SvgMoneyCircleArrowOutlined;

const SvgMoneyOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.055 22.815",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75.75h30.39V18.9H.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.14 3.915h3.165v18.15H3.915V18.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.975 13.407V6.243a2.411 2.411 0 0 1-2.411-2.411H6.326a2.411 2.411 0 0 1-2.411 2.411v7.164a2.41 2.41 0 0 1 2.411 2.411h19.238a2.41 2.41 0 0 1 2.411-2.411Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.945,
    cy: 9.825,
    r: 3.381
  })));
};
var SvgMoneyOutlined$1 = SvgMoneyOutlined;

const SvgMotorcycleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 36.951 21.54",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.51,
    cy: 15.099,
    r: 5.691
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.97 12.655A7.728 7.728 0 0 1 8.3 7.374h17.558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.451 15.099 24.476.75h-3.592"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.268 15.1h0a2.857 2.857 0 0 1-2.856 2.857H.75V15.1h18.691a4.394 4.394 0 0 0 3.912-2.394l2.534-4.958a2.843 2.843 0 0 0-.28-3.031l-.034-.043a2.939 2.939 0 0 0-3.636-.844l-1.414.7a3.139 3.139 0 0 0-1.744 2.812v3.477h-6.728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.744 7.6V4.812A1.462 1.462 0 0 1 7.4 3.362l8.582 1.117a3.235 3.235 0 0 1 2.818 3.23l-.017 2.732M28.029 1.679h1.241v4.042h0-1.241A2.021 2.021 0 0 1 26.008 3.7v0a2.021 2.021 0 0 1 2.021-2.021ZM2.644 15.1a5.691 5.691 0 0 1 11.382 0M13.223 17.956a5.693 5.693 0 0 1-9.846 0"
  })));
};
var SvgMotorcycleOutlined$1 = SvgMotorcycleOutlined;

const SvgMountainFlagOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 29.209 29.863",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 29.113 14.605 9.58l13.854 19.533H.75zM14.605.75v8.83M22.701 6.286h-8.096V1.627h8.096l-1.755 2.329 1.755 2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.149 17.272 1.742 2.412 1.856-2.571 1.857 2.571 1.857-2.571 1.857 2.571 1.743-2.412"
  })));
};
var SvgMountainFlagOutlined$1 = SvgMountainFlagOutlined;

const SvgMove = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.137 17.296a.75.75 0 0 1 1.061 0l6.236 6.238a.752.752 0 0 1 0 1.062l-6.236 6.238a.75.75 0 0 1-1.06-1.06l5.706-5.709-5.707-5.709a.75.75 0 0 1 0-1.06Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.321 24.066a.75.75 0 0 1 .75-.75h18.835a.75.75 0 0 1 0 1.5H23.07a.75.75 0 0 1-.75-.75ZM12.674 17.296a.75.75 0 0 1 0 1.06l-5.707 5.71 5.707 5.707a.75.75 0 0 1-1.06 1.061l-6.237-6.238a.751.751 0 0 1 0-1.062l6.236-6.238a.75.75 0 0 1 1.06 0Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.156 24.066a.75.75 0 0 1 .75-.75H24.74a.75.75 0 0 1 0 1.5H5.906a.75.75 0 0 1-.75-.75ZM23.906 7.126l5.708 5.708a.75.75 0 0 0 1.06-1.061l-6.236-6.236a.753.753 0 0 0-1.065 0l-6.236 6.236a.75.75 0 0 0 1.061 1.06l5.708-5.707Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.905 5.315a.75.75 0 0 1 .75.75V24.9a.75.75 0 0 1-1.5 0V6.065a.75.75 0 0 1 .75-.75ZM17.137 35.296a.75.75 0 0 1 1.06 0l5.708 5.708 5.708-5.708a.75.75 0 1 1 1.061 1.061l-6.236 6.236a.753.753 0 0 1-1.065 0l-6.236-6.236a.75.75 0 0 1 0-1.06Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.905 22.48a.75.75 0 0 1 .75.75v18.835a.75.75 0 0 1-1.5 0V23.23a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgMove$1 = SvgMove;

const SvgNetworkWiredOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 37.348 32.744",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.014,
    y: 0.75,
    width: 15.32,
    height: 9.412,
    rx: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.627 12.935h10.015M21.219 12.935H16.05l.454-2.773h4.261l.454 2.773z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 19.809,
    width: 15.32,
    height: 9.412,
    rx: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.363 31.994h10.015M10.955 31.994H5.786l.454-2.773h4.261l.454 2.773z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.278,
    y: 19.809,
    width: 15.32,
    height: 9.412,
    rx: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.891 31.994h10.015M31.483 31.994h-5.169l.454-2.773h4.261l.454 2.773zM18.674 12.935v3.129M8.41 19.809V17.9a1.835 1.835 0 0 1 1.835-1.835H27.1a1.835 1.835 0 0 1 1.838 1.835v1.91"
  })));
};
var SvgNetworkWiredOutlined$1 = SvgNetworkWiredOutlined;

const SvgNewsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.818 28.643",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2 27.893H4.616A3.866 3.866 0 0 1 .75 24.027V.75h21.585v23.277"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.335 7.345h7.732v16.682a3.866 3.866 0 0 1-3.867 3.866h0a3.866 3.866 0 0 1-3.866-3.866V7.345h.001ZM4.777 5.072h13.478M4.777 8.992h13.478M4.777 23.597h13.478M4.777 18.351h3.114M4.777 14.512h3.114M11.516 12.988h6.886v6.886h-6.886z"
  })));
};
var SvgNewsOutlined$1 = SvgNewsOutlined;

const SvgNorseIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#norse_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#ACDAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.847 19.007c-.878.045-1.46.103-2.195.214-.819.125-1.769.327-2.563.545-3.793 1.043-7.077 3.197-9.12 5.983-.535.73-.999 1.558-1.326 2.362-.42 1.038-.643 2.127-.643 3.157 0 .733.12 1.513.307 2.023.37 1.006 1.141 1.888 2.245 2.565 1.71 1.05 4.103 1.527 6.53 1.303 2.137-.198 4.18-.905 5.915-2.047a12.05 12.05 0 0 0 3.283-3.213c.234-.335.252-.37.252-.535 0-.11-.007-.144-.035-.195a.457.457 0 0 0-.21-.208.34.34 0 0 0-.192-.04c-.105 0-.107.001-.58.232-1.782.87-3.367 1.503-4.615 1.845-.65.177-1.34.297-2.03.352a9.91 9.91 0 0 1-1.698-.04c-1.867-.23-3.266-1.115-3.73-2.354a2.992 2.992 0 0 1-.103-1.623c.137-.674.502-1.373 1.072-2.057.177-.21.677-.702.903-.89A9.91 9.91 0 0 1 39 24.82c1.678-.662 3.334-.864 4.804-.585 1.509.287 2.81 1.065 3.615 2.164.111.152.18.258.442.706.431.733.68 1.498.78 2.402.03.27.024 1.183-.008 1.486-.106.97-.318 1.887-.705 3.054-.404 1.216-1.372 3.044-2.658 5.028-.801 1.234-1.627 2.403-3.564 5.037-2.41 3.277-3.44 4.76-4.604 6.617-3.001 4.793-4.319 9.86-3.929 15.11.08 1.084.272 2.415.436 3.038.703 2.677 1.956 5.362 3.583 7.68 1.952 2.784 4.428 5.154 7.445 7.128l.355.232.27.023c.664.056.826.06 1.947.06 1.17 0 1.441-.01 2.383-.083 1.847-.14 4.112-.485 5.396-.817l.057-.015-.29-.138a21.569 21.569 0 0 1-7.191-5.55 20.823 20.823 0 0 1-2.686-4.078c-1.926-3.85-2.559-8.142-1.842-12.481.294-1.774.795-3.404 1.48-4.81.056-.114.328-.641.606-1.168 1.608-3.056 2.98-5.69 4.597-8.832l.293-.564.028.096c.406 1.396.789 2.472 1.303 3.654 2.156 4.966 5.675 9.241 10.173 12.36a29.527 29.527 0 0 0 14.389 5.147c.158.013.327.027.38.033l.094.008.208-.422a34.292 34.292 0 0 0 1.95-4.72c.192-.584.206-.626.2-.631a10.063 10.063 0 0 0-.427-.03 24.753 24.753 0 0 1-13.28-4.808c-.989-.73-1.8-1.427-2.71-2.329a23.564 23.564 0 0 1-3.097-3.738 24.053 24.053 0 0 1-4.076-12.012c-.11-1.796-.028-2.923.406-5.555.105-.633.153-.979.195-1.39.198-1.93.056-3.71-.43-5.337a10.459 10.459 0 0 0-1.415-2.967c-.61-.878-1.382-1.675-2.096-2.167-1.419-.977-3.256-1.527-5.492-1.644a29.918 29.918 0 0 0-1.467-.005Z",
    fill: "#004578"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "norse_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25840",
    result: "shape"
  }))));
};
var SvgNorseIcon$1 = SvgNorseIcon;

const SvgNorwegianIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#norwegian_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#D12600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.123 49.487c-.386-.257-.772-.386-1.158-.643a165.408 165.408 0 0 0-4.759-2.315c.257-.514.257-.9.129-1.415-.129-.257-.514-.643-.772-.772-.386-.129-.643-.129-1.029.129-.386.129-.643.386-1.029.514-.129 0-.257-.129-.257-.129-.257-.129-.386-.129-.643-.257.257-.129.514-.386.772-.514 1.286-.9 2.572-1.672 3.859-2.701 1.158-.9 2.444-1.801 3.215-3.087.257-.386.515-.772.386-1.286-.129-.129 0-.257-.257-.386-.129-.129-.257-.257-.386-.257-.386-.257-.514-.257-.9-.386-.515-.129-1.158-.257-1.801-.257-.257 0-.386 0 .129-.257-.9.129-1.929.257-2.83.514-1.286.386-2.83 1.029-4.502 1.929-1.801.9-3.344 2.058-5.016 3.215-.257-.386-.772-.643-1.286-.643-.9.257-1.672.9-2.315 1.415h-.386c-.129-.129-.257 0-.386-.129-.129.129-.257 0-.386 0-1.415-.257-3.087-.386-4.502-.515-1.029-.129-2.187-.257-3.344-.386-1.029-.129-1.672-.257-2.572-.257-.514.129-.772.386-1.158.643-.257.257-.643.515-.772.772v.257c.643.257 1.286.257 1.801.514 1.158.257 1.415.386 2.701.643 0 0 .772.257 1.415.386.9.257 1.158.386 2.187.643.9.386 1.929.9 2.83 1.286-.643.386-1.029.643-1.801 1.158-.257.129-.643.386-1.029.643-.129.129-.515.386-.643.386-.257.129-.386.257-.772.386-.257 0-.514-.129-.772-.257a85.81 85.81 0 0 1-3.344-1.415c-.386-.129-.514 0-1.029.257-.129 0-.257 0-.386.129s-.257.257-.257.386c0 .257.129.386.257.514.643.643 1.158 1.286 1.801 1.929-.386 0-1.029-.129-1.543-.129-.514-.257-1.158 0-1.543.257-.257.257-.129.386 0 .514.643.386 1.286.514 2.058.772.386.129.643.257 1.029.386a.52.52 0 0 0 .178.109c-19.458 8.822-38.295 12.735-45.71 11.855-6.688-.9-5.917-11.962 4.63-20.836h-2.83C10.019 53.346 5.389 66.208 14.778 68.137c10.352 2.12 31.467-4.467 53.26-15.423.514.622 1.278.117 1.789-.011h.257c1.158.386 2.187.643 3.344.9.257-.129.386-.129.643-.257 0 0 .129 0 .129-.129-.257-.643-.772-.772-1.158-1.286 1.158-.386 2.187-.772 3.344-1.158 1.801-.643 3.215-1.415 4.759-2.058 1.029.129 1.929.129 2.958.129.9 0 1.672 0 2.444.129.643 0 1.158.129 1.801.257.772.257 1.672.386 2.444.515 1.029.129 2.058.386 3.087.643.772.257 1.415.386 2.058.514.643 0 1.158-.514 1.801-.772.257-.128.514-.386.385-.643Zm-23.151-1.801c-1.286.643-2.701 1.415-4.63 2.315-.514.257-1.029.386-1.543.257-.386 0-.386 0-.772-.129l-2.058-2.058c-.129-.129-.257-.257-.257-.386l.386-.257h.129c1.029.386 1.672.772 2.701 1.286.386.129.772.386 1.158.514.386 0 .772-.129 1.158-.257l.257-.129c.514-.386.772-.514 1.029-.643 1.029-.643 1.929-1.158 2.958-1.801l.257-.129c.386.129.643.257 1.158.386-.645.388-1.288.774-1.931 1.031Zm2.701-3.472c-.129-.129-.257-.257-.257-.514-.129-.386 0-.643.129-1.029l.257-.257c.257-.129.386-.257.643-.386s.386-.257.514-.257c-.129.386-.129.514 0 .9 0 .257.257.386.257.514-.514.386-1.029.643-1.543 1.029Zm7.46-3.216c-.514.386-1.672 1.286-1.801 1.415-.9-.129-1.672-.129-2.572-.257l.129-.129c1.158-.9 2.058-1.543 3.344-2.187 1.029-.643 2.701-1.543 3.987-2.058 1.158-.514 2.444-.9 3.73-1.029 1.029-.257 1.801-.257 2.444 0-.772.129-1.286.257-2.187.643-.772.257-1.929.772-2.958 1.286-1.415.644-2.573 1.416-4.116 2.316Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "norwegian_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25827"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25827",
    result: "shape"
  }))));
};
var SvgNorwegianIcon$1 = SvgNorwegianIcon;

const SvgPaperPlaneTopRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.445 28.445",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.239.793 1.56 7.64a1.1 1.1 0 0 0-.486 1.845L6 14.414v6.316a1.711 1.711 0 0 0 1.711 1.711h6.316l4.929 4.93a1.1 1.1 0 0 0 1.845-.486l6.851-24.679A1.148 1.148 0 0 0 26.239.793ZM6.505 21.94 27.392 1.053"
  })));
};
var SvgPaperPlaneTopRightOutlined$1 = SvgPaperPlaneTopRightOutlined;

const SvgPaperclipOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 26.772 29.62",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.915 6.475 8.792 16.6a2.968 2.968 0 0 0 0 4.2h0a2.917 2.917 0 0 0 4.125 0l10.159-10.165 1.509-1.509a4.907 4.907 0 0 0 0-6.939h0a4.906 4.906 0 0 0-6.938 0l-1.641 1.64-13.229 13.23a6.919 6.919 0 0 0 0 9.786h0a6.919 6.919 0 0 0 9.786 0l13.23-13.229",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }));
};
var SvgPaperclipOutlined$1 = SvgPaperclipOutlined;

const SvgPartlycloudyDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.098 50.74c-1.096 0-2.19.12-3.26.355C77.42 43.023 69.444 37.64 60.812 37.64c-10.773 0-19.73 7.735-21.512 18.478h-.076c-7.043 0-12.774 5.844-12.774 13.024 0 7.18 5.731 13.021 12.774 13.021h44.875c8.495 0 15.406-7.048 15.406-15.711 0-8.664-6.911-15.712-15.406-15.712Zm12.307 15.712c0 6.928-5.522 12.563-12.307 12.563H39.223c-5.335 0-9.675-4.428-9.675-9.873 0-5.445 4.34-9.877 9.675-9.877.357 0 .744.028 1.225.088l1.574.2.158-1.603c.972-9.785 8.982-17.163 18.63-17.163 7.893 0 14.98 5.11 17.63 12.716l.501 1.435 1.427-.461a12.165 12.165 0 0 1 3.73-.589c6.785 0 12.307 5.635 12.307 12.564ZM38.127 29.383a1.539 1.539 0 0 1-1.622 1.444 1.543 1.543 0 0 1-1.429-1.639l.85-13.64a1.539 1.539 0 0 1 1.622-1.445c.838.054 1.482.79 1.43 1.639l-.85 13.641Zm-16.85 5.885c.568.627 1.54.67 2.16.097.621-.575.664-1.557.096-2.183l-9.138-10.08a1.521 1.521 0 0 0-2.16-.095 1.56 1.56 0 0 0-.096 2.181l9.139 10.08Zm-.69 25.292-9.767 9.462a1.559 1.559 0 0 0-.046 2.183 1.524 1.524 0 0 0 2.164.045l9.765-9.46a1.563 1.563 0 0 0 .045-2.185 1.523 1.523 0 0 0-2.162-.045ZM18.06 47.167a1.545 1.545 0 0 0-1.406-1.66L3.164 44.45a1.54 1.54 0 0 0-1.644 1.42 1.546 1.546 0 0 0 1.408 1.66l13.491 1.057a1.537 1.537 0 0 0 1.642-1.42ZM36.167 34.14c2.092.157 4.038 1.023 5.764 1.987-2.31-.039-3.61 1.31-3.61 1.31l-.415-.159c-.657-.273-.785-.26-1.07-.23a4.337 4.337 0 0 1-.885.009c-6.201-.467-11.624 4.251-12.086 10.516a11.432 11.432 0 0 0 4.571 10.01 12.113 12.113 0 0 0-1.716 2.352 14.366 14.366 0 0 1-5.743-12.578c.58-7.874 7.395-13.804 15.19-13.217Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.677 46.175c0-6.937-5.533-12.58-12.335-12.58-.878 0-1.754.095-2.61.283-2.737-6.463-9.125-10.775-16.037-10.775-8.624 0-15.797 6.195-17.225 14.797h-.06c-5.64 0-10.228 4.678-10.228 10.428 0 1.717.42 3.329 1.145 4.755.58-.29 1.39-.58 2.437-.746a7.911 7.911 0 0 1-1.1-4.009c0-4.36 3.475-7.908 7.745-7.908.286 0 .598.023.98.072l1.261.158.127-1.283c.78-7.834 7.192-13.742 14.918-13.742 6.32 0 11.993 4.092 14.117 10.182l.401 1.15 1.144-.37a9.697 9.697 0 0 1 2.985-.472c5.434 0 9.855 4.513 9.855 10.06 0 .565-.055 1.117-.144 1.657a8.757 8.757 0 0 1 2.351.918c.172-.832.273-1.692.273-2.575Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgPartlycloudyDay$1 = SvgPartlycloudyDay;

const SvgPartlycloudyNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.153 56.452c-.925 0-1.85.102-2.753.3-2.889-6.82-9.628-11.367-16.92-11.367-9.102 0-16.669 6.535-18.175 15.611h-.064c-5.95 0-10.792 4.937-10.792 11.003S35.291 83 41.241 83h37.912c7.177 0 13.016-5.955 13.016-13.274 0-7.32-5.839-13.274-13.016-13.274Zm10.398 13.274c0 5.853-4.665 10.614-10.398 10.614H41.241c-4.507 0-8.174-3.741-8.174-8.341s3.667-8.344 8.174-8.344c.301 0 .629.023 1.035.074l1.33.17.133-1.355c.822-8.267 7.589-14.5 15.74-14.5 6.668 0 12.655 4.316 14.894 10.743l.424 1.212 1.206-.39a10.278 10.278 0 0 1 3.15-.497c5.733 0 10.398 4.76 10.398 10.614Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 52.24c0-5.785-4.73-10.491-10.544-10.491-.75 0-1.499.08-2.231.236C70.886 36.595 65.426 33 59.518 33c-7.372 0-13.503 5.166-14.723 12.339h-.053c-4.82 0-8.742 3.901-8.742 8.696 0 1.431.36 2.775.979 3.965.495-.242 1.189-.484 2.083-.623a6.475 6.475 0 0 1-.94-3.342c0-3.636 2.97-6.595 6.62-6.595.244 0 .511.02.838.06l1.078.132.108-1.07c.666-6.532 6.148-11.46 12.752-11.46 5.402 0 10.251 3.413 12.067 8.491l.342.96.978-.31a8.477 8.477 0 0 1 2.551-.393c4.645 0 8.424 3.764 8.424 8.39 0 .47-.046.93-.123 1.38.583.136 1.312.37 2.01.767.147-.694.233-1.411.233-2.148Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.823 61.75a23.747 23.747 0 0 1-5.957-.488c-3.937-.831-7.115-3.065-9.861-5.98-.405-.43-.79-.879-1.229-1.37 9.391 1.006 17.225-1.882 22.85-9.592 5.593-7.662 6.204-16.1 2.67-24.926.05.01.11.008.159.032 5.453 2.778 9.512 6.863 11.503 12.767.64-.19 1.337-.357 2.042-.457-.07-.21-.128-.419-.202-.629-2.672-7.557-8.32-12.201-15.553-15.01-.485-.187-.946-.113-1.287.31-.341.42-.332.88-.052 1.34.081.13.16.263.237.395 2.495 4.245 3.724 8.83 3.103 13.756-1.062 8.421-5.36 14.607-12.942 18.233-4.692 2.245-9.631 2.33-14.617 1.07-.706-.178-1.2-.07-1.496.389-.298.462-.265.905.223 1.5 1.102 1.345 2.159 2.74 3.366 3.983 5.06 5.207 11.167 7.55 18.382 6.786.12-.022.24-.04.36-.06a10.228 10.228 0 0 1-1.699-2.049Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgPartlycloudyNight$1 = SvgPartlycloudyNight;

const SvgPassportOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 29.172 32.899",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.874,
    y: 0.75,
    width: 24.549,
    height: 31.399,
    rx: 0.774
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.017 32.149H1.5a.749.749 0 0 1-.75-.749V1.5A.749.749 0 0 1 1.5.75h21.517"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.148,
    cy: 13.935,
    r: 8.531
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.839 19.677a12.123 12.123 0 0 1 6.309-1.709 12.123 12.123 0 0 1 6.309 1.709M22.457 8.27a12.123 12.123 0 0 1-6.309 1.709A12.123 12.123 0 0 1 9.839 8.27"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.148,
    cy: 13.935,
    rx: 3.732,
    ry: 8.531
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.679 13.935H7.617M22.811 26.348H9.485"
  })));
};
var SvgPassportOutlined$1 = SvgPassportOutlined;

const SvgPassportSecurityOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.04 40.251",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.667,
    y: 21.577,
    width: 13.624,
    height: 17.925,
    rx: 0.442
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 39.5H14.116a.428.428 0 0 1-.428-.427V22a.428.428 0 0 1 .428-.427H26.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.479,
    cy: 29.104,
    r: 4.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.877 32.382a7.133 7.133 0 0 1 7.2 0M26.08 25.87a7.139 7.139 0 0 1-7.2 0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.479,
    cy: 29.104,
    rx: 2.13,
    ry: 4.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.349 29.104h-9.74M26.282 36.19h-7.607M18.244 2.066 10.975.75l-7.27 1.316a1.189 1.189 0 0 0-.978 1.171v1.342A7.93 7.93 0 0 0 4.06 8.993a7.98 7.98 0 0 0 13.829 0 7.931 7.931 0 0 0 1.334-4.414V3.237a1.189 1.189 0 0 0-.979-1.171Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.937,
    cy: 5.037,
    r: 1.548
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.189 12.747a6.786 6.786 0 0 0 13.571 0v-3.34H4.189ZM18.513 21.577a10.221 10.221 0 0 0-4.384-2.821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82 18.756a10.229 10.229 0 0 0-7.07 9.729V33h12.078"
  })));
};
var SvgPassportSecurityOutlined$1 = SvgPassportSecurityOutlined;

const SvgPenOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 29.805 29.805",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.91 1.896h0a3.91 3.91 0 0 1 .001 5.53L8.928 26.41a.418.418 0 0 1-.591 0L3.4 21.473a.418.418 0 0 1 0-.592L22.383 1.898a3.91 3.91 0 0 1 5.53 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.298 21.037.75 29.055l7.966-2.533M25.706 9.628l-5.529-5.529"
  })));
};
var SvgPenOutlined$1 = SvgPenOutlined;

const SvgPenSignOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.559 33.719",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.153 1.224h0a3.459 3.459 0 0 1 1.237 4.733L17.205 26.775h0l-5.971-3.495h0L23.419 2.462a3.459 3.459 0 0 1 4.734-1.238Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.235 23.28-.179 5.257a1.09 1.09 0 0 0 1.655.968l4.495-2.73M26.633 10.669l-5.971-3.495M28.46 7.549l2.346 1.374M31.809 7.21 25.55 17.903M11.595 29.515l-.828 1.413M.75 30.221l1.139-1.071a1.875 1.875 0 0 1 3.138 1.65h0a1.875 1.875 0 0 0 2.64 1.989l1.11-.514"
  })));
};
var SvgPenSignOutlined$1 = SvgPenSignOutlined;

const SvgPeopleGroup3Outlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 42.055 27.867",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.982,
    cy: 7.818,
    r: 6.466
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.975 13.544a9.748 9.748 0 0 0-6.737 9.272v4.3h19.488v-4.3a9.749 9.749 0 0 0-6.738-9.272"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.385,
    cy: 6.006,
    r: 5.256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.726 21.692h10.579V18.2a7.924 7.924 0 0 0-5.476-7.536M30.942 10.66a7.943 7.943 0 0 0-4.642 3.991"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.67,
    cy: 6.006,
    r: 5.256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.731 14.606a7.943 7.943 0 0 0-4.618-3.946M6.226 10.66A7.924 7.924 0 0 0 .75 18.2v3.5h10.488"
  })));
};
var SvgPeopleGroup3Outlined$1 = SvgPeopleGroup3Outlined;

const SvgPeopleGroup6Outlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.779 32.51",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.853,
    cy: 19.275,
    r: 4.183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.908 22.98a6.307 6.307 0 0 0-4.359 6v2.78h12.608v-2.782a6.305 6.305 0 0 0-4.359-6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.726,
    cy: 16.877,
    r: 4.183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.282 29.362h9.747v-2.783a6.307 6.307 0 0 0-4.359-6M24.781 20.581a6.325 6.325 0 0 0-3.694 3.177"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.054,
    cy: 16.877,
    r: 4.183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.674 23.722A6.323 6.323 0 0 0 9 20.581M5.109 20.581a6.307 6.307 0 0 0-4.359 6v2.783h9.579"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.853,
    cy: 7.332,
    r: 4.183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.889 15.209a6.318 6.318 0 0 0-4.089-4.173M14.908 11.036a6.32 6.32 0 0 0-4.033 3.994"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.726,
    cy: 4.933,
    r: 4.183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.909 17.418h2.12v-2.782a6.306 6.306 0 0 0-4.359-6M24.781 8.638a6.324 6.324 0 0 0-3.694 3.176"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.054,
    cy: 4.933,
    r: 4.183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.674 11.778A6.321 6.321 0 0 0 9 8.638M5.109 8.638a6.306 6.306 0 0 0-4.359 6v2.782h2.156"
  })));
};
var SvgPeopleGroup6Outlined$1 = SvgPeopleGroup6Outlined;

const SvgPeopleGroupLightbulbOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.179 37.634",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.052,
    cy: 21.334,
    r: 5.21
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.63 25.948a7.855 7.855 0 0 0-5.43 7.471v3.465h15.7v-3.465a7.855 7.855 0 0 0-5.429-7.471"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.047,
    cy: 19.874,
    r: 4.235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 32.513h8.525V29.7a6.385 6.385 0 0 0-4.413-6.072M25.078 23.624a6.4 6.4 0 0 0-3.739 3.216"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.132,
    cy: 19.874,
    r: 4.235
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.822 26.8A6.4 6.4 0 0 0 9.1 23.624M5.163 23.624A6.385 6.385 0 0 0 .75 29.7v2.817H9.2M16.015 10.8s-1.656-3.463-1.934-4.12a6.349 6.349 0 0 1-.745-2.18A3.753 3.753 0 0 1 17.089.75h0a3.754 3.754 0 0 1 3.754 3.75 6.351 6.351 0 0 1-.743 2.177c-.278.657-1.934 4.12-1.934 4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.288 5.293-1.199 2.672h0L15.89 5.293M16.015 10.797h2.148v2.132h-2.148z"
  })));
};
var SvgPeopleGroupLightbulbOutlined$1 = SvgPeopleGroupLightbulbOutlined;

const SvgPeopleGroupTableOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 41.948 28.994",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.816,
    cy: 8.614,
    r: 4.135
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.739 12.276a6.235 6.235 0 0 1 2.991 2.1M7.894 12.276A6.233 6.233 0 0 0 3.586 18.2v3.66"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.105,
    cy: 8.614,
    r: 4.135
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.336 21.86V18.2a6.233 6.233 0 0 0-4.309-5.928M30.183 12.276a6.241 6.241 0 0 0-2.945 2.038"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.961,
    cy: 4.885,
    r: 4.135
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 28.244H1.951a1.2 1.2 0 0 1-1.029-1.816l4.675-7.8a2.986 2.986 0 0 1 2.561-1.451H33.79a2.985 2.985 0 0 1 2.561 1.451l4.675 7.8A1.2 1.2 0 0 1 40 28.244ZM23.114 8.4a4.045 4.045 0 0 1-4.288.01 6.25 6.25 0 0 0-4.1 5.864v2.9h12.512v-2.9A6.251 6.251 0 0 0 23.114 8.4Z"
  })));
};
var SvgPeopleGroupTableOutlined$1 = SvgPeopleGroupTableOutlined;

const SvgPersonAdultChildOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.997 32.762",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.066,
    cy: 16.604,
    r: 6.481
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.542 22.618a8.183 8.183 0 0 0-5.657 7.782v1.61h16.362V30.4a8.183 8.183 0 0 0-5.657-7.784M27.827 13.473a2.175 2.175 0 0 1-4.005-1.173M23.822 12.3A2.175 2.175 0 0 1 26 10.123"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.573,
    cy: 8.596,
    r: 7.846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 17.21a11.779 11.779 0 0 0-3.277-1.666M8.926 15.544A11.829 11.829 0 0 0 .75 26.794v5.218H24.4"
  })));
};
var SvgPersonAdultChildOutlined$1 = SvgPersonAdultChildOutlined;

const SvgPersonCircleCheckOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.16 32.762",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.932,
    cy: 25.534,
    r: 6.479
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.982 25.305 2.171 2.579 3.665-4.146"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.573,
    cy: 8.596,
    r: 7.846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.809 19.411a11.853 11.853 0 0 0-5.588-3.867M8.926 15.544A11.829 11.829 0 0 0 .75 26.794v5.218H24.4"
  })));
};
var SvgPersonCircleCheckOutlined$1 = SvgPersonCircleCheckOutlined;

const SvgPersonCircleCloseOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.16 32.762",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.932,
    cy: 25.534,
    r: 6.479
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.573,
    cy: 8.596,
    r: 7.846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.809 19.411a11.853 11.853 0 0 0-5.588-3.867M8.926 15.544A11.829 11.829 0 0 0 .75 26.794v5.218H24.4M21.659 23.261l4.546 4.546M26.205 23.261l-4.546 4.546"
  })));
};
var SvgPersonCircleCloseOutlined$1 = SvgPersonCircleCloseOutlined;

const SvgPersonCircleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.762 32.762",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.381,
    cy: 16.381,
    r: 15.631
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.381,
    cy: 12.322,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.423 29.134v-2.895a9.046 9.046 0 0 0-6.252-8.6M13.592 17.636a9.044 9.044 0 0 0-6.252 8.6v2.895"
  })));
};
var SvgPersonCircleOutlined$1 = SvgPersonCircleOutlined;

const SvgPersonCirclePlusOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.16 32.762",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.932,
    cy: 25.534,
    r: 6.479
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.573,
    cy: 8.596,
    r: 7.846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.809 19.411a11.853 11.853 0 0 0-5.588-3.867M8.926 15.544A11.829 11.829 0 0 0 .75 26.794v5.218H24.4M21.286 25.534h5.292M23.932 22.888v5.292"
  })));
};
var SvgPersonCirclePlusOutlined$1 = SvgPersonCirclePlusOutlined;

const SvgPersonHeartOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 23.317 37.349",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.659,
    cy: 19.186,
    r: 5.924
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.293 24.32A10.912 10.912 0 0 0 .75 34.7v1.9h21.817v-1.9a10.912 10.912 0 0 0-7.543-10.38M15.88 1.483a2.783 2.783 0 0 0-3.849.116l-.372.372-.419-.419a2.742 2.742 0 0 0-3.875 0h0a2.74 2.74 0 0 0 0 3.875l4.2 4.2a.131.131 0 0 0 .185 0l4.2-4.2a2.739 2.739 0 0 0-.07-3.944Z"
  })));
};
var SvgPersonHeartOutlined$1 = SvgPersonHeartOutlined;

const SvgPersonHeart = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.717 36.162",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.981 4.736-1.814 1.815M14.359.75v2.647M27.967 14.359h-2.646M4.736 4.736l1.815 1.815M.75 14.359h2.647"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.359,
    cy: 13.88,
    r: 7.239
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.993 20.291a10.914 10.914 0 0 0-7.543 10.38v4.741h21.817v-4.741a10.912 10.912 0 0 0-7.543-10.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.58 24.463a2.782 2.782 0 0 0-3.849.116l-.372.372-.419-.419a2.74 2.74 0 0 0-3.875 0h0a2.74 2.74 0 0 0 0 3.875l4.2 4.2a.13.13 0 0 0 .186 0l4.2-4.2a2.739 2.739 0 0 0-.071-3.944Z"
  })));
};
var SvgPersonHeart$1 = SvgPersonHeart;

const SvgPersonKneesOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.603 35.244",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.126 3.759a5.148 5.148 0 1 0-2.53 6.853 5.139 5.139 0 0 0 2.53-6.853Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.582 11.208a5.059 5.059 0 0 0-1.369 3.42L11.3 20.7l-8.372 6.362c-3.609 3.183-2.239 7 .534 7.432h17.32a3.02 3.02 0 1 0 .08-6.04l-8.513.045s1.605-.507 3.959-1.032c2.336-.511 4.884-2.248 4.948-5l-.069-7.885a4.99 4.99 0 0 0-5-4.948h-.168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.246 26.824 2.236.5a4.5 4.5 0 0 0 3.618-.748l6.417-4.656a1.3 1.3 0 0 0 .544-1.057v-5.8"
  })));
};
var SvgPersonKneesOutlined$1 = SvgPersonKneesOutlined;

const SvgPersonLightbulbOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.171 34.657",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.824 21.788a12.84 12.84 0 0 1 8.6 12.119H.75a12.84 12.84 0 0 1 8.705-12.156M12.25 13.629s-2.083-4.595-2.432-5.422a7.98 7.98 0 0 1-.939-2.735A4.723 4.723 0 0 1 13.6.75h0a4.722 4.722 0 0 1 4.722 4.722 7.978 7.978 0 0 1-.938 2.735c-.35.827-2.433 5.422-2.433 5.422Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.642 5.873-2.04 4.547h0l-2.04-4.547M12.25 13.629h2.703v2.087H12.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.742 9.665a7.04 7.04 0 1 1-6.286-.014"
  })));
};
var SvgPersonLightbulbOutlined$1 = SvgPersonLightbulbOutlined;

const SvgPersonOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.146 32.762",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.573,
    cy: 8.596,
    r: 7.846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.926 15.544A11.829 11.829 0 0 0 .75 26.794v5.218H24.4v-5.218a11.83 11.83 0 0 0-8.175-11.25"
  })));
};
var SvgPersonOutlined$1 = SvgPersonOutlined;

const SvgPersonPathCheck = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 43.355 33.027",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.892 20.984a5.757 5.757 0 0 1 3.854 5.432H5.239a5.755 5.755 0 0 1 3.9-5.448"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.992,
    cy: 18.478,
    r: 3.049
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.992,
    cy: 22.034,
    r: 10.242
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.379,
    cy: 8.381,
    r: 7.226
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.992 11.087V6.146a5.4 5.4 0 0 1 5.4-5.4h2.8a5.4 5.4 0 0 1 5.4 5.4v19.37a4.365 4.365 0 0 0 4.365 4.365h2.064a4.364 4.364 0 0 0 4.364-4.365v-9.909M32.289 8.087l2.738 3.382 3.803-5.385"
  })));
};
var SvgPersonPathCheck$1 = SvgPersonPathCheck;

const SvgPersonRemoveOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.16 32.762",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.932,
    cy: 25.534,
    r: 6.479
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.573,
    cy: 8.596,
    r: 7.846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.809 19.411a11.853 11.853 0 0 0-5.588-3.867M8.926 15.544A11.829 11.829 0 0 0 .75 26.794v5.218H24.4M21.286 25.534h5.292"
  })));
};
var SvgPersonRemoveOutlined$1 = SvgPersonRemoveOutlined;

const SvgPersonSoundShowerOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.165 38.702",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.414,
    cy: 22.138,
    r: 5.299
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.951 26.831a7.987 7.987 0 0 0-5.522 7.6v3.524H20.4v-3.527a7.987 7.987 0 0 0-5.522-7.6M.75 15.449a11.664 11.664 0 0 1 23.328 0M12.414 3.785V.75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.51,
    cy: 25.253,
    r: 1.501
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.913,
    cy: 24.382,
    r: 1.501
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.012 25.253v-5.39l5.403-2.341v6.86"
  })));
};
var SvgPersonSoundShowerOutlined$1 = SvgPersonSoundShowerOutlined;

const SvgPhoneRingingOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.842 27.786",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.743 21.984-4.7-4.7a1.251 1.251 0 0 0-1.768 0l-2.408 2.408a1.135 1.135 0 0 1-1.445.131 28.588 28.588 0 0 1-7.438-7.429 1.136 1.136 0 0 1 .123-1.439l2.4-2.442a1.251 1.251 0 0 0 0-1.768l-4.7-4.7a1.249 1.249 0 0 0-1.767 0L1.571 4.508a2.71 2.71 0 0 0-.785 1.675c-.2 2.175.2 7.448 6.785 14.033S19.428 27.2 21.6 27a2.717 2.717 0 0 0 1.676-.784l2.464-2.465a1.249 1.249 0 0 0 .003-1.767ZM14.238 7.706a5.784 5.784 0 0 1 5.9 5.9M14.58 4.059a9.2 9.2 0 0 1 9.2 9.092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5.75a11.891 11.891 0 0 1 11.592 11.592"
  })));
};
var SvgPhoneRingingOutlined$1 = SvgPhoneRingingOutlined;

const SvgPlaneDownOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 41.047 23.754",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m39.949 20.373-1.008-1.263-1.3-1.622-2.008-2.513a1.6 1.6 0 0 0-.9-.567l-1.38-.308-2.481-.549-2.923-.647-8.71-11.327L15.28.75l1.272 9.635L9.823 8.9a.651.651 0 0 1-.452-.366L5.788 1.655 2.585.986l.4 6.766a15.2 15.2 0 0 0 .342 2.818h0a8.445 8.445 0 0 0 6.323 6.281l1.715.379 1.429.284 8.073 1.605 2.2.438 15.415 3.41a1.446 1.446 0 0 0 1.545-.7 1.637 1.637 0 0 0-.078-1.894ZM6.122 11.209.75 10.02"
  })));
};
var SvgPlaneDownOutlined$1 = SvgPlaneDownOutlined;

const SvgPlaneGroundOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 39.538 35.188",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.769,
    cy: 12.172,
    rx: 4.788,
    ry: 5.393
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.769.75v6.029M24.496 12.654l12.947-1.008-.939 1.931-13.445 2.512M26.406 17.861v-2.289M33.152 7.828 23.674 9.05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.021,
    y: 17.861,
    width: 2.771,
    height: 3.424,
    rx: 1.386
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.041 12.654 2.095 11.646l.939 1.931 13.444 2.512M13.131 17.861v-2.289M6.385 7.828l9.479 1.222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.746,
    y: 17.861,
    width: 2.771,
    height: 3.424,
    rx: 1.386,
    transform: "rotate(-180 13.132 19.573)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.277 10.244h2.984M38.788 34.438H.75l8.476-9.911h21.086l8.476 9.911zM19.769 26.855v1.572M19.769 30.517v1.572"
  })));
};
var SvgPlaneGroundOutlined$1 = SvgPlaneGroundOutlined;

const SvgPlaneLandingOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.114 9.348c-1.432 0-2.692 1.328-2.692 3.095 0 1.767 1.26 3.095 2.692 3.095 1.433 0 2.692-1.328 2.692-3.095 0-1.767-1.26-3.095-2.692-3.095Zm-3.692 3.095c0-2.204 1.599-4.095 3.692-4.095 2.094 0 3.692 1.89 3.692 4.095 0 2.204-1.598 4.095-3.692 4.095-2.093 0-3.692-1.89-3.692-4.095Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.114 4.328a.5.5 0 0 1 .5.5v4.02a.5.5 0 0 1-1 0v-4.02a.5.5 0 0 1 .5-.5ZM28.31 11.81a.5.5 0 0 1 .037.501l-.626 1.287a.5.5 0 0 1-.358.273L18.4 15.546a.5.5 0 0 1-.184-.983l8.715-1.629.135-.275-7.76.604a.5.5 0 0 1-.079-.997l8.631-.672a.5.5 0 0 1 .452.217Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.54 14.21a.5.5 0 0 1 .5.5v1.526a.5.5 0 1 1-1 0V14.71a.5.5 0 0 1 .5-.5ZM25.533 9.484a.5.5 0 0 1-.432.56l-6.32.813a.5.5 0 1 1-.127-.991l6.32-.814a.5.5 0 0 1 .559.432Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.54 16.736a.424.424 0 0 0-.424.424v.434a.424.424 0 1 0 .847 0v-.434a.423.423 0 0 0-.423-.424Zm-1.424.424a1.424 1.424 0 1 1 2.847 0v.434a1.424 1.424 0 1 1-2.847 0v-.434ZM3.918 11.81a.5.5 0 0 1 .452-.216l8.632.672a.5.5 0 1 1-.078.997l-7.761-.604.134.275 8.716 1.629a.5.5 0 1 1-.184.983L4.866 13.87a.5.5 0 0 1-.358-.273l-.626-1.287a.5.5 0 0 1 .036-.5Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.69 14.21a.5.5 0 0 1 .5.5v1.526a.5.5 0 1 1-1 0V14.71a.5.5 0 0 1 .5-.5ZM6.696 9.484a.5.5 0 0 1 .56-.432l6.319.814a.5.5 0 0 1-.128.992l-6.319-.814a.5.5 0 0 1-.432-.56Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.69 18.018c.233 0 .423-.19.423-.424v-.434a.424.424 0 1 0-.847 0v.434c0 .235.19.424.423.424Zm1.423-.424a1.424 1.424 0 1 1-2.847 0v-.434a1.424 1.424 0 1 1 2.847 0v.434ZM14.62 11.158a.5.5 0 0 1 .5-.5h1.989a.5.5 0 1 1 0 1h-1.99a.5.5 0 0 1-.5-.5ZM8.706 20.355a.5.5 0 0 1 .38-.175h14.057a.5.5 0 0 1 .38.175l5.65 6.608a.5.5 0 0 1-.38.825H3.436a.5.5 0 0 1-.38-.825l5.65-6.608Zm.61.825L4.52 26.788h23.188l-4.795-5.608H9.316Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.114 21.732a.5.5 0 0 1 .5.5v1.048a.5.5 0 1 1-1 0v-1.048a.5.5 0 0 1 .5-.5ZM16.114 24.174a.5.5 0 0 1 .5.5v1.047a.5.5 0 0 1-1 0v-1.047a.5.5 0 0 1 .5-.5Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgPlaneLandingOutlined$1 = SvgPlaneLandingOutlined;

const SvgPlaneLanding = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.171 14.021c-2.148 0-4.038 1.993-4.038 4.643 0 2.651 1.89 4.643 4.038 4.643 2.15 0 4.038-1.992 4.038-4.643 0-2.65-1.889-4.643-4.038-4.643Zm-5.538 4.643c0-3.306 2.398-6.143 5.538-6.143s5.538 2.837 5.538 6.143c0 3.307-2.398 6.143-5.538 6.143s-5.538-2.836-5.538-6.143Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.171 6.492a.75.75 0 0 1 .75.75v6.03a.75.75 0 1 1-1.5 0v-6.03a.75.75 0 0 1 .75-.75ZM42.465 17.716a.75.75 0 0 1 .055.75l-.94 1.931a.75.75 0 0 1-.536.41L27.6 23.319a.75.75 0 1 1-.275-1.475l13.072-2.442.201-.414-11.64.906a.75.75 0 0 1-.117-1.495l12.946-1.008a.75.75 0 0 1 .678.325Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.81 21.314a.75.75 0 0 1 .75.75v2.29a.75.75 0 1 1-1.5 0v-2.29a.75.75 0 0 1 .75-.75ZM38.3 14.226a.75.75 0 0 1-.649.84l-9.479 1.22a.75.75 0 1 1-.191-1.487l9.479-1.221a.75.75 0 0 1 .84.648Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.81 25.103a.636.636 0 0 0-.637.636v.652a.636.636 0 1 0 1.271 0v-.652a.635.635 0 0 0-.635-.636Zm-2.137.636a2.136 2.136 0 1 1 4.271 0v.652a2.136 2.136 0 1 1-4.27 0v-.652ZM5.878 17.716a.75.75 0 0 1 .678-.325l12.947 1.008a.75.75 0 0 1-.117 1.495l-11.642-.906.202.414 13.073 2.442a.75.75 0 1 1-.275 1.475L7.299 20.807a.75.75 0 0 1-.537-.41l-.94-1.93a.75.75 0 0 1 .056-.75Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.534 21.314a.75.75 0 0 1 .75.75v2.29a.75.75 0 1 1-1.5 0v-2.29a.75.75 0 0 1 .75-.75ZM10.044 14.226a.75.75 0 0 1 .84-.648l9.478 1.22a.75.75 0 1 1-.191 1.488l-9.478-1.22a.75.75 0 0 1-.649-.84Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.534 27.027c.35 0 .635-.284.635-.636v-.651a.635.635 0 1 0-1.27 0v.651c0 .352.284.636.635.636Zm2.135-.636a2.136 2.136 0 1 1-4.27 0v-.651a2.136 2.136 0 1 1 4.27 0v.651ZM21.93 16.736a.75.75 0 0 1 .75-.75h2.983a.75.75 0 1 1 0 1.5H22.68a.75.75 0 0 1-.75-.75ZM13.058 30.532a.75.75 0 0 1 .57-.263h21.086a.75.75 0 0 1 .57.263l8.476 9.912a.75.75 0 0 1-.57 1.237H5.152a.75.75 0 0 1-.57-1.237l8.476-9.912Zm.916 1.237L6.78 40.181h34.781L34.37 31.77H13.974Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.171 32.597a.75.75 0 0 1 .75.75v1.572a.75.75 0 0 1-1.5 0v-1.572a.75.75 0 0 1 .75-.75ZM24.171 36.26a.75.75 0 0 1 .75.75v1.571a.75.75 0 1 1-1.5 0v-1.57a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgPlaneLanding$1 = SvgPlaneLanding;

const SvgPlaneRightLeafOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 42.939 29.526",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.832 17.018h-2.146A8.4 8.4 0 0 1 3.6 10.894L.75.75h3.928l5.792 7.688H34.3a3.474 3.474 0 0 1 2.218.8l4.915 4.077a2.093 2.093 0 0 1-1.336 3.7H23.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.461 12.016-4.709 9.916h4.697l12.799-9.489M6.85 10.795H1.532M32.61 23.614S28.4 27.7 19.865 27.493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.184 24.8s1.028-4.113 4.751-3.652 5.6.319 6.772-1.418c0 0-1.631 11.275-8.935 8.651"
  })));
};
var SvgPlaneRightLeafOutlined$1 = SvgPlaneRightLeafOutlined;

const SvgPlaneRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 42.939 22.682",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.832 17.018h-2.146A8.4 8.4 0 0 1 3.6 10.894L.75.75h3.928l5.792 7.688H34.3a3.474 3.474 0 0 1 2.218.8l4.915 4.077a2.093 2.093 0 0 1-1.336 3.7H23.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.461 12.016-4.709 9.916h4.697l12.799-9.489M6.85 10.795H1.532"
  })));
};
var SvgPlaneRightOutlined$1 = SvgPlaneRightOutlined;

const SvgPlaneUpOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.102 33.059",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M30.352 22.668v-3.19l-12.389-7.835V3.162A2.412 2.412 0 0 0 15.551.75h0a2.412 2.412 0 0 0-2.412 2.412v8.481L.75 19.478v3.19l12.389-3.8v8.123L10.067 29.6v2.708l5.544-1.731 5.545 1.731V29.6l-3.193-2.615v-8.122Z",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }));
};
var SvgPlaneUpOutlined$1 = SvgPlaneUpOutlined;

const SvgPlaneUpRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 45.256 20.323",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.408 5.742 41.857 5.2l-1.993-.7-3.088-1.076a1.62 1.62 0 0 0-1.08 0l-1.358.484-2.438.867L29.037 5.8 15.412.75l-3.856 1.428 6.3 7.61-6.6 2.355a.663.663 0 0 1-.587-.07L3.87 8.088.75 9.243l4 5.61A15.4 15.4 0 0 0 6.571 17.1h0a8.588 8.588 0 0 0 8.841 1.991l1.681-.6 1.385-.528 7.82-2.982 2.133-.814 15.119-5.4a1.467 1.467 0 0 0 .955-1.434 1.664 1.664 0 0 0-1.097-1.591ZM9.322 16.135l-5.269 1.881"
  })));
};
var SvgPlaneUpRightOutlined$1 = SvgPlaneUpRightOutlined;

const SvgPlayCircleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.587 33.587",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.794,
    cy: 16.794,
    r: 16.044
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.408 10.132V23.1a.929.929 0 0 0 1.407.8l10.552-6.349a1.086 1.086 0 0 0 0-1.863L13.815 9.337a.928.928 0 0 0-1.407.795Z"
  })));
};
var SvgPlayCircleOutlined$1 = SvgPlayCircleOutlined;

const SvgPlaygroundOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.219 33.123",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 32.373V8.871L8.518.75l7.768 8.121v23.502M16.286 8.871H.75M16.286 22.171H.75M16.286 26.937H.75"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.518,
    cy: 15.521,
    r: 3.576
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.286 13.005h1.034a6.159 6.159 0 0 1 5.69 3.8l3.776 9.118a1.167 1.167 0 0 0 1.077.719H29.6a2.865 2.865 0 0 1 2.865 2.865h0a2.865 2.865 0 0 1-2.865 2.866h-3.56a3.193 3.193 0 0 1-2.95-1.973l-4.4-10.619a1.7 1.7 0 0 0-1.568-1.048h-.837"
  })));
};
var SvgPlaygroundOutlined$1 = SvgPlaygroundOutlined;

const SvgPlowTruckOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 47.609 36.64",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.418.75h8.773a3.145 3.145 0 0 1 3.146 3.15v0h0-15.064 0v0A3.145 3.145 0 0 1 19.418.75ZM21.294.75v3.145M26.315.75v3.145",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.413
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.672 24.211-16.867 2.066v3.751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.27 22.785a13.058 13.058 0 0 1-2.931 0l-15.7-1.773c-1.628-.184-3.192.468-3.473 1.447L.732 30.938a.727.727 0 0 0 .234.731l2.125 2.084a2.071 2.071 0 0 0 1.244.495l18.306 1.634a13.105 13.105 0 0 0 2.327 0l18.306-1.634a2.071 2.071 0 0 0 1.244-.495l2.125-2.084a.725.725 0 0 0 .234-.731l-2.434-8.479c-.281-.979-1.845-1.631-3.473-1.447Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.724 31.123 21.917 1.956a13.105 13.105 0 0 0 2.327 0l21.917-1.956M6.938 24.211l16.867 2.066v3.751"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.032 20.981v-4.413a1.658 1.658 0 0 1 1.447-1.607l11.336-1.732a6.029 6.029 0 0 1 1.979 0l11.389 1.733a1.658 1.658 0 0 1 1.447 1.607v4.412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.536 14.714v-5.9a5.065 5.065 0 0 0-5.2-4.919H16.273a5.065 5.065 0 0 0-5.2 4.919v5.9M29.267 18.111h2.602M15.829 18.111h2.602"
  })), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M23.805 16.308v3.686M21.277 16.308v3.686M26.32 16.308v3.686M11.073 15.023v-3.946h-1.041a2.758 2.758 0 0 0-2.758 2.758v1.309a2.758 2.758 0 0 0 2.758 2.756h0M36.589 15.023v-3.946h1.041a2.758 2.758 0 0 1 2.759 2.758v1.309A2.758 2.758 0 0 1 37.63 17.9h0"
  })));
};
var SvgPlowTruckOutlined$1 = SvgPlowTruckOutlined;

const SvgPrototypeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.677 28.739",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.556 27.989h22.388M22.528 27.989H10.972l1.016-6.199h9.525l1.015 6.199zM29.712.75h1.315a1.9 1.9 0 0 1 1.9 1.9v17.24a1.9 1.9 0 0 1-1.9 1.9H2.65a1.9 1.9 0 0 1-1.9-1.9V2.65a1.9 1.9 0 0 1 1.9-1.9h27.062Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.593 4.291h2.513v2.513H7.593zM15.63 15.839h2.513v2.513H15.63zM20.817 7.57 10.106 5.547a9.558 9.558 0 0 1 6.781 10.292M27.36 11.377l-3.685.4-1.831 3.282-1.027-7.489 6.543 3.807z"
  })));
};
var SvgPrototypeOutlined$1 = SvgPrototypeOutlined;

const SvgQatarAirwaysIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#qatar_airways_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#qatar_airways_icon_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#DDE2E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.507 50.83a63.992 63.992 0 0 1-.033 5.746c-18.836.746-36.698 1.881-36.698 3.158 0 1.254 17.462 2.377 36.082 3.12a69.824 69.824 0 0 1-1.265 6.328c-18.355.75-35.388 1.855-35.388 3.098 0 1.198 15.902 2.277 33.51 3.027a63.127 63.127 0 0 1-2.748 6.521c-15.121.728-27.619 1.699-27.619 2.759 0 .99 10.919 1.904 24.682 2.61a57.806 57.806 0 0 1-2.423 3.654 59.332 59.332 0 0 1-2.9 3.762c-8.605.654-14.51 1.397-14.51 2.192 0 .683 4.23 1.321 10.747 1.892-3.557 3.52-7.76 6.809-12.714 9.68 0 0-5.834-5.025-10.65-10.893-4.293-5.233-13.4-19.03-15.544-22.117-2.146-3.087-3.557-3.99-6.065-3.095-3.364 1.191-7.272 1.788-8.474 1.788s-1.863-.466.153-1.265c2.008-.81 9.948-4.558 13.857-12.303 4.39-8.724.53-20.77.53-20.77-1.475 6.44-4.827 8.843-4.827 8.843 1.082-5.98-.097-11.4-3.05-15.204l-1.646 7.57s-1.03-.052-3.58 2.09c-2.546 2.147-3.247 5.275-3.247 5.275 2.004.806 4.416-1.205 4.416-1.205-3.08 11.523-7.496 20.904-10.717 25.864-3.218 4.961-5.872 6.832-9.097 8.142-2.722 1.09-3.617-.19-3.617-.19-2.378-2.054-4.155-3.935-6.007-6.17 0 0-.149-.262.351-.255 1.325.019 3.685-2.247 4.2-3.188.59-1.078.526-1.903.231-1.96-.291-.048-.795.807-3.352 2.42-2.542 1.608-3.71.492-4.558-.404-.657-.712-.011-1.594.4-2.146.388-.493 13.837-25.574 49.426-51.924 46.639-34.533 76.423-43.857 78.129-44.53 1.127-.443 2.968-1.03 3.386-.6.463.485.69.873.627 1.437-.06.56-.358.847-2.516 1.8-17.903 7.887-38.803 21.034-50.677 28.686-14.603 7.115-28.545 17.276-29.053 17.518-1.124.698-.295 1.714.384 1.288 24.66-16.402 53.571-27.574 85.52-36.727 1.527-.433 2.363-.433 2.617-.097.287.373.41.798.455 1.269.041.586-.444.896-1.754 1.407C121.157 1.482 95.86 13.327 79.588 24.275c0 0-1.683 1.016-1.706 2.191-.007.448.904.5.904.5 8.145.146 19.033.624 24.215.926 0 0-.739 2.625-5.7 4.737-3.83 1.635-7.377 1.374-10.886 1.404-.78-.015-1.44.773-.817 1.612.314.419 7.78 12.438 34.909 15.186Z",
    fill: "#6C0C54"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "qatar_airways_icon_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "qatar_airways_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25836"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25836",
    result: "shape"
  }))));
};
var SvgQatarAirwaysIcon$1 = SvgQatarAirwaysIcon;

const SvgQuestionCircleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.079 33.079",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.539,
    cy: 16.539,
    r: 15.789
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.009 11.986a4.83 4.83 0 0 1 8.245-3.416 4.892 4.892 0 0 1 0 6.831c-1.649 1.769-3.814 3.329-3.814 6.157M16.44 25.923v-1.068"
  })));
};
var SvgQuestionCircleOutlined$1 = SvgQuestionCircleOutlined;

const SvgRainDropSnowflakeOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.998 27.132",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.44 8.949 18.169.75M22.142 26.382l-1.271-8.198M21.731 2.546l-2.819 3.001-3.595-2.007M18.579 24.586l2.819-3 3.595 2.006M32.248 18.254 24.55 15.27M28.911 20.441 27.722 16.5l3.535-2.111M30.261 5.438l-6.465 5.2M30.487 9.421l-4.008-.941-.06-4.116M18.352 17.093a8.8 8.8 0 0 1-17.6 0c0-7.229 8.8-15.48 8.8-15.48s8.8 8.251 8.8 15.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.655c.048-.06.1-.12.149-.178a4.672 4.672 0 1 1 1.663 7.384"
  })));
};
var SvgRainDropSnowflakeOutlined$1 = SvgRainDropSnowflakeOutlined;

const SvgRain = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.345 31.979c-1.158 0-2.314.124-3.444.367-3.614-8.363-12.046-13.942-21.17-13.942-11.384 0-20.851 8.016-22.737 19.147h-.08c-7.444 0-13.5 6.055-13.5 13.496 0 7.44 6.056 13.494 13.5 13.494h47.431c8.979 0 16.284-7.305 16.284-16.282s-7.305-16.28-16.284-16.28Zm13.01 16.28c0 7.18-5.835 13.02-13.01 13.02h-47.43c-5.64 0-10.227-4.59-10.227-10.232 0-5.644 4.588-10.234 10.227-10.234.376 0 .787.03 1.293.09l1.664.208.167-1.661a19.732 19.732 0 0 1 19.692-17.785c8.344 0 15.832 5.295 18.634 13.177l.53 1.488 1.51-.48a13.092 13.092 0 0 1 3.94-.608c7.175 0 13.01 5.84 13.01 13.017ZM23.143 73.52l4.138 7.477c.96 1.735 3.64.187 2.68-1.55l-4.139-7.48c-.96-1.734-3.64-.186-2.679 1.552ZM38.517 73.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM54.674 73.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.641-.186-2.68 1.552ZM70.29 73.52l4.139 7.477c.96 1.735 3.641.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.961-1.734-3.641-.186-2.68 1.552Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgRain$1 = SvgRain;

const SvgRainandthunder = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.036 22.266c-1.135 0-2.268.12-3.375.361C65.12 14.394 56.858 8.902 47.918 8.902c-11.155 0-20.432 7.891-22.279 18.85h-.079c-7.293 0-13.228 5.959-13.228 13.284 0 7.323 5.935 13.282 13.228 13.282h46.476c8.797 0 15.955-7.19 15.955-16.026 0-8.837-7.158-16.026-15.955-16.026Zm12.746 16.026c0 7.067-5.718 12.815-12.746 12.815H25.56c-5.524 0-10.02-4.517-10.02-10.071 0-5.555 4.496-10.075 10.02-10.075.369 0 .773.028 1.268.09l1.631.203.164-1.635c1.008-9.98 9.303-17.506 19.295-17.506 8.175 0 15.513 5.212 18.259 12.971l.519 1.465 1.48-.472c1.255-.4 2.552-.6 3.86-.6 7.028 0 12.746 5.748 12.746 12.815ZM20.785 63.156l4.053 7.363c.942 1.707 3.568.183 2.627-1.528L23.41 61.63c-.94-1.708-3.568-.184-2.625 1.526ZM33.785 77.156l4.053 7.362c.942 1.709 3.568.184 2.627-1.527L36.41 75.63c-.94-1.708-3.568-.183-2.625 1.526ZM71.982 63.156l4.055 7.363c.94 1.707 3.566.183 2.624-1.528-1.35-2.454-2.702-4.907-4.054-7.361-.94-1.708-3.567-.184-2.625 1.526ZM69.982 76.156c1.351 2.454 2.702 4.908 4.055 7.362.94 1.709 3.566.184 2.624-1.527-1.35-2.454-2.702-4.907-4.054-7.361-.94-1.708-3.567-.183-2.625 1.526ZM61.532 73.442h-4.897c-.649 0-1.251.32-1.611.858a1.917 1.917 0 0 0-.176 1.813l4.596 10.938-18.72-19.748h4.686a1.94 1.94 0 0 0 1.697-1c.34-.617.317-1.37-.063-1.963l-4.63-7.24H39.53l4.975 7.782h-4.93c-.776 0-1.474.456-1.78 1.163a1.922 1.922 0 0 0 .37 2.086L59.542 90.68c.382.404.888.613 1.401.613.365 0 .732-.105 1.062-.318a1.897 1.897 0 0 0 .734-2.36L57.38 75.86h4.934c.667 0 1.279-.335 1.636-.895.357-.561.4-1.254.117-1.85L56.507 57.1H53.82l7.713 16.34Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgRainandthunder$1 = SvgRainandthunder;

const SvgRainshowersDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.92 50.12c-.859 0-1.716.093-2.554.277-2.682-6.295-8.936-10.494-15.705-10.494-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S88.58 50.12 81.92 50.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H46.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.247 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM46.257 26.293a1.62 1.62 0 0 1-1.732 1.488 1.621 1.621 0 0 1-1.482-1.741l1.112-14.291a1.62 1.62 0 0 1 1.734-1.49c.884.07 1.551.855 1.482 1.742l-1.114 14.292ZM30.672 32.33c-.662.59-1.687.53-2.276-.136l-9.476-10.72a1.631 1.631 0 0 1 .135-2.286 1.612 1.612 0 0 1 2.276.134l9.476 10.72c.59.666.53 1.695-.135 2.288ZM16.816 68.47l10.447-9.765a1.614 1.614 0 0 1 2.28.083 1.63 1.63 0 0 1-.083 2.289l-10.447 9.765a1.613 1.613 0 0 1-2.28-.082 1.632 1.632 0 0 1 .083-2.29Zm52.402-47.005a1.614 1.614 0 0 0-2.28-.083L56.49 31.148a1.63 1.63 0 0 0-.081 2.29 1.61 1.61 0 0 0 2.278.082l10.448-9.766a1.63 1.63 0 0 0 .082-2.288ZM24.816 44.62a1.625 1.625 0 0 0-1.457-1.762L9.15 41.529a1.62 1.62 0 0 0-.3 3.226l14.211 1.327a1.62 1.62 0 0 0 1.756-1.463ZM43.84 34.306c-6.533-.59-12.325 4.27-12.911 10.834-.379 4.24 1.516 8.163 4.66 10.572-.798.825-1.4 1.667-1.846 2.437-3.953-3.026-6.333-7.953-5.856-13.284.737-8.247 8.016-14.355 16.226-13.615 4.13.372 7.72 2.409 10.175 5.39a20.607 20.607 0 0 0-2.329 1.986 11.84 11.84 0 0 0-8.119-4.32ZM54.517 82.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM38.517 82.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM70.674 82.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM86.674 82.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgRainshowersDay$1 = SvgRainshowersDay;

const SvgRainshowersNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.92 50.12c-.859 0-1.716.093-2.554.277-2.682-6.295-8.936-10.494-15.705-10.494-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S88.58 50.12 81.92 50.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H46.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.247 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM54.517 82.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM38.517 82.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM70.674 82.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM86.674 82.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM28.244 67.469a26.305 26.305 0 0 1-6.65-.55c-4.394-.935-7.942-3.448-11.008-6.727-.451-.484-.88-.988-1.37-1.541 10.482 1.131 19.227-2.117 25.507-10.79 6.242-8.62 6.925-18.113 2.979-28.043.056.011.124.01.178.037 6.087 3.125 10.618 7.72 12.84 14.362a15.98 15.98 0 0 1 2.28-.514c-.077-.236-.143-.471-.225-.708-2.983-8.501-9.289-13.726-17.362-16.886-.541-.21-1.056-.127-1.437.35-.38.472-.37.99-.057 1.505.09.148.178.297.264.446 2.785 4.775 4.157 9.934 3.464 15.476-1.185 9.473-5.983 16.432-14.447 20.512-5.238 2.525-10.751 2.622-16.317 1.204-.788-.201-1.34-.08-1.67.436-.332.521-.296 1.02.25 1.688 1.229 1.514 2.409 3.083 3.756 4.48 5.65 5.859 12.466 8.494 20.52 7.635.133-.024.268-.044.403-.067a11.48 11.48 0 0 1-1.898-2.305Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgRainshowersNight$1 = SvgRainshowersNight;

const SvgRainshowersandthunderDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.92 41.12c-.859 0-1.716.093-2.554.276-2.682-6.294-8.936-10.493-15.705-10.493-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S80.58 41.12 73.92 41.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H38.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.248 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM38.517 73.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM37.517 87.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM74.674 73.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM73.674 87.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948ZM37.26 18.643a1.453 1.453 0 0 1-1.554 1.336 1.454 1.454 0 0 1-1.33-1.563l.998-12.82a1.454 1.454 0 0 1 1.555-1.337 1.457 1.457 0 0 1 1.33 1.563l-1 12.821ZM23.278 24.06a1.448 1.448 0 0 1-2.043-.122l-8.501-9.616a1.463 1.463 0 0 1 .121-2.052 1.446 1.446 0 0 1 2.043.12l8.5 9.619a1.46 1.46 0 0 1-.12 2.051ZM10.845 56.484l9.373-8.76a1.448 1.448 0 0 1 2.046.074c.541.585.508 1.51-.075 2.053l-9.373 8.76a1.447 1.447 0 0 1-2.045-.072 1.464 1.464 0 0 1 .074-2.055Zm47.013-42.17a1.448 1.448 0 0 0-2.046-.075l-9.373 8.76a1.463 1.463 0 0 0-.072 2.055 1.445 1.445 0 0 0 2.043.073l9.373-8.76a1.462 1.462 0 0 0 .075-2.054Zm-39.835 20.77a1.457 1.457 0 0 0-1.307-1.58L3.969 32.313a1.454 1.454 0 0 0-.268 2.894l12.748 1.19a1.453 1.453 0 0 0 1.575-1.312Zm17.068-9.252c-5.862-.528-11.058 3.832-11.584 9.72-.34 3.805 1.36 7.324 4.182 9.485a11.245 11.245 0 0 0-1.658 2.187c-3.546-2.716-5.68-7.136-5.253-11.918.66-7.4 7.191-12.88 14.557-12.215 3.705.333 6.926 2.16 9.129 4.835a18.497 18.497 0 0 0-2.09 1.783 10.623 10.623 0 0 0-7.283-3.877Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgRainshowersandthunderDay$1 = SvgRainshowersandthunderDay;

const SvgRainshowersandthunderNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.023,
    stroke: props.color || `#1d1d1b`,
    d: "M.5.5h98.01v99H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.92 49.12c-.859 0-1.716.093-2.554.276-2.682-6.294-8.936-10.493-15.705-10.493-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S80.58 49.12 73.92 49.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H38.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.248 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM38.517 81.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM37.517 95.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM74.674 81.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM73.674 95.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM68.058 91.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997-13.365-14.439h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 80h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487a1.36 1.36 0 0 0 1.001.448c.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 80h-1.919l5.506 11.948ZM21.823 63.75a23.747 23.747 0 0 1-5.957-.488c-3.937-.831-7.115-3.065-9.861-5.98-.405-.43-.79-.879-1.229-1.37 9.391 1.006 17.225-1.882 22.85-9.592 5.593-7.662 6.204-16.1 2.67-24.926.05.01.11.008.159.032 5.453 2.778 9.512 6.863 11.503 12.767.64-.19 1.337-.357 2.042-.457-.07-.21-.128-.419-.202-.629-2.672-7.557-8.32-12.201-15.553-15.01-.485-.187-.946-.113-1.287.31-.341.42-.332.88-.052 1.34.081.13.16.263.237.395 2.495 4.245 3.724 8.83 3.103 13.756-1.061 8.421-5.36 14.607-12.942 18.233-4.692 2.245-9.631 2.33-14.617 1.07-.706-.178-1.2-.07-1.496.389-.298.462-.265.905.223 1.5 1.102 1.345 2.159 2.74 3.366 3.983 5.06 5.207 11.167 7.55 18.382 6.786.12-.022.24-.04.36-.06a10.228 10.228 0 0 1-1.699-2.049Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgRainshowersandthunderNight$1 = SvgRainshowersandthunderNight;

const SvgRecycleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.588 34.422",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.423 9.392 4.044-7.009a3.263 3.263 0 0 1 5.656 0l6.62 11.51M12.178 30.28H4.019a3.264 3.264 0 0 1-2.827-4.895l6.641-11.507M29.236 18.2l4.158 7.179a3.264 3.264 0 0 1-2.824 4.9H17.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.691 33.672-3.392-3.392 3.392-3.392M3.198 15.113l4.635-1.235 1.235 4.635M28.022 9.27l-1.268 4.627-4.626-1.269"
  })));
};
var SvgRecycleOutlined$1 = SvgRecycleOutlined;

const SvgRemoveOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.165 31.165",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.583,
    cy: 15.583,
    r: 14.833
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.525 15.583H21.64"
  })));
};
var SvgRemoveOutlined$1 = SvgRemoveOutlined;

const SvgReportOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 26.354 32.709",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6 8.832v22.189a.938.938 0 0 1-.939.938H1.688a.938.938 0 0 1-.938-.938V1.688A.938.938 0 0 1 1.688.75h15.834M11.102 4.27h3.204M4.533 27.76h6.696M14.81 27.76h6.696M4.533 24.923h6.696M14.81 24.923h6.696M4.533 22.086h6.696M14.81 22.086h6.696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.162 8.832H25.6L17.522.75v7.441a.64.64 0 0 0 .64.641Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.888,
    cy: 17.812,
    r: 1.202
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.102,
    cy: 13.005,
    r: 1.202
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.012,
    cy: 17.812,
    r: 1.202
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.107,
    cy: 13.005,
    r: 1.202
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.648 16.881 3.478-3.175M11.968 13.837l3.284 3.044M16.897 17.001l3.344-3.164"
  })));
};
var SvgReportOutlined$1 = SvgReportOutlined;

const SvgResponsiveOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.805 38.901",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09 38.151h20.464M21.604 38.151H11.041l.928-5.667h8.706l.929 5.667zM3.612 26.306v-21.6h13.419M3.612 9.535h13.636"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.248,
    y: 0.75,
    width: 11.869,
    height: 19.301,
    rx: 1.343
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.248 3.199h11.869M17.248 16.22h11.869M21.252 18.069h3.562M7.247 17.752v7.62a2.31 2.31 0 0 0 2.31 2.309h10.682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.941 26.104 1.577 1.577-1.577 1.577M24.156 27.681h.778a2.309 2.309 0 0 0 2.309-2.309V23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.666 24.294 1.577-1.578 1.577 1.578M6.036 7.229h.123M8.497 7.229h.124M10.959 7.229h.123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.117 13.252h1.2a1.736 1.736 0 0 1 1.737 1.737v15.758a1.737 1.737 0 0 1-1.737 1.737H2.487A1.737 1.737 0 0 1 .75 30.747V14.989a1.737 1.737 0 0 1 1.737-1.737h1.125"
  })));
};
var SvgResponsiveOutlined$1 = SvgResponsiveOutlined;

const SvgRocketOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 27.981 27.981",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.85 21.811C28.63 14.456 27.2.784 27.2.784S13.525-.65 6.169 15.13ZM18.946 2.232l6.803 6.803"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.725,
    cy: 10.256,
    r: 3.017
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.33 20.65-5.84 5.84M4.955 18.275 2.01 21.22M9.705 23.025 6.76 25.971M10.3 8.564l-4.266-.089a2.9 2.9 0 0 0-2.112.849L1.055 12.19a1.041 1.041 0 0 0 .476 1.744l4.638 1.2M19.416 17.679l.09 4.268a2.9 2.9 0 0 1-.849 2.112l-2.867 2.866a1.04 1.04 0 0 1-1.743-.476l-1.2-4.638"
  })));
};
var SvgRocketOutlined$1 = SvgRocketOutlined;

const SvgRollerSkatesOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.946 31.8",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.027 18.157-.256-1.283a3.761 3.761 0 0 0-3.557-3.023 16.558 16.558 0 0 1-2.129-.176c-1.581-.279-3.565-1.8-5.548-4A21.257 21.257 0 0 1 11.732.75S5.161 3.044 3.178 2.858c0 0-.031 3.812-.992 5.548S.791 14.3.791 14.884c0 0 6.292.279 10.941 2.666 4.434 2.275 7.712 2.1 15.371 1.782a.983.983 0 0 0 .924-1.175ZM27.926 18.82l-2.635 3.478"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.502,
    cy: 26.525,
    r: 4.525
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.671,
    cy: 26.525,
    r: 4.525
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.962 23.608.994-.948a3.351 3.351 0 0 1 2.312-.926h4.462a3.349 3.349 0 0 1 2.368.981l1.017 1.016M10.028 5.764l3.006-1.443M11.568 8.654l3.006-1.442M13.071 11.544l3.006-1.442M.791 14.884a9.833 9.833 0 0 0 2.685 7.594"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.502,
    cy: 26.525,
    r: 1.53
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.671,
    cy: 26.525,
    r: 1.53
  })));
};
var SvgRollerSkatesOutlined$1 = SvgRollerSkatesOutlined;

const SvgRunway = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.751 7.808a.75.75 0 0 1 .725-.558h21.086a.75.75 0 0 1 .725.558l8.476 32a.75.75 0 0 1-.725.942H5a.75.75 0 0 1-.725-.942l8.476-32Zm1.302.942-8.078 30.5h36.088l-8.078-30.5H14.053Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11.25a.75.75 0 0 1 .75.75v.98a.75.75 0 0 1-1.5 0V12a.75.75 0 0 1 .75-.75Zm0 4.896a.75.75 0 0 1 .75.75v1.958a.75.75 0 0 1-1.5 0v-1.958a.75.75 0 0 1 .75-.75Zm0 5.875a.75.75 0 0 1 .75.75v1.958a.75.75 0 0 1-1.5 0v-1.958a.75.75 0 0 1 .75-.75Zm0 5.875a.75.75 0 0 1 .75.75v1.958a.75.75 0 0 1-1.5 0v-1.958a.75.75 0 0 1 .75-.75Zm0 5.875a.75.75 0 0 1 .75.75v.979a.75.75 0 0 1-1.5 0v-.98a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgRunway$1 = SvgRunway;

const SvgRyanairIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ryanair_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#004578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.527 22.525c4.146 1.385 8.533 2.446 13.006 2.955l3.12.03.096-.087c1.865.051 3.244-.768 5.058-1.167.195-.046.664-.164.863.102.09.347-.051.723-.444.98-2.221 1.7-4.87 2.965-7.368 3.875v-.05c-.82.157-1.696.51-2.547.789-3.076.932-6.578 1.516-9.887 1.278-6.338-.325-11.725-2.59-17.321-2.322-5.495-.321-10.721 1.778-13.646 5.923-1.5 2.168-2.694 4.455-3.066 6.97.165 2.277 3.361 3.151 4.56 5.034.687 1.139 1.027 2.393 1.545 3.575 1.328 2.381 2.643 4.76 4.274 7.002l-.04.046c.955 1.498 2.477 2.797 4.278 3.677 2.334 1.668 4.394 3.76 5.619 6.007l-.064.036c1.379 2.198 2.153 4.477 3.22 6.769.48 1.406 1.007 2.643 1.416 4.012.14.128.14.335.223.514.377 1.084.7 2.238 1.16 3.242-.199.152.155.21.112.357.026.608.619 1.52-.173 1.928-1.152-1.018-1.757-2.511-2.38-3.597-1.36-2.373-2.919-4.667-4.597-6.925l.051-.046c-1.03-1.294-2.168-2.751-3.346-4.09-4.965-5.498-12.263-8.799-17.597-14.032l-.05.046c-.455-.408-.747-.948-1.115-1.413l.035-.05c-.65-.91-1.036-1.948-1.664-2.88l.036-.046c-1.65-2.458-3.238-5.067-4.306-7.654-.222-1.144-.614-2.129-.701-3.446l-.125-.432c.07-1.2-2.907-1.894-1.27-4.195 1.028-1.109 5.007-2.476 6.36-4.558.03-.31.103-.681-.166-.963 0-.222-.23-.456-.391-.687-.753-.936-2.794-.197-2.76-1.578.209-.01.01-.193.148-.272-.114-.681-.162-1.132.03-1.708.412-1.132.814-2.436.733-3.578.083-.43.512-.686.945-.853.848-.213 1.588-.327 2.42-.438l.104.085c1.92-.157 4.227-.02 5.5 1.49.552 1.143.121 2.5-.188 3.653-.097.664-.824 1.205-.654 1.905.252.257.782.242 1.119.098 2.899-1.757 5.43-4.195 7.541-6.657 1.946-1.822 4.812-2.452 7.448-2.074 5.339.412 9.852 2.202 14.829 3.417l.017.003Z",
    fill: "#FDD244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.766 32.16c.752 1-.255 1.883-.554 2.763C47.078 39.63 45.985 44.958 43.906 50c-.156.173-.465.226-.688.157-.554-.395-.554-1.048-.49-1.619.417-5.464 1.86-10.59 4.187-15.475.544-.782 1.471-1.668 2.667-1.483.451.094.855.252 1.184.58Zm8.257 1.427c.4 1.796-.888 3.27-1.459 4.877-3.049 6.086-6.709 12.042-8.517 18.548-.084.206-.205.486-.447.577-.258.07-.474-.058-.541-.24-.61-2.586.092-5.277.756-7.735 1.737-5.462 3.839-11.05 6.777-16.13.341-.26.394-.48.82-.6 1.022-.106 2.046-.03 2.611.703Zm8.819.306c.821.619.397 1.788.075 2.513-3.573 7.912-9.36 14.735-11.755 23.033-.661 1.758-1.09 3.577-1.64 5.349-.097.32-.564.329-.897.25-.317-.752-.224-1.707-.224-2.52.754-6.668 2.348-13.146 5.606-18.95 1.48-2.9 2.913-5.508 4.467-8.338.439-.8 1.174-1.524 2.241-1.786a4.093 4.093 0 0 1 2.127.449Zm9.787.408c.573.959.02 2.015-.24 2.932-2.273 6.359-6.523 11.62-9.937 17.414-2.923 4.758-4.835 10.043-6.782 15.21-.673 1.551-.916 3.275-1.733 4.75-.067.159-.276.064-.419.104-.502-.423-.437-1.028-.556-1.564.386-6.468 2.88-12.312 5.222-18.15 2.93-6.509 6.86-12.725 9.53-19.455.373-.849 1.108-1.889 2.242-2.208 1.137-.171 1.997.239 2.673.967Z",
    fill: "#FDD244"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ryanair_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25839"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25839",
    result: "shape"
  }))));
};
var SvgRyanairIcon$1 = SvgRyanairIcon;

const SvgSasIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#sas_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#097CBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.176 38.521h-7.91c-.405 0-.608.197-.608.197l-21.799 26.27c-.102.197-.102.294.102.294h3.244c.304 0 .406-.098.406-.197l4.665-5.784s.101-.097.202-.097h7.807s.102 0 .102.098-1.115 5.686-1.115 5.686c0 .098 0 .294.304.294h9.43c.102 0 .203 0 .203-.197l5.272-26.271c-.102 0 0-.295-.305-.295v.002ZM52.791 56.558h-6.185v-.098l8.111-10.095.102-.098c.101 0 0 .098 0 .098L52.791 56.56c.102-.098.102-.098 0 0v-.002ZM14.769 61.95s.711-2.352.811-2.255c0-.391.203-.49.406-.294.913.882 3.752 3.53 7.706 3.53 4.359 0 4.055-3.431 4.055-3.921 0-1.372-1.826-8.137-2.332-9.901-1.419-5.686 2.13-10.882 10.545-10.882 4.461 0 6.692 1.177 7.503 1.568.507.295.405.687.405.687s-.506 2.059-.506 2.255c-.102.197-.304.197-.506 0-1.319-.784-2.84-1.666-5.172-1.666-2.737 0-4.157 1.96-3.446 4.803.304.981 2.027 7.745 2.331 9.117 1.217 4.902-2.231 10.783-11.557 10.783-5.172 0-8.416-1.862-9.531-2.744-.61-.492-.812-.786-.712-1.08Zm49.581.098s.507-2.548.507-2.353c.102-.294.405-.391.608-.196 1.015.882 3.65 3.431 7.605 3.431 4.359 0 4.057-3.431 4.057-3.921 0-1.372-1.826-8.137-2.333-9.901-1.419-5.686 2.131-10.882 10.545-10.882 4.461 0 6.692 1.177 7.503 1.568.507.295.406.687.406.687s-.507 2.059-.507 2.255c-.101.197-.304.197-.506 0-1.319-.784-2.84-1.666-5.172-1.666-2.737 0-4.156 1.96-3.446 4.803.304.981 2.027 7.745 2.332 9.117 1.216 4.902-2.231 10.783-11.56 10.783-5.171 0-8.212-1.765-9.327-2.646-.61-.491-.813-.785-.712-1.079Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "sas_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25831"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25831",
    result: "shape"
  }))));
};
var SvgSasIcon$1 = SvgSasIcon;

const SvgScissorCombOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.223 28.308",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.765,
    cy: 3.757,
    r: 3.007
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75.75a3.007 3.007 0 0 1 3.007 3.007"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.959,
    cy: 3.757,
    r: 3.007
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.357 27.558 9.762 11.134h3.19l-1.595 16.424zM12.952 11.134l3.27-4.369M6.492 6.752l3.27 4.382"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.406,
    cy: 23.412,
    r: 1.452
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.473.829h-5.255a2.879 2.879 0 0 0-2.878 2.879v19.7a4.067 4.067 0 1 0 7.269-2.506c-1.066-1.353-2.238-2.1-2.238-6.665h3.1M28.44 3.677h3.033M28.44 6.281h3.033M28.44 8.886h3.033M28.44 11.49h3.033"
  })));
};
var SvgScissorCombOutlined$1 = SvgScissorCombOutlined;

const SvgScooterOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.435 22.072",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.76,
    cy: 18.397,
    r: 2.925
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.694,
    cy: 18.397,
    r: 2.925
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 14.031A5.265 5.265 0 0 1 8.959 18.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.694 18.397h16.028l3.977-7.354M26.76 18.397 19.413.75M19.413.75h-2.811"
  })));
};
var SvgScooterOutlined$1 = SvgScooterOutlined;

const SvgScreenLuggageOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.502 31.207",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 33.002,
    height: 25.612,
    rx: 2.175
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.115 30.457h-7.727a1.219 1.219 0 0 1-1.132-1.67l.967-2.425h8.057l.966 2.425a1.218 1.218 0 0 1-1.131 1.67ZM10.043 10.073H24.46a1.9 1.9 0 0 1 1.9 1.9v8.885h0H8.141h0v-8.884a1.9 1.9 0 0 1 1.902-1.901Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.994 10.073v-.709a3.742 3.742 0 0 0-3.743-3.742h0a3.742 3.742 0 0 0-3.742 3.742v.709"
  })));
};
var SvgScreenLuggageOutlined$1 = SvgScreenLuggageOutlined;

const SvgScreenOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.677 28.739",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.556 27.989h22.388M22.528 27.989H10.972l1.016-6.199h9.525l1.015 6.199zM29.712.75h1.315a1.9 1.9 0 0 1 1.9 1.9v17.24a1.9 1.9 0 0 1-1.9 1.9H2.65a1.9 1.9 0 0 1-1.9-1.9V2.65a1.9 1.9 0 0 1 1.9-1.9h27.062Z"
  })));
};
var SvgScreenOutlined$1 = SvgScreenOutlined;

const SvgServerHouseRoofOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.414 31.348",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.834 13.552H26.58v4.832H4.834zM4.834 20.902H26.58v4.832H4.834zM15.707 25.734v2.365M12.485 30.598h-8.04M16.172 30.598h-.93M27.618 30.598h-8.689M7.547 23.318h-.172M10.388 23.318h-.173M13.228 23.318h-.172M7.547 15.968h-.172M10.388 15.968h-.173M13.228 15.968h-.172M15.369 4.517l-12.142 7.1a1.645 1.645 0 0 1-2.251-.59h0a1.646 1.646 0 0 1 .589-2.252L14.929.961a1.541 1.541 0 0 1 1.556 0l13.364 7.818a1.646 1.646 0 0 1 .59 2.252h0a1.646 1.646 0 0 1-2.252.59l-12.142-7.1a.67.67 0 0 0-.676-.004Z"
  })));
};
var SvgServerHouseRoofOutlined$1 = SvgServerHouseRoofOutlined;

const SvgServerOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.673 25.895",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.139.75h21.746v4.832H1.139zM1.139 8.1h21.746v4.832H1.139zM1.139 15.45h21.746v4.832H1.139zM12.012 20.281v2.366M8.79 25.145H.75M12.477 25.145h-.93M23.923 25.145h-8.689M3.852 17.866H3.68M6.693 17.866H6.52M9.533 17.866h-.172M3.852 10.516H3.68M6.693 10.516H6.52M9.533 10.516h-.172M3.852 3.166H3.68M6.693 3.166H6.52M9.533 3.166h-.172"
  })));
};
var SvgServerOutlined$1 = SvgServerOutlined;

const SvgSettings = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.427 8.75a.75.75 0 0 0-.671.415l-1.89 3.78a2.25 2.25 0 0 1-.855.923l-1.706 1.023a2.25 2.25 0 0 1-1.36.312l-4.094-.373a.75.75 0 0 0-.704.35L9.69 17.509a.75.75 0 0 0 .044.858l2.54 3.266c.308.395.475.881.475 1.382v1.512c0 .462-.142.912-.407 1.29l-2.66 3.8a.75.75 0 0 0-.021.827l1.48 2.368a.75.75 0 0 0 .71.349l3.641-.364a2.25 2.25 0 0 1 1.23.226l2.102 1.051a2.25 2.25 0 0 1 1.083 1.177l1.41 3.528a.75.75 0 0 0 .697.471h3.058a.75.75 0 0 0 .67-.415l1.89-3.78a2.25 2.25 0 0 1 .855-.923l1.706-1.023a2.25 2.25 0 0 1 1.361-.312l4.053.369a.75.75 0 0 0 .719-.375l1.086-1.9a.75.75 0 0 0-.008-.758l-2.335-3.89a2.25 2.25 0 0 1-.32-1.159v-2.168c0-.408.11-.808.32-1.158l2.335-3.89a.75.75 0 0 0 .008-.759l-1.086-1.9a.75.75 0 0 0-.72-.375l-4.052.369a2.25 2.25 0 0 1-1.361-.312l-1.706-1.023a2.25 2.25 0 0 1-.854-.923l-1.89-3.78a.75.75 0 0 0-.671-.415h-2.646Zm-2.013-.256a2.25 2.25 0 0 1 2.013-1.244h2.646a2.25 2.25 0 0 1 2.012 1.244l1.89 3.78a.75.75 0 0 0 .285.308l1.706 1.023a.749.749 0 0 0 .453.104l4.053-.369a2.25 2.25 0 0 1 2.157 1.125l1.086 1.9a2.25 2.25 0 0 1-.024 2.274l-2.334 3.89a.75.75 0 0 0-.107.387v2.168c0 .137.037.27.107.386l2.334 3.89a2.25 2.25 0 0 1 .024 2.275l-1.086 1.9a2.25 2.25 0 0 1-2.157 1.125l-4.053-.369a.749.749 0 0 0-.453.104l-1.706 1.023a.75.75 0 0 0-.285.308l-1.89 3.78a2.25 2.25 0 0 1-2.012 1.244h-3.058a2.25 2.25 0 0 1-2.089-1.414l-1.41-3.528a.75.75 0 0 0-.362-.392l-2.102-1.051a.75.75 0 0 0-.41-.076l-3.64.364a2.25 2.25 0 0 1-2.132-1.046L8.39 31.24a2.25 2.25 0 0 1 .065-2.482l2.66-3.8a.75.75 0 0 0 .135-.43v-1.512a.75.75 0 0 0-.158-.46l-2.54-3.267a2.25 2.25 0 0 1-.133-2.574l1.456-2.33a2.25 2.25 0 0 1 2.111-1.047l4.094.372a.749.749 0 0 0 .454-.104l1.705-1.023a.75.75 0 0 0 .285-.308l1.89-3.78Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 19.75a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5ZM18.25 24a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgSettings$1 = SvgSettings;

const SvgShareNodesOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.047 33.609",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.05,
    cy: 4.997,
    r: 4.247
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.05,
    cy: 28.612,
    r: 4.247
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.997,
    cy: 16.805,
    r: 4.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.742 14.8 14.563-7.798M23.305 26.607 8.742 18.81"
  })));
};
var SvgShareNodesOutlined$1 = SvgShareNodesOutlined;

const SvgShoeHeelsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.084 24.823",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.744 24.823h-6.408a4.028 4.028 0 0 1-3.65-2.337 27.044 27.044 0 0 0-6.628-9.042 9.676 9.676 0 0 0-.958 4.227v6.4a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-6.785a12.592 12.592 0 0 0-1-5.019A10.86 10.86 0 0 1 .089 5.6C.43 2.4 3.455.229 3.583.138a.75.75 0 0 1 .926.046 58.927 58.927 0 0 1 12.107 14.1c.273.439.468.759.606.938a4.439 4.439 0 0 0 3.484 2.078 5.55 5.55 0 0 0 3.041-1.029.758.758 0 0 1 .639-.135 10.786 10.786 0 0 1 4.772 2.653c1.473 1.617 2.075 2.834 1.895 3.829a1.93 1.93 0 0 1-1.1 1.392c-1.593.813-4.261.813-6.209.813ZM1.573 8.4c7.69 2.947 11.736 9.667 13.476 13.455a2.523 2.523 0 0 0 2.287 1.464h6.408c1.8 0 4.253 0 5.519-.65.282-.144.3-.271.314-.324.04-.22-.03-.908-1.528-2.553a8.937 8.937 0 0 0-3.71-2.117 7.02 7.02 0 0 1-3.633 1.125 5.876 5.876 0 0 1-4.672-2.664c-.157-.2-.383-.563-.692-1.061A57.167 57.167 0 0 0 4 1.731a6.841 6.841 0 0 0-2.42 4.025A11.757 11.757 0 0 0 1.573 8.4Zm2.172 14.923H4.6v-5.652a11.148 11.148 0 0 1 1.267-5.189A20.065 20.065 0 0 0 1.981 10.2a10.711 10.711 0 0 0 .6 1.387 14.219 14.219 0 0 1 1.163 5.7Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgShoeHeelsOutlined$1 = SvgShoeHeelsOutlined;

const SvgShoeSneakerOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 38.526 16.131",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.413 11.982h0a5.171 5.171 0 0 0-2.732-3.2L17.829.75s-3.284 3.514-7.489 3.514S4.811 1.5 4.811 1.5l-.752-.165A2.724 2.724 0 0 0 .75 3.994v7.988Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.681 15.381H.75v-3.4h36.663l.211.526a2.094 2.094 0 0 1-1.943 2.874ZM22.268 2.859l-1.18 2.451M24.761 4.059l-1.18 2.451M27.254 5.259l-1.18 2.451"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.809,
    cy: 7.47,
    r: 1.632
  })));
};
var SvgShoeSneakerOutlined$1 = SvgShoeSneakerOutlined;

const SvgShowerOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 26.016 28.595",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.107 15.743A8.221 8.221 0 1 1 23.3 9.451M6.978 16.211l17.449-7.228M25.148 16.107a1.555 1.555 0 0 1-2.873 1.19c-.328-.793.147-3.709.147-3.709s2.397 1.726 2.726 2.519ZM14.378 20.568a1.555 1.555 0 0 1-2.873 1.19c-.328-.793.147-3.709.147-3.709s2.397 1.726 2.726 2.519ZM21.061 21.472a1.554 1.554 0 1 1-2.872 1.19c-.329-.793.146-3.709.146-3.709s2.398 1.726 2.726 2.519Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 27.845V6.775A6.026 6.026 0 0 1 6.775.75h0a5.929 5.929 0 0 1 4.261 1.765 9.024 9.024 0 0 1 1.513 2.345"
  })));
};
var SvgShowerOutlined$1 = SvgShowerOutlined;

const SvgSidebarArrowRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 29.273 22.197",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 27.773,
    height: 20.697,
    rx: 2.938
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.019.75v20.697M14.495 11.099l-2.763-2.763M5.871 11.099h8.624l-2.763 2.763"
  })));
};
var SvgSidebarArrowRightOutlined$1 = SvgSidebarArrowRightOutlined;

const SvgSignCloseOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.079 33.079",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.545 1.2 1.2 9.545a1.55 1.55 0 0 0-.454 1.1v11.8a1.55 1.55 0 0 0 .454 1.1l8.341 8.341a1.55 1.55 0 0 0 1.1.454h11.8a1.55 1.55 0 0 0 1.1-.454l8.341-8.341a1.55 1.55 0 0 0 .454-1.1v-11.8a1.55 1.55 0 0 0-.454-1.1L23.534 1.2a1.55 1.55 0 0 0-1.1-.454h-11.8a1.55 1.55 0 0 0-1.089.454ZM23.521 9.558 9.558 23.521M23.521 23.521 9.558 9.558"
  })));
};
var SvgSignCloseOutlined$1 = SvgSignCloseOutlined;

const SvgSjNordIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#sj_nord_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.548 75.825c-2.765-.239-4.866-.795-6.96-1.84-3.098-1.549-5.346-3.754-7.158-7.021-1.147-2.07-1.505-2.498-2.376-2.846-.304-.12-.4-.126-2.756-.159-2.662-.036-2.67-.037-3.367-.392-1.281-.651-2.687-2.201-3.92-4.323-.348-.598-.42-.854-.257-.917.153-.058 8.538-.037 9.368.024 2.45.18 4.216.744 5.65 1.804 1.134.836 1.889 1.842 3.05 4.059.791 1.514 1.313 2.21 2.23 2.982 1.62 1.36 3.756 2.318 6.13 2.749.872.158 2.856.145 3.761-.024 2.66-.498 5.007-1.672 6.601-3.303.644-.658.953-1.122 1.788-2.682.974-1.823 1.613-2.715 2.452-3.428 1.521-1.294 3.4-1.957 6.107-2.157 1.164-.085 9.303-.077 9.39.01.116.116.075.25-.25.814-1.251 2.17-2.715 3.778-4.02 4.42-.685.337-.933.364-3.307.365-2.232.001-2.492.024-3.002.263-.647.303-1.106.89-2.121 2.713-1.007 1.808-1.851 2.943-3.067 4.126-.87.848-1.382 1.263-2.36 1.916-2.164 1.445-4.784 2.386-7.645 2.745-.644.081-3.387.152-3.961.102Zm-5.509-12.089c-.412-.218-.873-.933-1.206-1.87-1.08-3.038-4.15-5.422-7.962-6.18-1.366-.27-1.332-.27-7.912-.305l-6.23-.034-.336-.127c-.823-.31-1.872-1.146-2.681-2.136-.773-.947-1.787-2.63-1.708-2.836.035-.09.665-.094 10.042-.078 9.918.017 10.01.018 10.734.137 3.835.631 6.535 2.395 7.913 5.168.646 1.299.864 2.366.91 4.447.047 2.12-.088 3.117-.49 3.603a.85.85 0 0 1-1.074.211Zm13.17.034c-.616-.273-.814-1.092-.813-3.344 0-1.436.05-2.136.201-2.89.355-1.758 1.331-3.454 2.659-4.617 1.558-1.366 3.465-2.2 5.974-2.611.727-.12.81-.121 10.73-.138 9.483-.017 9.999-.012 10.035.081.05.132-.272.757-.829 1.61-1.163 1.78-2.28 2.84-3.517 3.339l-.365.147-6.23.034c-6.683.036-6.589.032-8.08.338-.74.152-2.054.587-2.736.907-2.411 1.13-4.27 3.039-5.038 5.175-.234.651-.568 1.297-.827 1.6-.337.394-.787.537-1.165.369Zm-3.864-13.95c-.506-.064-.542-.082-.542-.269 0-.134.041-.179.265-.287.747-.363 1.704-1.113 2.315-1.815a6.585 6.585 0 0 0 1.476-2.846c.118-.476.12-.553.138-8.351l.018-7.871h5.048v7.775c0 5.16-.02 7.956-.06 8.314a6.803 6.803 0 0 1-.582 2.13c-.826 1.742-2.224 2.718-4.464 3.115-.725.129-2.915.192-3.612.104Zm-8.343-1.552c-1.642-.084-3.22-.4-4.364-.873l-.406-.168v-1.622c0-.893.013-1.623.028-1.623.016 0 .325.09.688.2 1.368.417 2.954.745 4.054.838.536.045 1.728-.056 2.262-.193.89-.228 1.416-.63 1.585-1.211.194-.667.022-1.263-.523-1.807-.612-.612-1.537-1.1-3.549-1.87-1.768-.677-2.483-1.054-3.384-1.783-.777-.628-1.464-1.695-1.724-2.676-.181-.684-.214-2.013-.068-2.722.527-2.542 2.548-4.1 5.97-4.603 2.327-.342 4.763-.112 6.656.627l.576.224v1.652c0 .908-.009 1.651-.019 1.651s-.247-.1-.527-.22c-.784-.34-1.975-.72-2.758-.881-.636-.13-.798-.142-1.579-.117-1.357.042-2.136.314-2.724.95-.7.756-.626 1.716.192 2.467.634.584 1.42.964 3.34 1.616 1.854.63 3.07 1.31 4.02 2.246 1 .988 1.458 2.041 1.458 3.361 0 3.746-2.337 6.004-6.679 6.456-.618.064-1.996.108-2.525.081Z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "sj_nord_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4455_2508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4455_2508",
    result: "shape"
  }))));
};
var SvgSjNordIcon$1 = SvgSjNordIcon;

const SvgSkyssIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#skyss_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#skyss_icon_svg__b)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.726 54.696c.018-1.901-1.256-2.848-4.256-3.343-1.323-.221-2.087-.35-2.366-.414-.897-.207-1.295-.568-1.295-1.054.01-.37.143-.568.605-.77.464-.188 1.249-.283 2.366-.281 1.085 0 2.166.064 3.464.217l.222.026.304-2.028-.238-.03a39.543 39.543 0 0 0-4.3-.262c-3.37.006-5.229.978-5.232 3.084-.01 1.308.733 2.315 2.03 2.768.5.186 1.513.398 2.926.66.992.176 1.367.261 1.71.382.882.329 1.173.683 1.173 1.112-.007.397-.211.679-.742.923-.533.236-1.375.37-2.488.367-1.111 0-2.22-.063-3.883-.239l-.217-.021-.035.212-.333 1.882.255.023c1.643.155 3.082.242 4.317.242 3.839-.004 6.007-1.124 6.013-3.456ZM38.783 58.023l-6.503-6.245 6.374-4.928h-3.702l-5.134 3.913h-.574V42H26.46v16.023h2.784v-5.25l.503.002 5.39 5.248h3.646ZM51.958 57.63V46.851h-2.902V55.9c-.754.103-1.62.18-2.217.18-3.363 0-3.715-1.01-3.715-2.847V46.85H40.23v6.413c0 3.977 2.36 4.924 6.284 4.924.751 0 1.882-.127 2.53-.29-.01.652-.018 1.4-.491 1.875-.438.44-1.384.513-2.86.513-1.335 0-2.915-.166-4.242-.374l-.346 2.074c1.793.307 3.266.445 4.722.445 4.997 0 6.132-1.442 6.132-4.8ZM64.58 54.696c.018-1.901-1.256-2.848-4.256-3.343-1.322-.221-2.086-.35-2.364-.414-.899-.207-1.297-.568-1.297-1.054.011-.37.142-.568.605-.77.464-.188 1.25-.283 2.368-.281 1.085 0 2.165.064 3.462.217l.222.026.305-2.028-.239-.03a39.554 39.554 0 0 0-4.299-.262c-3.372.006-5.23.978-5.233 3.084-.01 1.308.734 2.315 2.03 2.768.502.186 1.513.398 2.926.66.992.176 1.367.261 1.71.382.881.329 1.173.683 1.173 1.112-.005.397-.21.679-.743.923-.532.236-1.373.37-2.487.367-1.11 0-2.22-.063-3.884-.239l-.215-.021-.035.212-.334 1.882.254.023c1.644.155 3.083.242 4.318.242 3.84-.004 6.008-1.124 6.014-3.456ZM76.597 54.696c.017-1.901-1.256-2.848-4.256-3.343-1.322-.221-2.087-.35-2.365-.414-.899-.207-1.296-.568-1.296-1.054.011-.37.142-.568.605-.77.463-.188 1.248-.283 2.367-.281 1.085 0 2.164.064 3.463.217l.22.026.306-2.028-.239-.03a39.544 39.544 0 0 0-4.299-.262c-3.372.006-5.228.978-5.232 3.084-.01 1.308.734 2.315 2.03 2.768.5.186 1.512.398 2.925.66.993.176 1.368.261 1.71.382.883.329 1.174.683 1.174 1.112-.006.397-.211.679-.743.923-.53.236-1.374.37-2.488.367-1.111 0-2.22-.063-3.882-.239l-.216-.021-.035.212-.334 1.882.254.023c1.644.155 3.082.242 4.318.242 3.84-.004 6.008-1.124 6.013-3.456ZM93.806 47.218l-.008-.369h-11.75l-.008.37c-.002.038-.072 3.972.605 6.822.123.517.265.978.424 1.37.363.901.857 1.758 1.465 2.546 1.014 1.317 2.15 2.22 3.065 2.947l.324.258.325-.258c.913-.729 2.05-1.631 3.063-2.947a10.7 10.7 0 0 0 1.465-2.546 9.61 9.61 0 0 0 .424-1.37c.677-2.851.607-6.784.606-6.822Z",
    fill: "#151616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.834 53.953a9.266 9.266 0 0 1-.407 1.317c-.383.952-.876 1.76-1.413 2.457l-.001.001h-6.18l3.09-3.775h-4.91c-.677-2.842-.597-6.726-.597-6.726l5.507 6.726 5.506-6.726s.08 3.884-.596 6.726Z",
    fill: "#FEFEFE"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "skyss_icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14 42)",
    d: "M0 0h80v20.513H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "skyss_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4455_2689"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4455_2689",
    result: "shape"
  }))));
};
var SvgSkyssIcon$1 = SvgSkyssIcon;

const SvgSleet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.345 23.979c-1.158 0-2.314.124-3.444.367-3.614-8.363-12.046-13.942-21.17-13.942-11.384 0-20.851 8.016-22.737 19.147h-.08c-7.444 0-13.5 6.055-13.5 13.496 0 7.44 6.056 13.494 13.5 13.494h47.431c8.979 0 16.284-7.305 16.284-16.282s-7.305-16.28-16.284-16.28Zm13.01 16.28c0 7.18-5.835 13.02-13.01 13.02h-47.43c-5.64 0-10.227-4.59-10.227-10.232 0-5.644 4.588-10.234 10.227-10.234.376 0 .787.03 1.293.09l1.664.208.167-1.661a19.732 19.732 0 0 1 19.692-17.785c8.344 0 15.832 5.295 18.634 13.177l.53 1.488 1.51-.48a13.092 13.092 0 0 1 3.94-.608c7.175 0 13.01 5.84 13.01 13.017ZM43.517 65.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM64.674 65.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.718 81.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM36.718 73.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgSleet$1 = SvgSleet;

const SvgSleetshowersandthunderDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.92 41.12c-.859 0-1.716.093-2.554.276-2.682-6.294-8.936-10.493-15.705-10.493-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S80.58 41.12 73.92 41.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H38.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.248 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM36.517 73.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM76.674 87.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.718 91.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM87.718 75.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.26 18.643a1.453 1.453 0 0 1-1.554 1.336 1.454 1.454 0 0 1-1.33-1.563l.998-12.82a1.454 1.454 0 0 1 1.555-1.337 1.457 1.457 0 0 1 1.33 1.563l-1 12.821ZM23.278 24.06a1.448 1.448 0 0 1-2.043-.122l-8.501-9.616a1.463 1.463 0 0 1 .121-2.052 1.446 1.446 0 0 1 2.043.12l8.5 9.619a1.46 1.46 0 0 1-.12 2.051ZM10.845 56.484l9.373-8.76a1.448 1.448 0 0 1 2.046.074c.541.585.508 1.51-.075 2.053l-9.373 8.76a1.447 1.447 0 0 1-2.045-.072 1.464 1.464 0 0 1 .074-2.055Zm47.013-42.17a1.448 1.448 0 0 0-2.046-.075l-9.373 8.76a1.463 1.463 0 0 0-.072 2.055 1.445 1.445 0 0 0 2.043.073l9.373-8.76a1.462 1.462 0 0 0 .075-2.054Zm-39.835 20.77a1.457 1.457 0 0 0-1.307-1.58L3.969 32.313a1.454 1.454 0 0 0-.268 2.894l12.748 1.19a1.453 1.453 0 0 0 1.575-1.312Zm17.068-9.252c-5.862-.528-11.058 3.832-11.584 9.72-.34 3.805 1.36 7.324 4.182 9.485a11.245 11.245 0 0 0-1.658 2.187c-3.546-2.716-5.68-7.136-5.253-11.918.66-7.4 7.191-12.88 14.557-12.215 3.705.333 6.926 2.16 9.129 4.835a18.497 18.497 0 0 0-2.09 1.783 10.623 10.623 0 0 0-7.283-3.877Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgSleetshowersandthunderDay$1 = SvgSleetshowersandthunderDay;

const SvgSleetshowersandthunderNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.92 41.12c-.859 0-1.716.093-2.554.276-2.682-6.294-8.936-10.493-15.705-10.493-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S80.58 41.12 73.92 41.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H38.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.248 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM36.517 73.52l4.136 7.477c.961 1.735 3.642.187 2.68-1.55l-4.137-7.48c-.96-1.734-3.642-.186-2.68 1.552ZM76.674 87.52l4.139 7.477c.96 1.735 3.64.187 2.68-1.55-1.38-2.493-2.76-4.986-4.138-7.48-.96-1.734-3.642-.186-2.68 1.552ZM68.058 83.948h-3.495c-.463 0-.894.234-1.15.627a1.43 1.43 0 0 0-.126 1.326l3.281 7.997L53.203 79.46h3.346c.504 0 .968-.28 1.211-.73a1.432 1.432 0 0 0-.045-1.436L54.41 72h-2.057l3.552 5.69h-3.52c-.554 0-1.052.333-1.271.85a1.43 1.43 0 0 0 .264 1.525l15.26 16.487c.274.295.635.448 1.001.448.26 0 .523-.077.758-.232.57-.377.787-1.086.524-1.726l-3.826-9.325h3.522c.476 0 .913-.245 1.168-.654.255-.411.286-.918.084-1.354L64.47 72h-1.919l5.506 11.948Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.718 91.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM87.718 75.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.823 55.75a23.747 23.747 0 0 1-5.957-.488c-3.937-.831-7.115-3.065-9.861-5.98-.405-.43-.79-.879-1.229-1.37 9.391 1.006 17.225-1.882 22.85-9.592 5.593-7.662 6.204-16.1 2.67-24.926.05.01.11.008.159.032 5.453 2.778 9.512 6.863 11.503 12.767.64-.19 1.337-.357 2.042-.457-.07-.21-.128-.419-.202-.629-2.672-7.557-8.32-12.201-15.553-15.01-.485-.187-.946-.113-1.287.31-.341.42-.332.88-.052 1.34.081.13.16.263.237.395 2.495 4.245 3.724 8.83 3.103 13.756-1.061 8.421-5.36 14.607-12.942 18.233-4.692 2.245-9.631 2.33-14.617 1.07-.706-.178-1.2-.07-1.496.389-.298.462-.265.905.223 1.5 1.102 1.345 2.159 2.74 3.366 3.983 5.06 5.207 11.167 7.55 18.382 6.786.12-.022.24-.04.36-.06a10.228 10.228 0 0 1-1.699-2.049Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgSleetshowersandthunderNight$1 = SvgSleetshowersandthunderNight;

const SvgSlidersOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.835 28.849",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.19,
    cy: 4.855,
    r: 4.105
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.956 4.855h17.129M.75 4.855h2.674"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.166,
    cy: 23.995,
    r: 4.105
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.932 23.995h14.153M.75 23.995H6.4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.24,
    cy: 14.425,
    r: 4.105
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.006 14.425h3.079M.75 14.425h16.724"
  })));
};
var SvgSlidersOutlined$1 = SvgSlidersOutlined;

const SvgSnow = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.987 33.996c-1.144 0-2.286.123-3.402.367-3.567-8.343-11.893-13.908-20.9-13.908-11.242 0-20.589 7.996-22.45 19.1l-.079-.001c-7.35 0-13.33 6.04-13.33 13.463 0 7.42 5.98 13.458 13.33 13.458h46.831c8.865 0 16.078-7.286 16.078-16.239 0-8.954-7.213-16.24-16.078-16.24Zm12.845 16.24c0 7.16-5.762 12.985-12.845 12.985h-46.83c-5.569 0-10.098-4.578-10.098-10.204 0-5.63 4.53-10.209 10.097-10.209.372 0 .777.029 1.278.091l1.642.206.166-1.657c1.014-10.113 9.373-17.738 19.443-17.738 8.237 0 15.63 5.281 18.398 13.142l.522 1.483 1.49-.478a12.81 12.81 0 0 1 3.892-.607c7.083 0 12.845 5.825 12.845 12.986Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.718 78.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM58.718 85.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM77.718 78.233h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.691-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.281 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.256 1.283 2.35c.183.376.64.658 1.099.658.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgSnow$1 = SvgSnow;

const SvgSnowandthunder = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.036 22.266c-1.135 0-2.268.12-3.375.361C65.12 14.394 56.858 8.902 47.918 8.902c-11.155 0-20.432 7.891-22.279 18.85h-.079c-7.293 0-13.228 5.959-13.228 13.284 0 7.323 5.935 13.282 13.228 13.282h46.476c8.797 0 15.955-7.19 15.955-16.026 0-8.837-7.158-16.026-15.955-16.026Zm12.746 16.026c0 7.067-5.718 12.815-12.746 12.815H25.56c-5.524 0-10.02-4.517-10.02-10.071 0-5.555 4.496-10.075 10.02-10.075.369 0 .773.028 1.268.09l1.631.203.164-1.635c1.008-9.98 9.303-17.506 19.295-17.506 8.175 0 15.513 5.212 18.259 12.971l.519 1.465 1.48-.472c1.255-.4 2.552-.6 3.86-.6 7.028 0 12.746 5.748 12.746 12.815ZM61.532 73.442h-4.896c-.649 0-1.251.32-1.611.858a1.917 1.917 0 0 0-.176 1.813l4.596 10.938-18.721-19.748h4.687a1.94 1.94 0 0 0 1.697-1c.34-.617.317-1.37-.063-1.963l-4.63-7.24h-2.883l4.975 7.782h-4.93c-.776 0-1.474.456-1.78 1.163a1.922 1.922 0 0 0 .37 2.086L59.542 90.68c.383.404.889.613 1.402.613.365 0 .732-.105 1.061-.318a1.897 1.897 0 0 0 .735-2.36L57.38 75.86h4.934c.667 0 1.279-.335 1.636-.895.356-.561.4-1.254.117-1.85L56.508 57.1H53.82l7.712 16.34Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.718 64.23h-2.565l1.282-2.35c.367-.565.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM41.718 79.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM79.718 65.23h-2.565l1.282-2.35c.367-.565.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgSnowandthunder$1 = SvgSnowandthunder;

const SvgSnowshowersDay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.92 50.12c-.859 0-1.716.093-2.554.277-2.682-6.295-8.936-10.494-15.705-10.494-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S88.58 50.12 81.92 50.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H46.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.247 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796ZM46.257 26.293a1.62 1.62 0 0 1-1.732 1.488 1.621 1.621 0 0 1-1.482-1.741l1.112-14.291a1.62 1.62 0 0 1 1.734-1.49c.884.07 1.551.855 1.482 1.742l-1.114 14.292ZM30.672 32.33c-.662.59-1.687.53-2.276-.136l-9.476-10.72a1.631 1.631 0 0 1 .135-2.286 1.612 1.612 0 0 1 2.276.134l9.476 10.72c.59.666.53 1.695-.135 2.288ZM16.816 68.47l10.447-9.765a1.614 1.614 0 0 1 2.28.083 1.63 1.63 0 0 1-.083 2.289l-10.447 9.765a1.613 1.613 0 0 1-2.28-.082 1.632 1.632 0 0 1 .083-2.29Zm52.402-47.005a1.614 1.614 0 0 0-2.28-.083L56.49 31.148a1.63 1.63 0 0 0-.081 2.29 1.61 1.61 0 0 0 2.278.082l10.448-9.766a1.63 1.63 0 0 0 .082-2.288ZM24.816 44.62a1.625 1.625 0 0 0-1.457-1.762L9.15 41.529a1.62 1.62 0 0 0-.3 3.226l14.211 1.327a1.62 1.62 0 0 0 1.756-1.463ZM43.84 34.306c-6.533-.59-12.325 4.27-12.911 10.834-.379 4.24 1.516 8.163 4.66 10.572-.798.825-1.4 1.667-1.846 2.437-3.953-3.026-6.333-7.953-5.856-13.284.737-8.247 8.016-14.355 16.226-13.615 4.13.372 7.72 2.409 10.175 5.39a20.607 20.607 0 0 0-2.329 1.986 11.84 11.84 0 0 0-8.119-4.32Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.718 86.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM73.718 93.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM92.718 86.233h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.691-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.281 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.256 1.283 2.35c.183.376.64.658 1.099.658.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgSnowshowersDay$1 = SvgSnowshowersDay;

const SvgSnowshowersNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.92 50.12c-.859 0-1.716.093-2.554.277-2.682-6.295-8.936-10.494-15.705-10.494-8.446 0-15.468 6.033-16.867 14.41h-.059c-5.523 0-10.015 4.557-10.015 10.158 0 5.599 4.492 10.154 10.015 10.154h35.186c6.66 0 12.08-5.497 12.08-12.253S88.58 50.12 81.92 50.12Zm9.65 12.252c0 5.403-4.328 9.798-9.65 9.798H46.736c-4.183 0-7.586-3.454-7.586-7.699 0-4.247 3.403-7.703 7.586-7.703.28 0 .585.022.96.07l1.236.154.123-1.25c.761-7.63 7.042-13.383 14.607-13.383 6.19 0 11.745 3.983 13.825 9.915l.392 1.12 1.119-.36a9.582 9.582 0 0 1 2.924-.458c5.32 0 9.65 4.394 9.65 9.796Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.718 86.23h-2.565l1.282-2.35c.366-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.365.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM73.718 93.23h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.692-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.282 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.255 1.283 2.35c.183.375.64.657 1.099.657.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222ZM92.718 86.233h-2.565l1.282-2.35c.367-.564.183-1.41-.458-1.691-.641-.376-1.374-.188-1.74.47l-1.283 2.255-1.282-2.255c-.367-.658-1.1-.846-1.65-.47-.366.188-.549.47-.64.752-.092.281 0 .657.091.94l1.283 2.255h-2.474c-.732.094-1.282.658-1.282 1.316s.55 1.316 1.282 1.316h2.565l-1.282 2.255c-.183.282-.183.658-.092.94.092.282.275.564.55.752.55.376 1.374.094 1.649-.47l1.282-2.256 1.283 2.35c.183.376.64.658 1.099.658.183 0 .458-.094.641-.188.55-.376.825-1.128.458-1.692l-1.282-2.35h2.565c.64 0 1.282-.563 1.282-1.315s-.641-1.222-1.282-1.222Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.244 67.469a26.305 26.305 0 0 1-6.65-.55c-4.394-.935-7.942-3.448-11.008-6.727-.451-.484-.88-.988-1.37-1.541 10.482 1.131 19.227-2.117 25.507-10.79 6.242-8.62 6.925-18.113 2.979-28.043.056.011.124.01.178.037 6.087 3.125 10.618 7.72 12.84 14.362a15.98 15.98 0 0 1 2.28-.514c-.077-.236-.143-.471-.225-.708-2.983-8.501-9.289-13.726-17.362-16.886-.541-.21-1.056-.127-1.437.35-.38.472-.37.99-.057 1.505.09.148.178.297.264.446 2.785 4.775 4.157 9.934 3.464 15.476-1.185 9.473-5.983 16.432-14.447 20.512-5.238 2.525-10.751 2.622-16.317 1.204-.788-.201-1.34-.08-1.67.436-.332.521-.296 1.02.25 1.688 1.229 1.514 2.409 3.083 3.756 4.48 5.65 5.859 12.466 8.494 20.52 7.635.133-.024.268-.044.403-.067a11.48 11.48 0 0 1-1.898-2.305Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgSnowshowersNight$1 = SvgSnowshowersNight;

const SvgSquareArrowInRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.529 32.508",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.44 9.474 6.779 6.779v.002l-6.779 6.779M.75 16.254h20.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.772 11.253V3.05a2.3 2.3 0 0 1 2.3-2.3H29.48a2.3 2.3 0 0 1 2.3 2.3v26.408a2.3 2.3 0 0 1-2.3 2.3H3.071a2.3 2.3 0 0 1-2.3-2.3v-8.2"
  })));
};
var SvgSquareArrowInRightOutlined$1 = SvgSquareArrowInRightOutlined;

const SvgSquareArrowRightCornerOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.165 31.165",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.01 7.982h9.171l.002.002v9.171M7.982 23.183 23.183 7.982"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 29.665,
    height: 29.665,
    rx: 2.2
  })));
};
var SvgSquareArrowRightCornerOutlined$1 = SvgSquareArrowRightCornerOutlined;

const SvgSquareParkingOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.967 32.967",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 31.467,
    height: 31.467,
    rx: 2.154
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.575,
    y: 4.575,
    width: 23.816,
    height: 23.816,
    rx: 0.067
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.982 24.587V9.252h3.745a4.713 4.713 0 0 1 4.712 4.713h0a4.712 4.712 0 0 1-4.712 4.712h-3.745"
  })));
};
var SvgSquareParkingOutlined$1 = SvgSquareParkingOutlined;

const SvgSquareParkingRoofOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 38.559 37.963",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.666,
    y: 13.623,
    width: 23.59,
    height: 23.59,
    rx: 0.067
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.993 33.445v-15.19H19.7a4.668 4.668 0 0 1 4.668 4.668h0a4.668 4.668 0 0 1-4.668 4.668h-3.707M.75 10.769V7.951a.866.866 0 0 1 .574-.815L18.9.827a1.32 1.32 0 0 1 .892 0l17.445 6.308a.867.867 0 0 1 .572.815v2.816a.866.866 0 0 1-1.161.815L19.8 5.489a1.314 1.314 0 0 0-.892 0L1.91 11.585a.867.867 0 0 1-1.16-.816Z"
  })));
};
var SvgSquareParkingRoofOutlined$1 = SvgSquareParkingRoofOutlined;

const SvgStairsArrowUpDownOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 28.888 28.888",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 28.138v-5.535h7.284v-7.284h7.285V8.034h7.284V.75h5.535M.795 9.684 9.684.795M4.314.795h5.37v5.371M28.093 19.204l-8.889 8.889M24.574 28.093h-5.37v-5.37"
  })));
};
var SvgStairsArrowUpDownOutlined$1 = SvgStairsArrowUpDownOutlined;

const SvgStarOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.704 30.323",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.742 1.3 3.9 7.9a.993.993 0 0 0 .747.543l8.711 1.268a.993.993 0 0 1 .551 1.693l-6.307 6.148a.992.992 0 0 0-.286.878l1.489 8.681a.992.992 0 0 1-1.44 1.046l-7.8-4.1a.993.993 0 0 0-.924 0l-7.8 4.1a.992.992 0 0 1-1.44-1.046l1.5-8.681a.992.992 0 0 0-.285-.878L1.051 12.7a.993.993 0 0 1 .55-1.693l8.716-1.267a.991.991 0 0 0 .747-.543l3.9-7.9a.993.993 0 0 1 1.778.003Z",
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }));
};
var SvgStarOutlined$1 = SvgStarOutlined;

const SvgStopSignOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.462 35.462",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.665.75 10.047 10.047v13.868L24.665 34.712H10.797L.75 24.665V10.797L10.797.75h13.868z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.532,
    cy: 17.607,
    r: 2.908
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.374 20.515v-5.816M26.5 20.515V14.7h1.9a1.9 1.9 0 0 1 1.9 1.9h0a1.9 1.9 0 0 1-1.9 1.9h-1.9M11.1 14.699h4.548M8.807 15.687a2.268 2.268 0 0 0-1.826-.987c-1.594 0-1.818 1.118-1.818 1.594 0 .773.695 1.225 1.822 1.454s2.17.5 2.17 1.578-.907 1.5-1.993 1.432a3.058 3.058 0 0 1-2-1.081"
  })));
};
var SvgStopSignOutlined$1 = SvgStopSignOutlined;

const SvgSuitcaseClaimOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48.838 28.418",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 27.668v-3.304h47.338v3.304M6.01 24.364v3.304M11.27 24.364v3.304M16.529 24.364v3.304M21.789 24.364v3.304M32.309 24.364v3.304M37.568 24.364v3.304M42.828 24.364v3.304M27.049 24.364v3.304"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.497,
    y: 4.188,
    width: 23.937,
    height: 16.387,
    rx: 1.021,
    transform: "rotate(-180 33.466 12.381)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.161 20.575h-15.39V4.188h15.39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.865 4.188V1.5a.753.753 0 0 0-.753-.75H30.82a.753.753 0 0 0-.753.753v2.685"
  })));
};
var SvgSuitcaseClaimOutlined$1 = SvgSuitcaseClaimOutlined;

const SvgSuitcaseOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 38.827 32.415",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 6.111,
    width: 37.327,
    height: 25.554,
    rx: 1.591,
    transform: "rotate(-180 19.413 18.888)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.413 31.665H7.414V6.111h23.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.713 6.111V1.924A1.173 1.173 0 0 0 23.54.75h-8.252a1.173 1.173 0 0 0-1.174 1.174v4.187"
  })));
};
var SvgSuitcaseOutlined$1 = SvgSuitcaseOutlined;

const SvgSunArrowDownOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 39.955 27.563",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.977 10.653V.75M7.223 8.721l3.644 4.523M36.453 26.706H3.501M39.205 19.592l-5.807.098M32.732 8.721l-3.644 4.523M24.188 6.442l-4.211 4.211-4.211-4.211M.75 19.592l5.807.098M10.11 26.813a10.072 10.072 0 1 1 19.756-.107"
  })));
};
var SvgSunArrowDownOutlined$1 = SvgSunArrowDownOutlined;

const SvgSunArrowUpOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 39.955 27.563",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.977.75v9.903M7.223 8.721l3.644 4.523M36.453 26.706H3.501M39.205 19.592l-5.807.098M32.732 8.721l-3.644 4.523M15.766 4.961 19.977.75l4.211 4.211M.75 19.592l5.807.098M10.11 26.813a10.072 10.072 0 1 1 19.756-.107"
  })));
};
var SvgSunArrowUpOutlined$1 = SvgSunArrowUpOutlined;

const SvgSunOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 34.763 34.763",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.621 5.621 3.125 3.125M.75 17.382h4.418M29.142 5.621l-3.124 3.125M17.382.75v4.418M5.621 29.142l3.125-3.124M34.013 17.382h-4.418M17.382 34.013v-4.418M29.142 29.142l-3.124-3.124"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.381,
    cy: 17.381,
    r: 8.441
  })));
};
var SvgSunOutlined$1 = SvgSunOutlined;

const SvgTaxFreeTagOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 42.181 23.32",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.117 2.882-7.869 8.377a1.662 1.662 0 0 0 0 2.276l7.869 8.377a2.09 2.09 0 0 0 1.523.658h28.186a1.6 1.6 0 0 0 1.6-1.605V3.828a1.606 1.606 0 0 0-1.6-1.6H11.64a2.091 2.091 0 0 0-1.523.654Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.267,
    cy: 12.397,
    r: 2.304
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89 11.875 1.368 4.354a2.112 2.112 0 0 1 0-2.986h0a2.112 2.112 0 0 1 2.986 0L6.281 3.3M20.898 10.397V6.313M22.714 6.075h-3.633M16.84 18.554v-4.085M22.076 18.554v-4.085h2.317a1.065 1.065 0 0 1 1.065 1.066h0a1.065 1.065 0 0 1-1.065 1.065h-2.317M19.549 14.232H16.84M19.549 16.393H16.84M28.047 18.554v-4.085M30.756 14.232h-2.709M30.756 16.393h-2.709M30.755 18.555h-2.709M33.255 18.554v-4.085M35.964 14.232h-2.709M35.964 16.393h-2.709M35.962 18.555h-2.708M28.047 10.397l-2.125-4.322-2.126 4.322M24.307 9.46h3.229M30.366 10.397l3.208-4.322M33.591 10.397l-3.207-4.322M23.98 16.6l1.377 1.955"
  })));
};
var SvgTaxFreeTagOutlined$1 = SvgTaxFreeTagOutlined;

const SvgThumbsUpHandOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 31.541 28.852",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 9.643,
    width: 6.546,
    height: 18.459,
    rx: 1.722
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.351 14.292h-3.619M28.175 18.282h-3.443M27.069 22.282h-2.337M7.3 26.277h19.6a2 2 0 0 0 2-2h0a2 2 0 0 0-2-2h1.273a2 2 0 0 0 2-2h0a2 2 0 0 0-2-2h.176a2 2 0 0 0 2-2h0a2 2 0 0 0-2-2h.442a2 2 0 0 0 2-2h0a2 2 0 0 0-2-2H17.059a10.531 10.531 0 0 0 1.328-5.118c.069-2.119-.36-4.167-2.15-4.4-1.962-.261-2.32 1.663-2.64 3.474-.53 3-1.754 6.777-5.878 8.009"
  })));
};
var SvgThumbsUpHandOutlined$1 = SvgThumbsUpHandOutlined;

const SvgTicketOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.086 21.795",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7 7.858h.639V2.43A1.68 1.68 0 0 0 32.656.75H2.43A1.68 1.68 0 0 0 .75 2.43v5.623h.638A2.943 2.943 0 0 1 4.331 11h0a2.943 2.943 0 0 1-2.943 2.942H.75v5.429a1.68 1.68 0 0 0 1.68 1.679h30.226a1.68 1.68 0 0 0 1.68-1.679v-5.629H33.7a2.942 2.942 0 0 1-2.945-2.942h0A2.942 2.942 0 0 1 33.7 7.858ZM11.043.75v1.253M11.043 5.496v1.253M11.043 10.242v1.253M11.043 14.988v1.253M11.043 19.734v1.252"
  })));
};
var SvgTicketOutlined$1 = SvgTicketOutlined;

const SvgTrainRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.992 29.89",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.75 4.556V29.14M31.62 18.028a14.765 14.765 0 0 1-6.042-3.46 10.022 10.022 0 0 1-2.255-5.034 9.493 9.493 0 0 1-.1-.6M.75 11.63h12.1A4.141 4.141 0 0 1 17 15.771v.823h0H.75h0V11.63h0ZM7.979 11.63v4.964"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 7.5h17.58c5.018 0 10.1 4.413 12.279 8.059s4.4 8.616.488 8.616h-6.306a1.6 1.6 0 0 1-1.314-.69l-.432-.626a1.6 1.6 0 0 0-1.314-.69h-11.18a1.6 1.6 0 0 0-1.314.69l-.432.626a1.6 1.6 0 0 1-1.314.69H.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.384 22.171a2.892 2.892 0 1 1-5.653.258M22.584 22.447a2.923 2.923 0 0 1 .035.452 2.892 2.892 0 1 1-5.691-.728M.75 26.99h28.915M12.265 7.502l3.98-2.942L11.984.75"
  })));
};
var SvgTrainRightOutlined$1 = SvgTrainRightOutlined;

const SvgTurkishAirlinesIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#turkish_airlines_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.42 56.971a29.793 29.793 0 0 0 4.222 11.055c7.74-2.155 14.546-6.236 16.967-15.329 2.662-10.009-.376-20.497-7.646-26.055-9.897 6.267-15.606 18.052-13.544 30.33Zm59.16-9.939c2.745 16.335-8.272 31.805-24.61 34.548-2.681.454-5.41.54-8.114.257-8.523-.891-16.205-5.42-21.146-12.23l48.567-13.925c.698-.202.517-.872-.059-.832l-20.362 1.422c2.868-2.77 5.05-6.166 4.788-10.862-.537-7.608-8.28-15.032-22.68-19.917a29.83 29.83 0 0 1 9.064-3.074c2.75-.46 5.475-.535 8.113-.257 13.07 1.368 24.155 11.276 26.439 24.87Z",
    fill: "#D12600"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "turkish_airlines_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25838"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25838",
    result: "shape"
  }))));
};
var SvgTurkishAirlinesIcon$1 = SvgTurkishAirlinesIcon;

const SvgTurnaround = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.368 7.916a16.215 16.215 0 1 0 11.466 27.682 16.17 16.17 0 0 0 3.52-5.26.75.75 0 1 1 1.386.573 17.667 17.667 0 0 1-3.846 5.748 17.716 17.716 0 1 1 .001-25.054.75.75 0 1 1-1.06 1.06 16.215 16.215 0 0 0-11.467-4.749Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.19 7.612a.75.75 0 0 1 .75.75v4.645a.75.75 0 0 1-.75.75h-4.645a.75.75 0 0 1 0-1.5h3.895V8.362a.75.75 0 0 1 .75-.75ZM21.737 16.297a.75.75 0 0 1 .52 0l9.964 3.691 4.737-1.691.003-.001a1.97 1.97 0 0 1 1.307 0h.001l2.316.809 1.495.525 1.172.41a1.998 1.998 0 0 1 1.311 1.884 1.851 1.851 0 0 1-1.205 1.788l-.009.003-11.331 4.048-8.497 3.24-.015.005-1.267.453a7.192 7.192 0 0 1-7.402-1.668l-.01-.01a12.293 12.293 0 0 1-1.445-1.78l-2.993-4.198a.75.75 0 0 1 .35-1.139l2.34-.866a.75.75 0 0 1 .64.056l5.022 2.942 3.829-1.367-4.043-4.883a.75.75 0 0 1 .318-1.181l2.892-1.07Zm-3.11 8.542Zm1.73-6.432 4.051 4.893a.75.75 0 0 1-.326 1.184l-4.949 1.767a1.246 1.246 0 0 1-1.086-.12l-4.78-2.8-1.087.402 2.43 3.408.014.02c.374.561.799 1.086 1.27 1.568a5.694 5.694 0 0 0 5.85 1.316l1.25-.447 8.496-3.24.016-.005 11.333-4.048a.351.351 0 0 0 .225-.342v-.04a.5.5 0 0 0-.324-.473l-1.156-.404-1.496-.526-2.315-.809h-.002a.47.47 0 0 0-.31 0h-.002l-4.99 1.782a.75.75 0 0 1-.514-.004l-9.958-3.69-1.64.608Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgTurnaround$1 = SvgTurnaround;

const SvgUtensilsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 32.421 30.572",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.78 13.621h1.882a.132.132 0 0 1 .133.136L2.457 28.1a1.68 1.68 0 0 0 1.68 1.721h0a1.682 1.682 0 0 0 1.682-1.681V1.74a.937.937 0 0 0-1.745-.475A24.3 24.3 0 0 0 .75 13.59a.031.031 0 0 0 .03.031ZM11.728 1.982A1.231 1.231 0 0 1 12.959.75h0a1.232 1.232 0 0 1 1.232 1.232v0A1.231 1.231 0 0 1 15.422.75h0a1.231 1.231 0 0 1 1.232 1.232v0A1.231 1.231 0 0 1 17.886.75h0a1.231 1.231 0 0 1 1.231 1.232h0l.139 8.024a3.837 3.837 0 0 1-2.517 3.69L17 28.214a1.579 1.579 0 1 1-3.157 0l.263-14.514a3.837 3.837 0 0 1-2.517-3.69l.139-8.024ZM31.671 7.545c0-3.688-1.707-6.678-3.812-6.678s-3.813 2.99-3.813 6.678c0 2.876 1.038 5.328 2.494 6.268l-.26 14.4a1.579 1.579 0 1 0 3.157 0l-.26-14.4c1.456-.94 2.494-3.392 2.494-6.268Z"
  })));
};
var SvgUtensilsOutlined$1 = SvgUtensilsOutlined;

const SvgVaarnesEkspressenIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#vaarnes_ekspressen_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 87c19.33 0 35-15.67 35-35S73.33 17 54 17 19 32.67 19 52s15.67 35 35 35Zm23.087-33.091c.093-.07.18-.151.255-.238.494-.546.5-1.063.023-1.59a3.95 3.95 0 0 0-.522-.46c-1.359-1.021-2.885-1.55-4.586-1.555l-2.146-.005c-2.499-.007-4.995-.013-7.491.005-.604 0-1.01-.186-1.382-.662-3.703-4.743-7.419-9.474-11.134-14.205a2223.385 2223.385 0 0 1-3.408-4.337c-.197-.25-.395-.465-.755-.465-.811.007-1.625.008-2.438.009-.542 0-1.084 0-1.626.003a.363.363 0 0 0-.115.03l-.105.034c2.473 6.502 4.946 12.992 7.419 19.47-.198.102-.364.094-.516.086-.04-.002-.079-.004-.117-.004-1.318.006-2.63.006-3.947 0-1.26-.006-2.52.006-3.756.244-.465.093-.709-.03-.964-.424a261.338 261.338 0 0 0-2.113-3.204c-.556-.834-1.112-1.67-1.66-2.508-.297-.453-.65-.656-1.197-.633-.553.023-1.11.02-1.664.018-.278-.001-.555-.003-.832 0-.031 0-.064-.003-.097-.006-.114-.01-.235-.02-.338.075.004.147.06.272.114.395.015.033.03.066.043.099l.878 2.212c.755 1.905 1.51 3.81 2.28 5.706.244.592.244 1.126 0 1.724-.973 2.38-1.92 4.77-2.866 7.156l-.194.49a4.58 4.58 0 0 1-.07.163c-.092.208-.187.423-.174.684l.831-.002c.734-.004 1.464-.007 2.194.014.441.011.726-.128.964-.494.44-.68.894-1.352 1.348-2.025.217-.32.433-.642.649-.964.714-1.056 1.422-2.119 2.13-3.18v-.002l.004-.006c.12-.183.22-.335.501-.208.726.319 1.498.354 2.276.354 1.898 0 3.79 0 5.69.005.037 0 .076-.002.115-.004.148-.009.307-.018.476.092L45.9 64.114c-1.418 3.727-2.84 7.466-4.278 11.24h4.284c.273 0 .476-.14.65-.331a8.16 8.16 0 0 0 .314-.383l.087-.11 2.552-3.249c3.894-4.955 7.788-9.912 11.671-14.876.412-.528.865-.737 1.527-.726 3.326.047 6.653.059 9.98-.04 1.671-.052 3.117-.697 4.4-1.73Z",
    fill: "#E3701C"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vaarnes_ekspressen_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4455_2684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4455_2684",
    result: "shape"
  }))));
};
var SvgVaarnesEkspressenIcon$1 = SvgVaarnesEkspressenIcon;

const SvgVyIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#vy_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#22958F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.805 56.324s.026-.013.026-.026-.007-.02-.02-.026a3.85 3.85 0 0 1-1.533-.55c-1.028-.655-1.84-1.907-2.528-3.99-.099-.275-3.531-11.922-3.747-12.682-.78-2.66-2.26-3.845-3.616-4.343a5.685 5.685 0 0 0-1.9-.334h-.95s-.026.013-.026.026c0 .014.007.02.02.027.406.059.819.17 1.199.327 1.264.53 2.58 1.723 3.34 4.297.17.577 3.636 12.309 3.708 12.538.694 2.182 1.52 3.472 2.58 4.14.676.42 1.435.603 2.32.603h1.14l-.013-.007Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.844 56.324s.026-.006.026-.02c0-.012-.007-.026-.02-.026-1.539-.196-2.541-2.358-3.091-4.192-.577-1.926-2.667-8.968-3.911-13.036-1.245-4.1-5.13-4.677-6.892-4.69 0 0-.026.007-.026.02 0 .013.007.026.02.026 1.644.216 3.976 1.218 4.985 4.625.884 3 3.688 12.511 3.8 12.832.674 1.985 1.46 3.19 2.469 3.839.675.439 1.441.616 2.339.616h.3v.006ZM34.368 69.635h-.479c-1.401 0-3.091-.714-4.022-3.976l-8.358-28.45c-.498-1.71-1.238-2.56-2.49-2.783 0 0-.019-.014-.019-.027s.013-.026.026-.026h1.258c1.677 0 2.587.832 3.164 2.83 0 0 7.743 26.157 8.444 28.626.517 1.828 1.126 3.073 2.07 3.577.13.072.268.13.406.17 0 0 .02.013.02.026.006.02-.007.04-.02.04v-.007ZM31.544 38.27c-.805-2.757-2.063-3.91-4.375-3.91h-1.127s-.026.013-.026.02c0 0 .006.02.02.026 1.807.255 2.855 1.441 3.556 3.858 0 0 6.93 23.497 7.828 26.57l.95-3.204-6.832-23.366.006.007Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.023 69.635h.825c1.029 0 1.77-.268 2.326-.72.897-.728 1.31-1.94 1.69-3.204.059-.19 7.39-24.957 7.645-25.92.877-3.27 2.83-4.69 4.913-5.195.34-.079.694-.144 1.048-.183 0 0 .026-.014.02-.027 0-.013-.014-.026-.027-.02h-.91c-2.752 0-5.81 1.088-6.97 5.431-.42 1.566-7.592 25.73-7.645 25.92-.38 1.272-.812 2.608-1.71 3.335a2.277 2.277 0 0 1-1.185.53s-.02.014-.02.027c-.013.013 0 .026.013.026h-.013ZM72.682 52.584l4.31-14.32c.701-2.417 1.756-3.603 3.557-3.858 0 0 .027-.013.02-.026 0-.013-.013-.027-.026-.02h-1.127c-2.312 0-3.563 1.153-4.37 3.91l-3.333 11.156s.884 2.935.963 3.158h.006Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.034 34.38h-1.199c-1.965 0-3.032.982-3.72 3.328 0 0-4.271 14.208-4.304 14.332-.315 1.002-.708 1.979-1.1 2.607.373.511.772.826 1.159.904.74-.635 1.362-1.808 1.906-3.59.026-.091 4.284-14.253 4.284-14.253.59-2.031 1.468-3.04 2.974-3.276 0 0 .02-.013.02-.026.006-.013-.007-.02-.02-.02v-.006ZM75.29 57.038h-1.94c-.877 2.883-2.037 6.695-2.469 8.136-1.199 4.01.694 4.415 1.415 4.415h1.526s.026-.013.026-.026-.006-.02-.02-.026c-.825-.197-1.951-1.055-.956-4.37 0 .007 1.756-5.895 2.411-8.129h.007ZM86.59 34.406s.019-.013.019-.026-.013-.02-.026-.02h-.269c-1.677 0-2.587.839-3.164 2.83 0 0-3.295 11.057-4.336 14.477-1.035 3.42-1.75 4.343-3.158 4.585l-.072.013s-.026.014-.02.027c0 .013.014.026.027.02h.956c2.457 0 3.367-1.632 4.232-4.501.72-2.404 4.952-16.488 4.952-16.488.112-.393.452-.8.858-.924v.007ZM77.235 56.986c-.681 2.3-2.607 8.85-2.607 8.85-1.022 3.406.59 3.753 1.205 3.753h1.494s.026-.013.026-.026-.007-.02-.02-.026c-.7-.184-1.618-.93-.78-3.708 0 0 2.123-7.146 2.922-9.878-.458.478-1.244.91-2.234 1.035h-.006ZM80.883 69.596s.027-.013.027-.026-.007-.02-.02-.026c-.59-.17-1.336-.826-.635-3.145 0 0 8.188-27.748 8.64-29.32.452-1.572-.642-2.555-1.638-2.7-.006 0-.04-.006-.046.007-.006.014.02.04.027.04.196.105.419.34.3.746L78.329 66.4c-.87 2.896.505 3.197 1.023 3.197h1.533ZM67.927 56.324s.026-.006.026-.02c0-.012-.007-.026-.02-.026a3.784 3.784 0 0 1-1.52-.543c-1.08-.681-1.919-2.011-2.633-4.265-.059-.19-3.544-12.007-3.668-12.42-.74-2.495-1.92-3.694-3.092-4.251a4.638 4.638 0 0 0-2.011-.439h-1.022s-.026.007-.026.02c0 .013.006.026.02.026.19.026 2.849.111 4.185 4.625 1.337 4.513 2.948 9.91 3.479 11.81 1.172 4.12 2.679 5.464 5.116 5.464h1.16l.006.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.605 35.913c-.983.838-1.782 2.076-2.267 3.878-.052.183-7.317 24.813-7.474 25.344-.616 2.05-1.127 4.087-3.432 4.441 0 0-.02.013-.02.026s.013.026.02.026h.458s.328-.006.4-.006c2.351-.092 3.524-1.094 4.526-4.48.734-2.483 7.415-25.155 7.474-25.351.289-.944.63-2.031 1.12-2.974a4.6 4.6 0 0 0-.805-.904Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.51 35.277c-.746-.21-1.794-.15-2.757.61-.956.766-1.814 2.056-2.253 3.707-.053.19-7.651 25.927-7.704 26.117-.38 1.265-.792 2.47-1.69 3.204a3.183 3.183 0 0 1-1.572.668s-.02.013-.02.026.013.026.02.026h1.192c1.029 0 1.769-.269 2.326-.72.897-.728 1.31-1.94 1.69-3.204.059-.19 7.592-25.73 7.644-25.92.485-1.808 1.29-3.04 2.267-3.878.275-.236.57-.446.884-.63a.05.05 0 0 0-.026-.012v.006ZM36.536 67.428a5.861 5.861 0 0 1-.812-1.77c-.295-1.008-8.228-27.957-8.228-27.957-.681-2.339-1.755-3.321-3.72-3.321h-1.2s-.026.013-.026.026.007.02.02.026c1.507.236 2.384 1.238 2.974 3.276l8.228 27.95c.425 1.495 1.008 2.45 1.65 3.06.452-.269.845-.7 1.114-1.29Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vy_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4393_37003"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4393_37003",
    result: "shape"
  }))));
};
var SvgVyIcon$1 = SvgVyIcon;

const SvgWasteOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.897 33.894",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.372 24.837a3.105 3.105 0 0 1 2.456-2.937 19.603 19.603 0 0 0-.334-1.415c-.742-2.7-3.6-4.328-5.032-3.935s-2.3 1.687-3.034 1.89c-.806.221-1.676-.472-3.288-.029s-1.924 1.234-1.924 1.234a4.125 4.125 0 0 1 1.913 2.981C3.5 24.522.75 26.182.75 26.182c1.727 4.089 5.436 6.2 6.483 5.893s1.247-1.568 2.212-1.833 2 .677 2.784.46c.526-.144.978-.518 2.021-2.459a3.059 3.059 0 0 1-1.878-3.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.428 18.439a3.661 3.661 0 0 1 .384-4.367M19.285.75l10.85 3.435-.72 2.275-10.85-3.436zM11.66 17l3.202-10.113 10.85 3.436-6.781 21.417-5.711-1.808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.712 10.323-10.85-3.436 3.702-3.862 10.85 3.435-3.702 3.863z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.414 6.46-3.702 3.863-6.781 21.417 4.435 1.404 6.781-21.417-.733-5.267z"
  })));
};
var SvgWasteOutlined$1 = SvgWasteOutlined;

const SvgWcOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.876 33.179",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.866,
    cy: 4.802,
    r: 3.395
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.287 7.808A5.117 5.117 0 0 0 .75 12.676v7.372a1.713 1.713 0 0 0 1.713 1.713h.847V31.7h5.111v-9.939h.848a1.712 1.712 0 0 0 1.712-1.713v-7.372a5.117 5.117 0 0 0-3.537-4.868"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.437,
    cy: 4.802,
    r: 3.395
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.253 7.984a4.055 4.055 0 0 0-2.753 2.928L19.783 22.17a1.3 1.3 0 0 0 1.26 1.6h2.838v7.93h5.111v-7.93h2.838a1.3 1.3 0 0 0 1.26-1.6l-2.713-11.258a4.055 4.055 0 0 0-2.757-2.928M15.995.75v31.679"
  })));
};
var SvgWcOutlined$1 = SvgWcOutlined;

const SvgWebcamOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.43 31.38",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.215,
    cy: 12.215,
    r: 2.74
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.215,
    cy: 12.215,
    r: 6.236
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.215,
    cy: 12.215,
    r: 11.465
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.83 22.213 1.206 5.06H5.394l1.207-5.06"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.696,
    y: 27.273,
    width: 21.038,
    height: 3.357,
    rx: 1.679
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.68 12.215h-5.229M.75 12.215h5.229"
  })));
};
var SvgWebcamOutlined$1 = SvgWebcamOutlined;

const SvgWheelchairCircleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 35.145 35.145",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.572,
    cy: 17.572,
    r: 16.822
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.724,
    cy: 8.99,
    r: 2.086
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.108 10.983.616 7.163h6.312l2.492 5.851 1.761-.487M19.516 15.112h-4.053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.536 23.233a5.8 5.8 0 1 1-8.489-7.463"
  })));
};
var SvgWheelchairCircleOutlined$1 = SvgWheelchairCircleOutlined;

const SvgWheelchairOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 21.023 25.661",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.093,
    cy: 3.352,
    r: 2.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.325 5.839.768 8.936h7.874l3.109 7.299 2.197-.608M11.824 10.99H6.768"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.344 21.12a7.233 7.233 0 1 1-10.59-9.309"
  })));
};
var SvgWheelchairOutlined$1 = SvgWheelchairOutlined;

const SvgWideroeIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#wideroe_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#BEF3F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.982 46.822c-.979.537-2.535 1.996-4.333 4.009 2.267 2.289 4.862 5.245 7.661 8.993 4.411-5.906 7.303-10.032 9.392-11.561 2.091-1.531 8.86-3.512 20.782-5.519-17.924 1.619-30.829 2.618-33.502 4.078Zm-11.345.542c-2.901-2.096-19.31-3.362-40.121-3.869 9.96 1.486 22.715 3.618 26.385 5.926 2.922 1.832 6.104 5.273 11.53 11.531l15.447.305c-5.543-7.425-10.29-11.751-13.241-13.893Z",
    fill: "#218365"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "wideroe_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25830"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25830",
    result: "shape"
  }))));
};
var SvgWideroeIcon$1 = SvgWideroeIcon;

const SvgWifiCircleOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 33.05 33.05",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.525,
    cy: 23.606,
    r: 1.796
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.709 19.444a6.678 6.678 0 0 1 9.632 0M9.009 16.186a10.629 10.629 0 0 1 14.94-.09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.059 12.732a13.735 13.735 0 0 1 18.932 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.525,
    cy: 16.525,
    r: 15.775
  })));
};
var SvgWifiCircleOutlined$1 = SvgWifiCircleOutlined;

const SvgWindLeftOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.014 18.014",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.487 12.686a3.525 3.525 0 1 1-3.525-3.525h14.2M20.202 3.591H8.547L11.388.75M3.653 3.3A1.954 1.954 0 1 0 2.7 6.966h4.855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.709 14.832a2.433 2.433 0 1 1-2.432-2.432h6.987M20.202 3.591H8.547l2.841 2.841"
  })));
};
var SvgWindLeftOutlined$1 = SvgWindLeftOutlined;

const SvgWindRightOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 25.014 18.014",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.527 12.686a3.525 3.525 0 1 0 3.525-3.525H1.858M4.812 3.591h11.655L13.626.75M21.361 3.3a1.954 1.954 0 1 1 .949 3.663h-4.85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.305 14.832A2.433 2.433 0 1 0 7.738 12.4H.75M4.812 3.591h11.655l-2.841 2.841"
  })));
};
var SvgWindRightOutlined$1 = SvgWindRightOutlined;

const SvgWindowBinaryOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.377 29.504",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 28.877,
    height: 28.004,
    rx: 3.251
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.627 5.604H.75M4.481 3.194h0M7.321 3.194h0M10.162 3.194h0M4.147 9.2v5.774"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.972,
    y: 9.2,
    width: 2.501,
    height: 5.774,
    rx: 1.251
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.525 9.2v5.774"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.35,
    y: 9.2,
    width: 2.501,
    height: 5.774,
    rx: 1.251
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.904 9.2v5.774"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.729,
    y: 9.2,
    width: 2.501,
    height: 5.774,
    rx: 1.251
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.147 19.001v5.774"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.972,
    y: 19.001,
    width: 2.501,
    height: 5.774,
    rx: 1.251
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.525 19.001v5.774"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.35,
    y: 19.001,
    width: 2.501,
    height: 5.774,
    rx: 1.251
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.904 19.001v5.774"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.729,
    y: 19.001,
    width: 2.501,
    height: 5.774,
    rx: 1.251
  })));
};
var SvgWindowBinaryOutlined$1 = SvgWindowBinaryOutlined;

const SvgWindowsOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 30.91 24.715",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.837,
    y: 7.837,
    width: 22.324,
    height: 16.128,
    rx: 2.478
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.837 20.422H6.771a2.479 2.479 0 0 1-2.478-2.478V6.771a2.479 2.479 0 0 1 2.478-2.478h17.368a2.478 2.478 0 0 1 2.478 2.478v1.066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.293 16.878H3.228A2.477 2.477 0 0 1 .75 14.4V3.228A2.477 2.477 0 0 1 3.228.75H20.6a2.478 2.478 0 0 1 2.478 2.478v1.065"
  })));
};
var SvgWindowsOutlined$1 = SvgWindowsOutlined;

const SvgWizzairIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#wizzair_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 100,
    height: 100,
    rx: 10,
    fill: "#F6F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.788 47.107h7.728l-9.152 11.968h-7.73l9.154-11.968Zm-.58-1.17-9.73 12.728a.951.951 0 0 0-.1 1.026.992.992 0 0 0 .882.552h8.685l9.807-12.824a.94.94 0 0 0 .093-.975.923.923 0 0 0-.836-.507h-8.802Zm-27.785-6.221a.289.289 0 0 1 .247-.14h5.068l.728-4.183a.274.274 0 0 1 .274-.222l4.743-.004c.087 0 .158.027.208.083.051.065.077.15.065.227l-.472 2.707 22.3.016c.12 0 .207.073.25.143.025.051.06.157-.013.256l-2.013 2.63 16.527-.005c.096 0 .165.06.192.115a.177.177 0 0 1-.002.194L78.788 59.512c-.156.195-.15.693-.04.905.113.215.505.52.75.52l9.662.01a.27.27 0 0 1 .27.311l-.734 4.201a.274.274 0 0 1-.275.22H51.664l-.604-.004a3.423 3.423 0 0 1-3.362 4.067 3.422 3.422 0 1 1 0-6.843c1.292 0 2.418.716 3.004 1.772l14.98-19.635c.242-.507.122-.689-.008-.987-.097-.225-.458-.457-.852-.453H54.336l-2.68 15.296a.271.271 0 0 1-.27.204H46.64a.279.279 0 0 1-.21-.094.26.26 0 0 1-.06-.219l2.91-16.603-11.839 23.2a.604.604 0 0 1-.525.307l-4.032.02c-.144 0-.262-.103-.275-.226l-1.112-16.854-8.747 16.758a.606.606 0 0 1-.523.304l-4.09-.002a.268.268 0 0 1-.271-.237l-2.668-25.585a.292.292 0 0 1 .07-.213.285.285 0 0 1 .207-.077h5.497c.15 0 .277.122.277.283l.824 16.691 8.085-16.83a.274.274 0 0 1 .244-.144l5.012-.021c.139 0 .262.104.271.228l.815 16.82 7.923-16.886ZM50.507 34c-.566 0-1.048.404-1.15.965l-.603 3.44h-4.263a1.18 1.18 0 0 0-1.045.641l-6 12.796-.597-12.37a1.17 1.17 0 0 0-1.164-1.066h-5.456c-.436 0-.838.242-1.046.643l-6.17 12.844-.609-12.322c0-.644-.524-1.165-1.166-1.165h-6.07c-.331 0-.639.13-.862.364a1.227 1.227 0 0 0-.303.91l2.72 26.13a1.166 1.166 0 0 0 1.162 1.037l4.512.002c.554 0 1.058-.302 1.319-.793l6.89-13.197.849 12.95a1.169 1.169 0 0 0 1.16 1.038l4.477.002c.552 0 1.06-.306 1.321-.8l8.373-16.412-1.622 9.256c-.061.341.034.688.254.957.221.263.548.416.894.416h5.307c.551 0 1.02-.384 1.143-.937l2.553-14.567h9.118L50.655 62.79a4.593 4.593 0 0 0-2.947-1.065 4.609 4.609 0 0 0-4.602 4.598c0 2.537 2.068 4.6 4.602 4.6 2.328 0 4.31-1.777 4.577-4.075l36.373-.001c.573 0 1.054-.407 1.148-.967l.832-4.734c.058-.34-.038-.69-.258-.951a1.16 1.16 0 0 0-.892-.412l-9.433-.008 13.753-17.993c.233-.349.254-.77.061-1.131a1.103 1.103 0 0 0-.98-.596H78.17l.933-1.218a1.15 1.15 0 0 0 .063-1.2 1.174 1.174 0 0 0-1.029-.623H56.672l.295-1.65a1.202 1.202 0 0 0-.272-.961 1.133 1.133 0 0 0-.884-.403h-5.304Z",
    fill: "#B5208F",
    stroke: "#6A004D",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "wizzair_icon_svg__a",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4391_25860"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4391_25860",
    result: "shape"
  }))));
};
var SvgWizzairIcon$1 = SvgWizzairIcon;

const SvgWomanOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 24.46 32.31",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.23,
    cy: 8.369,
    r: 7.619
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.688 15.055v2.7a1.062 1.062 0 0 1-.668.989A11.484 11.484 0 0 0 .75 29.429v2.131h22.96v-2.131a11.482 11.482 0 0 0-7.27-10.683 1.063 1.063 0 0 1-.668-.989v-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.44 18.746s-1.186-.288-1.52.564-1.786 6.337-2.69 6.337h0c-.9 0-2.357-5.484-2.69-6.337s-1.52-.564-1.52-.564M4.924 10.532s7.358.3 8.914-5.15a6.06 6.06 0 0 0 5.7 5.153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.849 8.369s-.9 7.94.548 10.089h-4.362M4.612 8.369s.9 7.94-.548 10.089h4.362"
  })));
};
var SvgWomanOutlined$1 = SvgWomanOutlined;

const SvgWomanWcOutlined = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 14.88 31.789",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: props.color || `#1d1d1b`,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.44,
    cy: 4.145,
    r: 3.395
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.256 7.327A4.056 4.056 0 0 0 3.5 10.255L.787 21.514a1.3 1.3 0 0 0 1.259 1.6h2.838v7.926H10v-7.927h2.837a1.3 1.3 0 0 0 1.26-1.6L11.38 10.255a4.053 4.053 0 0 0-2.757-2.928"
  })));
};
var SvgWomanWcOutlined$1 = SvgWomanWcOutlined;

const SvgZoomArea = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.width || `1em`,
    height: props.height || `1em`,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM10.25 20c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75-9.75-4.365-9.75-9.75Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.97 25.97a.75.75 0 0 1 1.06 0l9 9a.75.75 0 1 1-1.06 1.06l-9-9a.75.75 0 0 1 0-1.06Z",
    fill: props.color || `#1d1d1b`
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 6A.75.75 0 0 1 6 5.25h8.75a.75.75 0 0 1 0 1.5h-8v8a.75.75 0 0 1-1.5 0V6ZM31.5 6a.75.75 0 0 1 .75-.75H41a.75.75 0 0 1 .75.75v8.75a.75.75 0 0 1-1.5 0v-8h-8A.75.75 0 0 1 31.5 6ZM6 31.5a.75.75 0 0 1 .75.75v8h8a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75v-8.75A.75.75 0 0 1 6 31.5Zm35 0a.75.75 0 0 1 .75.75V41a.75.75 0 0 1-.75.75h-8.75a.75.75 0 0 1 0-1.5h8v-8a.75.75 0 0 1 .75-.75Z",
    fill: props.color || `#1d1d1b`
  }));
};
var SvgZoomArea$1 = SvgZoomArea;

export { SvgAircraftParkingOutlined$1 as AircraftParkingOutlined, SvgAirfranceIcon$1 as AirfranceIcon, SvgAirlineIcon$1 as AirlineIcon, SvgAnalyzeGlasOutlined$1 as AnalyzeGlasOutlined, SvgArrowDoubleLeftOutlined$1 as ArrowDoubleLeftOutlined, SvgArrowDoubleRightOutlined$1 as ArrowDoubleRightOutlined, SvgArrowDown$1 as ArrowDown, SvgArrowDownBoxOutlined$1 as ArrowDownBoxOutlined, SvgArrowDownOutlined$1 as ArrowDownOutlined, SvgArrowDownRightOutlined$1 as ArrowDownRightOutlined, SvgArrowLeftOutlined$1 as ArrowLeftOutlined, SvgArrowRightOutlined$1 as ArrowRightOutlined, SvgArrowSplitLeftRightOutlined$1 as ArrowSplitLeftRightOutlined, SvgArrowUp$1 as ArrowUp, SvgArrowUpBoxOutlined$1 as ArrowUpBoxOutlined, SvgArrowUpOutlined$1 as ArrowUpOutlined, SvgArrowUturnToLeftOutlined$1 as ArrowUturnToLeftOutlined, SvgArrowsRotateOutlined$1 as ArrowsRotateOutlined, SvgArrowsToCircleOutlined$1 as ArrowsToCircleOutlined, SvgArrowsUpDown$1 as ArrowsUpDown, SvgArrowsUpDownLeftRightOutlined$1 as ArrowsUpDownLeftRightOutlined, SvgAtbIcon$1 as AtbIcon, SvgAvinorAppOutlined$1 as AvinorAppOutlined, SvgBabyBottleOutlined$1 as BabyBottleOutlined, SvgBabyFullOutlined$1 as BabyFullOutlined, SvgBabyOutlined$1 as BabyOutlined, SvgBadgePercentOutlined$1 as BadgePercentOutlined, SvgBagPointerClickOutlined$1 as BagPointerClickOutlined, SvgBagSuitcaseClaimOutlined$1 as BagSuitcaseClaimOutlined, SvgBagsShoppingOutlined$1 as BagsShoppingOutlined, SvgBankOutlined$1 as BankOutlined, SvgBarsOutlined$1 as BarsOutlined, SvgBellOutlined$1 as BellOutlined, SvgBicycleOutlined$1 as BicycleOutlined, SvgBinOutlined$1 as BinOutlined, SvgBinocularsOutlined$1 as BinocularsOutlined, SvgBoardingCard$1 as BoardingCard, SvgBookFrontOutlined$1 as BookFrontOutlined, SvgBookOutlined$1 as BookOutlined, SvgBookPersonOutlined$1 as BookPersonOutlined, SvgBookTextFlatOutlined$1 as BookTextFlatOutlined, SvgBookTextOutlined$1 as BookTextOutlined, SvgBookmarkOutlined$1 as BookmarkOutlined, SvgBooksOutlined$1 as BooksOutlined, SvgBottlePlasticOutlined$1 as BottlePlasticOutlined, SvgBoxArrowOutRightOutlined$1 as BoxArrowOutRightOutlined, SvgBoxClosedOutlined$1 as BoxClosedOutlined, SvgBritishAirwaysIcon$1 as BritishAirwaysIcon, SvgBuildingColumnsOutlined$1 as BuildingColumnsOutlined, SvgBurgerDrinkOutlined$1 as BurgerDrinkOutlined, SvgBusRightOutlined$1 as BusRightOutlined, SvgBusTaxiOutlined$1 as BusTaxiOutlined, SvgBusTrainOutlined$1 as BusTrainOutlined, SvgByBanenIcon$1 as ByBanenIcon, SvgCalendarOutlined$1 as CalendarOutlined, SvgCameraOutlined$1 as CameraOutlined, SvgCameraSurveillanceOutlined$1 as CameraSurveillanceOutlined, SvgCarBusOutlined$1 as CarBusOutlined, SvgCarKeyOutlined$1 as CarKeyOutlined, SvgCarOutlined$1 as CarOutlined, SvgCarRightOutlined$1 as CarRightOutlined, SvgCarTrainOutlined$1 as CarTrainOutlined, SvgCardOverview$1 as CardOverview, SvgCaretDown$1 as CaretDown, SvgCaretUp$1 as CaretUp, SvgCaretUpDown$1 as CaretUpDown, SvgCartBagOutlined$1 as CartBagOutlined, SvgCartOutlined$1 as CartOutlined, SvgCashBagHandOutlined$1 as CashBagHandOutlined, SvgChargingStationOutlined$1 as ChargingStationOutlined, SvgChartNetworkOutlined$1 as ChartNetworkOutlined, SvgChartNetworkPersonOutlined$1 as ChartNetworkPersonOutlined, SvgChartUpOutlined$1 as ChartUpOutlined, SvgChatHappySadOutlined$1 as ChatHappySadOutlined, SvgChatHeartOutlined$1 as ChatHeartOutlined, SvgChatLinesOutlined$1 as ChatLinesOutlined, SvgChatOutlined$1 as ChatOutlined, SvgChecklistOutlined$1 as ChecklistOutlined, SvgChipOutlined$1 as ChipOutlined, SvgCigaretteOutlined$1 as CigaretteOutlined, SvgCircleLinesChartOutlined$1 as CircleLinesChartOutlined, SvgCircleMinus$1 as CircleMinus, SvgCirclePlus$1 as CirclePlus, SvgCirclePlusOutlined$1 as CirclePlusOutlined, SvgCircleSlashOutlined$1 as CircleSlashOutlined, SvgCirclesArrowOutlined$1 as CirclesArrowOutlined, SvgClearskyDay$1 as ClearskyDay, SvgClearskyNight$1 as ClearskyNight, SvgClockTimeOutlined$1 as ClockTimeOutlined, SvgClockWifiOutlined$1 as ClockWifiOutlined, SvgCloseOutlined$1 as CloseOutlined, SvgClothingHangerOutlined$1 as ClothingHangerOutlined, SvgCloudArrowUpOutlined$1 as CloudArrowUpOutlined, SvgCloudCoverPartSunOutlined$1 as CloudCoverPartSunOutlined, SvgCloudCoverSunOutlined$1 as CloudCoverSunOutlined, SvgCloudLightningOutlined$1 as CloudLightningOutlined, SvgCloudOutlined$1 as CloudOutlined, SvgCloudRainLightningOutlined$1 as CloudRainLightningOutlined, SvgCloudRainOutlined$1 as CloudRainOutlined, SvgCloudRainSunOutlined$1 as CloudRainSunOutlined, SvgCloudRaindropsOutlined$1 as CloudRaindropsOutlined, SvgCloudSnowflakeOutlined$1 as CloudSnowflakeOutlined, SvgCloudWindOutlined$1 as CloudWindOutlined, SvgCloudsOutlined$1 as CloudsOutlined, SvgCloudy$1 as Cloudy, SvgCoffeeOutlined$1 as CoffeeOutlined, SvgComputerCodeOutlined$1 as ComputerCodeOutlined, SvgContractOutlined$1 as ContractOutlined, SvgCovidTestOutlined$1 as CovidTestOutlined, SvgCrownOutlined$1 as CrownOutlined, SvgCustomsOutlined$1 as CustomsOutlined, SvgDatIcon$1 as DatIcon, SvgDeIceOutlined$1 as DeIceOutlined, SvgDiagramBars$1 as DiagramBars, SvgDocumentCheckOutlined$1 as DocumentCheckOutlined, SvgDocumentListCheckboxOutlined$1 as DocumentListCheckboxOutlined, SvgDocumentListPenOutlined$1 as DocumentListPenOutlined, SvgDocumentOutlined$1 as DocumentOutlined, SvgDogRightOutlined$1 as DogRightOutlined, SvgDoorArrowLeftOutlined$1 as DoorArrowLeftOutlined, SvgDotDiagramOutlined$1 as DotDiagramOutlined, SvgDownload$1 as Download, SvgDressBlingOutlined$1 as DressBlingOutlined, SvgDrinkMartiniOutlined$1 as DrinkMartiniOutlined, SvgDrinkWaterFountainOutlined$1 as DrinkWaterFountainOutlined, SvgDrinksOutlined$1 as DrinksOutlined, SvgDropOutlined$1 as DropOutlined, SvgElChargeOutlined$1 as ElChargeOutlined, SvgElectricCarOutlined$1 as ElectricCarOutlined, SvgElevatorOutlined$1 as ElevatorOutlined, SvgEmiratesIcon$1 as EmiratesIcon, SvgExclamationCircleOutlined$1 as ExclamationCircleOutlined, SvgExclamationSquareOutlined$1 as ExclamationSquareOutlined, SvgEyeOutlined$1 as EyeOutlined, SvgEyeSlashOutlined$1 as EyeSlashOutlined, SvgFairDay$1 as FairDay, SvgFairNight$1 as FairNight, SvgFileAppOutlined$1 as FileAppOutlined, SvgFileCsvOutlined$1 as FileCsvOutlined, SvgFileDocOutlined$1 as FileDocOutlined, SvgFileEpsOutlined$1 as FileEpsOutlined, SvgFileExeOutlined$1 as FileExeOutlined, SvgFileFsOutlined$1 as FileFsOutlined, SvgFileGifOutlined$1 as FileGifOutlined, SvgFileJpegOutlined$1 as FileJpegOutlined, SvgFileKsOutlined$1 as FileKsOutlined, SvgFilePdfOutlined$1 as FilePdfOutlined, SvgFilePngOutlined$1 as FilePngOutlined, SvgFilePptOutlined$1 as FilePptOutlined, SvgFileRtfOutlined$1 as FileRtfOutlined, SvgFileSvgOutlined$1 as FileSvgOutlined, SvgFileTxtOutlined$1 as FileTxtOutlined, SvgFileXlsOutlined$1 as FileXlsOutlined, SvgFileXmlOutlined$1 as FileXmlOutlined, SvgFileZipOutlined$1 as FileZipOutlined, SvgFilterOutlined$1 as FilterOutlined, SvgFinnairIcon$1 as FinnairIcon, SvgFireExtinguisherOutlined$1 as FireExtinguisherOutlined, SvgFirstAidOutlined$1 as FirstAidOutlined, SvgFlagOutlined$1 as FlagOutlined, SvgFlightTowerOutlined$1 as FlightTowerOutlined, SvgFloppyDiskOutlined$1 as FloppyDiskOutlined, SvgFlybussIcon$1 as FlybussIcon, SvgFlytogetIcon$1 as FlytogetIcon, SvgFog$1 as Fog, SvgFolderOutlined$1 as FolderOutlined, SvgGearOutlined$1 as GearOutlined, SvgGearsGraphOutlined$1 as GearsGraphOutlined, SvgGlobeDetailsOutlined$1 as GlobeDetailsOutlined, SvgGlobeOutlined$1 as GlobeOutlined, SvgGrid2Outlined$1 as Grid2Outlined, SvgGridOutlined$1 as GridOutlined, SvgHandClickOutlined$1 as HandClickOutlined, SvgHandHeartOutlined$1 as HandHeartOutlined, SvgHandshakeOutlined$1 as HandshakeOutlined, SvgHatGraduationOutlined$1 as HatGraduationOutlined, SvgHeartOutlined$1 as HeartOutlined, SvgHeavyrain$1 as Heavyrain, SvgHeavyrainandthunder$1 as Heavyrainandthunder, SvgHeavyrainshowersDay$1 as HeavyrainshowersDay, SvgHeavyrainshowersNight$1 as HeavyrainshowersNight, SvgHeavyrainshowersandthunderDay$1 as HeavyrainshowersandthunderDay, SvgHeavyrainshowersandthunderNight$1 as HeavyrainshowersandthunderNight, SvgHeavysleet$1 as Heavysleet, SvgHeavysleetshowersandthunderDay$1 as HeavysleetshowersandthunderDay, SvgHeavysleetshowersandthunderNight$1 as HeavysleetshowersandthunderNight, SvgHeavysnow$1 as Heavysnow, SvgHeavysnowandthunder$1 as Heavysnowandthunder, SvgHeavysnowshowersDay$1 as HeavysnowshowersDay, SvgHeavysnowshowersNight$1 as HeavysnowshowersNight, SvgHelicopterOutlined$1 as HelicopterOutlined, SvgHome$1 as Home, SvgHouseOutlined$1 as HouseOutlined, SvgHouseShopOutlined$1 as HouseShopOutlined, SvgIcelandairIcon$1 as IcelandairIcon, SvgImageMultiOutlined$1 as ImageMultiOutlined, SvgInboxFilesOutlined$1 as InboxFilesOutlined, SvgInboxOutlined$1 as InboxOutlined, SvgInfoICircleOutlined$1 as InfoICircleOutlined, SvgInfoILocationOutlined$1 as InfoILocationOutlined, SvgInfoIOutlined$1 as InfoIOutlined, SvgKlmIcon$1 as KlmIcon, SvgKolumbusIcon$1 as KolumbusIcon, SvgLandscapeOutlined$1 as LandscapeOutlined, SvgLaptopOutlined$1 as LaptopOutlined, SvgLetterOutlined$1 as LetterOutlined, SvgLightbulbBrightOutlined$1 as LightbulbBrightOutlined, SvgLightrain$1 as Lightrain, SvgLightrainandthunder$1 as Lightrainandthunder, SvgLightrainshowersDay$1 as LightrainshowersDay, SvgLightrainshowersNight$1 as LightrainshowersNight, SvgLightrainshowersandthunderDay$1 as LightrainshowersandthunderDay, SvgLightrainshowersandthunderNight$1 as LightrainshowersandthunderNight, SvgLightsleet$1 as Lightsleet, SvgLightsnow$1 as Lightsnow, SvgLightsnowandthunder$1 as Lightsnowandthunder, SvgLightsnowshowersDay$1 as LightsnowshowersDay, SvgLightsnowshowersNight$1 as LightsnowshowersNight, SvgLightssleetshowersandthunderDay$1 as LightssleetshowersandthunderDay, SvgLightssleetshowersandthunderNight$1 as LightssleetshowersandthunderNight, SvgLinkOutlined$1 as LinkOutlined, SvgListArrowUpDownOutlined$1 as ListArrowUpDownOutlined, SvgListClockOutlined$1 as ListClockOutlined, SvgLocationDotOutlined$1 as LocationDotOutlined, SvgLockClosedOutlined$1 as LockClosedOutlined, SvgLockOpenOutlined$1 as LockOpenOutlined, SvgLockerLockOutlined$1 as LockerLockOutlined, SvgLostAndFoundOutlined$1 as LostAndFoundOutlined, SvgLufthansaIcon$1 as LufthansaIcon, SvgMagnifyingGlassGraphOutlined$1 as MagnifyingGlassGraphOutlined, SvgMagnifyingGlassOutlined$1 as MagnifyingGlassOutlined, SvgManOutlined$1 as ManOutlined, SvgManWcOutlined$1 as ManWcOutlined, SvgMapOutlined$1 as MapOutlined, SvgMaskOutlined$1 as MaskOutlined, SvgMazeOutlined$1 as MazeOutlined, SvgMobileBatteryOutlined$1 as MobileBatteryOutlined, SvgMobileDownloadOutlined$1 as MobileDownloadOutlined, SvgMobileNetworkWiredOutlined$1 as MobileNetworkWiredOutlined, SvgMobileOutlined$1 as MobileOutlined, SvgMoneyCircleArrowOutlined$1 as MoneyCircleArrowOutlined, SvgMoneyOutlined$1 as MoneyOutlined, SvgMotorcycleOutlined$1 as MotorcycleOutlined, SvgMountainFlagOutlined$1 as MountainFlagOutlined, SvgMove$1 as Move, SvgNetworkWiredOutlined$1 as NetworkWiredOutlined, SvgNewsOutlined$1 as NewsOutlined, SvgNorseIcon$1 as NorseIcon, SvgNorwegianIcon$1 as NorwegianIcon, SvgPaperPlaneTopRightOutlined$1 as PaperPlaneTopRightOutlined, SvgPaperclipOutlined$1 as PaperclipOutlined, SvgPartlycloudyDay$1 as PartlycloudyDay, SvgPartlycloudyNight$1 as PartlycloudyNight, SvgPassportOutlined$1 as PassportOutlined, SvgPassportSecurityOutlined$1 as PassportSecurityOutlined, SvgPenOutlined$1 as PenOutlined, SvgPenSignOutlined$1 as PenSignOutlined, SvgPeopleGroup3Outlined$1 as PeopleGroup3Outlined, SvgPeopleGroup6Outlined$1 as PeopleGroup6Outlined, SvgPeopleGroupLightbulbOutlined$1 as PeopleGroupLightbulbOutlined, SvgPeopleGroupTableOutlined$1 as PeopleGroupTableOutlined, SvgPersonAdultChildOutlined$1 as PersonAdultChildOutlined, SvgPersonCircleCheckOutlined$1 as PersonCircleCheckOutlined, SvgPersonCircleCloseOutlined$1 as PersonCircleCloseOutlined, SvgPersonCircleOutlined$1 as PersonCircleOutlined, SvgPersonCirclePlusOutlined$1 as PersonCirclePlusOutlined, SvgPersonHeart$1 as PersonHeart, SvgPersonHeartOutlined$1 as PersonHeartOutlined, SvgPersonKneesOutlined$1 as PersonKneesOutlined, SvgPersonLightbulbOutlined$1 as PersonLightbulbOutlined, SvgPersonOutlined$1 as PersonOutlined, SvgPersonPathCheck$1 as PersonPathCheck, SvgPersonRemoveOutlined$1 as PersonRemoveOutlined, SvgPersonSoundShowerOutlined$1 as PersonSoundShowerOutlined, SvgPhoneRingingOutlined$1 as PhoneRingingOutlined, SvgPlaneDownOutlined$1 as PlaneDownOutlined, SvgPlaneGroundOutlined$1 as PlaneGroundOutlined, SvgPlaneLanding$1 as PlaneLanding, SvgPlaneLandingOutlined$1 as PlaneLandingOutlined, SvgPlaneRightLeafOutlined$1 as PlaneRightLeafOutlined, SvgPlaneRightOutlined$1 as PlaneRightOutlined, SvgPlaneUpOutlined$1 as PlaneUpOutlined, SvgPlaneUpRightOutlined$1 as PlaneUpRightOutlined, SvgPlayCircleOutlined$1 as PlayCircleOutlined, SvgPlaygroundOutlined$1 as PlaygroundOutlined, SvgPlowTruckOutlined$1 as PlowTruckOutlined, SvgPrototypeOutlined$1 as PrototypeOutlined, SvgQatarAirwaysIcon$1 as QatarAirwaysIcon, SvgQuestionCircleOutlined$1 as QuestionCircleOutlined, SvgRain$1 as Rain, SvgRainDropSnowflakeOutlined$1 as RainDropSnowflakeOutlined, SvgRainandthunder$1 as Rainandthunder, SvgRainshowersDay$1 as RainshowersDay, SvgRainshowersNight$1 as RainshowersNight, SvgRainshowersandthunderDay$1 as RainshowersandthunderDay, SvgRainshowersandthunderNight$1 as RainshowersandthunderNight, SvgRecycleOutlined$1 as RecycleOutlined, SvgRemoveOutlined$1 as RemoveOutlined, SvgReportOutlined$1 as ReportOutlined, SvgResponsiveOutlined$1 as ResponsiveOutlined, SvgRocketOutlined$1 as RocketOutlined, SvgRollerSkatesOutlined$1 as RollerSkatesOutlined, SvgRunway$1 as Runway, SvgRyanairIcon$1 as RyanairIcon, SvgSasIcon$1 as SasIcon, SvgScissorCombOutlined$1 as ScissorCombOutlined, SvgScooterOutlined$1 as ScooterOutlined, SvgScreenLuggageOutlined$1 as ScreenLuggageOutlined, SvgScreenOutlined$1 as ScreenOutlined, SvgServerHouseRoofOutlined$1 as ServerHouseRoofOutlined, SvgServerOutlined$1 as ServerOutlined, SvgSettings$1 as Settings, SvgShareNodesOutlined$1 as ShareNodesOutlined, SvgShoeHeelsOutlined$1 as ShoeHeelsOutlined, SvgShoeSneakerOutlined$1 as ShoeSneakerOutlined, SvgShowerOutlined$1 as ShowerOutlined, SvgSidebarArrowRightOutlined$1 as SidebarArrowRightOutlined, SvgSignCloseOutlined$1 as SignCloseOutlined, SvgSjNordIcon$1 as SjNordIcon, SvgSkyssIcon$1 as SkyssIcon, SvgSleet$1 as Sleet, SvgSleetshowersandthunderDay$1 as SleetshowersandthunderDay, SvgSleetshowersandthunderNight$1 as SleetshowersandthunderNight, SvgSlidersOutlined$1 as SlidersOutlined, SvgSnow$1 as Snow, SvgSnowandthunder$1 as Snowandthunder, SvgSnowshowersDay$1 as SnowshowersDay, SvgSnowshowersNight$1 as SnowshowersNight, SvgSquareArrowInRightOutlined$1 as SquareArrowInRightOutlined, SvgSquareArrowRightCornerOutlined$1 as SquareArrowRightCornerOutlined, SvgSquareParkingOutlined$1 as SquareParkingOutlined, SvgSquareParkingRoofOutlined$1 as SquareParkingRoofOutlined, SvgStairsArrowUpDownOutlined$1 as StairsArrowUpDownOutlined, SvgStarOutlined$1 as StarOutlined, SvgStopSignOutlined$1 as StopSignOutlined, SvgSuitcaseClaimOutlined$1 as SuitcaseClaimOutlined, SvgSuitcaseOutlined$1 as SuitcaseOutlined, SvgSunArrowDownOutlined$1 as SunArrowDownOutlined, SvgSunArrowUpOutlined$1 as SunArrowUpOutlined, SvgSunOutlined$1 as SunOutlined, SvgTaxFreeTagOutlined$1 as TaxFreeTagOutlined, SvgTaxiOutlined$1 as TaxiOutlined, SvgThumbsUpHandOutlined$1 as ThumbsUpHandOutlined, SvgTicketOutlined$1 as TicketOutlined, SvgTrainRightOutlined$1 as TrainRightOutlined, SvgTurkishAirlinesIcon$1 as TurkishAirlinesIcon, SvgTurnaround$1 as Turnaround, SvgUtensilsOutlined$1 as UtensilsOutlined, SvgVaarnesEkspressenIcon$1 as VaarnesEkspressenIcon, SvgVyIcon$1 as VyIcon, SvgWasteOutlined$1 as WasteOutlined, SvgWcOutlined$1 as WcOutlined, SvgWebcamOutlined$1 as WebcamOutlined, SvgWheelchairCircleOutlined$1 as WheelchairCircleOutlined, SvgWheelchairOutlined$1 as WheelchairOutlined, SvgWideroeIcon$1 as WideroeIcon, SvgWifiCircleOutlined$1 as WifiCircleOutlined, SvgWindLeftOutlined$1 as WindLeftOutlined, SvgWindRightOutlined$1 as WindRightOutlined, SvgWindowBinaryOutlined$1 as WindowBinaryOutlined, SvgWindowsOutlined$1 as WindowsOutlined, SvgWizzairIcon$1 as WizzairIcon, SvgWomanOutlined$1 as WomanOutlined, SvgWomanWcOutlined$1 as WomanWcOutlined, SvgZoomArea$1 as ZoomArea };
